import{jsx as e,jsxs as t,Fragment as o}from"react/jsx-runtime";import*as i from"react";import n,{useState as r,useEffect as a,useMemo as l,createRef as d,useRef as s,useCallback as c,forwardRef as p,isValidElement as m,memo as u}from"react";import h,{css as g,createGlobalStyle as A}from"styled-components";import{agroTheme as f,portalTheme as v}from"exo-frontend-remote-theme";import{ChevronUp24 as x,ChevronDown24 as b,Subtract32 as w,Add32 as y,Subtract24 as C,Add24 as E,ColorSwitch16 as B,ArrowLeft32 as k,HelpFilled32 as I,ArrowRight32 as N,RadioButtonChecked20 as S,RadioButton20 as O,ChevronLeft32 as P,ChevronRight32 as Q,Misuse16 as z,CheckmarkFilled16 as M,WarningFilled16 as D,InformationFilled16 as j,Close32 as T,Chat32 as R,Information16 as L,Calendar32 as U,HelpFilled16 as q,View20 as W,ViewOff20 as G,Search16 as H,Close16 as F,Search32 as V,WarningAltFilled16 as K,ChevronUp16 as J,ChevronDown16 as Y,Pending16 as Z,CheckboxCheckedFilled16 as X,Checkbox16 as _,RadioButtonChecked16 as $,RadioButton16 as ee,ChevronLeft24 as te,ChevronRight24 as oe,Calendar16 as ie,UserAvatar16 as ne,Logout32 as re,UserAvatarFilled32 as ae,Home16 as le,LicenseDraft16 as de,UserMultiple16 as se,DocumentView16 as ce,Camera32 as pe,LogoYoutube32 as me,LogoFacebook32 as ue,LogoInstagram32 as he,Tag32 as ge,Home20 as Ae,Currency20 as fe,Dashboard20 as ve,Close20 as xe,ArrowLeft16 as be,ArrowRight16 as we,ShoppingCart20 as ye,Blog20 as Ce,ShoppingCart32 as Ee,ShoppingCartError32 as Be,Store32 as ke,Location32 as Ie,UserAvatarFilledAlt32 as Ne,NotificationNew32 as Se,Notification32 as Oe,UserProfile16 as Pe,Logout16 as Qe,Misuse32 as ze,ChevronUp20 as Me,ChevronDown20 as De,InformationFilled32 as je,TrashCan16 as Te,NotificationNew16 as Re,Notification16 as Le,LicenseDraft24 as Ue,UserMultiple24 as qe,User24 as We,Currency16 as Ge,ShoppingCart16 as He,LicenseThirdParty16 as Fe,RadioButtonChecked24 as Ve,RadioButton24 as Ke}from"@carbon/icons-react";import{TagManagerUtils as Je,ActionType as Ye,formatCurrency as Ze,insertComponentsIntoText as Xe,formatPhone as _e,formatCPF as $e,removeAccents as et,Event as tt,validateArray as ot,UserLoggedStatus as it,formatBankAccount as nt,formatPersonName as rt,findOffer as at}from"exo-frontend-remote-utils";import{useWindowDimensions as lt,useAskQuestion as dt,useGetProfile as st,useGetBusinessHours as ct,useAuthentication as pt,useAgroLogout as mt,Username as ut,usePrivilegedUserSession as ht,usePrivilegedSession as gt,useUpdateOrderViewed as At,useGetClientProfile as ft,useManageUserFile as vt,useFooter as xt,useGetHeader as bt,useDropdownCategoriasBanner as wt,useGetProductCart as yt,useGetMunicipio as Ct,useGetAddressByZipcode as Et,useCartSetShippingInfo as Bt,useLinkRegister as kt,useRefreshCart as It,useLazyTagueamento as Nt,useCategories as St,useGetIdBrRegion as Ot,useNotificationBell as Pt,useGetOrderDataPrivileged as Qt,useValidToken as zt,useSetUserInfo as Mt,useQueryParams as Dt,useGetPossibleClients as jt,useGetOrderByOrderNumber as Tt,useRedirect as Rt,useOIDC as Lt,useCMSDashboardBannerDownload as Ut}from"exo-frontend-remote-hooks";import{useSessionContext as qt,ProfileEnum as Wt,generateObjectKey as Gt,sessionStorage as Ht}from"@exo/frontend-common-session-context";import{Button as Ft,Loading as Vt,Link as Kt,RadioButtonGroup as Jt,RadioButton as Yt,RadioTile as Zt,TileGroup as Xt,Checkbox as _t,FormGroup as $t,Toggle as eo,Dropdown as to,StructuredListRow as oo,StructuredListCell as io,MultiSelect as no,Search as ro,Modal as ao,PaginationNav as lo,Grid as so,Row as co,Column as po,TextInput as mo,Table as uo,TableHead as ho,TableRow as go,TableHeader as Ao,TableBody as fo,TableCell as vo,Tabs as xo,Tab as bo}from"carbon-components-react";import{useHistory as wo,Link as yo,useLocation as Co}from"react-router-dom";import{ifProp as Eo,media as Bo,when as ko,getBottom as Io,spacing as No,responsiveFontBlock as So}from"@exo/frontend-common-style-utils";import Oo from"react-slick";import{v4 as Po}from"uuid";import Qo from"socket.io-client";import zo from"react-otp-input";import Mo from"universal-cookie";import{useIMask as Do}from"react-imask";import{useSelect as jo,useCombobox as To}from"downshift";import{isEqual as Ro,isBefore as Lo,isAfter as Uo,parseISO as qo,isValid as Wo,format as Go}from"date-fns";import{AppErrorBoundary as Ho}from"@exo/frontend-features-chrome-logic";import{AppErrorRenderer as Fo,ChromeCSS as Vo,Notifications as Ko}from"@exo/frontend-features-chrome-ui";import{LoadingIndicator as Jo,ButtonGroup as Yo,Button as Zo}from"@exo/frontend-components-base";import{Tooltip as Xo}from"carbon-components-react/lib/components/Tooltip/Tooltip";import{gql as _o,useQuery as $o}from"@apollo/client";import{ptBR as ei}from"date-fns/locale";import{useStatusOrder as ti,usePrivilegedSession as oi}from"@exo/frontend-features-especialista-logic";import{UploadS3FileService as ii}from"@exo/frontend-services";import{useNotificationContext as ni}from"@exo/frontend-common-notification";import{Helmet as ri}from"react-helmet";import{EagroHeader as ai,EagroFooter as li}from"exo-frontend-remote-layout";import{useMarketplaceContext as di,useCpr as si,useCartSideMenu as ci,useRecommendation as pi,useCart as mi,useHandleWasAddeToCart as ui,useSearchQuery as hi,MarketplaceCookies as gi,usePagination as Ai}from"@exo/contexts";import{useCartModification as fi,MiniCartContainer as vi,useCart as xi,CartContainer as bi}from"@exo/frontend-features-cart-logic";import{Link as wi}from"@exo/frontend-common-link";import{MonetaryCardItem as yi,SkeletonLine as Ci,MonetaryAmount as Ei}from"@exo/frontend-components-core";import{getClientImagePath as Bi}from"@exo/frontend-common-utils";import{useIntl as ki}from"@exo/frontend-common-i18n";import{useForm as Ii,useFieldArray as Ni,Controller as Si,appendErrors as Oi}from"react-hook-form";import{useSetShipping as Pi}from"@exo/frontend-features-catalog-logic";import{MiniCartExt as Qi}from"@exo/frontend-features-cart-ui";import{validateFieldsNatively as zi,toNestError as Mi}from"@hookform/resolvers";import*as Di from"yup";function ji(e,t,o){return(t=function(e){var t=function(e,t){if("object"!=typeof e||!e)return e;var o=e[Symbol.toPrimitive];if(void 0!==o){var i=o.call(e,t);if("object"!=typeof i)return i;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:t+""}(t))in e?Object.defineProperty(e,t,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[t]=o,e}function Ti(e,t){var o=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);t&&(i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),o.push.apply(o,i)}return o}function Ri(e){for(var t=1;t<arguments.length;t++){var o=null!=arguments[t]?arguments[t]:{};t%2?Ti(Object(o),!0).forEach((function(t){ji(e,t,o[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(o)):Ti(Object(o)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(o,t))}))}return e}function Li(e,t){if(null==e)return{};var o,i,n=function(e,t){if(null==e)return{};var o={};for(var i in e)if({}.hasOwnProperty.call(e,i)){if(t.includes(i))continue;o[i]=e[i]}return o}(e,t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);for(i=0;i<r.length;i++)o=r[i],t.includes(o)||{}.propertyIsEnumerable.call(e,o)&&(n[o]=e[o])}return n}var Ui=["width","height","viewBox"],qi=["tabindex"],Wi={focusable:"false",preserveAspectRatio:"xMidYMid meet"};var Gi="undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},Hi=void 0!==Gi?Gi:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},Fi=Hi.performance||{};Fi.now||Fi.mozNow||Fi.msNow||Fi.oNow||Fi.webkitNow;var Vi={};function Ki(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e.default:e}var Ji,Yi={exports:{}},Zi={exports:{}},Xi={};var _i,$i,en,tn,on,nn,rn,an,ln,dn,sn,cn,pn,mn,un={};function hn(){return $i||($i=1,"production"===Vi.NODE_ENV?Zi.exports=function(){if(Ji)return Xi;Ji=1;var e="function"==typeof Symbol&&Symbol.for,t=e?Symbol.for("react.element"):60103,o=e?Symbol.for("react.portal"):60106,i=e?Symbol.for("react.fragment"):60107,n=e?Symbol.for("react.strict_mode"):60108,r=e?Symbol.for("react.profiler"):60114,a=e?Symbol.for("react.provider"):60109,l=e?Symbol.for("react.context"):60110,d=e?Symbol.for("react.async_mode"):60111,s=e?Symbol.for("react.concurrent_mode"):60111,c=e?Symbol.for("react.forward_ref"):60112,p=e?Symbol.for("react.suspense"):60113,m=e?Symbol.for("react.suspense_list"):60120,u=e?Symbol.for("react.memo"):60115,h=e?Symbol.for("react.lazy"):60116,g=e?Symbol.for("react.block"):60121,A=e?Symbol.for("react.fundamental"):60117,f=e?Symbol.for("react.responder"):60118,v=e?Symbol.for("react.scope"):60119;function x(e){if("object"==typeof e&&null!==e){var m=e.$$typeof;switch(m){case t:switch(e=e.type){case d:case s:case i:case r:case n:case p:return e;default:switch(e=e&&e.$$typeof){case l:case c:case h:case u:case a:return e;default:return m}}case o:return m}}}function b(e){return x(e)===s}return Xi.AsyncMode=d,Xi.ConcurrentMode=s,Xi.ContextConsumer=l,Xi.ContextProvider=a,Xi.Element=t,Xi.ForwardRef=c,Xi.Fragment=i,Xi.Lazy=h,Xi.Memo=u,Xi.Portal=o,Xi.Profiler=r,Xi.StrictMode=n,Xi.Suspense=p,Xi.isAsyncMode=function(e){return b(e)||x(e)===d},Xi.isConcurrentMode=b,Xi.isContextConsumer=function(e){return x(e)===l},Xi.isContextProvider=function(e){return x(e)===a},Xi.isElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===t},Xi.isForwardRef=function(e){return x(e)===c},Xi.isFragment=function(e){return x(e)===i},Xi.isLazy=function(e){return x(e)===h},Xi.isMemo=function(e){return x(e)===u},Xi.isPortal=function(e){return x(e)===o},Xi.isProfiler=function(e){return x(e)===r},Xi.isStrictMode=function(e){return x(e)===n},Xi.isSuspense=function(e){return x(e)===p},Xi.isValidElementType=function(e){return"string"==typeof e||"function"==typeof e||e===i||e===s||e===r||e===n||e===p||e===m||"object"==typeof e&&null!==e&&(e.$$typeof===h||e.$$typeof===u||e.$$typeof===a||e.$$typeof===l||e.$$typeof===c||e.$$typeof===A||e.$$typeof===f||e.$$typeof===v||e.$$typeof===g)},Xi.typeOf=x,Xi}():Zi.exports=(_i||(_i=1,"production"!==Vi.NODE_ENV&&function(){var e="function"==typeof Symbol&&Symbol.for,t=e?Symbol.for("react.element"):60103,o=e?Symbol.for("react.portal"):60106,i=e?Symbol.for("react.fragment"):60107,n=e?Symbol.for("react.strict_mode"):60108,r=e?Symbol.for("react.profiler"):60114,a=e?Symbol.for("react.provider"):60109,l=e?Symbol.for("react.context"):60110,d=e?Symbol.for("react.async_mode"):60111,s=e?Symbol.for("react.concurrent_mode"):60111,c=e?Symbol.for("react.forward_ref"):60112,p=e?Symbol.for("react.suspense"):60113,m=e?Symbol.for("react.suspense_list"):60120,u=e?Symbol.for("react.memo"):60115,h=e?Symbol.for("react.lazy"):60116,g=e?Symbol.for("react.block"):60121,A=e?Symbol.for("react.fundamental"):60117,f=e?Symbol.for("react.responder"):60118,v=e?Symbol.for("react.scope"):60119;function x(e){if("object"==typeof e&&null!==e){var m=e.$$typeof;switch(m){case t:var g=e.type;switch(g){case d:case s:case i:case r:case n:case p:return g;default:var A=g&&g.$$typeof;switch(A){case l:case c:case h:case u:case a:return A;default:return m}}case o:return m}}}var b=d,w=s,y=l,C=a,E=t,B=c,k=i,I=h,N=u,S=o,O=r,P=n,Q=p,z=!1;function M(e){return x(e)===s}un.AsyncMode=b,un.ConcurrentMode=w,un.ContextConsumer=y,un.ContextProvider=C,un.Element=E,un.ForwardRef=B,un.Fragment=k,un.Lazy=I,un.Memo=N,un.Portal=S,un.Profiler=O,un.StrictMode=P,un.Suspense=Q,un.isAsyncMode=function(e){return z||(z=!0,console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")),M(e)||x(e)===d},un.isConcurrentMode=M,un.isContextConsumer=function(e){return x(e)===l},un.isContextProvider=function(e){return x(e)===a},un.isElement=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===t},un.isForwardRef=function(e){return x(e)===c},un.isFragment=function(e){return x(e)===i},un.isLazy=function(e){return x(e)===h},un.isMemo=function(e){return x(e)===u},un.isPortal=function(e){return x(e)===o},un.isProfiler=function(e){return x(e)===r},un.isStrictMode=function(e){return x(e)===n},un.isSuspense=function(e){return x(e)===p},un.isValidElementType=function(e){return"string"==typeof e||"function"==typeof e||e===i||e===s||e===r||e===n||e===p||e===m||"object"==typeof e&&null!==e&&(e.$$typeof===h||e.$$typeof===u||e.$$typeof===a||e.$$typeof===l||e.$$typeof===c||e.$$typeof===A||e.$$typeof===f||e.$$typeof===v||e.$$typeof===g)},un.typeOf=x}()),un)),Zi.exports}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/function gn(){if(tn)return en;tn=1;var e=Object.getOwnPropertySymbols,t=Object.prototype.hasOwnProperty,o=Object.prototype.propertyIsEnumerable;return en=function(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},o=0;o<10;o++)t["_"+String.fromCharCode(o)]=o;if("0123456789"!==Object.getOwnPropertyNames(t).map((function(e){return t[e]})).join(""))return!1;var i={};return"abcdefghijklmnopqrst".split("").forEach((function(e){i[e]=e})),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},i)).join("")}catch(e){return!1}}()?Object.assign:function(i,n){for(var r,a,l=function(e){if(null==e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}(i),d=1;d<arguments.length;d++){for(var s in r=Object(arguments[d]))t.call(r,s)&&(l[s]=r[s]);if(e){a=e(r);for(var c=0;c<a.length;c++)o.call(r,a[c])&&(l[a[c]]=r[a[c]])}}return l},en}function An(){if(nn)return on;nn=1;return on="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"}function fn(){return an?rn:(an=1,rn=Function.call.bind(Object.prototype.hasOwnProperty))}if("production"!==Vi.NODE_ENV){var vn=hn();Yi.exports=function(){if(cn)return sn;cn=1;var e=hn(),t=gn(),o=An(),i=fn(),n=function(){if(dn)return ln;dn=1;var e=function(){};if("production"!==Vi.NODE_ENV){var t=An(),o={},i=fn();e=function(e){var t="Warning: "+e;"undefined"!=typeof console&&console.error(t);try{throw new Error(t)}catch(e){}}}function n(n,r,a,l,d){if("production"!==Vi.NODE_ENV)for(var s in n)if(i(n,s)){var c;try{if("function"!=typeof n[s]){var p=Error((l||"React class")+": "+a+" type `"+s+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+typeof n[s]+"`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");throw p.name="Invariant Violation",p}c=n[s](r,s,l,a,null,t)}catch(e){c=e}if(!c||c instanceof Error||e((l||"React class")+": type specification of "+a+" `"+s+"` is invalid; the type checker function must return `null` or an `Error` but returned a "+typeof c+". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."),c instanceof Error&&!(c.message in o)){o[c.message]=!0;var m=d?d():"";e("Failed "+a+" type: "+c.message+(null!=m?m:""))}}}return n.resetWarningCache=function(){"production"!==Vi.NODE_ENV&&(o={})},ln=n}(),r=function(){};function a(){return null}return"production"!==Vi.NODE_ENV&&(r=function(e){var t="Warning: "+e;"undefined"!=typeof console&&console.error(t);try{throw new Error(t)}catch(e){}}),sn=function(l,d){var s="function"==typeof Symbol&&Symbol.iterator,c="<<anonymous>>",p={array:g("array"),bigint:g("bigint"),bool:g("boolean"),func:g("function"),number:g("number"),object:g("object"),string:g("string"),symbol:g("symbol"),any:h(a),arrayOf:function(e){return h((function(t,i,n,r,a){if("function"!=typeof e)return new u("Property `"+a+"` of component `"+n+"` has invalid PropType notation inside arrayOf.");var l=t[i];if(!Array.isArray(l))return new u("Invalid "+r+" `"+a+"` of type `"+v(l)+"` supplied to `"+n+"`, expected an array.");for(var d=0;d<l.length;d++){var s=e(l,d,n,r,a+"["+d+"]",o);if(s instanceof Error)return s}return null}))},element:h((function(e,t,o,i,n){var r=e[t];return l(r)?null:new u("Invalid "+i+" `"+n+"` of type `"+v(r)+"` supplied to `"+o+"`, expected a single ReactElement.")})),elementType:h((function(t,o,i,n,r){var a=t[o];return e.isValidElementType(a)?null:new u("Invalid "+n+" `"+r+"` of type `"+v(a)+"` supplied to `"+i+"`, expected a single ReactElement type.")})),instanceOf:function(e){return h((function(t,o,i,n,r){if(!(t[o]instanceof e)){var a=e.name||c;return new u("Invalid "+n+" `"+r+"` of type `"+((l=t[o]).constructor&&l.constructor.name?l.constructor.name:c)+"` supplied to `"+i+"`, expected instance of `"+a+"`.")}var l;return null}))},node:h((function(e,t,o,i,n){return f(e[t])?null:new u("Invalid "+i+" `"+n+"` supplied to `"+o+"`, expected a ReactNode.")})),objectOf:function(e){return h((function(t,n,r,a,l){if("function"!=typeof e)return new u("Property `"+l+"` of component `"+r+"` has invalid PropType notation inside objectOf.");var d=t[n],s=v(d);if("object"!==s)return new u("Invalid "+a+" `"+l+"` of type `"+s+"` supplied to `"+r+"`, expected an object.");for(var c in d)if(i(d,c)){var p=e(d,c,r,a,l+"."+c,o);if(p instanceof Error)return p}return null}))},oneOf:function(e){return Array.isArray(e)?h((function(t,o,i,n,r){for(var a=t[o],l=0;l<e.length;l++)if(m(a,e[l]))return null;var d=JSON.stringify(e,(function(e,t){return"symbol"===x(t)?String(t):t}));return new u("Invalid "+n+" `"+r+"` of value `"+String(a)+"` supplied to `"+i+"`, expected one of "+d+".")})):("production"!==Vi.NODE_ENV&&r(arguments.length>1?"Invalid arguments supplied to oneOf, expected an array, got "+arguments.length+" arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).":"Invalid argument supplied to oneOf, expected an array."),a)},oneOfType:function(e){if(!Array.isArray(e))return"production"!==Vi.NODE_ENV&&r("Invalid argument supplied to oneOfType, expected an instance of array."),a;for(var t=0;t<e.length;t++){var n=e[t];if("function"!=typeof n)return r("Invalid argument supplied to oneOfType. Expected an array of check functions, but received "+b(n)+" at index "+t+"."),a}return h((function(t,n,r,a,l){for(var d=[],s=0;s<e.length;s++){var c=(0,e[s])(t,n,r,a,l,o);if(null==c)return null;c.data&&i(c.data,"expectedType")&&d.push(c.data.expectedType)}return new u("Invalid "+a+" `"+l+"` supplied to `"+r+"`"+(d.length>0?", expected one of type ["+d.join(", ")+"]":"")+".")}))},shape:function(e){return h((function(t,i,n,r,a){var l=t[i],d=v(l);if("object"!==d)return new u("Invalid "+r+" `"+a+"` of type `"+d+"` supplied to `"+n+"`, expected `object`.");for(var s in e){var c=e[s];if("function"!=typeof c)return A(n,r,a,s,x(c));var p=c(l,s,n,r,a+"."+s,o);if(p)return p}return null}))},exact:function(e){return h((function(n,r,a,l,d){var s=n[r],c=v(s);if("object"!==c)return new u("Invalid "+l+" `"+d+"` of type `"+c+"` supplied to `"+a+"`, expected `object`.");var p=t({},n[r],e);for(var m in p){var h=e[m];if(i(e,m)&&"function"!=typeof h)return A(a,l,d,m,x(h));if(!h)return new u("Invalid "+l+" `"+d+"` key `"+m+"` supplied to `"+a+"`.\nBad object: "+JSON.stringify(n[r],null,"  ")+"\nValid keys: "+JSON.stringify(Object.keys(e),null,"  "));var g=h(s,m,a,l,d+"."+m,o);if(g)return g}return null}))}};function m(e,t){return e===t?0!==e||1/e==1/t:e!=e&&t!=t}function u(e,t){this.message=e,this.data=t&&"object"==typeof t?t:{},this.stack=""}function h(e){if("production"!==Vi.NODE_ENV)var t={},i=0;function n(n,a,l,s,p,m,h){if(s=s||c,m=m||l,h!==o){if(d){var g=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");throw g.name="Invariant Violation",g}if("production"!==Vi.NODE_ENV&&"undefined"!=typeof console){var A=s+":"+l;!t[A]&&i<3&&(r("You are manually calling a React.PropTypes validation function for the `"+m+"` prop on `"+s+"`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."),t[A]=!0,i++)}}return null==a[l]?n?null===a[l]?new u("The "+p+" `"+m+"` is marked as required in `"+s+"`, but its value is `null`."):new u("The "+p+" `"+m+"` is marked as required in `"+s+"`, but its value is `undefined`."):null:e(a,l,s,p,m)}var a=n.bind(null,!1);return a.isRequired=n.bind(null,!0),a}function g(e){return h((function(t,o,i,n,r,a){var l=t[o];return v(l)!==e?new u("Invalid "+n+" `"+r+"` of type `"+x(l)+"` supplied to `"+i+"`, expected `"+e+"`.",{expectedType:e}):null}))}function A(e,t,o,i,n){return new u((e||"React class")+": "+t+" type `"+o+"."+i+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+n+"`.")}function f(e){switch(typeof e){case"number":case"string":case"undefined":return!0;case"boolean":return!e;case"object":if(Array.isArray(e))return e.every(f);if(null===e||l(e))return!0;var t=function(e){var t=e&&(s&&e[s]||e["@@iterator"]);if("function"==typeof t)return t}(e);if(!t)return!1;var o,i=t.call(e);if(t!==e.entries){for(;!(o=i.next()).done;)if(!f(o.value))return!1}else for(;!(o=i.next()).done;){var n=o.value;if(n&&!f(n[1]))return!1}return!0;default:return!1}}function v(e){var t=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":function(e,t){return"symbol"===e||!!t&&("Symbol"===t["@@toStringTag"]||"function"==typeof Symbol&&t instanceof Symbol)}(t,e)?"symbol":t}function x(e){if(null==e)return""+e;var t=v(e);if("object"===t){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return t}function b(e){var t=x(e);switch(t){case"array":case"object":return"an "+t;case"boolean":case"date":case"regexp":return"a "+t;default:return t}}return u.prototype=Error.prototype,p.checkPropTypes=n,p.resetWarningCache=n.resetWarningCache,p.PropTypes=p,p},sn}()(vn.isElement,!0)}else Yi.exports=function(){if(mn)return pn;mn=1;var e=An();function t(){}function o(){}return o.resetWarningCache=t,pn=function(){function i(t,o,i,n,r,a){if(a!==e){var l=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw l.name="Invariant Violation",l}}function n(){return i}i.isRequired=i;var r={array:i,bigint:i,bool:i,func:i,number:i,object:i,string:i,symbol:i,any:i,arrayOf:n,element:i,elementType:i,instanceOf:n,node:i,objectOf:n,oneOf:n,oneOfType:n,shape:n,exact:n,checkPropTypes:o,resetWarningCache:t};return r.PropTypes=r,r}}()();var xn=Ki(Yi.exports);function bn(e,t){var o=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);t&&(i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),o.push.apply(o,i)}return o}function wn(e){for(var t=1;t<arguments.length;t++){var o=null!=arguments[t]?arguments[t]:{};t%2?bn(Object(o),!0).forEach((function(t){yn(e,t,o[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(o)):bn(Object(o)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(o,t))}))}return e}function yn(e,t,o){return t in e?Object.defineProperty(e,t,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[t]=o,e}function Cn(){return Cn=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)Object.prototype.hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},Cn.apply(this,arguments)}function En(e,t){if(null==e)return{};var o,i,n=function(e,t){if(null==e)return{};var o,i,n={},r=Object.keys(e);for(i=0;i<r.length;i++)o=r[i],t.indexOf(o)>=0||(n[o]=e[o]);return n}(e,t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);for(i=0;i<r.length;i++)o=r[i],t.indexOf(o)>=0||Object.prototype.propertyIsEnumerable.call(e,o)&&(n[o]=e[o])}return n}var Bn,kn=["className","children","tabIndex"],In=["tabindex"],Nn=n.forwardRef((function(e,t){var o=e.className,i=e.children,r=e.tabIndex,a=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.width,o=e.height,i=e.viewBox,n=void 0===i?"0 0 ".concat(t," ").concat(o):i,r=Li(e,Ui),a=r.tabindex,l=Li(r,qi),d=Ri(Ri(Ri({},Wi),l),{},{width:t,height:o,viewBox:n});return d["aria-label"]||d["aria-labelledby"]||d.title?(d.role="img",null!=a&&(d.focusable="true",d.tabindex=a)):d["aria-hidden"]=!0,d}(wn(wn({},En(e,kn)),{},{tabindex:r})),l=a.tabindex,d=En(a,In);return o&&(d.className=o),null!=l&&(d.tabIndex=l),t&&(d.ref=t),n.createElement("svg",d,i)}));Nn.displayName="Icon",Nn.propTypes={"aria-hidden":xn.string,"aria-label":xn.string,"aria-labelledby":xn.string,children:xn.node,className:xn.string,height:xn.oneOfType([xn.number,xn.string]),preserveAspectRatio:xn.string,tabIndex:xn.string,viewBox:xn.string,width:xn.oneOfType([xn.number,xn.string]),xmlns:xn.string},Nn.defaultProps={xmlns:"http://www.w3.org/2000/svg",preserveAspectRatio:"xMidYMid meet"};var Sn,On,Pn,Qn,zn,Mn,Dn,jn,Tn,Rn,Ln,Un,qn,Wn,Gn,Hn,Fn,Vn,Kn,Jn,Yn,Zn,Xn=["children"],_n=n.forwardRef((function(e,t){var o=e.children,i=En(e,Xn);return n.createElement(Nn,Cn({width:24,height:24,viewBox:"0 0 32 32",xmlns:"http://www.w3.org/2000/svg",fill:"currentColor",ref:t},i),Bn||(Bn=n.createElement("path",{d:"M17 15L17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17 24 15z"})),o)})),$n=["children"],er=n.forwardRef((function(e,t){var o=e.children,i=En(e,$n);return n.createElement(Nn,Cn({width:32,height:32,viewBox:"0 0 32 32",xmlns:"http://www.w3.org/2000/svg",fill:"currentColor",ref:t},i),Sn||(Sn=n.createElement("path",{d:"M18 6L16.57 7.393 24.15 15 4 15 4 17 24.15 17 16.57 24.573 18 26 28 16 18 6z"})),o)})),tr=["children"],or=n.forwardRef((function(e,t){var o=e.children,i=En(e,tr);return n.createElement(Nn,Cn({width:16,height:16,viewBox:"0 0 32 32",xmlns:"http://www.w3.org/2000/svg",fill:"currentColor",ref:t},i),On||(On=n.createElement("path",{d:"M24 12L16 22 8 12z"})),o)})),ir=["children"],nr=["children"],rr=["children"],ar=n.forwardRef((function(e,t){var o=e.children,i=En(e,ir);return n.createElement(Nn,Cn({width:24,height:24,viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg",fill:"currentColor",ref:t},i),Pn||(Pn=n.createElement("path",{d:"M12,1C6,1,1,6,1,12s5,11,11,11s11-4.9,11-11S18.1,1,12,1z M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z"})),Qn||(Qn=n.createElement("path",{fill:"none",d:"M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z","data-icon-path":"inner-path",opacity:"0"})),o)})),lr=n.forwardRef((function(e,t){var o=e.children,i=En(e,nr);return n.createElement(Nn,Cn({width:24,height:24,viewBox:"0 0 32 32",xmlns:"http://www.w3.org/2000/svg",fill:"currentColor",ref:t},i),zn||(zn=n.createElement("path",{d:"M16 22L6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z"})),o)})),dr=n.forwardRef((function(e,t){var o=e.children,i=En(e,rr);return n.createElement(Nn,Cn({width:24,height:24,viewBox:"0 0 32 32",xmlns:"http://www.w3.org/2000/svg",fill:"currentColor",ref:t},i),Mn||(Mn=n.createElement("path",{d:"M16 10L26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z"})),o)})),sr=["children"],cr=["children"],pr=["children"],mr=n.forwardRef((function(e,t){var o=e.children,i=En(e,sr);return n.createElement(Nn,Cn({width:32,height:32,viewBox:"0 0 32 32",xmlns:"http://www.w3.org/2000/svg",fill:"currentColor",ref:t},i),Dn||(Dn=n.createElement("path",{d:"M17.4141 16L24 9.4141 22.5859 8 16 14.5859 9.4143 8 8 9.4141 14.5859 16 8 22.5859 9.4143 24 16 17.4141 22.5859 24 24 22.5859 17.4141 16z"})),o)})),ur=n.forwardRef((function(e,t){var o=e.children,i=En(e,cr);return n.createElement(Nn,Cn({width:24,height:24,viewBox:"0 0 32 32",xmlns:"http://www.w3.org/2000/svg",fill:"currentColor",ref:t},i),jn||(jn=n.createElement("path",{d:"M17.4141 16L24 9.4141 22.5859 8 16 14.5859 9.4143 8 8 9.4141 14.5859 16 8 22.5859 9.4143 24 16 17.4141 22.5859 24 24 22.5859 17.4141 16z"})),o)})),hr=n.forwardRef((function(e,t){var o=e.children,i=En(e,pr);return n.createElement(Nn,Cn({width:24,height:24,viewBox:"0 0 32 32",xmlns:"http://www.w3.org/2000/svg",fill:"currentColor",ref:t},i),Tn||(Tn=n.createElement("path",{d:"M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9\tl5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"})),Rn||(Rn=n.createElement("path",{d:"M14.4 16L9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4 21.4 23 16 17.6 10.6 23 9 21.4 14.4 16","data-icon-path":"inner-path",opacity:"0"})),o)})),gr=["children"],Ar=n.forwardRef((function(e,t){var o=e.children,i=En(e,gr);return n.createElement(Nn,Cn({width:16,height:16,viewBox:"0 0 32 32",xmlns:"http://www.w3.org/2000/svg",fill:"currentColor",ref:t},i),Ln||(Ln=n.createElement("path",{d:"M16,18a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,18Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,10Z"})),Un||(Un=n.createElement("path",{d:"M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,1,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"})),o)})),fr=["children"],vr=n.forwardRef((function(e,t){var o=e.children,i=En(e,fr);return n.createElement(Nn,Cn({width:24,height:24,viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg",fill:"currentColor",ref:t},i),qn||(qn=n.createElement("path",{d:"M12,1C6,1,1,6,1,12s5,11,11,11s11-4.9,11-11S18.1,1,12,1z M16.2,17.5L12,13.3l-4.2,4.2l-1.3-1.3l4.2-4.2L6.5,7.8l1.3-1.3\tl4.2,4.2l4.2-4.2l1.3,1.3L13.3,12l4.2,4.2L16.2,17.5z"})),Wn||(Wn=n.createElement("path",{fill:"none",d:"M16.2,17.5L12,13.3l-4.2,4.2l-1.3-1.3l4.2-4.2L6.5,7.8l1.3-1.3l4.2,4.2l4.2-4.2l1.3,1.3\tL13.3,12l4.2,4.2L16.2,17.5z","data-icon-path":"inner-path",opacity:"0"})),o)})),xr=["children"],br=n.forwardRef((function(e,t){var o=e.children,i=En(e,xr);return n.createElement(Nn,Cn({width:24,height:24,viewBox:"0 0 32 32",xmlns:"http://www.w3.org/2000/svg",fill:"currentColor",ref:t},i),Gn||(Gn=n.createElement("circle",{cx:"10",cy:"28",r:"2"})),Hn||(Hn=n.createElement("circle",{cx:"24",cy:"28",r:"2"})),Fn||(Fn=n.createElement("path",{d:"M28,7H5.82L5,2.8A1,1,0,0,0,4,2H0V4H3.18L7,23.2A1,1,0,0,0,8,24H26V22H8.82L8,18H26a1,1,0,0,0,1-.78l2-9A1,1,0,0,0,28,7Zm-2.8,9H7.62L6.22,9H26.75Z"})),o)})),wr=["children"],yr=n.forwardRef((function(e,t){var o=e.children,i=En(e,wr);return n.createElement(Nn,Cn({width:24,height:24,viewBox:"0 0 32 32",xmlns:"http://www.w3.org/2000/svg",fill:"currentColor",ref:t},i),Vn||(Vn=n.createElement("path",{d:"M8 15H24V17H8z"})),o)})),Cr=["children"],Er=n.forwardRef((function(e,t){var o=e.children,i=En(e,Cr);return n.createElement(Nn,Cn({width:24,height:24,viewBox:"0 0 32 32",xmlns:"http://www.w3.org/2000/svg",fill:"currentColor",ref:t},i),Kn||(Kn=n.createElement("path",{d:"M12 12H14V24H12zM18 12H20V24H18z"})),Jn||(Jn=n.createElement("path",{d:"M4 6V8H6V28a2 2 0 002 2H24a2 2 0 002-2V8h2V6zM8 28V8H24V28zM12 2H20V4H12z"})),o)})),Br=["children"],kr=n.forwardRef((function(e,t){var o=e.children,i=En(e,Br);return n.createElement(Nn,Cn({width:24,height:24,viewBox:"0 0 24 24",xmlns:"http://www.w3.org/2000/svg",fill:"currentColor",ref:t},i),Yn||(Yn=n.createElement("path",{d:"M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11C23,5.9,18.1,1,12,1z M11.1,6h1.8v8h-1.8V6z M12,19.2\tc-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2S12.7,19.2,12,19.2z"})),Zn||(Zn=n.createElement("path",{fill:"none",d:"M13.2,18c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2S13.2,17.3,13.2,18z M12.9,6\th-1.8v8h1.8V6z","data-icon-path":"inner-path",opacity:"0"})),o)}));const Ir=h.div`
  .cardAccordion {
    background-color: transparent;
    box-shadow: none;
  }
`,Nr=h("div")`
  display: flex;
  flex-direction: column;
  overflow-x: ${e=>(null==e?void 0:e.hasOverflow)?"hidden":"unset"};
  overflow-y: ${e=>(null==e?void 0:e.hasOverflow)?(null==e?void 0:e.isExpanded)?"auto":"hidden":"unset"};
  height: 100%;
`,Sr=h("div")`
  cursor: pointer;
  display: flex;
  flex-grow: 1;
  font: 700 1rem/1.45rem ${e=>e.theme.typography.body.short.M.family};
  position: relative;

  .line {
    display: flex;
    flex: 1;
    flex-direction: row;
  }

  .subtitle {
    font-size: 14px;
    font-weight: normal;
    padding-bottom: 30px;
  }
`,Or=h("ol")`
  list-style: none;
  max-height: ${e=>e.isExpanded?"100%":0};
  overflow: ${e=>e.isExpanded?"initial":"hidden"};
`,Pr=h("div")`
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  display: flex;
  align-items: center;
`,Qr=h("div")`
  background-color: ${f.color03};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-radius: 0.25rem;
  border: 1px solid ${f.color07};

  ${({borderVariation:e})=>"shadow"===e&&`box-shadow: 0px 2px 8px ${f.color11};\n      `};
`,zr=({className:t,children:o,borderVariation:i})=>e(Qr,{"data-testid":"card",className:t,borderVariation:i,children:o}),Mr=({header:i,isDefaultExpanded:n,children:a,className:l,subtitle:d,hasOverflow:s=!0})=>{const[c,p]=r(n);return e(Ir,{className:l,children:e(zr,{className:"cardAccordion",children:t(Nr,{isExpanded:c,hasOverflow:s,children:[t(Sr,{"data-testid":"OpenMenu",onClick:()=>{p(!c)},className:"headAccordion",children:[t("div",{className:"line",children:[i,d?e("div",{className:"line subtitle",children:d}):e(o,{})]}),t(Pr,{children:[" ",e(c?dr:lr,{})]})]}),e(Or,{isExpanded:c,children:a})]})})})},Dr=h("div")`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: ${e=>e.isExpanded?"auto":"hidden"};
  height: 100%;
`,jr=h("div")`
  font-size: ${f.fontSize03};
  font-weight: ${f.fontWeight03};
  color: ${f.color10};
  cursor: pointer;
  display: flex;
  flex-grow: 1;
  position: relative;
  align-items: center;
  width: 100%;
  margin-bottom: 17px;
`,Tr=h("ol")`
  list-style: none;
  max-height: ${e=>e.isExpanded?"3000px":0};
  overflow-x: hidden;
  overflow-y: ${e=>e.isExpanded?"auto":"hidden"};
  transition: max-height 200ms ease-in-out;
  width: 100%;
`,Rr=h("div")`
  justify-content: center;
  right: 0;
  display: flex;
  align-items: center;
  max-width: 20px;
  max-height: 20px;
  transition: all 200ms;

  transform: ${e=>e.isExpanded?"rotate(0deg)":"rotate(180deg)"};
`,Lr=({label:i,isDefaultExpanded:n,children:a,className:l})=>{const[d,s]=r(n);return e(o,{children:t(Dr,{isExpanded:d,className:l,children:[t(jr,{"data-testid":"OpenMenu",onClick:()=>{s(!d)},className:"headAccordion",children:[i,e(Rr,{isExpanded:d,children:e(or,{})})]}),e(Tr,{isExpanded:d,children:a})]})})},Ur=h.a`
  cursor: pointer;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 0px;
  border-radius: 30px;
  font-weight: ${f.fontWeight02};

  ${({variant:e})=>"primary"===e&&`\n  background-color: ${f.color01};\n  color: ${f.color03};\n  border: none;\n\n   :hover {\n    background-color: ${f.color01Dark};\n    color: ${f.color03};\n    border: none;\n    }\n\n  &.bx--btn:disabled {\n    background-color: ${f.color08};\n    color: ${f.color09};\n  }\n  `};

  ${({variant:e})=>"secondary"===e&&`\n  background-color: ${f.color03};\n  color: ${f.color01};\n  border: 2px solid ${f.color01};\n\n  :hover {\n    background-color: ${f.color03};\n    color: ${f.color01Dark};\n    border: 2px solid ${f.color01Dark};\n  }\n\n  &.bx--btn:disabled {\n    background-color: ${f.color03};\n    color: ${f.color09};\n  }\n  `};

  ${({variant:e})=>"banner"===e&&`\n  background-color: ${f.color03};\n  color: ${f.color01};\n  border: 2px solid ${f.color01};\n\n  :hover {\n    background-color: ${f.color01Dark};\n    color: ${f.bg03};\n    border: 2px solid ${f.color01Dark};\n  }\n\n  &.bx--btn:disabled {\n    background-color: ${f.color03};\n    color: ${f.color09};\n  }\n  `};

  ${({isDisabled:e})=>e&&`\n      cursor: not-allowed;\n      color: ${f.color09};\n      border-color: ${f.color09};\n      background-color: ${f.color08};\n      :hover{\n        cursor: not-allowed;\n        color: ${f.color09};\n        border-color: ${f.color09};\n        background-color: ${f.color08};\n      }\n  `}

  ${({size:e})=>"small"===e&&"\n      width: 6.25rem;\n      height: 3.12rem;\n  "};

  ${({size:e})=>"medium"===e&&"\n      width: 12.5rem;\n      height: 3.12rem;\n  "};

  ${({size:e})=>"long"===e&&"\n      width: 15.5rem;\n      height: 3.12rem;\n  "};

  ${({size:e})=>"large"===e&&"\n      width: 18.75rem;\n      height: 3.12rem;\n  "};
`,qr=({label:t,title:o,type:i,size:n,disabled:r,variant:a,className:l,onClick:d,alt:s})=>e(Ur,{isDisabled:r,className:l,type:i,variant:a,size:n,onClick:()=>{r||d(!0)},title:o,alt:s,tabIndex:0,children:t}),Wr=h.div`
  position: relative;
  .cardAccordion {
    background-color: #fff;
    padding: 1rem;
  }
`,Gr=h("div")`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: ${e=>e.isExpanded?"auto":"hidden"};
  height: 100%;
`,Hr=h.h2`
  font-size: 22px;
`,Fr=h.p`
  padding-top: 1rem;
  font-size: 14px;

  @media (min-width: 1056px) {
    min-height: 79px;
  }
`,Vr=h.h3`
  font-size: 18px;
  padding-top: 4px;
`,Kr=h(qr)`
  width: 100%;
  height: 33px;
  margin-top: 1rem;
  font-size: 14px;

  ${({disabled:e})=>e&&"\n    background-color: white;\n    color: #BCBDC0;\n    border-color: #BCBDC0;\n\n    :hover {\n      background-color: white;\n      color: #BCBDC0;\n      border-color: #BCBDC0;\n    }\n  "};
`,Jr=h.div`
  right: 1rem;
  top: 18px;
  position: absolute;
  display: flex;
  align-items: center;
`,Yr=h.button`
  background-color: transparent;
  border: none;
  text-align: start;
`,Zr=h("div")`
  max-height: ${e=>e.isExpanded?"100%":0};
  overflow: ${e=>e.isExpanded?"initial":"hidden"};
`,Xr=h.div`
  width: 100%;
  height: 1px;
  background-color: #d9dcdd;
  margin: 1rem 0;
`,_r=({title:o,subtitle:i,className:n,text:a,children:l,titleButton:d,isDisable:s,onClick:c})=>{const[p,m]=r(!1);return e(Wr,{className:n,children:t(zr,{className:"cardAccordion",borderVariation:"shadow",children:[t(Gr,{isExpanded:p,children:[t(Yr,{"data-testid":"OpenMenu",onClick:()=>m(!p),className:"headAccordion",tabIndex:0,"aria-expanded":p,children:[t("div",{className:"line",children:[o&&e(Hr,{children:o}),i&&e(Vr,{children:i})]}),t(Jr,{children:[" ",e(p?x:b,{})]})]}),a&&e(Fr,{children:a}),t(Zr,{isExpanded:p,children:[e(Xr,{}),l]})]}),d&&e(Kr,{title:d,size:"small",alt:d,label:d,variant:"secondary",onClick:c,disabled:s})]})})};var $r,ea,ta,oa,ia,na,ra,aa;function la(){return la=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},la.apply(null,arguments)}const da=e=>i.createElement("svg",la({xmlns:"http://www.w3.org/2000/svg",width:39,height:33.37,"data-name":"Grupo 10757"},e),$r||($r=i.createElement("path",{fill:"none",stroke:"#fff",strokeLinejoin:"round",strokeWidth:2,d:"M7.02 9.899A2.313 2.313 0 0 1 9.1 7.41h20.8a2.313 2.313 0 0 1 2.08 2.489v14.938a2.313 2.313 0 0 1-2.08 2.49H12.22l-5.2 5.043Z","data-name":"Caminho 10230"})),ea||(ea=i.createElement("g",{fill:"none",strokeLinejoin:"round","data-name":"Subtra\\xE7\\xE3o 4"},i.createElement("path",{d:"M19.5 23.742a8.82 8.82 0 0 1-5.516-1.828 5.65 5.65 0 0 1-2.284-4.412h15.6a5.65 5.65 0 0 1-2.285 4.412 8.83 8.83 0 0 1-5.515 1.828"}),i.createElement("path",{fill:"#fff",d:"M19.5 21.742c1.631 0 3.146-.493 4.266-1.39a4.7 4.7 0 0 0 .832-.85H14.402q.34.456.832.85c1.12.897 2.635 1.39 4.266 1.39m0 2c-2.084 0-4.042-.649-5.516-1.828-1.473-1.178-2.284-2.745-2.284-4.412h15.6c0 1.667-.812 3.234-2.285 4.412-1.473 1.179-3.432 1.828-5.515 1.828"}))),ta||(ta=i.createElement("path",{fill:"none",stroke:"#fff",strokeLinejoin:"round",strokeWidth:2,d:"M17.145 14.818a2.34 2.34 0 1 0-4.68 0","data-name":"Caminho 10232"})),oa||(oa=i.createElement("path",{fill:"none",stroke:"#fff",strokeLinejoin:"round",strokeWidth:2,d:"M26.523 14.818a2.34 2.34 0 1 0-4.68 0","data-name":"Caminho 10233"})),ia||(ia=i.createElement("g",{fill:"none",stroke:"#fff",strokeWidth:2,"data-name":"Ret\\xE2ngulo 269",transform:"translate(34 11.5)"},i.createElement("path",{stroke:"none",d:"M0 0h3a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H0z"}),i.createElement("rect",{width:3,height:6,x:1,y:1,rx:1}))),na||(na=i.createElement("g",{fill:"none",stroke:"#fff",strokeWidth:2,"data-name":"Ret\\xE2ngulo 271",transform:"translate(0 11.5)"},i.createElement("path",{stroke:"none",d:"M2 0h3v8H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"}),i.createElement("rect",{width:3,height:6,x:1,y:1,rx:1}))),ra||(ra=i.createElement("path",{fill:"none",stroke:"#fff",strokeWidth:2,d:"M35.1 12.478V3.12","data-name":"Linha 11"})),aa||(aa=i.createElement("g",{fill:"none",stroke:"#fff",strokeWidth:2,"data-name":"Elipse 38",transform:"translate(32.76)"},i.createElement("circle",{cx:2.34,cy:2.34,r:2.34,stroke:"none"}),i.createElement("circle",{cx:2.34,cy:2.34,r:1.34})))),sa=h.div`
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
`,ca=h.div`
  .question,
  .answer {
    font-family: 'Bradesco Sans';
  }

  .cardAccordion {
    background-color: transparent;
    box-shadow: none;
    border: none;
    border-bottom: 1px solid ${f.color07} !important;
  }
`,pa=h("div")`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: ${e=>e.isExpanded?"auto":"hidden"};
  padding: 1rem 1rem 1rem 0;
  height: 100%;
`,ma=h("div")`
  cursor: pointer;
  display: flex;
  flex-grow: 1;
  font: 700 1rem/1.45rem ${e=>e.theme.typography.body.short.M.family};
  position: relative;

  .line {
    display: flex;
    flex: 1;
    flex-direction: row;
  }
  .subtitle {
    font-size: ${f.fontSize02};
    font-weight: ${f.fontWeight02};
    margin-left: -1rem;
  }
  .description {
    font-size: ${f.fontSize01};
  }
`,ua=h("ol")`
  max-height: ${e=>e.isExpanded?"100%":0};
  overflow-x: hidden;
  overflow-y: ${e=>e.isExpanded?"auto":"hidden"};
  transition: max-height 200ms ease-out;
  .answer {
    margin-top: 1rem;
    color: ${f.color09};
    font-size: ${f.fontSize01};
    font-weight: ${f.fontWeight01};
  }

  ul {
    list-style: disc;
    margin-left: 1.2rem;
  }
`,ha=h("div")`
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  margin-right: -20px;
  @media (max-width: 672px) {
    margin-top: -0.4rem;
  }
`,ga=h(qr)`
  width: 148px;
  height: 33px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1.5rem;
`,Aa=h.div`
  position: relative;
  background-color: #0670bf;
  width: 100%;
  display: flex;
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 3px 6px ${f.color11};
  margin-top: 2rem;
  margin-bottom: 2rem;

  .description {
    color: ${f.color03};
    @media (max-width: 672px) {
      p {
        font-size: ${f.fontSize01};
      }
    }
  }
  .assistant {
    font-weight: bold;
    display: inline;
  }

  border-radius: 3px;

  @media (min-width: 1056px) {
    margin-left: auto;
    margin-right: auto;
    flex-wrap: wrap;
  }

  @media (max-width: 1056px) {
    display: flex;
    border-radius: 5px;
    flex-direction: row;
    align-content: space-between;
    align-items: center;
  }
`,fa=h(da)`
  width: 4rem;
`,va=f,xa=h("h4")`
  ${({color:e})=>e==e&&`color: ${va[e]}; `}
  ${({size:e})=>e==e&&`font-size: ${va[e]}; `}
  ${({weight:e})=>e==e&&`font-weight: ${va[e]}; `}
  text-overflow: ellipsis;
  overflow: hidden;
`,ba=({text:t,className:o,color:i,size:n,weight:r})=>e(xa,{"data-testid":"text",color:i,size:n,weight:r,title:t,className:o,dangerouslySetInnerHTML:{__html:t||""}}),wa=({onClick:o,className:i,data:l,showIndex:d,IconToExpand:s,IconToRegread:c,showAssistContainer:p,isExpanded:m,isInMarketPlace:u,hideButton:h=!1,handleTag:g})=>{const[A,f]=r(""),[v,x]=r(m||!1),b=qt(),{width:C}=lt(),[E,B]=r();a((()=>{const e=null==l?void 0:l.map((e=>Object.assign(Object.assign({},e),{isExpanded:!1})));B(e)}),[l]),a((()=>{A?sessionStorage.setItem("lastFaqExpanded",A):sessionStorage.removeItem("lastFaqExpanded")}),[A]);const k=(e,t)=>{((e,t)=>{E&&E[e]&&(E[e].isExpanded=!t.isExpanded,B([...E]),E[e].isExpanded&&f(E[e].pergunta))})(e,t),g?g(t):(e=>{var t,o,i;u?Je.interact(Ye.Click,Je.getActionLocation(),`${null===(i=null===(o=null===(t=e.pergunta.replace("<strong>","").replace("</strong>",""))||void 0===t?void 0:t.toLowerCase())||void 0===o?void 0:o.normalize("NFD"))||void 0===i?void 0:i.replace(/[\u0300-\u036f]/g,"")}`,"consulta",Je.getUserStatus(b),`e-agro${null===location||void 0===location?void 0:location.pathname}`,null,{userId:Je.getUserId(b)}):Je.interact(Ye.Click,Je.getActionLocation(),Je.formattedElementName(e.pergunta),"faq",Je.getUserStatus(b),"e-agro/faq",null,{userId:Je.getUserId(b)})})(t)};return t(sa,{children:[null==E?void 0:E.map(((r,a)=>v||a+1<=5?e(ca,{className:i,onClick:o,children:e(zr,{className:"cardAccordion",children:t(pa,{isExpanded:r.isExpanded,children:[t(ma,{"data-testid":"OpenMenu",onClick:()=>k(a,r),className:"headAccordion",children:[e("div",{className:"line",children:e(ba,{color:"color04",size:C>=1312?"fontSize03":"fontSize02",weight:"fontWeight01",text:`${d?`${a+1} `:""}${r.pergunta}`,className:"question"})}),e(ha,{children:r.isExpanded?e(c||w,{}):e(s||y,{})})]}),e(ua,{isExpanded:r.isExpanded,children:u?e("h4",{className:"answer",dangerouslySetInnerHTML:{__html:r.resposta||""}}):e(ba,{color:"color09",size:"fontSize01",weight:"fontWeight01",text:r.resposta,className:"answer"})})]})})},a):e(n.Fragment,{},a))),!m&&!h&&e(ga,{title:v?"Ver menos":"Ver mais",size:"small",alt:v?"Ver menos":"Ver mais",label:v?"Ver menos":"Ver mais",variant:"secondary",onClick:()=>x(!v)}),p&&t(Aa,{children:[e("div",{className:"description",children:t("p",{children:["Não encontrou o que procurava?",e("br",{}),"Envie sua dúvida para o nosso"," ",e("div",{className:"assistant",children:"assistente virtual."})]})}),e(fa,{})]})]})},ya=h.div`
  .cardAccordion {
    background-color: transparent;
    box-shadow: none;
    border: none;
    border-bottom: 1px solid ${f.color07} !important;
    margin-left: 1rem;
    margin-right: 1rem;
    * {
      font-family: Bradesco Sans;
    }
  }
`,Ca=h("div")`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: ${e=>e.isExpanded?"auto":"hidden"};
  padding: 1rem;
  height: 100%;
`,Ea=h("div")`
  cursor: pointer;
  display: flex;
  flex-grow: 1;
  font: 700 1rem/1.45rem ${e=>e.theme.typography.body.short.M.family};
  position: relative;

  .line {
    display: flex;
    flex: 1;
    flex-direction: row;
  }
  .subtitle {
    font-size: ${f.fontSize02};
    font-weight: ${f.fontWeight02};
    /* padding-bottom: 30px; */
    margin-left: -1rem;
  }
  .description {
    font-size: ${f.fontSize01};
  }
`,Ba=h("ol")`
  max-height: ${e=>e.isExpanded?"100%":0};
  overflow-x: hidden;
  overflow-y: ${e=>e.isExpanded?"auto":"hidden"};
  transition: max-height 200ms ease-out;
  /* margin-left: 1rem; */
  .answer {
    margin-top: 1rem;
  }
  ul {
    list-style: disc;
    margin-left: 1.2rem;
  }
`,ka=h("div")`
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  @media (max-width: 672px) {
    margin-top: -0.4rem;
    margin-right: -20px;
  }
`,Ia=h(qr)`
  width: 292px;
  height: 33px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2rem;
  margin-bottom: 40px;
`;h.div`
  background-color: #0670bf;
  width: 90vw;
  height: 19vh;
  margin-bottom: 40px;
  display: flex;
  .description {
    margin-top: 1rem;
    color: ${f.color03};
    margin-left: 24px;
    padding-bottom: 1rem;
    @media (max-width: 672px) {
      p {
        font-size: ${f.fontSize01};
      }
      margin-left: 15px;
    }
  }
  .assistant {
    display: none;
    @media (min-width: 672px) {
      display: initial;
    }
  }
  border-radius: 5px;
  /* @media (min-width: 672px) {
    width: 50rem;
  } */

  @media (min-width: 1056px) {
    width: 768px;
    height: 89px;
    margin-left: auto;
    margin-right: auto;
    flex-wrap: wrap;
  }

  @media (max-width: 1056px) {
    display: flex;
    border-radius: 5px;
    flex-direction: row;
    align-content: space-between;
    align-items: center;
  }
`,h(da)`
  margin-right: 1rem;

  width: 4rem;
  @media (min-width: 672px) {
    margin-top: 1rem;
    margin-left: 6rem;
    /* margin-left: 3rem; */
  }

  @media (min-width: 1056px) {
  }
`;const Na=({onClick:i,className:n,data:a,onChatRequestClick:l})=>{const[d,s]=r((()=>a.map((e=>Object.assign(Object.assign({},e),{isExpanded:!1})))));return t(o,{children:[null==d?void 0:d.map(((o,r)=>e(ya,{className:n,onClick:i,children:e(zr,{className:"cardAccordion",children:t(Ca,{isExpanded:o.isExpanded,children:[t(Ea,{"data-testid":"OpenMenu",onClick:()=>{d[r].isExpanded=!o.isExpanded,s([...d])},className:"headAccordion",children:[e("div",{className:"line",children:e(ba,{color:"color04",size:"fontSize02",weight:"fontWeight02",text:o.pergunta})}),t(ka,{children:[" ",o.isExpanded?e(C,{}):e(E,{})]})]}),e(Ba,{isExpanded:o.isExpanded,children:e(ba,{color:"color04",size:"fontSize02",weight:"fontWeight01",text:o.resposta,className:"answer"})})]})})},r))),e(Ia,{title:"Fale com nosso assistente virtual",size:"small",alt:"Fale com nosso assistente virtual",label:"Fale com nosso assistente virtual",variant:"secondary",onClick:()=>l&&l()})]})},Sa=h.div`
  @media (max-width: 1055px) {
    display: none;
  }

  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: flex-end;

  height: 3rem;
  width: 100%;

  padding-right: 10%;

  background-color: ${f.color01Dark};
  color: ${f.color03};
  font-size: ${f.fontSize01};

  svg {
    width: 18px;
    height: 18px;
  }

  button {
    width: auto;

    background: transparent;
    border: none;

    :hover,
    :focus {
      background-color: transparent;
      opacity: 0.8;
    }
  }

  .switchColorIcon {
    :hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
`,Oa=h(Ft)`
  background-image: ${v.bg06};
  justify-content: center;
  padding: 0px;
  width: 100%;
  border-radius: 30px;
  font-weight: bold;
  border: none;

  :focus {
    box-shadow: 0 0 0 0;
  }

  &.bx--btn:disabled {
    color: ${v.disabled03};
    font-weight: bold;
  }
`,Pa=({label:t,onClick:o,disabled:i,className:n,href:r,type:a})=>e(Oa,{type:a,onClick:o,disabled:i,className:n,href:r,children:t});var Qa,za;function Ma(){return Ma=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},Ma.apply(null,arguments)}const Da=e=>i.createElement("svg",Ma({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16"},e),Qa||(Qa=i.createElement("defs",null,i.createElement("clipPath",{id:"icon-acessibilidade_svg__a"},i.createElement("path",{fill:"#fff",d:"M12 6.857V5.714H4v1.143h2.857v1.562l-2.21 3.869.992.567L7.76 9.143h.48l2.121 3.712.992-.567-2.21-3.869V6.857ZM8 5.143A1.143 1.143 0 0 0 9.143 4 1.143 1.143 0 0 0 8 2.857 1.143 1.143 0 0 0 6.857 4 1.143 1.143 0 0 0 8 5.143M8 16a8 8 0 0 1-8-8 8 8 0 0 1 8-8 8 8 0 0 1 8 8 8.01 8.01 0 0 1-8 8M8 1.143A6.857 6.857 0 0 0 1.143 8 6.857 6.857 0 0 0 8 14.857 6.857 6.857 0 0 0 14.857 8 6.865 6.865 0 0 0 8 1.143",clipRule:"evenodd","data-name":"Caminho 38408"})))),za||(za=i.createElement("g",{clipPath:"url(#icon-acessibilidade_svg__a)","data-name":"Grupo 80043"},i.createElement("path",{fill:"#fff",d:"M-.762-.762h17.524v17.524H-.762Z","data-name":"Caminho 38407"})))),ja=()=>t(Sa,{children:[e(Da,{}),e("span",{children:"Acessibilidade"}),e(Pa,{label:"A-",onClick:()=>{}}),e(Pa,{label:"A+",onClick:()=>{}}),e(B,{className:"switchColorIcon",onClick:()=>{}})]}),Ta=h("div")`
  h2 {
    background-color: ${v.bg03};
    width: 36px;
    height: 36px;
  }
`,Ra=({className:t})=>e(Ta,{className:t,children:e("h2",{"data-testid":"logo-id"})}),La=h("div")`
  .carbon-button-back {
    margin-top: 20px !important;
    background-color: white;
    color: #a3a3a3;
  }

  .carbon-button-back:hover {
    background-color: white;
    color: #a3a3a3;
  }

  .bx--btn--icon-only .bx--btn__icon {
    width: 30px;
    height: 30px;
    position: inherit;
  }
`,Ua=({className:t,onClick:o,href:i})=>e(La,{className:t,children:e(Ft,{hasIconOnly:!0,href:i,onClick:o,iconDescription:"Voltar",className:"carbon-button-back",renderIcon:k,"data-testid":"back-arrow"})}),qa=h.button`
  display: flex;
  align-items: center;

  padding: 0.5rem;

  border: none;
  border-radius: 50%;
  margin: -0.5rem;

  transition-duration: 0.2s;

  cursor: pointer;

  svg {
    width: 1.5rem;
    height: 1.5rem;

    color: ${f.color10};
  }

  :hover {
    background-color: ${f.bx01};
  }
`,Wa=({className:t,origin:o,title:i,onClick:n})=>{const r=wo();return e(qa,{className:t,onClick:()=>{n?n():o?r.push(o):r.goBack()},title:i,children:e(k,{})})},Ga=h(Ft)`
  color: ${v.color08};
  background-color: transparent;
  min-height: auto;
  padding: 0;
  margin: 24px 0;
  border: none;

  &:hover {
    color: ${v.color08};
    background-color: transparent;
  }

  .bx--btn__icon {
    width: 22.8px;
    height: 28px;
  }

  .bx--btn--icon-only,
  .bx--btn__icon {
    position: inherit;
    left: -2px;
  }
`,Ha=({href:t,className:o,onClick:i})=>e(Ga,{"data-testid":"button-back",hasIconOnly:!0,iconDescription:"Voltar",className:o,renderIcon:k,href:t,onClick:i}),Fa=h.div`
  .buttonEnter {
    .button {
      background: ${v.bg05}
        linear-gradient(90deg, #327cbd 0%, #3aaf9c 100%);
      border-radius: 30px;
      width: 100%;
      height: 43px;
      max-width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
      border: none;
    }

    .button:hover {
      background: ${v.bg01};
      border: 1px solid ${v.border01};
      color: #3aaf9c;
      box-shadow: 0 0 0 0;
    }

    .button:focus {
      box-shadow: none;
    }

    .link {
      text-decoration: none !important;
    }

    @media (min-width: 1056px) {
      .button {
        width: 100%;
        height: 41px;
      }
    }

    @media (min-width: 672px) and (max-width: 1055px) {
      .button {
        width: 100%;
        height: 60px;
      }
    }
  }
`,Va=({children:t,isLoading:o,className:i,onClick:n})=>e(Fa,{children:e("div",{"data-testid":"button-enter",className:"buttonEnter",children:e(Ft,{disabled:o,"data-testid":"button",className:`button ${i}`,type:"submit",onClick:n,children:o?e(Vt,{withOverlay:!1,small:!0}):t})})}),Ka=h("div")`
  display: flex;
  justify-content: center;
`,Ja=h("button")`
  margin: 0 auto;
  padding: 10px;
  align-items: center;
  justify-content: center;
  background-color: ${f.color03};
  color: ${f.color01};
  border: 2px solid ${f.color01};

  :hover {
    cursor: pointer;
    background-color: ${f.color03};
    color: ${f.color01Dark};
    border: 2px solid ${f.color01Dark};
  }
  border-radius: 30px;
  font-weight: ${f.fontWeight02};
  justify-content: center;
  align-items: center;
`,Ya=({text:t,sellerPlan:o})=>{const i=qt(),n=()=>{Je.interact(Ye.Click,Je.getActionLocation(),"voltar-ao-topo",o?"dados-vendedor":"produtos",Je.getUserStatus(i),`e-agro${null===location||void 0===location?void 0:location.pathname}`,null,{userId:Je.getUserId(i)}),window.scrollTo({top:0,behavior:"smooth"})};return e(Ka,{children:e(Ja,{onClick:()=>n(),children:null!=t?t:"Voltar ao topo"})})},Za=h("button")`
  border: 0px;
  cursor: ${e=>e.isIconAddToCartAvailable?"pointer":"default"};
  color: ${e=>e.isIconAddToCartAvailable?f.bg01:f.color08};
`,Xa=e=>{location.href=e},_a=({className:t,icon:o,pageToRedirect:i})=>e(Za,{className:t,onClick:()=>Xa(i),children:e(o,{})}),$a=({className:t,Icon:o,onEventClick:i,isIconAddToCartAvailable:n})=>e(Za,{className:t,onClick:e=>i(e),isIconAddToCartAvailable:n,children:o}),el=h(Kt)`
  color: ${f.color01};
  font-size: ${f.fontSize01};
  font-weight: ${f.fontWeight02};
  background: none;
  border: none;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    color: ${f.color01Dark};
  }

  ${e=>!0===(null==e?void 0:e.disabled)&&"\n    pointer-events: none;\n  "}
`,tl=({label:t,onClick:i,href:n,className:r,title:a,target:l,disabled:d=!1})=>e(el,{onClick:i,href:n,className:r,title:a,target:l,disabled:d,children:e(o,{children:t})}),ol=h.a`
  color: ${f.color01};
  font-size: ${f.fontSize01};
  font-weight: ${f.fontWeight02};
  background: none;
  border: none;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: ${f.color01Dark};
  }
`,il=({label:t,onClick:o,href:i,className:n,title:r,Icon:a,target:l})=>e(ol,{onClick:o,href:i,className:n,title:r,target:l,children:t||e(a,{})}),nl=h.div`
  display: flex;
  align-items: center;
  color: ${f.color04};

  ${({isActive:e})=>e&&`\n      color: ${f.color02};\n      fill:  ${f.color02};\n  `}
`,rl=h(Kt)`
  margin-left: 1rem;

  font-size: ${f.fontSize01};
  font-weight: ${f.fontWeight01};
  background: none;
  border: none;

  cursor: pointer;

  color: ${f.color04};

  &.bx--link:visited {
    color: ${f.color04};
  }

  ${({isActive:e})=>e&&`\n    font-weight: ${f.fontWeight03};\n    color:  ${f.color02};\n    &.bx--link:visited {\n      color:  ${f.color02};\n    };\n  `}

  :hover {
    text-decoration: none;
    opacity: 0.8;
  }
`,al=({label:o,onClick:i,href:n,className:r,icon:a,hasNews:l,title:d,isActive:s})=>t(nl,{isActive:s,children:[a,e(rl,{isActive:s,onClick:i,href:n,className:r,title:d,children:o}),l&&e(Ft,{children:"Novo!"})]}),ll=h("div")`
  .icon-button {
    padding: 0;
    background: ${v.infoColor};
    border-radius: 23px;
    color: ${v.color04};
    width: 145px;
    display: flex;
    justify-content: flex-start;
    font-weight: 600;
    font-size: ${v.fontSize02};
    border: none;
    outline: none;
    box-shadow: 0 0 0 0;
    min-height: auto;
    height: 32px;
  }

  .icon-arrow {
    width: 24px;
    height: 24px;
    margin-left: 5px;
    margin-right: 8px;
    box-shadow: 0 0 0 0;
  }

  .icon-arrow:focus {
    box-shadow: none;
  }

  .link-button {
    text-decoration: none;
  }
`,dl=({url:o,label:i,onClick:n,className:r})=>e(ll,{className:r,onClick:n,"data-testid":"button-icon-id",children:e(Kt,{href:o,"data-testid":"link-id",className:"link-button",children:t(Ft,{className:"icon-button",children:[e(I,{className:"icon-arrow"}),i]})})}),sl=({items:t,className:o})=>e(Jt,{name:o,labelPosition:"right",orientation:"vertical",className:o,children:null==t?void 0:t.map((t=>e(Yt,{labelText:t.label,className:`button-${o}`},t.label)))}),cl=h(Ft)`
  justify-content: center;
  width: 100%;
  padding: 0px;
  border-radius: 30px;
  margin-top: 10px;
  font-weight: ${f.fontWeight02};

  ${({variant:e})=>"primary"===e&&`\n  background-color: ${f.color01};\n  color: ${f.color03};\n  border: none;\n\n  :hover {\n    background-color: ${f.color01Dark};\n    color: ${f.color03};\n    border: none;\n  }\n\n  &.bx--btn:disabled {\n    background-color: ${f.color08};\n    color: ${f.color09};\n  }\n  `};

  ${({variant:e})=>"secondary"===e&&`\n  background-color: ${f.color03};\n  color: ${f.color01};\n  border: 2px solid ${f.color01};\n\n  :hover {\n    background-color: ${f.color03};\n    color: ${f.color01Dark};\n    border: 2px solid ${f.color01Dark};\n  }\n\n  &.bx--btn:disabled {\n    background-color: ${f.color03};\n    color: ${f.color09};\n    border: 2px solid ${f.color08};\n  }\n  `};

  ${({variant:e})=>"advisor"===e&&`\n  background-color: ${f.color26};\n  color: ${f.color01};\n  border: 2px solid ${f.color01};\n  width: 202px;\n\n  :hover {\n    background-color: ${f.color03};\n    color: ${f.color01Dark};\n    border: 2px solid ${f.color01Dark};\n  }\n\n  &.bx--btn:disabled {\n    background-color: ${f.color03};\n    color: ${f.color09};\n    border: 2px solid ${f.color08};\n  }\n  `};

  ${({size:e})=>"small"===e&&"\n      width: 6.25rem;\n      height: 3.12rem;\n  "};

  ${({size:e})=>"medium"===e&&"\n      width: 12.5rem;\n      height: 3.12rem;\n  "};

  ${({size:e})=>"long"===e&&"\n      width: 15.5rem;\n      height: 3.12rem;\n  "};

  ${({size:e})=>"large"===e&&"\n      width: 18.75rem;\n      height: 3.12rem;\n  "};
`,pl=({label:e,type:o,size:i,disabled:n,variant:r,className:a,onClick:l,alt:d,title:s,children:c})=>t(cl,{className:a,type:o,variant:r,size:i,disabled:n,onClick:l,alt:d,title:s,children:[e,c]}),ml=h.div`
  div {
    display: flex;
    justify-content: space-between;
    width: 310px;

    @media (max-width: 800px) {
      width: 238px;
    }
  }

  .button-radio {
    padding: 8px 10px 10px 11px;
    text-align: center;
    background-color: ${v.bg01};
    border: 1px solid ${v.borderActive};
    min-height: 0px;
    min-width: 0px;
    width: 95px;
    height: 35px;
    border-radius: 10px;
    font-size: ${v.fontSize02};

    @media (max-width: 800px) {
      padding: 8px 0px 10px 0px;
      width: 75px;
    }
  }

  .bx--tile--is-selected {
    background-color: ${v.bg02};
    color: ${v.color04};
    border: 0px;
  }

  .bx--tile--is-selected .bx--tile__checkmark svg,
  .bx--tile__checkmark svg {
    display: none;
  }
`;h(Zt)``;const ul=({items:t,className:o})=>e(ml,{"data-testid":"button-select",children:e(Xt,{defaultSelected:"default-selected",name:"radio tile group",children:null==t?void 0:t.map((t=>e(Zt,{value:t.value,className:`button-radio ${o}`,id:t.id,children:t.label},t.id)))})}),hl=h(Ft)`
  background-color: transparent;
  border: 1px solid ${f.color03};
  color: ${f.color03};
  justify-content: center;
  padding: 0px;
  width: 100%;
  border-radius: 30px;
  font-weight: bold;

  &:hover {
    background-color: transparent;
    border: 1px solid ${f.color03};
    color: ${f.color03};
  }
`,gl=({label:t,onClick:o,className:i,href:n,alt:r,title:a})=>e(hl,{href:n,onClick:o,className:i,alt:r,title:a,children:t}),Al=h.section`
  .bx--checkbox-label::before {
    border-width: 2px;
    border-radius: 6px;
    border-color: ${v.border02};
  }

  .bx--checkbox:checked + .bx--checkbox-label::before {
    border-color: ${v.border01};
    background-color: ${v.bg02};
  }
`,fl=({id:t,labelText:o,className:i,onChange:n,checked:r,required:a,classWrapper:l,disabled:d,name:s})=>e(Al,{className:l,children:e(_t,{id:t,labelText:o,className:i,onChange:n,name:s,checked:r,required:a,disabled:d})}),vl=h.div`
  .bx--radio-button,
  .bx--radio-button:checked {
    & + .bx--radio-button__label {
      .bx--radio-button__appearance {
        border-color: #0c881e;

        &::before {
          background-color: #0c881e;
        }
      }
    }
  }
`,xl=({orientation:t,items:o,className:i,onChange:n,valueSelected:r})=>e(vl,{className:i,children:e($t,{legendText:"",children:e(Jt,{defaultSelected:"default-selected",name:"radio-button",labelPosition:"right",orientation:t,onChange:n,valueSelected:r,children:null==o?void 0:o.map((t=>e(Yt,{value:t.value,labelText:t.label,id:t.key},t.key)))})})}),bl=h(eo)`
  .bx--toggle-input:checked
    + .bx--toggle-input__label
    > .bx--toggle__switch::before {
    background-color: ${v.bg03};
    box-shadow: none;
  }

  .bx--toggle-input + .bx--toggle-input__label > .bx--toggle__switch::before {
    box-shadow: none;
  }
`,wl=({labelA:t,labelB:o,className:i,toggled:n,onClick:r})=>e(bl,{className:i,labelA:t,labelB:o,toggled:n,onClick:r});const yl=h("div")`
  width: 100%;

  .borderContainer {
    box-shadow: 0px 2px 8px #22222229;

    border-radius: 8px;
    opacity: 1;
    margin-bottom: 24px;
  }

  .borderColor {
    border: 1px solid #cccccc;
  }
  .borderColorChecked {
    border: 1px solid #3ab19f;
  }

  .cardContainer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 14px;
  }

  .containerBankInfo {
    display: flex;
  }

  .bankImg[id='Banco do Brasil S.A.'] {
    background-image: url(${"data:image/png;base64,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"});
  }

  .bankImg[id='Banco Itau S.A.'] {
    background-image: url(${"data:image/png;base64,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"});
  }

  .bankImg[id='Caixa Economica Federal'] {
    background-image: url(${"data:image/png;base64,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"});
  }

  .bankImg[id='Banco Bradesco S.A.'] {
    background-image: url(${"data:image/png;base64,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"});
  }

  .bankImg[id='Banco Santander S.A.'] {
    background-image: url(${"data:image/png;base64,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"});
  }

  .bankImg {
    background-size: cover;
    width: 32px;
    height: 32px;
    border-radius: 100%;
    padding-right: 16.5px;
  }

  .containerBankAccount {
    display: flex;
    flex-direction: column;
    padding-left: 16.5px;
  }

  .bankTitle {
    font-size: 14px;
    font-weight: regular;
    color: #767676;
  }

  .agencyAccount {
    font-size: 16px;
    font-weight: bold;
    color: #000000;
  }

  .bx--radio-button {
    width: 18px;
    height: 18px;
  }

  .radionButtonCustom span:before {
    background-color: #3ab19f !important;
  }

  .bx--radio-button:checked
    + .bx--radio-button__label
    .bx--radio-button__appearance {
    border-color: #3ab19f;
  }

  .delimiter {
    width: 95%;
    margin: auto;
    background: #cccccc;
    height: 1px;
    border: 0;
  }

  .selectedPhrase {
    font-size: 14px;
    font-weight: regular;
    color: #767676;
    padding-top: 14px;
    padding-left: 16.5px;
    padding-bottom: 15px;
  }
`,Cl=({accountInfo:i,onChange:n,isChecked:r,cardIndex:a,isPrincipal:d})=>{const s=l((()=>r?"borderColorChecked":"borderColor"),[r]);return i.index=a,e(yl,{children:t("div",{className:`borderContainer ${s}`,children:[t("div",{className:"cardContainer",children:[t("div",{className:"containerBankInfo",children:[e("span",{className:"bankImg",id:i.bank}),t("div",{className:"containerBankAccount",children:[e("span",{className:"bankTitle",children:i.bank}),t("span",{className:"agencyAccount",children:["Ag ",i.agency," - Cc ",i.account]})]})]}),e(Yt,{checked:r,value:a,name:"radioButtonCardInfo",className:"radionButtonCustom",onChange:e=>n(e)})]}),d&&t(o,{children:[e("hr",{className:"delimiter"}),e("div",{className:"selectedPhrase",children:e("span",{children:"Essa conta foi a que você escolheu para receber o crédito"})})]})]})})},El=({listAccount:t,onChangeAccount:i})=>{const[n,a]=r(),l=e=>{a(parseInt(e)),i&&i(t.find((t=>t.index===e)))};return e(o,{children:t.map((t=>e(Cl,{accountInfo:t,isPrincipal:t.isPrincipal,cardIndex:t.index.toString(),isChecked:n?t.index===n:t.isPrincipal,onChange:l},t.account)))})},Bl=h("div")`
  background-image: ${e=>`url(${e.img})`};
  background-repeat: no-repeat;
  background-size: contain;
  display: flex;
  height: 100%;
  padding-top: 100%;

  @media (max-width: 671px) {
    background-size: cover;
    padding-top: 70%;
  }
`,kl=h("div")``,Il=h("div")`
  display: flex;

  @media (max-width: 671px) {
    display: flex;
    flex-direction: column-reverse;
  }

  ${e=>Eo(e,"isImageRight").isFalsy().then(g`
        @media (max-width: 671px) {
          display: flex;
          flex-direction: column;
        }
      `)}

  .card-image {
    width: 40%;
    ${e=>Eo(e,"isImageRight").isTruthy().then(g`
          order: 2;
          padding-right: 0;
        `)}

    ${e=>Eo(e,"isImageRight").isFalsy().then(g`
          padding-right: 0;
          ${Bl} {
            background-position: right;
          }
        `)}

        > div {
      margin-left: 24%;
    }
  }

  .card-content {
    width: 60%;
    ${e=>Eo(e,"isImageRight").isTruthy().then(g`
          order: 1;
          padding-right: 0;

          ${kl} {
            text-align: left;
          }
        `)}

    ${e=>Eo(e,"isImageRight").isFalsy().then(g`
          padding-left: 0;
        `)}
  }

  @media (min-width: 672px) {
    .img-mobile {
      display: none;
    }
  }

  @media (max-width: 671px) {
    .img-desktop {
      display: none;
    }

    .card-image {
      > div {
        margin-left: 0;
      }
    }
  }
`,Nl=({className:o,children:i,img:n,imgMobile:r,isImageRight:a})=>t(Il,{"data-testid":"card-content-id",className:o,isImageRight:a,children:[t("div",{className:"card-image",children:[e("div",{className:"img-desktop",children:n&&e(Bl,{img:n})}),e("div",{className:"img-mobile",children:r&&e(Bl,{img:r})})]}),e("div",{className:"card-content",children:e(kl,{children:i})})]}),Sl=h.div`
  .cardAccordion {
    background-color: transparent;
    box-shadow: none;
  }
`,Ol=h("div")`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: ${e=>e.isExpanded?"auto":"hidden"};
  padding: 1rem 1rem 0 1rem;
  height: 100%;
`,Pl=h("div")`
  cursor: pointer;
  display: flex;
  flex-grow: 1;
  font: 700 1rem/1.45rem ${e=>e.theme.typography.body.short.M.family};
  position: relative;

  .line {
    display: flex;
    flex: 1;
    flex-direction: column;
    padding-right: 15px;
  }

  .subtitle {
    font-size: 14px;
    font-weight: normal;
    padding-bottom: 30px;
    margin-top: 15px;
    width: 90%;
  }
  .description {
    font-size: ${f.fontSize01};
  }
`,Ql=h("ol")`
  list-style: none;
  max-height: ${e=>e.isExpanded?"100%":0};
  overflow-x: hidden;
  overflow-y: ${e=>e.isExpanded?"auto":"hidden"};
  transition: max-height 200ms ease-out;
`,zl=h("div")`
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
`,Ml=({label:i,onClick:n,isDefaultExpanded:a,children:l,className:d,classExpander:s,subtitle:c,description:p,onExpanded:m})=>{const[u,h]=r(a);return e(Sl,{className:d,onClick:n,children:e(zr,{className:"cardAccordion",children:t(Ol,{isExpanded:u,className:s,children:[t(Pl,{"data-testid":"OpenMenu",onClick:()=>{h(!u),m&&m(!u)},className:"headAccordion",children:[t("div",{className:"line",children:[i,c?e("div",{className:"line subtitle",children:c}):e(o,{}),p?e("div",{className:"line description",children:p}):e(o,{})]}),t(zl,{children:[" ",e(u?dr:lr,{})]})]}),e(Ql,{isExpanded:u,children:l})]})})})},Dl=h.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;

  box-sizing: border-box;
  height: 350px;
  width: 230px;
  padding: 15px;
  margin-top: -150px;

  // UI Properties
  background: ${v.bg01} 0% 0% no-repeat padding-box;
  border-radius: 20px;
  box-shadow: 0px 3px 6px ${v.color06};
  opacity: 1;

  > div {
    margin-bottom: 10px;
  }
`,jl=h.p`
  font-weight: bold;
  font-size: normal normal bold 16px/20px;

  // UI Properties
  color: ${v.color03};
  text-align: left;
  opacity: 1;
  margin-bottom: 8px;
`,Tl=h.p`
  // UI Properties
  text-align: left;
  font-size: ${v.fontSize02};
  letter-spacing: 0px;
  color: ${v.color03};
  opacity: 1;
  margin: 0px;
`,Rl=h.a`
  display: flex;
  margin-top: 10px;
  justify-content: left;
  align-items: center;
  width: 100%;
  cursor: pointer;

  p {
    text-align: left;
    margin: 0;

    // UI Properties
    text-align: left;
    letter-spacing: 0px;
    font-weight: bold;
    color: ${v.color01};
    opacity: 1;
    margin-right: 10px;
  }

  svg {
    color: ${v.color01};
  }
`;h.img`
  height: 85px;
  width: 85px;
  background: ${v.bg05} 0% 0% no-repeat padding-box;
`;const Ll=({title:o,description:i,className:n,children:r})=>t(Dl,{className:n,children:[r,e(jl,{children:o}),e(Tl,{children:i}),t(Rl,{children:[e("p",{children:"Saiba mais"}),e(N,{})]})]}),Ul=h("div")`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-radius: 0.25rem;
  border: 1px solid ${f.color07};

  .card-radio-container {
    display: flex;
    padding: 0.875rem 1rem;
    gap: 1.5rem;
    flex-direction: ${({title:e})=>(null==e?void 0:e.length)?"column":"row"};

    .radio-content {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .text-content {
      display: flex;
      flex-direction: column;
      gap: 14px;
    }
  }

  .color-green {
    color: ${f.color01};
  }
  .icon {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 999px;
    transition-duration: 200ms;
  }
`,ql=({className:o,title:i,children:n,isSelected:r,onClick:a})=>e(Ul,{isSelected:r,onClick:a,title:i,children:e(zr,{className:o,borderVariation:"shadow",children:t("div",{className:"card-radio-container",children:[t("div",{className:"radio-content",children:[e(r?S:O,{className:"color-green icon"}),e(ba,{text:i,color:"color04",size:"fontSize01",weight:"fontWeight02",className:"card-title"})]}),e("div",{className:"text-content",children:n})]})})}),Wl=h("div")`
  .slider {
    .slick-dots > .slick-active {
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
      background-color: ${v.bg02};
    }

    .slick-dots > li {
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
      background-color: ${v.bg07};
    }

    .slick-next,
    .slick-prev {
      color: ${v.color04};

      ${({arrowColor:e})=>e&&`\n        color:${e};\n      `};
    }
  }
  .slick-loading .slick-list {
    background: #fff url('../assets/loader.gif') center center no-repeat;
  }

  /* Arrows */
  .slick-prev,
  .slick-next {
    font-size: 0;
    line-height: 0;

    position: absolute;
    top: 50%;

    display: block;

    width: 20px;
    height: 20px;
    padding: 0;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);

    cursor: pointer;

    color: ${v.color12};
    border: none;
    outline: none;
    background: ${v.bg05};
  }
  .slick-prev:hover,
  .slick-prev:focus,
  .slick-next:hover,
  .slick-next:focus {
    color: ${v.color12};
    outline: none;
    background: ${v.bg05};
  }
  .slick-prev:hover:before,
  .slick-prev:focus:before,
  .slick-next:hover:before,
  .slick-next:focus:before {
    opacity: 1;
  }
  .slick-prev.slick-disabled:before,
  .slick-next.slick-disabled:before {
    opacity: 0.25;
  }

  .slick-prev:before,
  .slick-next:before {
    font-family: 'slick';
    font-size: ${v.fontSize06};
    line-height: 1;

    opacity: 0.75;
    color: ${v.color04};

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .slick-prev {
    left: -25px;
  }
  [dir='rtl'] .slick-prev {
    right: -25px;
    left: auto;
  }
  .slick-prev:before {
    content: '←';
  }
  [dir='rtl'] .slick-prev:before {
    content: '→';
  }

  .slick-next {
    right: -25px;
  }
  [dir='rtl'] .slick-next {
    right: auto;
    left: -25px;
  }
  .slick-next:before {
    content: '→';
  }
  [dir='rtl'] .slick-next:before {
    content: '←';
  }

  /* Dots */
  .slick-dotted.slick-slider {
    margin-bottom: 30px;
  }

  .slick-dots {
    position: absolute;
    bottom: -25px;

    display: ${({displayDots:e})=>e||"block"};

    width: 100%;
    padding: 0;
    margin: 0;

    list-style: none;

    text-align: center;
  }
  .slick-dots li {
    position: relative;

    display: inline-block;

    width: 20px;
    height: 20px;
    margin: 0 5px;
    padding: 0;

    cursor: pointer;
  }
  .slick-dots li button {
    font-size: 0;
    line-height: 0;

    display: block;

    width: 20px;
    height: 20px;
    padding: 5px;

    cursor: pointer;

    color: transparent;
    border: 0;
    outline: none;
    background: ${v.bg05};
  }
  .slick-dots li button:hover,
  .slick-dots li button:focus {
    outline: none;
  }
  .slick-dots li button:hover:before,
  .slick-dots li button:focus:before {
    opacity: 1;
  }
  .slick-dots li button:before {
    font-family: 'slick';
    font-size: 6px;
    line-height: 20px;

    position: absolute;
    top: 0;
    left: 0;

    width: 20px;
    height: 20px;

    content: '•';
    text-align: center;

    opacity: 0.25;
    color: transparent;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .slick-dots li.slick-active button:before {
    opacity: 0.75;
    color: transparent;
  }

  /* Slider */
  .slick-slider {
    position: relative;

    display: block;
    box-sizing: border-box;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: ${v.color12};
  }

  .slick-list {
    position: relative;

    display: block;
    overflow: hidden;

    margin: 0;
    padding: 0;
  }
  .slick-list:focus {
    outline: none;
  }
  .slick-list.dragging {
    cursor: pointer;
    cursor: hand;
  }

  .slick-slider .slick-track,
  .slick-slider .slick-list {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  .slick-track {
    position: relative;
    top: 0;
    left: 0;

    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .slick-track:before,
  .slick-track:after {
    display: table;

    content: '';
  }
  .slick-track:after {
    clear: both;
  }
  .slick-loading .slick-track {
    visibility: hidden;
  }

  .slick-slide {
    display: none;
    float: left;

    height: 100%;
    min-height: 1px;
  }
  [dir='rtl'] .slick-slide {
    float: right;
  }
  .slick-slide img {
    display: block;
  }
  .slick-slide.slick-loading img {
    display: none;
  }
  .slick-slide.dragging img {
    pointer-events: none;
  }
  .slick-initialized .slick-slide {
    display: block;
  }
  .slick-loading .slick-slide {
    visibility: hidden;
  }
  .slick-vertical .slick-slide {
    display: block;

    height: auto;

    border: 1px solid ${v.color12};
  }
  .slick-arrow.slick-hidden {
    display: none;
  }
`,Gl={dots:!0,infinite:!0,speed:500,slidesToShow:1,slidesToScroll:1,nextArrow:e(Q,{}),prevArrow:e(P,{})};var Hl;!function(e){e[e.Empty=0]="Empty",e[e.Prev=1]="Prev",e[e.Next=2]="Next"}(Hl||(Hl={}));const Fl=({className:t,settings:o,children:i,size:n,arrowColor:r,slideDirection:l,displayDots:s})=>{const c=d();return a((()=>{var e,t;if(l)switch(l){case Hl.Prev:null===(e=null==c?void 0:c.current)||void 0===e||e.slickPrev();break;case Hl.Next:null===(t=null==c?void 0:c.current)||void 0===t||t.slickNext()}}),[l,c]),e(Wl,{id:"CardSlider",className:t,size:n,arrowColor:r,"datatest-id":"cardSlider-test",displayDots:s,children:e(Oo,Object.assign({},o||Gl,{className:"slider",ref:c,children:i}))})};function Vl(e){switch(e){case"info":return{light:f.colorInfoLight,default:f.colorInfo};case"error":return{light:f.colorErrorLight,default:f.colorError};case"success":return{light:f.colorSuccessLight,default:f.colorSuccess};case"warning":return{light:f.colorWarningLight,default:f.colorWarning};default:return{light:f.color06,default:f.color08}}}const Kl=h.div`
  display: flex;
  flex-direction: row;
  align-items: start;

  ${({status:e,type:t})=>"card"===t&&g`
      background-color: ${Vl(e).light};
      border: 1px solid ${f.color07};
      border-left: 4px solid ${Vl(e).default};
    `}

  padding:  ${({type:e})=>"text"===e?"1rem 0rem":"1rem 1rem 1rem 0.5rem"};

  font-size: 0.875rem;
  line-height: 1rem;
  border-radius: 4px;

  ._Link_Button {
    font-size: 0.875rem;
    width: fit-content;
  }

  ._Link_Button:hover {
    text-decoration: underline;
  }

  ._Status_Icon {
    min-width: 1rem;
    margin-right: 1rem;
    color: ${({status:e})=>Vl(e).default};
  }

  ._Status_Text_Box {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    word-wrap: break-word;
  }

  ._Status_Text_Title {
    font-weight: ${f.fontWeight03};
    color: ${f.color04};
    font-size: 0.875rem;
    line-height: 1rem;
    margin-bottom: 1rem;
  }
  ._Status_Text_Subtitle {
    font-weight: ${f.fontWeight01};
    font-size: 0.875rem;
    color: ${f.color09};
    white-space: pre-wrap;

    span {
      text-decoration: underline;
      cursor: pointer;
      :hover {
        transition: 0.2s;
        color: ${f.color10};
      }
    }
  }

  a {
    margin-top: 1rem;
    text-decoration: none;
    color: #0c881e;
    font-weight: bold;
    font-size: 1rem;
  }
`;function Jl(e,t){var o={};for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&t.indexOf(i)<0&&(o[i]=e[i]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(i=Object.getOwnPropertySymbols(e);n<i.length;n++)t.indexOf(i[n])<0&&Object.prototype.propertyIsEnumerable.call(e,i[n])&&(o[i[n]]=e[i[n]])}return o}function Yl(e,t,o,i){return new(o||(o=Promise))((function(n,r){function a(e){try{d(i.next(e))}catch(e){r(e)}}function l(e){try{d(i.throw(e))}catch(e){r(e)}}function d(e){var t;e.done?n(e.value):(t=e.value,t instanceof o?t:new o((function(e){e(t)}))).then(a,l)}d((i=i.apply(e,t||[])).next())}))}"function"==typeof SuppressedError&&SuppressedError;const Zl=h.a`
  text-decoration: none;
  cursor: pointer;
  appearance: none;

  ${e=>!0===(null==e?void 0:e.disabled)&&"\n    pointer-events: none;\n  "}
`,Xl=t=>{var{children:o}=t,i=Jl(t,["children"]);return e(Zl,Object.assign({dangerouslySetInnerHTML:i.dangerouslySetInnerHTML,className:i.class},i,{children:o}))},_l=({status:t})=>{switch(t){case"info":return e(j,{className:"_Status_Icon"});case"warning":return e(D,{className:"_Status_Icon"});case"success":return e(M,{className:"_Status_Icon"});case"error":return e(z,{className:"_Status_Icon"});default:return null}},$l=({type:i="card",title:n,description:r,status:a,className:l,buttonText:d,hasLinkButton:s=!0,noStatusIcon:c=!1,onClickButton:p})=>t(Kl,{type:i,status:a,className:l,children:[c?e(o,{}):e(_l,{status:a}),t("div",{className:"_Status_Text_Box",children:[n&&e("p",{className:"_Status_Text_Title",children:n}),r&&e("p",{className:"_Status_Text_Subtitle",children:r}),s&&d&&e(Xl,{className:"_Link_Button",alt:d,title:d,onClick:p,children:d})]})]}),ed=h("div")`
  background-color: ${f.bg07};
  border: 1px solid ${f.color07};
  border-left: 4px solid ${f.bg08};
  padding: 16px 16px 16px 12px;
  border-radius: 4px;
  box-shadow: none;
  width: 100%;
  text-align: left;
  display: flex;
  flex-direction: row;

  .icon-container {
    padding-right: 16px;
  }

  .info-icon {
    color: ${f.colorInfo};
  }

  .column {
    display: flex;
    flex-direction: column;
  }

  .card-title {
    margin-bottom: 9px;
  }
`,td=h("div")`
  color: ${f.color09};
  font-size: ${f.fontSize01};
  line-height: ${f.lineHeight01};
`,od=({children:i,cardTitle:n,cardText:r,className:a})=>t(ed,{"data-testid":"info-card",className:a,children:[e("div",{className:"icon-container",children:e(j,{"data-testid":"icon",className:"info-icon"})}),n?t("div",{className:"column",children:[e(ba,{text:n,color:"color04",size:"fontSize01",weight:"fontWeight02",className:"card-title"}),i,e(td,{children:r})]}):t(o,{children:[i,e(td,{children:r})]})]}),id=h("div")`
  background-color: transparent;
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: row;

  .infoIcon {
    color: ${f.colorWarning};
    padding-top: -2px;
    width: 1rem;
    height: 1rem;
  }

  .success {
    color: ${f.colorSuccess};
  }
`,nd=h("div")`
  font-size: ${f.fontSize01};
  color: ${f.color09};
  padding-left: 8px;
`,rd=({text:o,icon:i,className:n})=>t(id,{"data-testid":"info-text",children:[e("div",{"data-testid":"icon",className:`infoIcon ${n}`,children:i}),e(nd,{children:o})]}),ad=h("div")`
  background-color: ${f.bg09};
  border: 1px solid ${f.color07};
  border-left: 4px solid ${f.colorWarning};
  padding: 16px 16px 16px 12px;
  border-radius: 4px;
  box-shadow: none;
  width: 100%;
  text-align: left;
  display: flex;
  flex-direction: row;

  .icon-container {
    padding-right: 16px;
  }

  .info-icon {
    color: ${f.colorWarning};
  }

  .column {
    display: flex;
    flex-direction: column;
  }

  .card-title {
    margin-bottom: 0.3rem;
  }
`,ld=h("div")`
  color: ${f.color09};
  font-size: ${f.fontSize01};
  line-height: ${f.lineHeight01};
`,dd=({cardTitle:o,cardText:i,className:n})=>t(ad,{"data-testid":"info-card",className:n,children:[e("div",{className:"icon-container",children:e(D,{"data-testid":"icon",className:"info-icon"})}),o?t("div",{className:"column",children:[e(ba,{text:o,color:"color04",size:"fontSize01",weight:"fontWeight02",className:"card-title"}),e(ld,{children:i})]}):e(ld,{children:i})]}),sd=h.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;

  width: 100%;

  margin: 1rem 0 1.5rem;
  padding: 1rem;

  border: 1px solid ${f.color16};
  border-radius: 4px;
`,cd=h.label`
  padding: 0.25rem 0.5rem;

  background: ${f.color20};
  border-radius: 4px;

  font-size: ${f.fontSize07};
  font-weight: ${f.fontWeight03};
  color: ${f.color03};
`,pd=h.p`
  font-size: ${f.fontSize02};
  line-height: ${f.lineHeight02};
`,md=h(pd)`
  font-weight: ${f.fontWeight03};
  color: ${f.color04};
`,ud=h(pd)`
  margin-top: 0.25rem;

  color: ${f.color09};
`,hd=({className:o,orderNumber:i,modality:n,value:r,product:a,variety:l})=>t(sd,{className:o,children:[t(cd,{children:["Contrato ",i]}),t("div",{children:[t(md,{children:[n,a?` - ${a}${l?` (${l})`:""}`:""]}),e(ud,{children:Ze(r)})]})]}),gd=h("div")`
  ${({sender:e})=>"me"===e&&" display: flex;\n        justify-content: flex-end;\n        flex-direction: column;\n        align-items: flex-end;"}

  .balloon-time {
    font-size: 10px;
    color: #a7a8ac;
    margin-top: 8px;

    ${({sender:e})=>"me"===e&&"   max-width: 75%;\n            display: flex;\n            justify-content: flex-end;"}
    ${({sender:e})=>"other"===e&&"   max-width: 75%;\n            display: flex;\n            justify-content: flex-start;"}
  }

  .balloon-text {
    margin-top: 1rem;
    overflow-wrap: break-word;

    ${({sender:e})=>"me"===e&&`   background: #0C881E;\n            color: ${v.color04};\n            font-size: 14px;\n            padding: 8px;\n            max-width: 75%;\n            justify-content: flex-end;\n            flex-direction: column;\n            align-items: flex-end;\n            box-shadow: 0px 2px 8px #00000029;\n            border-radius: 8px 8px 0px 8px;`}
    ${({sender:e})=>"other"===e&&`   background: ${v.bg01};\n            color: #47484C;\n            padding: 8px;\n            font-size: 14px;\n            max-width: 75%;\n            justify-content: flex-start;\n            box-shadow: 0px 2px 8px #00000029;\n            border-radius: 8px 8px 8px 0px;\n            `}

        ${({useFitWidth:e})=>e&&"\n            width: fit-content;\n        "}

        //código funcional apenas no firefox
        @-moz-document url-prefix() {
      li {
        margin-left: 0.75rem;
      }
    }
  }
`,Ad=h.div``,fd=h.span``,vd=({message:o,link:i,time:n,sender:r,useFitWidth:a,onLinkClick:l})=>t(gd,{"data-testid":"balloon-text-id",sender:r,useFitWidth:a,children:[i?t(Ad,{className:"balloon-text",children:["Clique"," ",e("a",{href:i,onClick:l,children:"aqui"})," ","para acessar"]}):e(Ad,"me"===r?{className:"balloon-text",children:o}:{className:"balloon-text",dangerouslySetInnerHTML:{__html:o||""}}),e(fd,{className:"balloon-time",children:n})]}),xd=h.div`
  box-shadow: ${f.color10};

  .mainContainer {
    max-width: 75%;
    height: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-radius: 8px 8px 8px 0px;
    box-shadow: 0px 2px 8px ${f.color11};
    background: ${f.bg03};
    margin-top: 8px;
  }

  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 10px;
    width: 100%;

    .dropdown-container {
      width: 100%;
      padding: 0 8px 8px 8px;
    }

    .bx--list-box__label {
      color: ${f.color08};
    }
  }

  h1 {
    font-size: 14px;
    color: ${f.color04};
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 8px 8px 8px;
    word-break: break-word;
  }

  hr {
    box-sizing: border-box;
    width: 100%;
    border-color: #fcfcfc6e;
  }

  .listRow {
    :hover {
      cursor: pointer;
    }
  }

  .listRow:last-child {
    border-bottom: none;
  }

  .bx--structured-list-td {
    padding: 0 !important;
    word-break: break-word;
  }

  .bx--structured-list-row {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2rem;
    box-sizing: border-box;
    width: 100%;

    span {
      font-size: 14px;
    }
  }

  .bx--structured-list {
    margin-bottom: 0;
  }

  .listWrapper {
    width: 100%;
  }

  .iconLabelOption {
    color: ${f.color01};
    font-size: 14px;
  }

  .balloon-time {
    font-size: 10px;
    color: ${f.color08};
    margin: 8px 16px;
  }
`,bd=h("div")`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  position: relative;

  width: 100%;
  width: 300px;

  label {
    font-size: ${f.fontSize01};
    font-weight: ${f.fontWeight01};
  }

  .bx--dropdown {
    border-bottom: none;
  }

  .bx--list-box__menu {
    width: 95%;
    left: 8px;
  }

  .bx--list-box__menu-item__option {
    margin: 0;
    padding-left: 1rem;
  }

  .bx--list-box__label {
    color: ${f.color08};
    ${({isSelected:e})=>e&&`color: ${f.color04}; `}
  }

  .bx--list-box__field {
    padding: 0 1rem;
    outline: none;
    border: 1px solid ${f.color08};
    font-size: ${f.fontSize01};
    background-color: ${f.color03};
    border-radius: 0.5rem;
    width: 100%;
    height: 2.5rem;
    padding-right: 40px;
    display: flex;
    align-items: center;

    span {
      flex: 1;
      text-align: left;
    }

    &:focus {
      border: 2px solid ${f.color02};
    }

    ${({error:e})=>e&&`border: 2px solid ${f.colorError}; `}
  }

  .error {
    font-size: ${f.fontSize01};
    font-weight: ${f.fontWeight01};
    color: ${f.colorError};
  }

  .errorIcon {
    width: 1rem;
    height: 1rem;

    text-align: center;
    border-radius: 50%;
    color: ${f.color03};
    background-color: ${f.colorError};

    position: absolute;
    top: 2.25rem;
    right: 2.75rem;
  }

  .bx--list-box__menu {
    :focus {
      outline: 2px solid transparent !important;
      outline-offset: 2px !important;
    }

    background-color: ${f.color03};
  }

  ${({disabled:e})=>e&&`\n    label {\n      color: ${f.color08};\n    }\n\n    input, input:focus {\n      border: 1px solid ${f.color07};\n      color: ${f.color07};\n    }\n  `}
`,wd=({title:i,label:n,items:l,onChange:d,onBlur:s,hasError:c,errorMsg:p,direction:m,className:u,isDisabled:h,selectedItem:g})=>{const A=e=>{var t,o;const i=l.filter((t=>(null==t?void 0:t.value)?(null==t?void 0:t.label)===e:t));return(null===(t=i[0])||void 0===t?void 0:t.value)?null===(o=i[0])||void 0===o?void 0:o.value:i[0]},[f,v]=r(g||"");a((()=>{v(null!=g?g:"")}),[g]);return t(bd,{className:u,error:c,disabled:h,isSelected:null!=f,id:"div-dropdown-component",children:[n&&e("span",{children:i}),l&&e(to,{id:"dropdown-component",label:n,items:l.map((e=>(null==e?void 0:e.label)?e.label:e)),onChange:e=>{e=Object.assign(Object.assign({},e),{value:A(e.selectedItem)}),d&&d(e),v(e.value)},onBlur:e=>s&&s(Object.assign(Object.assign({},e),{value:A(e.selectedItem)})),selectedItem:f,direction:m}),c&&t(o,{children:[e("span",{className:"error",children:p}),e("span",{className:"errorIcon","data-testid":"errorIcon",children:"!"})]})]})},yd=({message:i,onSelect:n,onChange:a})=>{const[l,d]=r(),s=i.options?i.options:[],c=void 0!==l;return t(xd,{"data-testid":"baloon-options-id",children:[e("div",{className:"mainContainer",children:t("div",{className:"container",children:[i.title&&e("h1",{dangerouslySetInnerHTML:{__html:i.title||""}}),e("hr",{}),e("div",{className:"listWrapper",children:s.length<=5?null==s?void 0:s.map(((i,r)=>e(o,{children:e(oo,{tabIndex:0,className:"listRow",children:t(io,{className:"iconLabelOption",onClick:()=>(e=>{c||(d(e),n(s[e]))})(r),children:[" ",e("span",{dangerouslySetInnerHTML:{__html:i.label||""}})]},i.value)})}))):e(wd,{className:"dropdown-container",label:"Selecione uma opção",items:s,onChange:a,direction:"top"})})]})}),e("div",{className:"balloon-time",children:(p=i.time,[p.getHours(),p.getMinutes()].map((function(e){return e<10?"0"+e:e})).join(":"))})]});var p},Cd=h.div`
  .header {
    display: flex;
    align-items: center;
    height: 60px;
    background-color: #0c881e;
    border-radius: 8px 8px 0 0;
  }

  .textContainer {
    flex-direction: column;
    flex: 0.95;
  }

  h1,
  h2 {
    font-size: 14px;
    color: #ffffff;
    margin-left: 8px;
  }

  h1 {
    font-weight: bold;
  }

  .iconAvatar {
    margin-left: 12px;
  }

  .iconClose {
    fill: #ffffff;
    width: 24px;
    height: 24px;
  }
`;var Ed,Bd;function kd(){return kd=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},kd.apply(null,arguments)}const Id=e=>i.createElement("svg",kd({xmlns:"http://www.w3.org/2000/svg",width:32,height:32},e),Ed||(Ed=i.createElement("defs",null,i.createElement("clipPath",{id:"avatar_svg__a"},i.createElement("path",{fill:"#fff",d:"M16 32A16 16 0 0 1 4.686 4.686a16.005 16.005 0 0 1 26.329 16.855 6 6 0 0 0-8.073 8.879A15.85 15.85 0 0 1 16 32"})))),Bd||(Bd=i.createElement("g",null,i.createElement("circle",{cx:4,cy:4,r:4,fill:"#5cc85f",transform:"translate(23 22)"}),i.createElement("path",{fill:"#fff",d:"M16 32A16 16 0 0 1 4.686 4.686a16.005 16.005 0 0 1 26.329 16.855 6 6 0 0 0-8.073 8.879A15.85 15.85 0 0 1 16 32","data-name":"avatar"}),i.createElement("g",{clipPath:"url(#avatar_svg__a)","data-name":"logo"},i.createElement("path",{fill:"#5cc75e",d:"M5.038 15.875v.124a10.96 10.96 0 0 0 10.958 10.962v-.125A10.96 10.96 0 0 0 5.038 15.875","data-name":"Caminho 39918"}),i.createElement("path",{fill:"#5cc75e",d:"M26.962 16v-.124a10.96 10.96 0 0 0-10.958 10.961v.124A10.96 10.96 0 0 0 26.962 16","data-name":"Caminho 39919"}),i.createElement("path",{fill:"#e5ba00",d:"M15.999 9.403a6.6 6.6 0 0 0-6.014 3.886l1.989.9a4.414 4.414 0 0 1 8.049 0l1.989-.9a6.6 6.6 0 0 0-6.014-3.886","data-name":"Caminho 39920"}),i.createElement("path",{fill:"#e5ba00",d:"M15.999 13.77a2.23 2.23 0 0 0-2.034 1.316l2.034.917 2.034-.917a2.23 2.23 0 0 0-2.034-1.316","data-name":"Caminho 39921"}),i.createElement("path",{fill:"#008aeb",d:"M16 5.038a10.96 10.96 0 0 0-9.993 6.458l1.989.9a8.779 8.779 0 0 1 16.007 0l1.989-.9A10.96 10.96 0 0 0 16 5.038","data-name":"Caminho 39922"}))))),Nd=({className:o,onClick:i})=>e(Cd,{className:o,"data-testid":"header-id",children:t("div",{className:"header",children:[e(Id,{className:"iconAvatar"}),t("div",{className:"textContainer",children:[e("h1",{children:"e-agro"}),e("h2",{children:"Assistente Virtual"})]}),e(T,{className:"iconClose",onClick:i})]})}),Sd=h.div`
  display: flex;
  background: #f0f0f0;
  padding-bottom: 1rem;

  flex-direction: column;

  .ipt-container {
    display: flex;
    align-items: center;
    width: 90%;
    height: 40px;
    margin: 0 1rem;
    padding: 0px 5px 0px 16px;
    border: 1px solid #a7a8ac;
    background: ${f.color03};
    border-radius: 8px;

    ${({focused:e})=>e&&`border: 2px solid ${f.color02};`}

    ${({hasErrorInput:e})=>e&&g`
        border: 1px solid red;
      `}

    .ipt-message {
      width: 100%;
      border: none;
      outline: none;
      background: ${f.color03};
    }

    .icon-message {
      cursor: pointer;
    }
  }
`;h.div`
  display: grid;
  align-items: center;
  justify-content: center;
  padding: 8px 8px 8px 15px;
  cursor: pointer;
`;const Od=h.p`
  font-size: 12px !important;
  margin: 0 1rem;
`;var Pd;function Qd(){return Qd=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},Qd.apply(null,arguments)}const zd=e=>i.createElement("svg",Qd({xmlns:"http://www.w3.org/2000/svg",width:24,height:24,"data-name":"Actions / Operations / send--alt / 16"},e),Pd||(Pd=i.createElement("path",{fill:"#a7a8ac",d:"M14.25 20.999a.75.75 0 0 1-.675-.472l-2.88-7.2-7.199-2.88a.75.75 0 0 1 0-1.4l16.5-6a.8.8 0 0 1 .258-.048.74.74 0 0 1 .528.219.75.75 0 0 1 .158.787l-6 16.5a.745.745 0 0 1-.69.494m.443-12.749 1.056 1.056-3.592 3.593 2.093 5.25 4.748-13.15L5.85 9.75l5.221 2.122 3.62-3.621Z"})));var Md;function Dd(){return Dd=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},Dd.apply(null,arguments)}const jd=e=>i.createElement("svg",Dd({xmlns:"http://www.w3.org/2000/svg",width:24,height:24,"data-name":"Actions / Operations / send--alt / 16"},e),Md||(Md=i.createElement("path",{fill:"#0c881e",d:"M14.25 20.999a.75.75 0 0 1-.675-.472l-2.88-7.2-7.199-2.88a.75.75 0 0 1 0-1.4l16.5-6a.8.8 0 0 1 .258-.048.74.74 0 0 1 .528.219.75.75 0 0 1 .158.787l-6 16.5a.745.745 0 0 1-.69.494m.443-12.749 1.056 1.056-3.592 3.593 2.093 5.25 4.748-13.15L5.85 9.75l5.221 2.122 3.62-3.621Z"}))),Td=({onSend:o,className:i})=>{const[n,a]=r(!1),[l,d]=r(!1),[s,c]=r(""),p=()=>{/^[a-zA-Z0-9\s.,áéíóúãõâêîôûàèìòùäëïöüçñÁÉÍÓÚÃÕÂÊÎÔÛÀÈÌÒÙÄËÏÖÜÇÑ!?@]*$/.test(s)?(o(s),d(!1)):d(!0),c("")};return t(Sd,{"data-testid":"input-message-id",focused:n,hasErrorInput:l,className:i,children:[t("div",{className:"ipt-container",children:[e("input",{className:"ipt-message",type:"text",placeholder:"Digite sua mensagem aqui",value:s,onFocus:()=>a(!0),onBlur:()=>a(!1),onKeyDown:e=>{"Enter"===e.key&&(p(),a(!1))},maxLength:130,onChange:e=>{c(e.target.value),a(!0)}}),e("div",{className:"icon-message",onClick:p,children:e(n?jd:zd,{})})]}),l&&e(Od,{children:"A mensagem contém caracteres inválidos"})]})},Rd=h.div`
  .chatbot-icon {
    cursor: pointer;
  }

  &.icon-container {
    position: fixed;
    z-index: 1;
    bottom: 0;
    right: 0;
    margin-bottom: 48px;
    display: flex;
    justify-content: end;
    margin-right: 17.5% !important;

    @media (max-width: 1583px) {
      margin-right: 9% !important;
    }
  }

  &.chat-container {
    position: fixed;
    right: 0;
    bottom: 0 !important;
    z-index: 9999;

    @media (max-width: 671px) {
      inset: 0;

      .scroll-view {
        width: 100%;
        height: 100%;
      }
    }
  }
`,Ld=h.div`
  b {
    font-weight: bold;
  }

  height: 100%;
  width: 100%;
  max-height: 100dvh;

  display: flex;
  flex-direction: column;

  .visibleChat {
    display: flex;
  }

  .hiddenChat {
    display: none;
  }

  .scroll-view {
    overflow-y: auto;
    text-align: left;
    background-color: #f0f0f0;
    height: 400px;
    width: 400px;
    padding: 1rem;
    overscroll-behavior: contain;

    .messages-wrap {
      width: 100%;
      min-height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }
  }

  .loading {
    stroke: #07cc57;
  }
`,Ud=h.div`
  .toolTipText {
    visibility: hidden;
    width: 13rem;
    background-color: white;
    font-size: 14px;
    color: #075512;
    text-align: center;
    border-radius: 6px;
    padding: 0.4rem;
    position: absolute;
    z-index: 5;
    margin-left: -9.5rem;
    bottom: 4rem;
    border-color: #0c881e;
    border: 2px solid #0c881e;
  }

  .toolTipText:after {
    content: '';
    position: absolute;
    top: 100%;
    border-width: 5px;
    border-style: solid;
    border-color: #0c881e transparent transparent transparent;
  }

  .visible {
    visibility: visible !important;
  }
`,qd=h.div``,Wd=Qo(process.env.CONVERSATION_API||"",{transports:["websocket"],rememberUpgrade:!0,autoConnect:!0}),Gd="portal",Hd=({isVisible:i,isHumanChatByDefault:l,onStartHumanChat:d,onClick:s})=>{var c;const{location:p}=wo(),[m,u]=r(!1),[h,g]=r(!0),[A,f]=r(!0),[v,x]=r(!1),[b,w]=r([]),[y,C]=r({}),E=n.useRef(""),B=n.useRef(null),k=qt(),I=dt(),N=st(),S=ct();function O(e,t){var o,i,{options:n=[]}=e,r=Jl(e,["options"]);const a=`${null!==(o=r.title)&&void 0!==o?o:""}\n${n.map(((e,t)=>`${t+1}. ${e.label}`)).join("\n")}`,l=r.link?"Clique aqui para acessar":"options"===r.sender?a:null!==(i=r.text)&&void 0!==i?i:"";return{position:t,timestamp:r.time.getTime(),from:{me:"client",other:"attendant",options:"attendant"}[r.sender],message:l,link:r.link,options:n,title:r.title}}function P(e){var t;const o=(null===(t=e.options)||void 0===t?void 0:t.length)?"options":{client:"me",attendant:"other"}[e.from];return{id:Po(),sender:o,time:new Date(e.timestamp),text:e.message,link:e.link,options:e.options,title:e.title}}const Q=e=>{var t;const o=Object.assign({},JSON.parse(JSON.stringify(null!=e?e:{})),{originPage:p.pathname,channel:Gd});return null===(t=o.plataforma)||void 0===t||delete t.callToAction,JSON.stringify(o)},z=e=>{((e,t)=>{"loginAth"===e.loggedIn&&(e.loggedIn="ath");const o={context:e,messages:t};sessionStorage.setItem("chatHistoric",JSON.stringify(o))})(y,b),window.location.href=e},M=(e,t)=>{w((o=>[...o,{id:Po(),text:e,time:new Date,sender:t}]))},D=(e,t)=>{w((o=>[...o,{id:Po(),title:e,time:new Date,sender:"options",options:t}]))},j=()=>{setTimeout((()=>{sessionStorage.removeItem("chatHistoric"),x(!1),C({}),g(!0)}),50)};let T=0;const R=(...e)=>Yl(void 0,[...e],void 0,(function*(e=500){return new Promise((t=>setTimeout((()=>t()),e)))})),L=(e,t,o)=>Yl(void 0,void 0,void 0,(function*(){var i,n,r,{messagesHistoric:a=[]}=o,l=Jl(o,["messagesHistoric"]);const d=a.map(((e,t)=>O(e,t+1)));if(l.enterQueue){let o=!1;try{const{data:e}=yield S.getBusinessHours();o=(null===(i=null==e?void 0:e.getBusinessHours)||void 0===i?void 0:i.isHoliday)||!((e,t)=>{if(!e||!t)return!1;const[o,i]=e.split(":"),[n,r]=t.split(":"),a=new Date,l=new Date,d=new Date;return l.setHours(Number(o)),l.setMinutes(Number(i)),d.setHours(Number(n)),d.setMinutes(Number(r)),a>=l&&a<=d})(null===(n=null==e?void 0:e.getBusinessHours)||void 0===n?void 0:n.from,null===(r=null==e?void 0:e.getBusinessHours)||void 0===r?void 0:r.to)}catch(e){o=!0}if(o){return["Ah, entendi que você quer falar com um atendente.","Porém, a disponibilidade é de segunda a sexta-feira, das 9h às 17h50, exceto em feriados nacionais."].forEach((e=>M(e,"other"))),x(!0),yield R(100),void x(!1)}Wd.emit("enterQueue",{conversationId:e,transferLabel:t,clientData:l.clientData})}l.userId&&(R(),Wd.emit("messageHistory",{userId:l.userId,conversationId:e,messages:d})),l.showPosition&&(R(),Wd.emit("positionClient",{conversationId:e,transferLabel:t})),x(!0)}));a((()=>{const e=y.conversation_id;e&&Wd.emit("join",e)}),[y.conversation_id]);const U=e=>{var t,o,i;const n=JSON.parse(null!==(t=e.context)&&void 0!==t?t:"{}"),r=Array.from(null!==(o=e.responses)&&void 0!==o?o:[]),a=r[r.length-1],l=(null===(i=null==a?void 0:a.options)||void 0===i?void 0:i.length)>0;if(l&&r.pop(),r.forEach((e=>{var t;(null===(t=null==e?void 0:e.options)||void 0===t?void 0:t.length)?D(null==e?void 0:e.title,null==e?void 0:e.options):(null==e?void 0:e.text)?M(null==e?void 0:e.text,"other"):M(null==e?void 0:e.description,"other")})),e.callToActionURI){const t=`/${e.callToActionURI}`;d=t,w((e=>[...e,{id:Po(),link:d,time:new Date,sender:"other"}]))}var d;l&&D(null==a?void 0:a.title,null==a?void 0:a.options),n.derivatedHumanChat&&w((e=>{var t;return L(n.conversation_id,n.callReason,{showPosition:!0,messagesHistoric:e,userId:null===(t=k.user)||void 0===t?void 0:t.sub}),e})),C(n)},q=(e,t)=>{u(!0),I.getAskQuestion(e,t).then((e=>{var t;U(null===(t=e.data)||void 0===t?void 0:t.askQuestion)})).catch((()=>{})).finally((()=>{u(!1)}))},W=(e=!1)=>{const t=((e,t)=>{var o,i,n,r,a;const l=sessionStorage.getItem("chatHistoric"),d=null!==(o=sessionStorage.getItem("lastFaqExpanded"))&&void 0!==o?o:void 0;sessionStorage.removeItem("chatHistoric"),sessionStorage.removeItem("lastFaqExpanded");const s=JSON.parse(null!=l?l:"{}");return"ath"!==(null===(i=s.context)||void 0===i?void 0:i.loggedIn)||t||(s.context.loggedIn="loginAth"),{context:Object.assign({},JSON.parse(JSON.stringify(null!==(n=s.context)&&void 0!==n?n:{})),{channel:Gd,originPage:e,plataforma:{perguntaAnterior:d}}),messages:null!==(a=null===(r=null==s?void 0:s.messages)||void 0===r?void 0:r.map((e=>Object.assign(Object.assign({},e),{time:new Date(e.time)}))))&&void 0!==a?a:[]}})(p.pathname,e);t.messages.length&&w(t.messages),t.messages.length&&"ath"!==t.context.loggedIn||q("",Q(t.context)),C(t.context)};return a((()=>{i&&b.length&&B.current&&B.current.scroll({top:B.current.scrollHeight})}),[i,b]),a((()=>{v&&(null==d||d())}),[v]),a((()=>{A&&v&&(Wd.on("position",(e=>{M(e.messagePosition.message,"other")})),Wd.off("newMessage").on("newMessage",(({payload:e})=>{M(e.message,{client:"me",attendant:"other"}[e.from])})),Wd.off("protocol").on("protocol",(({messageProtocol:e})=>{E.current=e.message})),Wd.off("endedShift").on("endedShift",(({messageShift:e})=>{M(e.message,"other"),j()})),Wd.off("endedQueue").on("endedQueue",(({messageEndedQueue:e})=>{M(e.message,"other"),j()})),Wd.off("connect_error").once("connect_error",(e=>{if(console.error(`Erro de conexão: ${null==e?void 0:e.message}`),T<3)T++,setTimeout((()=>{Wd.connect()}),5e3);else{const e=["Desculpe fazê-lo esperar. Porém, neste momento, estamos com indisponibilidade e não conseguimos prosseguir com o seu atendimento.\n            Para otimizar seu tempo, recomendamos que entre em contato em um outro momento.\n            Nosso horário de atendimento é de segunda a sexta-feira, das 9h às 17h50, exceto feriados nacionais."];M(E.current?E.current:e,"other")}})),Wd.on("requestFeedback",(e=>{Wd.emit("leave",e.conversationId),j()})),f(!1))}),[A,v]),a((()=>{var e,t,o;if(i)if(h||v)(null===(e=k.user)||void 0===e?void 0:e.sub)?Wd.emit("getHistoric",{userId:k.user.sub},(e=>{var t;if(null==e?void 0:e.conversationId){const o=(null!==(t=e.messages)&&void 0!==t?t:[]).map((e=>JSON.parse(e))).sort(((e,t)=>{var o,i,n,r;return(null!==(o=e.position)&&void 0!==o?o:0)>(null!==(i=t.position)&&void 0!==i?i:0)?1:(null!==(n=e.position)&&void 0!==n?n:0)<(null!==(r=t.position)&&void 0!==r?r:0)?-1:0})).map(P);x(!0),w(o),C((t=>Object.assign(Object.assign({},t),{conversation_id:e.conversationId})))}else l||(x(!1),W(!0));g(!1)})):(W(!1),g(!1));else if(l&&!h&&!v&&(null===(t=k.user)||void 0===t?void 0:t.sub)&&(null===(o=N.data)||void 0===o?void 0:o.getProfile)){const{fullName:e,email:t,phone:o,cpf:i}=N.data.getProfile;L(Po(),"Dúvida geral",{enterQueue:!0,showPosition:!0,userId:k.user.sub,clientData:{name:e,email:t,phone:o,cpf:i},messagesHistoric:[...b,{id:Po(),text:"Vou te encaminhar para um atendente. Não se preocupe, vamos te avisar assim que o atendimento começar.",time:new Date,sender:"other"}]})}}),[i,null===(c=k.user)||void 0===c?void 0:c.sub,N.data,l,h,v]),i?t(Ld,{children:[e(Nd,{onClick:s}),e("div",{className:"scroll-view",ref:B,children:t("div",{className:"messages-wrap",children:[b.map((t=>{return"options"===t.sender?e(yd,{message:t,onSelect:e=>!v&&(e=>{const t=Q(y);M(e.label,"me"),q(e.value,t)})(e),onChange:e=>!v&&(e=>{const t=Q(y);M(e.selectedItem,"me"),q(e.value,t)})(e)},t.id):e(vd,{message:t.text,link:t.link,time:(o=t.time,[o.getHours(),o.getMinutes()].map((function(e){return e<10?"0"+e:e})).join(":")),sender:t.sender,onLinkClick:e=>{var o;e.preventDefault(),z(null!==(o=t.link)&&void 0!==o?o:"")}},t.id);var o})),m&&e(vd,{message:"...",sender:"other",useFitWidth:!0})]})}),e(Td,{className:"ipt-msg",onSend:e=>{if(e.trim())if(v)((e,t)=>{const o={id:Po(),text:e,time:new Date,sender:"me"},i=O(o);w((e=>[...e,o])),Wd.emit("sendMessage",{conversationId:t,payload:i})})(e,y.conversation_id);else{const t=Q(y);q(e,t),M(e,"me")}}})]}):e(o,{})};var Fd;function Vd(){return Vd=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},Vd.apply(null,arguments)}const Kd=e=>i.createElement("svg",Vd({xmlns:"http://www.w3.org/2000/svg",width:50,height:49},e),Fd||(Fd=i.createElement("g",{"data-name":"Grupo 86574",transform:"translate(19056 -3105)"},i.createElement("rect",{width:50,height:49,fill:"#0c881e","data-name":"Ret\\xE2ngulo 16096",rx:8,transform:"translate(-19056 3105)"}),i.createElement("g",{fill:"#fff","data-name":"Grupo 86366"},i.createElement("path",{d:"m-19029.264 3143-1.736-1 4-7h6a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-20a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9v2h-9a4 4 0 0 1-4-4v-12a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4h-4.835Z","data-name":"Caminho 10582"}),i.createElement("path",{d:"M-19038.997 3123h15.997v2h-15.997z","data-name":"Ret\\xE2ngulo 2092"}),i.createElement("path",{d:"M-19038.997 3129h9.997v2h-9.997z","data-name":"Ret\\xE2ngulo 2093"}))))),Jd=({chatVisibility:i,isHumanChatByDefault:n,onStartHumanChat:l,onChangeVisibility:d})=>{const[c,p]=r(!1),m=qt(),u=s(null);a((()=>{void 0!==i&&p(i)}),[i]),a((()=>{c&&(Je.overrideFirebaseScreenClass("assistante-virtual"),Je.pageview(Ye.PageView,"chatbot",Je.getUserStatus(m),"e-agro/chatbot",Je.getActionLocation(),null,{userId:Je.getUserId(m)}))}),[c]);const h=()=>{Je.overrideFirebaseScreenClass("home"),Je.interact(Ye.Click,Je.getActionLocation(),c?Ye.Close:Ye.Open,"chatbot",Je.getUserStatus(m),"e-agro/chatbot",null,{userId:Je.getUserId(m)}),d&&d(!c),p(!c)};return t(Rd,{className:c?"chat-container":"icon-container",children:[e(Hd,{onClick:h,onStartHumanChat:l,isVisible:c,isHumanChatByDefault:n}),!c&&e(o,{children:t(Ud,{className:"toolTip",onMouseEnter:()=>{var e;null===(e=null==u?void 0:u.current)||void 0===e||e.classList.add("visible")},onMouseLeave:()=>{var e;null===(e=null==u?void 0:u.current)||void 0===e||e.classList.remove("visible")},children:[e(Kd,{className:"chatbot-icon",onClick:h}),t(qd,{className:"toolTipText",ref:u,children:["Olá! Sou o assistente e-agro."," ",e("strong",{children:"Como posso te ajudar?"})]})]})})]})},Yd=h.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  width: 100%;

  padding: 1rem;

  border-radius: 4px;
  background-color: ${f.bg02};
  box-shadow: 0px 2px 8px ${f.bx01};

  p,
  .highlight {
    color: ${f.color03};
    font-size: ${f.fontSize01};
    line-height: ${f.lineHeight01};
  }

  .highlight {
    font-weight: bold;
  }

  .action {
    text-decoration: underline;
    cursor: pointer;
  }

  @media (max-width: 672px) {
    padding: 1rem;
  }
`,Zd=h(da)`
  width: 2.5rem;
  min-width: 2.5rem;
`,Xd=({className:o,title:i="Não encontrou o que procurava?",description:n="Envie sua dúvida para o nosso [[link]]",link:r="assistente virtual",onClick:a})=>t(Yd,{className:o,children:[t("div",{children:[e("p",{children:i}),e("p",{children:Xe(n,{link:e("span",{className:"highlight"+(a?" action":""),onClick:a,children:r})})})]}),e(Zd,{})]}),_d=h.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  width: 100%;

  padding: 1rem;

  background: ${f.bg03};
  box-shadow: 0px 2px 8px ${f.bx01};
  border-radius: 8px;

  svg {
    color: ${f.color20};
  }
`,$d=h.h5`
  margin-bottom: 0.75rem;

  color: ${f.color04};
  font-size: ${f.fontSize02};
  line-height: ${f.lineHeight02};
`,es=h.p`
  max-width: 17rem;

  color: ${f.color04};
  font-size: ${f.fontSize01};
  line-height: ${f.lineHeight01};
`,ts=h.span`
  color: ${f.color01};
  font-size: ${f.fontSize01};
  line-height: ${f.lineHeight01};
  font-weight: ${f.fontWeight03};

  cursor: pointer;
`,os=({title:o,message:i,link:n,onLinkClick:r})=>t(_d,{children:[e(R,{}),t("div",{children:[e($d,{children:o}),e(es,{children:Xe(i,{link:e(ts,{onClick:r,children:n})})})]})]}),is=h("div")`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  position: relative;

  width: 100%;

  label {
    font-size: ${f.fontSize01};
    font-weight: ${f.fontWeight01};
  }

  input {
    padding: 0 1rem;
    outline: none;
    border: 1px solid ${f.color08};
    font-size: ${f.fontSize01};
    background-color: transparent;
    color: ${f.color08};
    border-radius: 0.5rem;
    width: 100%;
    height: 2.5rem;

    z-index: 2;

    &:focus {
      border: 2px solid ${f.color02};
    }

    &::-webkit-calendar-picker-indicator {
      background: transparent;
    }

    ${({hasValue:e})=>e&&`color: ${f.color04}; `}

    ${({error:e})=>e&&`border: 2px solid ${f.colorError}; `}
  }

  @media (max-width: 672px) {
    @supports selector(:nth-child(1 of x)) {
      input[type='date'] {
        font-size: 14px;
        padding: 0 1.75rem 0 0.25rem;
      }
    }
  }

  .error {
    font-size: ${f.fontSize01};
    font-weight: ${f.fontWeight01};
    color: ${f.colorError};
  }

  .errorIcon {
    border-radius: 50%;
    color: ${f.color03};
    background-color: ${f.colorError};

    path:last-child {
      display: none;
    }

    z-index: 1;
    position: absolute;
    top: 2.1rem;
    right: 2.4rem;
  }

  .calendarIcon {
    position: absolute;
    right: 10px;
    top: 26px;
    z-index: 1;
    width: 1.25rem;

    color: ${f.color08};
  }

  ${({disabled:e})=>e&&`\n    label {\n      color: ${f.color08};\n    }\n\n    input, input:focus {\n      border: 1px solid ${f.color07};\n      color: ${f.color07};\n    }\n\n    .calendarIcon {\n      color: ${f.color07};\n    }\n  `}
`,ns=h("span")`
  visibility: hidden;
  line-height: 1.5;
  width: 150px;
  background-color: ${f.color10};
  color: ${f.bg03};
  text-align: ${e=>e.alignText} !important;
  white-space: pre-wrap;
  border-radius: 6px;
  padding: 5px 5px;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  margin-left: -38px;
  :after {
    content: '';
    position: absolute;
    top: 100%;
    left: 20%;
    margin-left: -14px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }
  @media (max-width: 672px) {
    visibility: hidden;
    line-height: 1.5;
    width: 150px;
    background-color: ${f.color10};
    color: #fff;
    text-align: ${e=>e.alignText} !important;
    border-radius: 6px;
    padding: 5px 5px;
    position: absolute;
    z-index: 1;
    bottom: 150%;
    margin-left: -125px;
    :after {
      content: '';
      position: absolute;
      top: 100%;
      left: 20%;
      margin-left: 90px;
      border-width: 5px;
      border-style: solid;
      border-color: black transparent transparent transparent;
    }
  }
`,rs=h("div")({position:"relative",display:"inline-block",cursor:"default",":hover span":{visibility:"visible"}}),as=({children:o,toolTipText:i,className:n,alignText:r="justify"})=>t(rs,{className:n,onClick:e=>e.stopPropagation(),children:[o,e(ns,{alignText:r,children:i})]}),ls=({label:i,className:n,errorMsg:r,hasError:l,onBlur:d,onFocus:s,onChange:c,onKeyUp:p,isDisabled:m,value:u,min:h="1979-12-31",max:g="2999-12-31",toolTipText:A})=>{var f;a((()=>{null===window||void 0===window||window.addEventListener("scroll",(()=>{var e;null===(e=null===document||void 0===document?void 0:document.getElementById("datePicker"))||void 0===e||e.blur()}))}),[window]);return t(is,{className:n,"data-testid":"input-id",error:l,hasValue:u&&u.length>0,disabled:m,children:[i&&e((()=>e(o,{children:A?t(as,{toolTipText:A,children:[i,"   ",e(q,{color:"#0C881E"})]}):e("label",{className:"label",children:i})})),{}),e("input",{id:"datePicker",type:"date",placeholder:"dd/mm/aaaa",onBlur:d,onChange:c,onFocus:s,value:u,disabled:m,onClick:e=>{m&&e.preventDefault()},onKeyUp:p,min:h,max:g,required:(null===(f=null===navigator||void 0===navigator?void 0:navigator.userAgent)||void 0===f?void 0:f.indexOf("Firefox"))>-1}),l&&t(o,{children:[e("span",{className:"error",children:r}),e(L,{className:"errorIcon","data-testid":"errorIcon"})]}),!/Firefox/i.test(null===navigator||void 0===navigator?void 0:navigator.userAgent)&&e(U,{className:"calendarIcon"})]})},ds=h(to)`
  border: 0;

  &:hover {
    background-color: ${f.color03};
  }

  .bx--list-box__label {
    max-height: 100%;

    ${({selectedItem:e})=>!e&&`color: ${f.color08};`}
  }

  .bx--list-box__field {
    max-height: 100%;
  }

  .bx--list-box__menu {
    max-width: calc(100% - 1rem + 2px);

    margin: 0.5rem;

    outline: 0;

    .bx--list-box__menu-item {
      height: fit-content;
      min-height: fit-content;

      background-color: ${f.color03};

      &:not(:last-child) {
        border-bottom: 1px solid ${f.color07};
      }

      &:hover:not(:active) {
        background: ${f.color06};
      }

      .bx--list-box__menu-item__option {
        padding: 0.6875rem 0;
        height: fit-content;
        min-height: fit-content;

        color: ${f.color04};
        border-top: 0;
        white-space: normal;

        svg {
          display: none;
        }
      }
    }
  }

  button {
    border-radius: 0.5rem;
    background-color: ${f.color03};

    border: 1px solid ${f.color08};
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    .bx--list-box__menu {
      max-width: 100%;

      .bx--list-box__menu-item {
        &:active {
          background: ${f.color06};
        }
      }
    }
  }

  @media (max-width: 320px) {
  }
`,ss=t=>{var o,{value:i,options:n,onChange:r}=t,a=Jl(t,["value","options","onChange"]);return e(ds,Object.assign({},a,{items:n,itemToString:e=>{var t;return null!==(t=e.label)&&void 0!==t?t:""},selectedItem:null!==(o=n.find((e=>e.value===i)))&&void 0!==o?o:"",onChange:r,hideLabel:!0}))},cs=h("div")`
  width: 100%;
  height: auto;
  position: relative;
  z-index: 1;

  .label_container {
    position: relative;
    z-index: 1;
  }

  .input {
    position: relative;
    box-sizing: border-box;
    height: 38px;
    width: 100%;
    padding: 0 1rem;
    outline: none;
    border: 1px solid ${f.color08};
    font-size: ${f.fontSize01};
    border-radius: 8px;
    z-index: 1;
    &:hover {
      border: 2px solid ${f.color02};
    }
    &::placeholder {
      color: ${f.color08};
    }
    &.inputError {
      border: 2px solid ${f.colorError};
      cursor: pointer;
    }
    &.inputErrorAdvice {
      border: 2px solid ${f.colorWarning};
      cursor: pointer;
    }
  }

  [data-label]::before {
    position: absolute;
    z-index: 1;
    content: attr(data-label);
    cursor: text;
  }

  .input + [data-label]::before,
  [data-label]::before {
    background-color: ${f.bg03};
    padding: 0 5px;
    top: -32px;
    left: -5px;
    font-size: ${f.fontSize01};
    color: ${f.color04};
    font-weight: ${f.fontWeight01};
    z-index: 1;
  }

  .messageError {
    width: 100%;
    display: flex;
    padding-top: 7px;
    padding-left: 3px;
    font-size: ${f.fontSize01};
    font-weight: ${f.fontWeight01};
    color: ${f.colorError};
  }

  .messageAdvice {
    width: 100%;
    display: flex;
    padding-top: 7px;
    padding-left: 3px;
    font-size: ${f.fontSize01};
    font-weight: ${f.fontWeight01};
    color: ${f.colorAdvice};
  }

  .label .icon {
    position: absolute;
    top: 2px;
    right: 12px;
    color: ${f.color08};
    background-color: ${f.bg03};
    border: none;
  }

  .label .icon-warning {
    position: absolute;
    top: 3px;
    right: 12px;
    z-index: 1;
    color: ${f.colorError};
  }

  .label .icon-warning-advice {
    position: absolute;
    top: 3px;
    right: 12px;
    z-index: 1;
    color: ${f.colorWarning};
  }

  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    z-index: 1;
  }
`,ps=({id:i,mask:n,label:a,type:l,placeholder:d,hasError:s,hasViewIcon:p,errorMsg:m,name:u,onChange:h,refControl:g,className:A,onBlur:f,onFocus:v,onKeyUp:x,maxDigits:b,maxLength:w,value:y,defaultValue:C,disabled:E})=>{const[B,k]=r(!1);const I=c((e=>{"currency"===n&&function(e){const t=new Intl.NumberFormat("pt-BR",{style:"currency",currency:"BRL"}),o=e.target;if(o.value=o.value.replace(/\D/g,""),0===o.value.length)return;const i=b||0;o.value.length>i&&(o.value=o.value.substring(0,i)),o.value=t.format(o.value/100)}(e)}),[n]);return e(cs,{"data-testid":"input",className:A,children:t("div",{children:[t("div",{className:"label_container",children:[e("input",{id:i,className:s?"inputError input":`input ${A}`,type:p&&!B?"password":l,placeholder:d,name:u,value:y,defaultValue:C,ref:g,onChange:h,onBlur:f,onFocus:v,onKeyUp:I||x,"data-maxdigits":b,"data-testid":"input-html","data-mask":n,disabled:E,maxLength:w}),e("span",{className:"txtLabel","data-label":a}),s?e("div",{className:"icon-warning",children:e(D,{})}):e(o,{}),p?e("div",{onClick:()=>{k(!B)},className:"icon",children:p&&B?e(W,{}):p&&e(G,{})}):e(o,{})]}),s?e("div",{className:"messageError",children:m}):""]})})},ms=({label:i,type:n,placeholder:r,hasError:a,errorMsg:l,name:d,onChange:s,refControl:c,className:p,onBlur:m,onFocus:u,maxDigits:h,value:g,hasAdvice:A,adviceMsg:f})=>e(cs,{"data-testid":"input",className:p,children:t("div",{children:[t("label",{className:"label",children:[e("input",{className:a?"inputError input":A?"inputErrorAdvice input":"input",type:n,placeholder:r,name:d,value:g,ref:c,onChange:e=>s(function(e){const t=new Intl.NumberFormat("pt-BR",{style:"currency",currency:"BRL"}),o=e.target;if(o.value=o.value.replace(/\D/g,""),0===o.value.length)return;const i=h||0;return o.value.length>i&&(o.value=o.value.substring(0,i)),o.value=t.format(o.value/100)}(e)),onBlur:m,onFocus:u,"data-testid":"input-html"}),e("span",{className:"txtLabel","data-label":i}),a?e("div",{className:"icon-warning",children:e(D,{})}):A?e("div",{className:"icon-warning-advice",children:e(D,{})}):e(o,{})]}),a?e("div",{className:"messageError",children:l}):"",A?e("div",{className:"messageAdvice",children:f}):""]})}),us=h("div")`
  @media only screen and (max-width: 672px) {
    align-self: center;
  }

  &.input-style {
    width: 100px;
    height: 316px;
  }

  input {
    border: 1px solid ${f.color08};
    background: ${f.bg03} 0% 0% no-repeat padding-box;
    height: 40px;
    min-width: 32px;
    border-radius: 8px;
    color: ${f.color04};
    font-size: ${f.fontSize03};
    font-weight: ${f.fontWeight02};
  }

  .focusInput {
    background: ${f.bg03} 0% 0% no-repeat padding-box;
    border: 2px solid ${f.color02};
    outline: none;
  }

  input::placeholder {
    color: ${f.bg03};
  }
`,hs=({className:t,onChange:o})=>{const[i,n]=r("");return e(us,{"data-testid":"ipt-auth-id",children:e(zo,{value:i,onChange:e=>{n(e),o&&o(e)},numInputs:6,separator:e("span",{children:" "}),containerStyle:"input-style",focusStyle:"focusInput",className:t})})},gs=h.div`
  .container {
    width: 100%;
    margin-top: 20px;
  }

  .label_container {
    position: relative;
  }

  .input {
    box-sizing: border-box;
    height: 38px;
    width: 100%;
    padding: 0 1rem;
    outline: none;
    border: 1px solid ${f.color08};
    font-size: 14px;
    border-radius: 8px;
    &:hover {
      border: 2px solid ${f.color02};
    }
    &::placeholder {
      color: ${f.color08};
    }
    &.inputError {
      border: 2px solid ${f.colorError};
    }
    &.inputError + [data-label]::before,
    [data-label]::before {
      color: ${f.colorError};
    }
  }

  [data-label]::before {
    position: absolute;
    content: attr(data-label);
    cursor: text;
  }

  .input + [data-label]::before,
  [data-label]::before {
    background-color: ${f.bg03};
    padding: 0 5px;
    top: -27px;
    left: -3px;
    font-size: ${f.fontSize01};
    color: ${f.color04};
    font-weight: ${f.fontWeight01};
  }

  .messageError {
    width: 100%;
    display: flex;
    padding-top: 7px;
    padding-left: 3px;
    font-size: ${f.fontSize01};
    font-weight: ${f.fontWeight01};
    color: ${f.colorError};
  }

  .label .icon {
    position: absolute;
    top: 3px;
    right: 12px;
    color: ${f.color08};
    background-color: ${f.bg03};
    border: none;
  }

  .label .icon-warning {
    position: absolute;
    top: 3px;
    right: 12px;
    color: ${f.colorError};
  }

  .label .icon-checkmark {
    position: absolute;
    top: 3px;
    right: 12px;
    color: ${f.colorSuccess};
  }

  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
`,As=({label:i,type:n,placeholder:a,hasError:l,isSuccessful:d,hasViewIcon:s,errorMsg:c,className:p,name:m,onChange:u,refControl:h,onBlur:g,value:A,required:f})=>{const[v,x]=r(!1),[b,w]=r(A),[y,C]=r(A),[E,B]=r(A);return e(gs,{children:t("div",{"data-testid":"input-id",className:`container ${p}`,children:[t("div",{className:"label_container",children:[e("input","cpf"===n||"phone"===n||"inputName"===n?{"data-testid":"mask-id",className:l?"inputError input":"input",type:"text",placeholder:a,name:m,ref:h,onChange:e=>{(e=>{const t=e.target.value,o=()=>{u&&u(Object.assign(Object.assign({},e),{target:{value:t.replace(/\D/g,"")}}))};if("cpf"===n){const t=e.target.value.replace(/\D/g,"").replace(/(\d{3})(\d)/,"$1.$2").replace(/(\d{3})(\d)/,"$1.$2").replace(/(\d{3})(\d{1,2})/,"$1-$2").replace(/(-d{2})\d+?$/,"$1");w(t),o()}else if("phone"===n){const t=e.target.value.replace(/\D/g,"").replace(/^(\d{2})(\d)/g,"($1) $2").replace(/(\d)(\d{4})$/,"$1-$2");C(t),o()}else if("inputName"===n){const t=e.target.value.replace(/[^a-zA-Z ´`ˆ'˜àáâäãåąčćÇçęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑ ]/g);B(t),o()}})(e)},required:f,onBlur:g,maxLength:"cpf"===n?14:"phone"===n?15:256,minLength:"cpf"===n?14:0,value:"cpf"===n?b:"phone"===n?y:E}:{className:l?"inputError input":"input",type:s&&!v?"password":"text",placeholder:a,name:m,ref:h,onChange:u,onBlur:g,value:A,required:f}),e("span",{className:"txtLabel","data-label":i}),l?e("div",{className:"icon-warning",children:e(D,{})}):e(o,{}),d?e("div",{className:"icon-checkmark",children:e(M,{})}):e(o,{}),s?e("div",{"data-testid":"toogle",onClick:()=>{x(!v)},className:"icon",children:s&&v?e(W,{}):s&&e(G,{})}):e(o,{})]}),l?e("div",{className:"messageError",children:c}):""]})})},fs=h("div")`
  position: relative;
  width: 100%;

  .search-icon {
    display: none;
  }

  ${({hasIcon:e})=>e&&` .search-box input {\n        padding-left: 2.5rem;\n      }\n      .search-icon {\n        display: inherit;\n        position: absolute;\n        top: 0.75rem;\n        left: 1rem;\n\n        color: ${f.color08}\n      }\n    `}
`,vs=({className:i,placeholder:n,onChangeHandler:r,onBlur:a,hasIcon:l})=>t(fs,{hasIcon:l,children:[e(ps,{label:"",className:`search-box ${i}`,type:"search",placeholder:n,onChange:r,onBlur:a}),e(o,{children:l&&e(H,{className:"search-icon"})})]}),xs=h.div`
  display: flex;
  justify-content: center;
  align-items: center;

  background: #fff;
  height: 40px;
  border-radius: 5px;
  padding: 0 10px;
  border: 1px solid #a7a8ac;
  width: 100%;

  svg {
    margin-right: 5px;
    color: #a7a8ac;
  }

  input {
    flex: 1;
    height: 100%;
    border: 0;
    background: transparent;
    outline: none;
    padding: 0 5px;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 0;

    svg {
      color: #000000;
    }
  }
`,bs=o=>{var{icon:i,handleDeleteInputText:n,handleInputChange:r,inputValue:a}=o,l=Jl(o,["icon","handleDeleteInputText","handleInputChange","inputValue"]);return t(xs,{children:[i&&e(i,{name:""}),e("input",Object.assign({onChange:e=>r(e),value:a},l)),!!a&&e("button",{onClick:()=>n(),children:e(F,{})})]})},ws=h("div")`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  position: relative;

  width: 100%;
  width: 300px;

  label {
    font-size: ${f.fontSize01};
    font-weight: ${f.fontWeight01};
  }

  .bx--multi-select {
    border-bottom: none;
  }

  .bx--tag--high-contrast {
    background-color: rgb(12, 136, 30);
  }

  .bx--label {
    display: none;
  }

  .bx--list-box__menu-item .bx--checkbox-label {
    padding-left: 2rem;
  }

  .bx--checkbox-label::before {
    border: 1px solid rgb(12, 136, 30);
  }

  .bx--checkbox-label[data-contained-checkbox-state='true']::before {
    border-color: rgb(12, 136, 30);
    background-color: rgb(12, 136, 30);
  }

  .bx--list-box__menu-item__option {
    padding: 0.4875rem 1rem;
    margin: 0;
  }

  .bx--list-box__menu-item--active {
    background: transparent;

    .bx--list-box__menu-item__option {
      border-bottom: 1px solid #dcdcdc;
    }
  }

  .bx--list-box__field {
    padding: 0 1rem;
    outline: none;
    border: 1px solid ${f.color08};
    font-size: ${f.fontSize01};
    background-color: ${f.color03};
    border-radius: 0.5rem;
    width: 100%;
    height: 2.5rem;
    padding-right: 40px;
    display: flex;

    span {
      flex: 1;
      text-align: left;
    }

    &:focus {
      border: 2px solid ${f.color02};
    }

    ${({error:e})=>e&&`border: 2px solid ${f.colorError}; `}
  }

  .bx--list-box__menu {
    :focus {
      outline: 2px solid transparent !important;
      outline-offset: 2px !important;
    }
    width: 95%;
    left: 8px;
    background-color: ${f.color03};
  }

  .error {
    font-size: ${f.fontSize01};
    font-weight: ${f.fontWeight01};
    color: ${f.colorError};
  }

  .errorIcon {
    width: 1rem;
    height: 1rem;

    text-align: center;
    border-radius: 50%;
    color: ${f.color03};
    background-color: ${f.colorError};

    position: absolute;
    top: 2.25rem;
    right: 2.75rem;
  }
`,ys=({title:i,label:n,items:r,onChange:a,hasError:l,errorMsg:d,className:s})=>t(ws,{className:s,error:l,children:[n&&e("span",{children:i}),r&&e(no,{id:"multi-select-component",itemToString:e=>e,label:n,items:r.map((e=>(null==e?void 0:e.label)?e.label:e)),onChange:e=>{a&&a(e.selectedItems)}}),l&&t(o,{children:[e("span",{className:"error",children:d}),e("span",{className:"errorIcon","data-testid":"errorIcon",children:"!"})]})]}),Cs=h.div`
  position: relative;
`,Es=h(ro)`
  .bx--search-magnifier-icon {
    fill: ${f.color08};
  }

  input {
    border-radius: 8px;
    border: 1px solid ${f.color08};
    border-bottom: 1px solid ${f.color08} !important;
    background: ${f.color03};

    &::placeholder {
      color: ${f.color08};
    }
  }

  .bx--search-close {
    display: none;
  }
`,Bs=h.div`
  position: absolute;
  top: 100%;
  left: 2rem;

  width: 14px;
  height: 0;

  border-right: 7px solid transparent;
  border-left: 7px solid transparent;
  border-bottom: 8px solid ${f.bg03};

  z-index: 40;

  ${({isVisible:e})=>!e&&"\n    visibility: hidden;\n    z-index: -1;\n  "}

  -webkit-filter: drop-shadow(0px 4px 12px ${f.bx01});
  filter: drop-shadow(0px 4px 12px ${f.bx01});
`,ks=h.div`
  position: absolute;
  top: calc(100% + 8px);

  width: 100%;

  border-radius: 4px;
  background: ${f.bg03};
  box-shadow: 0px 4px 12px ${f.bx01};

  z-index: 40;

  ${({isVisible:e})=>!e&&"\n    visibility: hidden;\n    z-index: -1;\n  "}

  .loading-container {
    display: flex;
    align-items: center;
    justify-content: center;

    margin: 1rem;

    height: 6rem;
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
  }

  @media (max-width: 320px) {
  }
`,Is=h.ul`
  display: flex;
  flex-direction: column;

  max-height: 20.375rem;

  overflow: auto;
  overscroll-behavior: contain;

  padding: 0 0.75rem 0.5rem;

  li {
    background: ${f.bg03};
    transition: background-color 0.2s;

    cursor: pointer;

    &:hover:not(:active) {
      background: ${f.bg07};
    }

    ${({isDisabled:e})=>e&&`\n      background: ${f.bg03} !important;\n      opacity: 0.6;\n    `}
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    li:active {
      background: ${f.bg07};
    }

    ${({isDisabled:e})=>e&&`\n      background: ${f.bg03} !important;\n      opacity: 0.6;\n    `}
  }

  @media (max-width: 320px) {
  }
`,Ns=function({label:o="",placeholder:i,searchProps:n,inputGroupProps:l,wrapperProps:d,isLoading:c=!1,hasError:p=!1,autoCloseWrapper:m=!0,disabled:u=!1,value:h,itemKey:g,items:A,onChange:f,renderItem:v,renderNotFound:x,renderError:b}){const[w,y]=r(!1),[C,E]=r(!1),[B,k]=r(!1),I=s(null),N=s(null),S=e=>{var t,o;if(I.current&&N.current){const i=I.current.contains(e.target)||!!(null===(o=null===(t=N.current.input)||void 0===t?void 0:t.contains)||void 0===o?void 0:o.call(t,e.target));E(i)}};return a((()=>{m&&E(!0)}),[m]),a((()=>{m&&((w||C)&&h&&(null==A?void 0:A.length)||k(!1))}),[w,C,h,A]),a((()=>{w&&h.trim().length>=3&&((null==A?void 0:A.length)||c||p&&b||A&&!A.length&&x)&&k(!0)}),[w,h,A,c,p,b,x]),a((()=>(document.addEventListener("mousedown",S),()=>{document.removeEventListener("mousedown",S)})),[]),t(Cs,Object.assign({},l,{children:[e(Es,Object.assign({},n,{ref:N,labelText:o,placeholder:i,role:"searchbox",size:"lg",type:"text",value:h,onChange:e=>{var t;return null==f?void 0:f(null!==(t=e.target.value)&&void 0!==t?t:"")},onFocus:()=>y(!0),onBlur:()=>y(!1),disabled:u})),e(ks,Object.assign({},d,{ref:I,isVisible:B,children:c?e("div",{className:"loading-container",children:e(Vt,{withOverlay:!1})}):p&&b?b():A&&!A.length&&x?x():A&&t(Is,{isDisabled:u,children:[A.map((t=>e("li",{children:v(t)},t[g])))," "]})})),e(Bs,{isVisible:B})]}))},Ss=h.div`
  @media (min-width: 1056px) {
    display: none;
  }
  .searchInputs {
    display: flex;
    border-style: solid;
    border-width: 1px;
    border-radius: 10px;
    border-color: #a7a8ac;
    background-color: #ffffff;
    margin-top: -1.5rem;
  }

  .searchInputs:focus-within {
    box-shadow: 0px 0px 2px 2px ${f.color02};
  }

  .search input {
    border-width: 0px;
    font-size: 14px;
    margin-right: 7px;
    height: 40px;
    width: 100%;
  }

  #searchField::placeholder {
    color: #a7a8ac;
  }

  .searchIcon {
    width: 50px;
    display: grid;
    place-items: center;
  }
  svg.search-icon {
    fill: #a7a8ac;
    width: 16px;
    height: 16px;
  }
  input:focus {
    outline: none;
  }
  .searchIcon svg {
    font-size: 35px;
  }
  .searchIcon svg:hover {
    cursor: pointer;
  }
`,Os=()=>{const[o,i]=r(),n=wo(),a=()=>{o&&""!==(null==o?void 0:o.replace(/\s/g,""))&&(n.push(`/loja/resultado-busca?busca=${o}`),i(""));const e=new Mo,t=e.get("marketplace");e.set("marketplace",Object.assign(Object.assign({},t),{miraklShopIds:void 0,miraklShopName:void 0,sort:""}))};return e(Ss,{children:e("form",{className:"search",onSubmit:e=>e.preventDefault(),children:t("div",{className:"searchInputs",children:[e("div",{onClick:a,className:"searchIcon",children:e(V,{"aria-label":"Search",className:"search-icon"})}),e("input",{id:"searchField",placeholder:"Busca",value:o,onChange:e=>{var t;return i(null===(t=null==e?void 0:e.target)||void 0===t?void 0:t.value)},onKeyDown:e=>{"Enter"===(null==e?void 0:e.key)&&a()}})]})})})},Ps=h("div")`
  width: 100%;
  height: auto;

  .label {
    position: relative;
  }

  /* Safari Only */
  @supports selector(:nth-child(1 of x)) {
    .label {
      width: 100%;
    }
  }

  .first-option {
    display: none;

    &.option {
      color: ${f.color04};
    }
  }

  .select {
    border: none;
    outline: none;
    height: 36px;
    width: 100%;
    color: ${f.color08};
    font-size: ${f.fontSize01};
    background-color: white;
    -webkit-appearance: none;
  }

  .container + [data-label]::before {
    background-color: ${f.bg03};
    padding: 0 5px;
    top: -21px;
    left: -5px;
    font-size: ${f.fontSize01};
    color: ${f.color04};
    font-weight: ${f.fontWeight01};
    width: 200px;

    @-moz-document url-prefix() {
      width: 200px;
      top: -10px;
    }

    @supports (-moz-appearance: none) {
      top: -1.25rem;
    }
  }

  .container {
    margin-top: 0.5rem;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    height: 40px;
    width: 100%;
    padding: 0 10px;
    outline: none;
    border: 1px solid ${f.color08};
    font-size: ${f.fontSize01};
    border-radius: 9px;
    background-color: ${f.bg03};
    display: flex;
    &:hover {
      border: 2px solid ${f.color02};
    }

    &:focus-within {
      border: 2px solid ${f.color02};
      /* color: ${f.color03}; */
    }

    &.selectError {
      border: 2px solid ${f.colorError};
    }

    &.selectError + [data-label]::before,
    [data-label]::before {
      ${f.colorError}
    }
  }

  [data-label]::before {
    content: attr(data-label);
    cursor: text;
    font-size: ${f.fontSize01};
  }

  .select-color-change {
    color: ${f.color04};
  }

  .selectError:not(:placeholder-shown) {
    border: 2px solid ${f.colorError};
  }

  .messageError {
    width: 100%;
    display: flex;
    padding-top: 7px;
    padding-left: 3px;
    font-size: ${f.fontSize01};
    font-weight: ${f.fontWeight01};
    color: ${f.colorError};
  }

  .label .icon-warning {
    position: absolute;
    top: 12px;
    right: 30px;
    color: ${f.colorError};
  }

  .label .icon-select-container {
    position: relative;
    pointer-events: none;
  }

  .label .icon-down {
    position: absolute;
    top: -30px;
    right: 15px;
    color: ${f.color08};
  }
`,Qs=({label:i,className:n,items:a,placeholder:l,onSelectedChange:d,onChange:s,hasError:c,errorMsg:p,onBlur:m,valueSelected:u,selectedValue:h,isDisabled:g=!1})=>{const[A,f]=r(!1);return t(Ps,{className:n,children:[t("label",{id:"label-id",className:`label ${(A||h)&&"label-color-change"}`,children:[e("span",{className:"txtLabel","data-label":i}),e("div",{id:"container-id",className:c?`selectError container ${A&&"container-border-change"}`:`container ${(A||h)&&"container-border-change"}`,children:t("select",{required:!0,disabled:g,id:"select-id","data-testid":"select",className:`select ${(A||h)&&"select-color-change"}`,name:"test",onChange:e=>{(e=>{const{value:t}=e.target;f(t),d&&d(t)})(e),s&&s(e)},onBlur:m,value:u,children:[e("option",{className:"first-option",children:l}),null==a?void 0:a.map((t=>e("option",{selected:t.selected||(t.key?t.key:t.title)==h,"data-testid":"option",value:t.key?t.key:t.title,className:"option",children:t.title},t.key)))]})}),c?e("div",{className:"icon-warning",children:e(D,{})}):e(o,{}),e("div",{className:"icon-select-container",children:e("div",{className:"icon-down",children:e(b,{})})})]}),c?e("div",{className:"messageError",children:p}):""]})},zs=h.div`
  .bx--modal-close {
    display: none;
  }

  .bx--modal-close:focus {
    border: none;
  }

  .bx--modal-container {
    background-color: ${f.bg03};
    border-radius: 4px;

    @media (max-width: 671px) {
      height: auto;
      width: 94%;
      margin-top: 68px;
    }

    @media (min-width: 672px) and (max-width: 911px) {
      width: 72%;
      margin-top: 120px;
    }
  }

  .bx--modal-header__heading {
    display: flex;
    justify-content: flex-start;
    font-size: ${f.fontSize03};
    font-weight: ${f.fontWeight02};
  }

  .bx--modal-content {
    padding-top: 0;
    margin-bottom: 29px;

    p {
      padding: 0;
    }
  }
`,Ms=t=>{var{className:o,children:i}=t,n=Jl(t,["className","children"]);return e(zs,{children:e(ao,Object.assign({},n,{passiveModal:!0,className:o,"data-testid":"modal-id",children:i}))})},Ds=h(ao)`
  &.info {
    .bx--modal-footer {
      .bx--btn--primary {
        background-color: ${f.bg01};
      }
    }
  }

  &.danger {
    .bx--modal-footer {
      .bx--btn--primary {
        background-color: ${f.colorError};
      }
    }
  }

  .bx--modal {
    background-color: ${f.bg13};
  }

  .bx--modal-close,
  .bx--modal-header {
    display: none;
  }

  .bx--modal-container {
    position: initial;

    width: 100%;
    height: fit-content;
    max-width: 23.375rem;

    padding: 1rem;
    margin: 1rem;

    background-color: ${f.bg03};
    border-radius: 0.25rem;
  }

  .bx--modal-content {
    margin-bottom: 2rem;

    padding: 0;

    p {
      padding: 0;
    }
  }

  .bx--modal-footer {
    display: flex;
    flex-direction: column-reverse;
    gap: 1rem;

    height: fit-content;

    .bx--btn--primary {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;

      height: fit-content;

      border-radius: 6.25rem;
      padding: 1rem;

      font-size: ${f.fontSize01};
      font-weight: ${f.fontWeight03};
    }

    .bx--btn--secondary {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;

      height: fit-content;

      background-color: transparent;
      border: 2px solid ${f.bg01};
      border-radius: 6.25rem;
      padding: 1rem;

      color: ${f.color01};
      font-size: ${f.fontSize01};
      font-weight: ${f.fontWeight03};
    }
  }
`,js=h.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;

  text-align: ${e=>e.textAlign};
  line-height: ${f.lineHeight01};

  svg {
    align-self: center;

    height: 2.5rem;
    min-width: 2.5rem;
  }

  h2 {
    font-size: ${f.fontSize03};
    font-weight: ${f.fontWeight03};
  }

  p {
    font-size: ${f.fontSize01};
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    text-align: ${e=>e.textAlignMobile};
  }

  @media (max-width: 320px) {
  }
`,Ts=h.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  padding: 1rem;

  width: 100%;

  border: 1px solid ${f.color07};
  border-radius: 0.25rem;

  color: ${f.color04};
  font-size: ${f.fontSize01};
  font-weight: ${f.fontWeight01};
  line-height: ${f.lineHeight01};
  text-align: left;

  .title {
    font-size: ${f.fontSize01};
    font-weight: ${f.fontWeight03};
  }

  .label-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
`,Rs=h.div`
  align-self: stretch;
  display: flex;
  align-items: baseline;
  gap: 0.5rem;

  span {
    min-width: fit-content;

    color: ${f.color09};
  }

  strong {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    width: fit-content;

    word-break: break-all;
    font-weight: ${f.fontWeight01};
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    font-size: ${f.fontSize01};
  }

  @media (max-width: 320px) {
  }
`,Ls=({className:o,name:i="",email:n="",phoneNumber:r=""})=>t(Ts,{className:o,children:[e("h3",{className:"title",children:i}),t("div",{className:"label-group",children:[t(Rs,{children:[e("span",{children:"E-mail"}),e("strong",{children:n})]}),t(Rs,{children:[e("span",{children:"Telefone"}),e("strong",{children:_e(r)})]})]})]}),Us=({className:o="",title:i,message:n,icon:r,iconType:l="neutral",isOpen:d,clientInfo:s,btnConfirmText:c="Ok, entendi",btnCancelText:p="Voltar",hasShowCancelButton:m=!1,type:u="info",textAlign:h="center",textAlignMobile:g=h||"center",usePreventCloseOnClickOutside:A=!0,tagging:f,onConfirm:v,onCancel:x})=>{a((()=>{d&&f&&Je.pageview(Ye.PageView,f.flow,f.loggedUser,f.firebaseScreen,"web",null,{userId:f.userId})}),[d,f]);const b=e=>{e.stopPropagation(),f&&Je.interact(Ye.Click,"modal",p,f.flow,f.loggedUser,f.firebaseScreen,null,{userId:f.userId}),null==x||x()};return e(Ds,{className:`${u} ${o}`,open:d,primaryButtonText:c,secondaryButtonText:m&&p,preventCloseOnClickOutside:A,onRequestSubmit:e=>{e.stopPropagation(),f&&Je.interact(Ye.Click,"modal",c,f.flow,f.loggedUser,f.firebaseScreen,null,{userId:f.userId}),null==v||v()},onSecondarySubmit:b,onRequestClose:b,children:t(js,{textAlign:h,textAlignMobile:g,children:[e("div",{className:`icon-${l}`,children:r}),e("h2",{children:i}),e("p",{children:n}),s&&e(Ls,Object.assign({},s))]})})},qs=h.div`
  .bx--modal-close {
    display: none;
  }

  .bx--modal-close:focus {
    border: none;
  }

  .bx--modal-container {
    width: 288px;
    background-color: ${f.bg03};
    border-radius: 4px;

    @media (max-width: 671px) {
      height: auto;
      margin-top: 17rem;
    }
  }

  .bx--modal-header__heading {
    display: flex;
    justify-content: flex-start;
    font-size: ${f.fontSize03};
    font-weight: ${f.fontWeight02};
  }

  .bx--modal-content {
    padding-top: 0;
    margin-bottom: 29px;

    p {
      padding: 0;
    }
  }

  .bx--modal-footer {
    flex-direction: column-reverse;
    align-items: center;
    height: auto;
    padding-bottom: 2rem;
    padding-right: 1rem;
    padding-left: 1rem;
    gap: 1rem;
  }

  .bx--btn--primary,
  .bx--btn--secondary {
    height: 50px;
    width: 100%;
    justify-content: center;
    padding: 0px;
    border: none;
    border-radius: 30px;
    font-weight: bold;
  }

  .button-modal .bx--btn--primary {
    background-color: ${f.bg01};
    color: ${f.color03};
  }

  .button-modal .bx--btn--secondary {
    background-color: ${f.bg03};
    border: 2px solid ${f.color01};
    color: ${f.color01};
  }
`,Ws=({className:t,openModal:o,modalHeadingSection:i,children:n,setOpenModal:r,setConfirm:a,primaryButtonText:l,secondaryButtonText:d,setCancel:s})=>e(qs,{children:e(ao,{modalHeading:i||"Confirmar alteração",primaryButtonText:l||"Confirmar",secondaryButtonText:d||"Cancelar",preventCloseOnClickOutside:!0,open:o,onRequestSubmit:()=>(r(!1),void a(!0)),onRequestClose:()=>(s&&s(!0),void r(!1)),className:`button-modal ${t}`,"data-testid":"modal-id",children:n||e("p",{children:"Confirme e salve suas alterações"})})}),Gs=h("div")`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  width: 100%;
  font-weight: 400;
  color: ${f.color04};

  ._InputBase_Label_Wrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: start;
    :focus-within ._InputBase_Border_Box {
      outline: 2px solid ${f.color02};
      transition-duration: 200ms;
    }
  }
  ._InputBase_Label_Text {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.875rem;
    line-height: 1.063rem;
    padding-bottom: 0.4rem;
  }
  ._InputBase_Border_Box {
    min-height: ${e=>e.height?e.height:"40px"};
    max-height: ${e=>e.height?e.height:"40px"};
    height: ${e=>e.height?e.height:"40px"};
    overflow: hidden;
    display: flex;
    justify-content: start;
    align-items: center;
    position: relative;
    flex: 1 1 auto;
    border: 1px solid ${f.color08};
    border-radius: 8px;
    outline: 0px solid rgba(0, 0, 0, 0);
    transition-duration: 200ms;
  }

  ._InputBase_Input_Text {
    flex: 1 1 auto;
    font-size: 1rem;
    padding: 0.6rem 2rem 0.6rem 0.875rem;
    max-height: ${e=>e.height?e.height:"40px"};
    height: ${e=>e.height?e.height:"40px"};
    overflow-y: visible !important;
    background-color: transparent;
    overflow-x: hidden;
    position: absolute;
    width: 100%;
    word-break: break-all;
    resize: none;
    border: none;

    :focus-visible {
      outline: none;
    }
    :disabled {
      background-color: transparent;
      color: ${f.color08};
    }
    ::placeholder {
      color: ${f.color07};
    }
  }
  ._InputBase_Helper_Text {
    font-size: 0.875rem;
    line-height: 1.063rem;
    color: ${f.color08};
    padding-top: 0.5rem;
  }
  /* ESTADOS DO INPUT */
  ._InputBase_Status_Icon {
    position: absolute;
    top: ${e=>e.height?`calc( calc( ${e.height} / 2 ) - 8px )`:"calc( calc( 40px / 2 ) - 8px )"};
    right: 16px;
    min-width: 16px;
  }

  ${e=>{switch(e.status){case"error":return g`
          ._InputBase_Status_Icon {
            color: ${f.colorError};
          }
          ._InputBase_Border_Box {
            border: 1px solid ${f.colorError};
          }
          ._InputBase_Helper_Text {
            color: ${f.colorError};
          }
        `;case"success":return g`
          ._InputBase_Status_Icon {
            color: ${f.colorSuccess};
          }
          ._InputBase_Border_Box {
            border: 1px solid ${f.colorSuccess};
          }
          ._InputBase_Helper_Text {
            color: ${f.colorSuccess};
          }
        `;case"warning":return g`
          ._InputBase_Status_Icon {
            color: ${f.colorWarning};
          }
          ._InputBase_Border_Box {
            border: 1px solid ${f.colorWarning};
          }
          ._InputBase_Helper_Text {
            color: ${f.colorWarning};
          }
        `;case"disabled":return g`
          ._InputBase_Status_Icon {
            color: ${f.color08};
          }
          ._InputBase_Border_Box {
            border: 1px solid ${f.color07};
            background-color: ${f.color06};
          }
          ._InputBase_Label_Text {
            color: ${f.color08};
          }
        `;default:return""}}}
`,Hs=({status:t})=>{switch(t){case"error":return e(D,{className:"_InputBase_Status_Icon error"});case"success":return e(M,{className:"_InputBase_Status_Icon success"});case"warning":return e(K,{className:"_InputBase_Status_Icon warning"});default:return null}},Fs=p((({label:o,value:i,onChange:n,onBlur:l,status:d,disabled:c,height:p,placeholder:m,className:u,message:h,maxlength:g},A)=>{const f=s(null),[v,x]=r(A?i:i||"");return a((()=>{null==i||i===v?null===i&&x(""):x(i)}),[i]),e(Gs,{status:c?"disabled":d,height:p,className:u,children:t("label",{title:o,className:"_InputBase_Label_Wrapper",children:[t("p",{className:"_InputBase_Label_Text",children:[o," ",t("span",{children:[g&&`${null==v?void 0:v.length} / ${g}`," "]})]}),t("div",{className:"_InputBase_Border_Box",children:[e("textarea",{maxLength:g,onBlur:e=>{l&&l(e.target.value)},ref:A||f,placeholder:m,disabled:c,className:"_InputBase_Input_Text",value:v,onChange:e=>{n&&n(e.target.value)}}),e(Hs,{status:d})]}),h&&e("p",{className:"_InputBase_Helper_Text",children:h})]})})})),Vs=h("div")`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  width: 100%;

  font-weight: 400;
  color: ${f.color04};

  ._InputBase_Label_Wrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: start;
    transition-duration: 100ms;
    :focus-within ._InputBase_Border_Box {
      border: 2px solid ${f.bg02};
      transition-duration: 200ms;
    }
  }
  ._InputBase_Label_Text {
    font-size: 0.875rem;
    line-height: 1.063rem;
    padding-bottom: 0.4rem;
  }
  ._InputBase_Border_Box {
    min-height: 40px;
    max-height: 40px;
    height: 40px;
    overflow: hidden;
    display: flex;
    justify-content: start;
    align-items: center;
    flex: 1 1 auto;
    border: 1px solid ${f.color08};
    border-radius: 8px;
    outline: 0px solid rgba(0, 0, 0, 0);
    transition-duration: 200ms;
  }

  ._InputBase_Input_Text {
    flex: 1 1 auto;
    font-size: 1rem;
    background-color: transparent;
    overflow-x: hidden;
    word-break: break-all;
    border: none;

    :focus-visible {
      outline: none;
    }
    :first-child {
      margin-left: 0.875rem;
    }
    :last-child {
      margin-right: 0.875rem;
    }

    :disabled {
      background-color: transparent;
      color: ${f.color08};
      -webkit-text-fill-color: ${f.color08};
    }
    ::placeholder {
      color: ${f.color08};
    }
  }
  ._InputBase_Helper_Text {
    font-size: 0.875rem;
    line-height: 1.063rem;
    color: ${f.color08};
    padding-top: 0.5rem;
  }
  /* ESTADOS DO INPUT */
  ._InputBase_Status_Icon {
    margin-right: 0.8rem;
    min-width: 16px;
  }

  ${e=>{switch(e.status){case"error":return g`
          ._InputBase_Status_Icon {
            color: ${f.colorError};
          }
          ._InputBase_Border_Box {
            border: 1px solid ${f.colorError};
          }
          ._InputBase_Label_Wrapper {
            :focus-within ._InputBase_Border_Box {
              border: 2px solid ${f.colorError};
              transition-duration: 200ms;
            }
          }
          ._InputBase_Helper_Text {
            color: ${f.colorError};
          }
        `;case"success":return g`
          ._InputBase_Status_Icon {
            color: ${f.colorSuccess};
          }
          ._InputBase_Border_Box {
            border: 1px solid ${f.colorSuccess};
          }
          ._InputBase_Label_Wrapper {
            :focus-within ._InputBase_Border_Box {
              border: 2px solid ${f.colorSuccess};
              transition-duration: 200ms;
            }
          }
          ._InputBase_Helper_Text {
            color: ${f.colorSuccess};
          }
        `;case"warning":return g`
          ._InputBase_Status_Icon {
            color: ${f.colorWarning};
          }
          ._InputBase_Border_Box {
            border: 1px solid ${f.colorWarning};
          }
          ._InputBase_Label_Wrapper {
            :focus-within ._InputBase_Border_Box {
              border: 2px solid ${f.colorWarning};
              transition-duration: 200ms;
            }
          }
          ._InputBase_Helper_Text {
            color: ${f.colorWarning};
          }
        `;case"disabled":return g`
          ._InputBase_Status_Icon {
            color: ${f.color08};
          }
          ._InputBase_Border_Box {
            border: 1px solid ${f.color07};
            background-color: ${f.color06};
          }
          ._InputBase_Label_Text {
            color: ${f.color08};
          }
          ._InputBase_Start_Adornment,
          ._InputBase_End_Adornment {
            background-color: rgba(0, 0, 0, 0) !important;
          }
        `;default:return""}}}

  /* ADORNAMENTOS */

  ._InputBase_Start_Adornment , ._InputBase_End_Adornment {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: none;
    min-height: 32px;
    max-height: 32px;
    min-width: 32px;
    max-width: 32px;
    border-radius: 9999px;
    background-color: rgba(0, 0, 0, 0);
    transition-duration: 200ms;
    outline: none;
    :not(:disabled):hover {
      transition-duration: 200ms;
      background-color: ${f.color06};
    }
    :not(:disabled):focus,
    :not(:disabled):focus-visible {
      background-color: ${f.color07};
    }
    :active {
      filter: brightness(0.95);
    }
  }
  ._InputBase_Start_Adornment {
    margin-left: 0.875rem;
    margin-right: 0.3rem;
  }
  ._InputBase_End_Adornment {
    :last-child {
      margin-right: 0.875rem;
    }
    margin-right: 0.3rem;
    margin-left: 0.3rem;
  }
`,Ks=({status:t})=>{switch(t){case"error":return e(D,{className:"_InputBase_Status_Icon error"});case"success":return e(M,{className:"_InputBase_Status_Icon success"});case"warning":return e(K,{className:"_InputBase_Status_Icon warning"});default:return null}};var Js;!function(e){e.SQUARE_METER=" m²",e.HEADS=" cabeças",e.PER_HEADS=" por cabeças",e.LITERS_DAY=" litros/dia",e.KILOGRAM=" kg",e.HECTARE=" ha"}(Js||(Js={}));const Ys=n.forwardRef((({label:o,value:i,onChange:n,startAdornment:l,endAdornment:d,status:c,disabled:p,placeholder:m,className:u,onBlur:h,message:g,maxLength:A,suffix:f,isLivestock:v},x)=>{const b=s(null),[w,y]=r(x?i:i||""),C=e=>{var t,o;if("0,0000"!==e&&"0,00"!==e&&null!=i)if("0,00 m²"!==e){if(!(null==e?void 0:e.target)&&(null===(t=null==e?void 0:e.target)||void 0===t?void 0:t.value.trim())&&y((null===(o=null==e?void 0:e.target)||void 0===o?void 0:o.value.trim())+f),i&&f){const e=i.toString().replace(Js.SQUARE_METER,"").trim();y(e+f)}}else y(e);else y(e+f)};return a((()=>{if(v)if(i!==w)y(i);else if(null!==i||void 0!==i)C(i);else{const e=f&&f===Js.SQUARE_METER?"0,00":"0,0000";C(e)}else null!=i&&i!==w&&y(i)}),[i]),e(Vs,{status:p?"disabled":c,className:u,children:t("label",{title:o,className:"_InputBase_Label_Wrapper",children:[o&&e("p",{className:"_InputBase_Label_Text",children:o}),t("div",{className:"_InputBase_Border_Box",children:[l&&e("button",{disabled:p||l.disabled,onClick:()=>{l.onClick&&l.onClick()},className:"_InputBase_Start_Adornment",children:l.icon}),e("input",{onBlur:e=>{h&&h(e.target.value),f&&C(e)},ref:x||b,placeholder:m,disabled:p,className:"_InputBase_Input_Text",value:w,onChange:e=>{n?n(e.target.value):y(e.target.value)},maxLength:A,onFocus:e=>(e=>{y(e.target.value.toString().replace(f,"").trim())})(e)}),d&&e("button",{disabled:p||d.disabled,onClick:()=>{d.onClick&&d.onClick()},className:"_InputBase_End_Adornment",children:d.icon}),e(Ks,{status:c})]}),g&&e("p",{className:"_InputBase_Helper_Text",children:g})]})})})),Zs=n.forwardRef((({label:o,value:i,onChange:n,startAdornment:l,endAdornment:d,status:c,disabled:p,placeholder:m,className:u,onBlur:h,message:g,uppercase:A,maxLength:f,onKeyDown:v,onKeyUp:x,type:b,inputMode:w},y)=>{const C=s(null),[E,B]=r(y?i:i||"");return a((()=>{null!=i&&i!==E&&B(A?i.toUpperCase():i)}),[i]),e(Vs,{status:p?"disabled":c,className:u,children:t("label",{title:o,className:"_InputBase_Label_Wrapper",children:[o&&e("p",{className:"_InputBase_Label_Text",children:o}),t("div",{className:"_InputBase_Border_Box",children:[l&&e("button",{disabled:p||l.disabled,onClick:()=>{l.onClick&&l.onClick()},className:"_InputBase_Start_Adornment",children:l.icon}),e("input",{onBlur:e=>{h&&h(e.target.value)},ref:y||C,placeholder:m,disabled:p,type:b,inputMode:w,className:"_InputBase_Input_Text "+(A?"uppercase":""),value:E,onChange:e=>{n&&n(e.target.value)},maxLength:f,onKeyDown:v,onKeyUp:x}),d&&e("button",{disabled:p||d.disabled,onClick:()=>{d.onClick&&d.onClick()},className:"_InputBase_End_Adornment",children:d.icon}),e(Ks,{status:c})]}),g&&e("p",{className:"_InputBase_Helper_Text",children:g})]})})})),Xs=({label:t,mask:o,onChange:i,onBlur:n,className:r,startAdornment:l,endAdornment:d,status:s,message:c,disabled:p,value:m,onChangeMasked:u,uppercase:h,placeholder:g,maxLength:A,onKeyDown:f,onKeyUp:v})=>{const{ref:x,maskRef:b,value:w,unmaskedValue:y,setUnmaskedValue:C,typedValue:E,setTypedValue:B}=Do(o,{onAccept:(e,{unmaskedValue:t},o)=>{(null==o?void 0:o.isTrusted)&&(u&&u(e),i&&i(t))}});return a((()=>{void 0!==m&&null===m&&C(""),null!=m&&m!==y&&m!==w&&C(m.toString())}),[m]),e(Zs,{onBlur:()=>{n&&n({value:y,valueMasked:w})},label:t,disabled:p,ref:x,startAdornment:l,endAdornment:d,status:s,message:c,className:r,uppercase:h,placeholder:g,maxLength:A,onKeyDown:f,onKeyUp:v})},_s={mask:[{mask:""},{mask:"num{%}",lazy:!1,blocks:{num:{mask:Number,scale:3,min:0,max:100,radix:".",mapToRadix:[",","."]}}}]},$s={mask:"00000-000",lazy:!0,placeholderChar:"_"},ec={mask:"R$ {num}",lazy:!1,blocks:{num:{mask:Number,thousandsSeparator:".",scale:2,radix:",",mapToRadix:["."],padFractionalZeros:!0}}};var tc=Object.freeze({__proto__:null,Address:{mask:/^[a-zA-Z\s]*$/,lazy:!0,placeholderChar:"_"},CAR:{mask:"##-0000000-DDDD.DDDD.DDDD.DDDD.DDDD.DDDD.DDDD.DDDD",definitions:{"#":/[a-zA-Z]/,D:/[0-9a-zA-Z]/},lazy:!0,placeholderChar:"_"},CCIR:{mask:"000.000.000.000-0",lazy:!0,placeholderChar:"_"},CVV:{mask:"000[0]",lazy:!0,placeholderChar:"_"},CVVAmex:{mask:"0000",lazy:!0,placeholderChar:"_"},Cellphone:{mask:"(000) [9] 0000-0000 ",lazy:!0,placeholderChar:"_"},CellphoneAndTelephone:{mask:[{mask:"(00) 0000-0000 ",lazy:!0,placeholderChar:" "},{mask:"(00) 0 0000-0000 ",lazy:!0,placeholderChar:"_"}]},CellphoneTwoDDD:{mask:"(00) 00000-0000 ",lazy:!0,placeholderChar:"_"},Cep:$s,Cnpj:{mask:"00.000.000/0000-00",lazy:!0,placeholderChar:"_"},Complement:{mask:/^[a-zA-Z0-9\s]*$/,lazy:!0,placeholderChar:"_"},Cpf:{mask:"000.000.000-00",lazy:!0,placeholderChar:"_"},CpfAndCnpj:{mask:[{mask:"000.000.000-00",lazy:!0,placeholderChar:"_"},{mask:"00.000.000/0000-00",lazy:!0,placeholderChar:"_"}]},CreditCard:{mask:"0000 0000 0000 0000",lazy:!0,placeholderChar:"_"},CreditCardAmericanExpress:{mask:"0000 000000 00000",lazy:!0,placeholderChar:"_"},CreditCardDate:{mask:"00/00",lazy:!0,placeholderChar:"_"},Email:{mask:/^\S*@?\S*$/,lazy:!1,placeholderChar:"_"},Idade:{mask:"000",lazy:!0,placeholderChar:"_"},Matricula:{mask:"0000000000",lazy:!0,placeholderChar:"_"},Money:ec,NIRF:{mask:"0.000.000-0",lazy:!0,placeholderChar:"_"},Name:{mask:/^[a-zA-ZA-zÀ-ú\s]*$/,lazy:!0,placeholderChar:"_"},NameNoAccent:{mask:/^[a-zA-ZA-z\s]*$/,lazy:!0,placeholderChar:"_"},NomeImovel:{mask:/[a-zA-ZÀ-ÖØ-öø-ÿ0-9'`˜ˆ,\s]+$/,lazy:!0,placeholderChar:"_"},Percentage:_s,Telephone:{mask:"(000) 0000-0000 ",lazy:!0,placeholderChar:"_"},qtdInteiros:{mask:"000000",lazy:!0,placeholderChar:"_"}});const oc=h("div")`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  width: 100%;
  position: relative;

  font-weight: 400;
  color: ${f.color04};
  cursor: pointer;

  //INPUT E BORDER
  :focus-within ._SelectBase_Border_Box {
    border: 2px solid ${f.color02};
  }

  ._SelectBase_Wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-flow: row nowrap;
    align-items: center;
    padding-left: 1rem;
  }

  ._SelectBase_Select_Text {
    font-size: 1rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    word-break: break-all;
    color: ${f.color04};
    /* text-transform: lowercase; */

    /* :first-letter {
      text-transform: uppercase;
    } */
  }

  ._SelectBase_Actions {
    display: flex;
    align-items: center;
    flex-flow: row nowrap;
  }

  ._SelectBase_Border_Box {
    height: 40px;
    overflow: hidden;
    display: flex;
    justify-content: start;
    align-items: center;
    border: 1px solid ${f.color08};
    border-radius: 8px;
    outline: 0px solid rgba(0, 0, 0, 0);
    transition-duration: 200ms;
  }

  .placeholder {
    color: ${f.color08};
  }

  //FIM INPUT E BORDER
  //LABEL
  .__SelectBase_Label_Wrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: start;
  }
  ._Select_Label_Text {
    font-size: 0.875rem;
    line-height: 1.063rem;
    line-height: 1.063rem;
    padding-bottom: 0.4rem;
  }

  //FIM LABEL
  //LISTA
  ._Select_Item_List {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background-color: ${f.bg03};
    box-shadow: 0px 3px 6px ${f.color11};
    max-height: 210px;
    width: 100%;
    overflow-y: auto;
    outline: none;
    position: absolute;
    top: ${e=>e.hasLabel?"70px":"45px"};
    z-index: 10;
  }
  ._Select_Item {
    display: flex;
    align-items: center;
    padding: 0.8rem;
    border-bottom: 1px solid ${f.color06};
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0);
    transition-duration: 200ms;
    font-size: 0.875rem;
    line-height: 1.063rem;
  }

  ._Select_Item_Text {
    flex: 1 1 auto;
    font-size: 0.875rem;
    line-height: 1.063rem;
    /* text-transform: lowercase; */
    /*
    :first-letter {
      text-transform: uppercase;
    } */
  }

  ._Select_Input {
    height: 35px;
    width: 100%;
    margin: 0 8px;
    border: none;
    outline: none;
  }

  .focused {
    transition-duration: 200ms;
    background-color: ${f.color06};
  }
  .selected {
    transition-duration: 200ms;
    border-left: 5px solid ${f.color02};
  }
  ._Select_Selected_Icon {
    display: none;
    color: ${f.bg03};
    transition-duration: 200ms;
    min-width: 16px;
  }

  .selected ._Select_Selected_Icon {
    display: flex;
    color: ${f.colorSuccess};
    transition-duration: 200ms;
  }
  //FIM LISTA
  //BOTOES
  ._SelectBase_Open_Button {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: none;
    min-height: 32px;
    max-height: 32px;
    min-width: 32px;
    max-width: 32px;
    border-radius: 9999px;
    background-color: rgba(0, 0, 0, 0);
    color: ${f.color04};
    transition-duration: 200ms;
    outline: none;
    color: ${f.color04};
    :hover {
      transition-duration: 200ms;
      background-color: ${f.color06};
    }
    :focus,
    :focus-visible {
      background-color: ${f.color07};
    }
    :active {
      filter: brightness(0.95);
    }
  }
  ._SelectBase_Open_Button {
    :last-child {
      margin-right: 0.5rem;
    }
    margin-right: 0.3rem;
    margin-left: 0rem;
  }

  ._SelectBase_Clear_Button {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: none;
    min-height: 32px;
    max-height: 32px;
    min-width: 32px;
    max-width: 32px;
    border-radius: 9999px;
    background-color: rgba(0, 0, 0, 0);
    transition-duration: 200ms;
    outline: none;
    color: ${f.color04};
    :hover {
      transition-duration: 200ms;
      color: ${f.colorError};
      background-color: ${f.color06};
    }
    :focus,
    :focus-visible {
      color: ${f.colorError};
      background-color: ${f.color07};
    }
    :active {
      filter: brightness(0.95);
    }
  }
  //FIM BOTOES

  ._SelectBase_Helper_Text {
    font-size: 0.875rem;
    line-height: 1.063rem;
    color: ${f.color08};
    padding-top: 0.5rem;
  }

  ._SelectBase_Status_Icon {
    margin: 0rem 0.8rem 0rem 0.4rem;
    min-width: 16px;
  }
  ${e=>{switch(e.status){case"error":return g`
          ._SelectBase_Status_Icon {
            color: ${f.colorError};
          }
          ._SelectBase_Border_Box {
            border: 1px solid ${f.colorError};
          }
          ._SelectBase_Helper_Text {
            color: ${f.colorError};
          }
        `;case"success":return g`
          ._SelectBase_Status_Icon {
            color: ${f.colorSuccess};
          }
          ._SelectBase_Border_Box {
            border: 1px solid ${f.colorSuccess};
          }
          ._SelectBase_Helper_Text {
            color: ${f.colorSuccess};
          }
        `;case"warning":return g`
          ._SelectBase_Status_Icon {
            color: ${f.colorWarning};
          }
          ._SelectBase_Border_Box {
            border: 1px solid ${f.colorWarning};
          }
          ._SelectBase_Helper_Text {
            color: ${f.colorWarning};
          }
        `;case"disabled":return g`
          ._SelectBase_Status_Icon {
            color: ${f.color08};
          }
          ._SelectBase_Border_Box {
            border: 1px solid ${f.color07};
            background-color: ${f.color06};
          }
          ._Select_Label_Text {
            color: ${f.color08};
          }
          ._SelectBase_Select_Text {
            color: ${f.color08};
          }
          ._SelectBase_Open_Button {
            background-color: rgba(0, 0, 0, 0) !important;
          }
        `;default:return""}}}
`,ic=({status:t})=>{switch(t){case"error":return e(D,{title:"Ícone Alerta",className:"_SelectBase_Status_Icon error"});case"success":return e(M,{title:"Ícone Sucesso",className:"_SelectBase_Status_Icon success"});case"warning":return e(K,{title:" Ícone Erro",className:"_SelectBase_Status_Icon warning"});default:return null}};function nc(e,t){return 0==e.length?[]:"object"==typeof e[0]&&t?e.map((e=>Object.assign({title:t.subtitle&&e[t.subtitle]?e[t.title]+" / "+e[t.subtitle]:e[t.title],value:e[t.value],disabled:e[t.disabled||""]},e))):e.map((e=>({title:e,value:e})))}function rc(e){return m(e.title)?"":e?e.title:""}function ac(e,t){if(e===t)return!0;if(null==e||null==t)return!1;if(e.length!==t.length)return!1;const o=JSON.parse(JSON.stringify(e));o.sort(((e,t)=>{var o,i;return e.value==t.value?0:"number"==typeof e&&"number"==typeof t?e-t:(null===(o=null==e?void 0:e.value)||void 0===o?void 0:o.toString().localeCompare((null===(i=null==t?void 0:t.value)||void 0===i?void 0:i.toString())||""))||0}));const i=[...t];i.sort(((e,t)=>{if(e==t)return 0;if(!0===e||!1===e){if(e&&t||!e&&!t)return 0;if(!0===e&&!1===t)return-1;if(!1===e&&!0===t)return 1}return"number"==typeof e&&"number"==typeof t?e-t:(null==e?void 0:e.toString().localeCompare((null==t?void 0:t.toString())||""))||!1}));for(let t=0;t<e.length;++t)if(o[t]!==i[t])return!1;return!0}function lc(e){if(Array.isArray(e)&&e.length){const t=JSON.parse(JSON.stringify(e[0]));return Object.keys(t).forEach((e=>{!0===t[e]?t[e]=!1:"number"==typeof t[e]?t[e]=0:"string"==typeof t[e]&&(t[e]="")})),t.title="",t.value="",t}return{title:"",value:""}}function dc({label:o,items:i,onChange:n,onChangeItem:l,parser:d,className:c,placeholder:p,status:m,message:u,disabled:h,value:g,itemRender:A,hasOptionToAddItem:f,hideCheckmark:v=!1,hasClearButton:x=!0}){const[b,w]=r([]),[y,C]=r(""),E=s(null),{getToggleButtonProps:B,getLabelProps:k,getMenuProps:I,getItemProps:N,selectItem:S,isOpen:O,selectedItem:P,highlightedIndex:Q}=jo({items:b,itemToString:rc,onSelectedItemChange:e=>{var t;e.selectedItem&&""!==e.selectedItem.title&&e.selectedItem.value!==g&&(n&&n((null===(t=e.selectedItem)||void 0===t?void 0:t.value)||""),l&&l(e.selectedItem))}});a((()=>{if(!P&&g||P&&g&&g!==P.value){const e=b.filter((e=>g==e.value))[0];e&&S(e)}""===g&&S(Object.assign({},lc(b)))}),[g]),a((()=>{if(void 0===i)throw new Error("Array nao pode ser undefined");const e=nc(i,d);if(w(e),(!P||""===P.value)&&g){const t=e.filter((e=>g==e.value))[0];t&&S(t)}if(P){const t=e.filter((e=>P.value==e.value))[0];t&&t.value!=P.value&&S(t)}}),[i]);return t(oc,{status:h?"disabled":m,className:c,hasLabel:!!o,children:[e("label",Object.assign({className:"_SelectBase_Label_Wrapper"},k(),{children:o&&e("p",{className:"_Select_Label_Text",children:o||"‎"})})),e("button",Object.assign({type:"button"},B({disabled:h}),{className:"_SelectBase_Border_Box",children:t("div",{className:"_SelectBase_Wrapper",children:[e("p",{className:`_SelectBase_Select_Text ${P&&P.value||"placeholder"}`,children:(null==P?void 0:P.labelSelectedOption)||(null==P?void 0:P.title)||p}),t("div",{className:"_SelectBase_Actions",children:[x&&P&&""!=P.value&&e("button",{title:"Limpar seleção",disabled:h,type:"button",className:"_SelectBase_Clear_Button",onClick:e=>{e.stopPropagation(),S(Object.assign({},lc(b))),n&&n(""),l&&l(Object.assign({},lc(b)))},children:e(F,{title:"Ícone X"})}),e("button",{disabled:h,type:"button",title:"Abrir opções",className:"_SelectBase_Open_Button",children:O?e(J,{title:"Ícone seta para cima"}):e(Y,{title:"Ícone seta para baixo"})}),e(ic,{status:m})]})]})})),t("ul",Object.assign({},I(),{className:"_Select_Item_List",children:[O&&f&&e("li",{children:e("input",{type:"text",value:y,onChange:e=>{C(e.target.value)},onKeyDown:e=>{var t;if("Enter"===e.key&&""!==y.trim()){const e={title:y.trim(),value:y.trim()};0===b.filter((t=>t.value==e.value)).length&&w((t=>[...t,e])),S(e),C(""),null===(t=E.current)||void 0===t||t.focus()}},placeholder:"Adicionar novo item",className:"_Select_Input"})}),O&&!b.length&&e("div",{className:"_Select_Item",children:"Nada encontrado"}),O&&b.length>0&&!A&&b.map(((o,i)=>t("li",Object.assign({className:`_Select_Item ${Q==i&&"focused"} ${(null==P?void 0:P.value)==o.value&&"selected"}`},N({item:o,index:i}),{children:[e("p",{className:"_Select_Item_Text",children:o.title}),!v&&e(M,{title:"Valor selecionado",className:"_Select_Selected_Icon"})]}),`${o.value}`))),O&&b.length>0&&A&&b.map(((t,o)=>e("li",Object.assign({className:`_Select_Item ${Q==o&&"focused"} ${(null==P?void 0:P.value)==t.value&&"selected"}`},N({item:t,index:o}),{children:A(t,{index:o})}),`${t.value}`)))]})),u&&e("p",{className:"_SelectBase_Helper_Text",children:u})]})}const sc=h("div")`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  width: 100%;
  position: relative;

  font-weight: 400;
  color: ${f.color04};

  button,
  svg {
    color: ${f.color04};
  }

  :focus-within ._ComboBox_Border_Box {
    outline: 2px solid ${f.color02};
  }

  //TEXTO E BORDER

  ._ComboBox_Input_Text_First_Letter {
    flex-direction: column;
    height: 100%;
    flex: 1 1 auto;
    display: flex;
    align-items: stretch;

    /* :first-letter {
      text-transform: uppercase;
    } */
  }

  ._ComboBox_Input_Text {
    height: 100%;
    font-size: 1rem;
    background-color: transparent;
    overflow-x: hidden;
    word-break: break-all;
    border: none;
    /* text-transform: lowercase; */
    color: ${f.color04};

    :focus-visible {
      outline: none;
    }
    :focus-visible {
      outline: none;
    }
    :first-child {
      margin-left: 0.875rem;
    }
    :last-child {
      margin-right: 0.875rem;
    }
    :disabled {
      background-color: transparent;
      color: ${f.color08};
      -webkit-text-fill-color: ${f.color08};
    }
    ::placeholder {
      color: ${f.color08};
    }
  }

  .__ComboBox_Wrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: start;
  }

  .__ComboBox_Label_Wrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: start;
  }

  ._ComboBox_Border_Box {
    height: 40px;
    overflow: hidden;
    display: flex;
    justify-content: start;
    align-items: center;
    border: 1px solid ${f.color08};
    border-radius: 8px;
    outline: none;
    transition-duration: 200ms;
  }

  ._ComboBox_Selection_Status {
    margin-right: 5px;
    min-width: 16px;
  }
  .changed {
    color: ${f.color02};
  }

  .match {
    color: ${f.colorSuccess};
  }
  //FIM TEXTO E BORDA
  // LABEL
  ._ComboBox_Label_Text {
    font-size: 0.875rem;
    line-height: 1.063rem;
    overflow: hidden;
    padding-bottom: 0.4rem;
  }

  ._ComboBox_Text {
    font-size: 0.875rem;
    line-height: 1.063rem;
    padding-bottom: 0.4rem;
  }

  .__ComboBox_Label_Wrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: start;
  }

  //LISTA
  ._ComboBox_Item_List {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background-color: ${f.bg03};
    box-shadow: 0px 3px 6px ${f.color11};
    max-height: 210px;
    width: 100%;
    overflow-y: auto;
    outline: none;
    position: absolute;
    top: 70px;
    z-index: 10;
  }

  ._ComboBox_Item {
    display: flex;
    align-items: center;
    padding: 0.8rem;
    border-bottom: 1px solid ${f.color06};
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0);
    transition-duration: 200ms;
    font-size: 0.875rem;
    line-height: 1.063rem;
  }

  ._ComboBox_Item_Text {
    flex: 1 1 auto;
    font-size: 0.875rem;
    line-height: 1.063rem;
    /* text-transform: lowercase; */

    /* :first-letter {
      text-transform: uppercase;
    } */
  }

  ._ComboBox_Selected_Icon {
    display: none;
    color: ${f.bg03};
    transition-duration: 200ms;
    min-width: 16px;
  }

  .selected ._ComboBox_Selected_Icon {
    display: flex;
    color: ${f.colorSuccess};
    transition-duration: 200ms;
  }

  .focused {
    transition-duration: 200ms;
    background-color: ${f.color06};
  }
  .selected {
    transition-duration: 200ms;
    border-left: 5px solid ${f.color02};
  }

  //FIM LISTA
  //BOTOES

  ._ComboBox_Open_Button {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: none;
    min-height: 32px;
    max-height: 32px;
    min-width: 32px;
    max-width: 32px;
    border-radius: 9999px;
    background-color: rgba(0, 0, 0, 0);
    transition-duration: 200ms;
    outline: none;
    :hover {
      transition-duration: 200ms;
      background-color: ${f.color06};
    }
    :focus,
    :focus-visible {
      background-color: ${f.color07};
    }
    :active {
      filter: brightness(0.95);
    }
  }
  ._ComboBox_Open_Button {
    :last-child {
      margin-right: 0.5rem;
    }
    margin-right: 0.3rem;
    margin-left: 0rem;
  }

  ._Combobox_Clear_Button {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: none;
    min-height: 32px;
    max-height: 32px;
    min-width: 32px;
    max-width: 32px;
    border-radius: 9999px;
    background-color: rgba(0, 0, 0, 0);
    transition-duration: 200ms;
    outline: none;
    :hover {
      transition-duration: 200ms;
      color: ${f.colorError};
      background-color: ${f.color06};
    }
    :focus,
    :focus-visible {
      color: ${f.colorError};
      background-color: ${f.color07};
    }
    :active {
      filter: brightness(0.95);
    }

    svg {
      color: ${f.color04};
    }
  }

  // FIM BOTES

  ._ComboBox_Helper_Text {
    font-size: 0.875rem;
    line-height: 1.063rem;
    color: ${f.color08};
    padding-top: 0.5rem;
  }

  //STATUS

  ._ComboBox_Status_Icon {
    margin-right: 0.875rem;
  }

  ${e=>{switch(e.status){case"error":return g`
            ._ComboBox_Status_Icon {
              color: ${f.colorError};
            }
            ._ComboBox_Border_Box {
              border: 1px solid ${f.colorError};
            }
            ._ComboBox_Helper_Text {
              color: ${f.colorError};
            }
          `;case"success":return g`
            ._ComboBox_Status_Icon {
              color: ${f.colorSuccess};
            }
            ._ComboBox_Border_Box {
              border: 1px solid ${f.colorSuccess};
            }
            ._ComboBox_Helper_Text {
              color: ${f.colorSuccess};
            }
          `;case"warning":return g`
            ._ComboBox_Status_Icon {
              color: ${f.colorWarning};
            }
            ._ComboBox_Border_Box {
              border: 1px solid ${f.colorWarning};
            }
            ._ComboBox_Helper_Text {
              color: ${f.colorWarning};
            }
          `;case"disabled":return g`
            ._ComboBox_Status_Icon {
              color: ${f.color08};
            }
            ._ComboBox_Border_Box {
              border: 1px solid ${f.color07};
              background-color: ${f.color06};
            }
            ._ComboBox_Label_Text {
              color: ${f.color08};
            }
            ._ComboBox_Select_Text {
              color: ${f.color08};
            }
            ._ComboBox_Open_Button {
              background-color: rgba(0, 0, 0, 0) !important;
            }
          `;default:return""}}}
`,cc=({status:t})=>{switch(t){case"error":return e(D,{title:" Ícone Alerta",width:24,className:"_ComboBox_Status_Icon error"});case"success":return e(M,{title:" Ícone Sucesso",className:"_ComboBox_Status_Icon success"});case"warning":return e(K,{title:" Ícone Erro",className:"_ComboBox_Status_Icon warning"});default:return null}};function pc(e,t){return e&&e.replaceAll(" ","")?t.filter((t=>t.title&&t.title.toLowerCase().includes(e.toLowerCase()))):t}function mc({label:o,items:i,className:n,parser:l,value:d,onChange:s,onChangeItem:c,onTextChange:p,placeholder:m,disabled:u,status:h,message:g,mustCloseWhenSelect:A,emptyText:f,notFoundText:v}){const[x,b]=r([]),[w,y]=r([]),{getLabelProps:C,getMenuProps:E,getInputProps:B,getToggleButtonProps:k,getComboboxProps:I,setInputValue:N,getItemProps:S,openMenu:O,selectItem:P,isOpen:Q,inputValue:z,selectedItem:D,closeMenu:j,highlightedIndex:T}=To({items:w,itemToString:rc,onIsOpenChange:e=>{var t;e.isOpen||(e.selectedItem&&e.selectedItem.title!=z&&(N(e.selectedItem.title),y(pc(e.selectedItem.title,x))),(null===(t=e.selectedItem)||void 0===t?void 0:t.value)||(N(""),y(pc(void 0,x))))},onInputValueChange:({inputValue:e})=>{x.length&&y(pc(e,x)),p&&(f||D&&D.title!=d)&&p(e||"")},onSelectedItemChange:e=>{var t;e.selectedItem&&e.selectedItem.value!=d&&""!==e.selectedItem.title&&(s&&s((null===(t=e.selectedItem)||void 0===t?void 0:t.value)||""),A&&j(),c&&c(e.selectedItem))}});return a((()=>{if(null==i)throw new Error("Array nao pode ser undefined");const e=nc(i,l);if(D&&""!==D.value||!d)if(D&&""!==D.value){const t=e.filter((e=>D.value==e.value))[0];t&&(y(pc(D.title,e)),P(t))}else y(pc("",e));else{const t=e.filter((e=>d==e.value))[0];t?(y(pc(t.title,e)),P(t)):y(pc("",e))}b(e)}),[i]),a((()=>{if(!D&&d||D&&d&&d!==D.value){const e=x.filter((e=>d==e.value))[0];e&&(y(pc(e.title,x)),P(e))}""!==d&&null!==d||(y(pc("",nc(i,l))),P(Object.assign({},lc(x))))}),[d]),t(sc,{status:u?"disabled":h,className:n,children:[e("label",Object.assign({className:"_ComboBox_Label_Wrapper"},C({disabled:u}),{children:e("p",{className:"_ComboBox_Label_Text",children:o||"‎"})})),t("div",Object.assign({className:"_ComboBox_Border_Box"},I({disabled:u}),{children:[e("p",{className:"_ComboBox_Input_Text_First_Letter",children:e("input",Object.assign({placeholder:m,className:"_ComboBox_Input_Text"},B({disabled:u,onFocus:O})))}),(D&&D.title!=z||!D&&z)&&e(Z,{title:"O texto escrito não está selecionado",className:"_ComboBox_Selection_Status changed "}),D&&""!=D.value&&e("button",{title:"Limpar seleção",disabled:u,type:"button",className:"_Combobox_Clear_Button",onClick:()=>{P(Object.assign({},lc(x))),s&&s(""),c&&c(Object.assign({},lc(x)))},children:e(F,{title:"Ícone X"})}),e("button",Object.assign({disabled:u,type:"button",className:"_ComboBox_Open_Button"},k(),{children:Q?e(J,{title:"Ícone Seta para cima"}):e(Y,{title:" Ícone Seta para baixo"})})),e(cc,{status:h})]})),t("ul",Object.assign({},E(),{className:"_ComboBox_Item_List",children:[Q&&!w.length&&e("div",{className:"_ComboBox_Item",children:v||"Nenhum item com esta descrição"}),Q&&w.length>0&&w.map(((o,i)=>t("li",Object.assign({},S({item:o,index:i}),{className:`_ComboBox_Item ${T==i&&"focused"} ${(null==D?void 0:D.value)==o.value&&"selected"}`,children:[e("p",{className:"_ComboBox_Item_Text",children:o.title}),e(M,{title:"Valor selecionado",className:"_ComboBox_Selected_Icon"})]}),`${o.value}`)))]})),g&&e("p",{className:"_ComboBox_Helper_Text",children:g})]})}const uc=h("div")`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  width: 100%;
  position: relative;

  font-weight: 400;
  color: ${f.color04};
  cursor: pointer;

  //INPUT E BORDER
  :focus-within ._SelectBase_Border_Box {
    outline: 2px solid ${f.color02};
  }

  ._SelectBase_Select_Text {
    display: flex;
    align-items: center;
    font-size: 1rem;
    padding-left: 1rem;
    height: 100%;
    flex: 1 1 auto;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    word-break: break-all;
  }

  ._SelectBase_Border_Box {
    height: 40px;
    overflow: hidden;
    display: flex;
    justify-content: start;
    align-items: center;
    border: 1px solid ${f.color08};
    border-radius: 8px;
    outline: 0px solid rgba(0, 0, 0, 0);
    transition-duration: 200ms;
  }

  .placeholder {
    color: ${f.color08};
  }

  //FIM INPUT E BORDER
  //LABEL
  .__SelectBase_Label_Wrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: start;
  }
  ._Select_Label_Text {
    font-size: 0.875rem;
    line-height: 1.063rem;
    line-height: 1.063rem;
    padding-bottom: 0.4rem;
  }

  //FIM LABEL
  //LISTA
  ._Select_Item_List {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background-color: ${f.bg03};
    box-shadow: 0px 3px 6px ${f.color11};
    max-height: 210px;
    width: 100%;
    overflow-y: auto;
    outline: none;
    position: absolute;
    top: 70px;
    z-index: 10;
  }
  ._Select_Item {
    display: flex;
    align-items: center;
    padding: 0.8rem;
    border-bottom: 1px solid ${f.color06};
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0);
    transition-duration: 200ms;
    font-size: 0.875rem;
    line-height: 1.063rem;
    border-left: 0px solid ${f.color02};
  }

  ._Select_Item_Text {
    flex: 1 1 auto;
    font-size: 0.875rem;
    line-height: 1.063rem;
  }
  .focused {
    transition-duration: 200ms;
    background-color: ${f.color06};
  }
  .selected {
    transition-duration: 200ms;
    border-left: 5px solid ${f.color02};
  }
  ._Select_Selected_Icon {
    display: none;
    color: ${f.bg03};
    transition-duration: 200ms;
    min-width: 16px;
  }

  .selected ._Select_Selected_Icon {
    display: flex;
    color: ${f.colorSuccess};
    transition-duration: 200ms;
  }

  ._Select_Item_Checkbox {
    margin-right: 1rem;
    color: ${f.bg01} !important;
  }
  //FIM LISTA
  //BOTOES
  ._SelectBase_Open_Button {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: none;
    min-height: 32px;
    max-height: 32px;
    min-width: 32px;
    max-width: 32px;
    border-radius: 9999px;
    background-color: rgba(0, 0, 0, 0);
    transition-duration: 200ms;
    outline: none;
    :hover {
      transition-duration: 200ms;
      background-color: ${f.color06};
    }
    :focus,
    :focus-visible {
      background-color: ${f.color07};
    }
    :active {
      filter: brightness(0.95);
    }
  }
  ._SelectBase_Open_Button {
    :last-child {
      margin-right: 0.5rem;
    }
    margin-right: 0.3rem;
    margin-left: 0rem;
  }

  ._SelectBase_Clear_Button {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: none;
    min-height: 32px;
    max-height: 32px;
    min-width: 32px;
    max-width: 32px;
    border-radius: 9999px;
    background-color: rgba(0, 0, 0, 0);
    transition-duration: 200ms;
    outline: none;
    :hover {
      transition-duration: 200ms;
      color: ${f.colorError};
      background-color: ${f.color06};
    }
    :focus,
    :focus-visible {
      color: ${f.colorError};
      background-color: ${f.color07};
    }
    :active {
      filter: brightness(0.95);
    }
  }
  //FIM BOTOES

  ._SelectBase_Helper_Text {
    font-size: 0.875rem;
    line-height: 1.063rem;
    color: ${f.color08};
    padding-top: 0.5rem;
  }

  ._SelectBase_Status_Icon {
    margin: 0rem 0.8rem 0rem 0.4rem;
    min-width: 16px;
  }
  ${e=>{switch(e.status){case"error":return`\n        ._SelectBase_Status_Icon {\n          color: ${f.colorError};\n        }\n        ._SelectBase_Border_Box {\n          border: 1px solid ${f.colorError};\n        }\n        ._Select_Helper_Text{\n          color: ${f.colorError};\n\n        }`;case"success":return`\n        ._SelectBase_Status_Icon {\n          color: ${f.colorSuccess};\n        }\n        ._SelectBase_Border_Box {\n          border: 1px solid ${f.colorSuccess};\n        }\n        ._SelectBase_Helper_Text {\n          color: ${f.colorSuccess};\n        }\n        `;case"warning":return`\n        ._SelectBase_Status_Icon {\n          color: ${f.colorWarning};\n        }\n        ._SelectBase_Border_Box {\n          border: 1px solid ${f.colorWarning};\n        }\n        ._SelectBase_Helper_Text {\n          color: ${f.colorWarning};\n        }\n        `;case"disabled":return`\n        ._SelectBase_Status_Icon {\n          color: ${f.color08};\n        }\n        ._SelectBase_Border_Box {\n          border: 1px solid ${f.color07};\n          background-color: ${f.color06}\n        }\n        ._Select_Label_Text{\n          color:${f.color08}\n        }\n        ._SelectBase_Select_Text {\n          color:${f.color08}\n        }\n       ._SelectBase_Open_Button{\n            background-color: rgba(0,0,0,0)!important;\n        }\n        `;default:return""}}}
`,hc=({status:t})=>{switch(t){case"error":return e(D,{title:" Ícone Alerta",className:"_SelectBase_Status_Icon error"});case"success":return e(M,{title:" Ícone Sucesso",className:"_SelectBase_Status_Icon success"});case"warning":return e(K,{title:" Ícone Erro",className:"_SelectBase_Status_Icon warning"});default:return null}};function gc(e,t){const{changes:o,type:i}=t;switch(i){case jo.stateChangeTypes.MenuKeyDownEnter:case jo.stateChangeTypes.MenuKeyDownSpaceButton:case jo.stateChangeTypes.ItemClick:return Object.assign(Object.assign({},o),{isOpen:!0,highlightedIndex:e.highlightedIndex});default:return o}}function Ac({label:o,items:i,onChange:n,onChangeItem:l,parser:d,className:s,placeholder:c,status:p,message:m,disabled:u,value:h}){const[g,A]=r([]),[f,v]=r([]),{getToggleButtonProps:x,getLabelProps:b,getMenuProps:w,getItemProps:y,isOpen:C,highlightedIndex:E}=jo({items:g,itemToString:rc,stateReducer:gc,selectedItem:null,onSelectedItemChange:e=>{if(e.selectedItem){const t=f.filter((t=>{var o;return t.value!==(null===(o=e.selectedItem)||void 0===o?void 0:o.value)}));t.length==f.length?(n&&n([...t.map((e=>e.value)),e.selectedItem.value]),l&&l([...t,e.selectedItem]),v([...f,e.selectedItem])):(n&&n(t.map((e=>e.value))),l&&l(t),v([...t]))}}});return a((()=>{if(!f.length&&h&&h.length||f.length&&h&&h.length&&!ac(f,h)){const e=g.filter((e=>!!h.filter((t=>t==e.value)).length));e.length&&v(e)}h&&h.length||v([])}),[h]),a((()=>{if(void 0===i)throw new Error("Array nao pode ser undefined");const e=nc(i,d);if(A(e),(!f||!f.length)&&h&&h.length){const t=e.filter((e=>!!h.filter((t=>e.value==t)).length));t.length&&v(t)}if(f&&f.length){const t=e.filter((e=>!!f.filter((t=>t.value==e.value)).length));t.length&&!ac(t,f)&&v(t)}}),[i]),t(uc,{status:u?"disabled":p,className:s,children:[e("label",Object.assign({className:"_SelectBase_Label_Wrapper"},b(),{children:e("p",{className:"_Select_Label_Text",children:o||"‎"})})),t("button",Object.assign({type:"button"},x({disabled:u}),{className:"_SelectBase_Border_Box ",children:[e("p",{className:`_SelectBase_Select_Text ${f.length||"placeholder"}`,children:f.length?`${f.length} ite${f.length>1?"ns":"m"} selecionado${f.length>1?"s":""} `:c}),f&&!!f.length&&e("button",{title:"Limpar seleção",disabled:u,type:"button",className:"_SelectBase_Open_Button",onClick:()=>{v([]),n&&n([]),l&&l([])},children:e(F,{title:"Ícone X"})}),e("button",{disabled:u,type:"button",className:"_SelectBase_Open_Button",children:C?e(J,{title:"Ícone seta para cima"}):e(Y,{title:"Ícone seta para baixo"})}),e(hc,{status:p})]})),t("ul",Object.assign({},w({disabled:!!u}),{className:"_Select_Item_List",children:[C&&!g.length&&e("div",{className:"_Select_Item",children:"Nada encontrado"}),C&&g.length>0&&g.map(((o,i)=>t("li",Object.assign({className:`_Select_Item ${E==i&&"focused"} ${f.includes(o)&&"selected"}`},y({item:o,index:i,disabled:!!u}),{children:[f.includes(o)?e(X,{className:"_Select_Item_Checkbox ",title:"Checkbox selecionado"}):e(_,{className:" _Select_Item_Checkbox ",title:"Checkbox não selecionado"}),e("p",{className:"_Select_Item_Text",children:o.title}),e(M,{title:"Valor selecionado",className:"_Select_Selected_Icon"})]}),`${o.value}`)))]})),m&&e("p",{className:"_SelectBase_Helper_Text",children:m})]})}const fc=h("div")`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  width: 100%;
  position: relative;

  font-weight: 400;
  color: ${f.color04};
  cursor: pointer;

  button,
  svg {
    color: ${f.color04};
  }

  //INPUT E BORDER
  :focus-within ._SelectBase_Border_Box {
    outline: 2px solid ${f.color02};
  }

  ._SelectBase_Select_Text {
    display: flex;
    align-items: center;
    font-size: 1rem;
    padding-left: 1rem;
    height: 100%;
    flex: 1 1 auto;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    word-break: break-all;
  }

  ._SelectBase_Border_Box {
    height: 40px;
    overflow: hidden;
    display: flex;
    justify-content: start;
    align-items: center;
    border: 1px solid ${f.color08};
    border-radius: 8px;
    outline: 0px solid rgba(0, 0, 0, 0);
    transition-duration: 200ms;
  }

  .placeholder {
    color: ${f.color08};
  }

  //FIM INPUT E BORDER
  //LABEL
  .__SelectBase_Label_Wrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: start;
  }
  ._Select_Label_Text {
    font-size: 0.875rem;
    line-height: 1.063rem;
    line-height: 1.063rem;
    padding-bottom: 0.4rem;
  }

  //FIM LABEL
  //LISTA
  ._Select_Item_List {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background-color: ${f.bg03};
    box-shadow: 0px 3px 6px ${f.color11};
    max-height: 210px;
    width: 100%;
    overflow-y: auto;
    outline: none;
    position: absolute;
    top: 70px;
    z-index: 10;
  }
  ._Select_Item {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    cursor: pointer;
    padding: 0 0 0 0;
    background-color: rgba(0, 0, 0, 0);
  }

  .not_found {
    padding: 1rem;
    border-left: 4px solid ${f.bg02};
    font-size: 0.875rem;
    line-height: 1.063rem;
  }
  //FIM LISTA
  //BOTOES
  ._SelectBase_Open_Button {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: none;
    min-height: 32px;
    max-height: 32px;
    min-width: 32px;
    max-width: 32px;
    border-radius: 9999px;
    background-color: rgba(0, 0, 0, 0);
    transition-duration: 200ms;
    outline: none;
    :hover {
      transition-duration: 200ms;
      background-color: ${f.color06};
    }
    :focus,
    :focus-visible {
      background-color: ${f.color07};
    }
    :active {
      filter: brightness(0.95);
    }
  }
  ._SelectBase_Open_Button {
    :last-child {
      margin-right: 0.5rem;
    }
    margin-right: 0.3rem;
    margin-left: 0rem;
  }

  ._SelectBase_Clear_Button {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: none;
    min-height: 32px;
    max-height: 32px;
    min-width: 32px;
    max-width: 32px;
    border-radius: 9999px;
    background-color: rgba(0, 0, 0, 0);
    transition-duration: 200ms;
    outline: none;
    :hover {
      transition-duration: 200ms;
      color: ${f.colorError};
      background-color: ${f.color06};
    }
    :focus,
    :focus-visible {
      color: ${f.colorError};
      background-color: ${f.color07};
    }
    :active {
      filter: brightness(0.95);
    }
  }
  //FIM BOTOES

  ._SelectBase_Helper_Text {
    font-size: 0.875rem;
    line-height: 1.063rem;
    color: ${f.color08};
    padding-top: 0.5rem;
  }

  ._SelectBase_Status_Icon {
    margin: 0rem 0.8rem 0rem 0.4rem;
    min-width: 16px;
  }
  ${e=>{switch(e.status){case"error":return`\n        ._SelectBase_Status_Icon {\n          color: ${f.colorError};\n        }\n        ._SelectBase_Border_Box {\n          border: 1px solid ${f.colorError};\n        }\n        ._Select_Helper_Text{\n          color: ${f.colorError};\n\n        }`;case"success":return`\n        ._SelectBase_Status_Icon {\n          color: ${f.colorSuccess};\n        }\n        ._SelectBase_Border_Box {\n          border: 1px solid ${f.colorSuccess};\n        }\n        ._SelectBase_Helper_Text {\n          color: ${f.colorSuccess};\n        }\n        `;case"warning":return`\n        ._SelectBase_Status_Icon {\n          color: ${f.colorWarning};\n        }\n        ._SelectBase_Border_Box {\n          border: 1px solid ${f.colorWarning};\n        }\n        ._SelectBase_Helper_Text {\n          color: ${f.colorWarning};\n        }\n        `;case"disabled":return`\n        ._SelectBase_Status_Icon {\n          color: ${f.color08};\n        }\n        ._SelectBase_Border_Box {\n          border: 1px solid ${f.color07};\n          background-color: ${f.color06}\n        }\n        ._Select_Label_Text{\n          color:${f.color08}\n        }\n        ._SelectBase_Select_Text {\n          color:${f.color08}\n        }\n       ._SelectBase_Open_Button{\n            background-color: rgba(0,0,0,0)!important;\n        }\n        `;default:return""}}}
`,vc=({status:t})=>{switch(t){case"error":return e(D,{title:" Ícone Alerta",className:"_SelectBase_Status_Icon error"});case"success":return e(M,{title:" Ícone Sucesso",className:"_SelectBase_Status_Icon success"});case"warning":return e(K,{title:" Ícone Erro",className:"_SelectBase_Status_Icon warning"});default:return null}};function xc(e,t){const{changes:o,type:i}=t;switch(i){case jo.stateChangeTypes.MenuKeyDownEnter:case jo.stateChangeTypes.MenuKeyDownSpaceButton:case jo.stateChangeTypes.ItemClick:return Object.assign(Object.assign({},o),{isOpen:!0,highlightedIndex:e.highlightedIndex});default:return o}}function bc({label:o,items:i,onChange:n,onChangeItem:l,parser:d,className:s,placeholder:c,status:p,message:m,disabled:u,value:h,notFound:g,render:A,onIsOpenChange:f,itemsDisabled:v=[]}){const[x,b]=r([]),[w,y]=r([]),{getToggleButtonProps:C,getLabelProps:E,getMenuProps:B,getItemProps:k,isOpen:I,highlightedIndex:N}=jo({items:x,itemToString:rc,stateReducer:xc,selectedItem:null,onIsOpenChange:f,onSelectedItemChange:e=>{var t;if(e.selectedItem&&!v.includes(String(null===(t=e.selectedItem)||void 0===t?void 0:t.value))){const t=w.filter((t=>{var o;return t.value!==(null===(o=e.selectedItem)||void 0===o?void 0:o.value)}));t.length==w.length?(n&&n([...t.map((e=>e.value)),e.selectedItem.value]),l&&l([...t,e.selectedItem]),y([...w,e.selectedItem])):(n&&n(t.map((e=>e.value))),l&&l(t),y([...t]))}}});return a((()=>{if(!w.length&&h&&h.length||w.length&&h&&h.length&&!ac(w,h)){const e=x.filter((e=>!!h.filter((t=>t==e.value)).length));e.length&&y(e)}h&&h.length||y([])}),[h]),a((()=>{if(void 0===i)throw new Error("Array nao pode ser undefined");const e=nc(i,d);if(b(e),(!w||!w.length)&&h&&h.length){const t=e.filter((e=>!!h.filter((t=>e.value==t)).length));t.length&&y(t)}if(w&&w.length){const t=e.filter((e=>!!w.filter((t=>t.value==e.value)).length));t.length&&!ac(t,w)&&y(t)}}),[i]),t(fc,{status:u?"disabled":p,className:s,children:[e("label",Object.assign({className:"_SelectBase_Label_Wrapper"},E(),{children:e("p",{className:"_Select_Label_Text",children:o||"‎"})})),t("button",Object.assign({type:"button"},C({disabled:u}),{className:"_SelectBase_Border_Box ",children:[e("p",{className:`_SelectBase_Select_Text ${w.length||"placeholder"}`,children:w.length?`${w.length} ite${w.length>1?"ns":"m"} selecionado${w.length>1?"s":""} `:c}),w&&!!w.length&&e("button",{title:"Limpar seleção",disabled:u,type:"button",className:"_SelectBase_Open_Button",onClick:()=>{y([]),n&&n([]),l&&l([])},children:e(F,{title:"Ícone X"})}),e("button",{disabled:u,type:"button",className:"_SelectBase_Open_Button",children:I?e(J,{title:"Ícone seta para cima"}):e(Y,{title:"Ícone seta para baixo"})}),e(vc,{status:p})]})),t("ul",Object.assign({},B(),{className:"_Select_Item_List",children:[I&&!x.length&&e("div",{className:"_Select_Item not_found",children:g||"Nada encontrado"}),I&&x.length>0&&x.map(((t,o)=>e("li",Object.assign({className:"_Select_Item"},k({item:t,index:o}),{children:A({item:t,disabled:v.includes(String(t.value))||!!u,highlighted:N==o,index:o,selected:!!w.filter((e=>e.value==t.value)).length})}),`${t.value}`)))]})),m&&e("p",{className:"_SelectBase_Helper_Text",children:m})]})}const wc=h("div")`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  width: 100%;
  position: relative;

  font-weight: 400;
  color: ${f.color04};

  ._Unused {
    display: none;
  }
  //LISTA
  ._Checkbox_Group_List {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    outline: none;
  }
  ._Checkbox_Item {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    cursor: pointer;
    padding: 0 0 0 0;
    background-color: rgba(0, 0, 0, 0);
  }

  .not_found {
    padding: 1rem;
    border-left: 4px solid ${f.bg02};
    font-size: 0.875rem;
    line-height: 1.063rem;
  }
  //FIM LISTA
`;function yc(e,t){const{changes:o,type:i}=t;switch(i){case jo.stateChangeTypes.FunctionToggleMenu:return Object.assign(Object.assign({},o),{isOpen:!0});case jo.stateChangeTypes.MenuKeyDownEnter:case jo.stateChangeTypes.MenuKeyDownSpaceButton:case jo.stateChangeTypes.ItemClick:return Object.assign(Object.assign({},o),{isOpen:!0,highlightedIndex:e.highlightedIndex});case jo.stateChangeTypes.MenuBlur:return Object.assign(Object.assign({},o),{isOpen:!0});default:return o}}function Cc({items:o,onChange:i,onChangeItem:n,parser:l,className:d,disabled:s,value:c,notFound:p,render:m}){const[u,h]=r([]),[g,A]=r([]),{getMenuProps:f,getItemProps:v,getLabelProps:x,getToggleButtonProps:b,highlightedIndex:w}=jo({items:u,defaultIsOpen:!0,itemToString:rc,stateReducer:yc,selectedItem:null,onSelectedItemChange:e=>{if(e.selectedItem){const t=g.filter((t=>{var o;return t.value!==(null===(o=e.selectedItem)||void 0===o?void 0:o.value)}));t.length==g.length?(i&&i([...t.map((e=>e.value)),e.selectedItem.value]),n&&n([...t,e.selectedItem]),A([...g,e.selectedItem])):(i&&i(t.map((e=>e.value))),n&&n(t),A([...t]))}}});return a((()=>{if(!g.length&&c&&c.length||g.length&&c&&c.length&&!ac(g,c)){const e=u.filter((e=>!!c.filter((t=>t==e.value)).length));e.length&&A(e)}c&&c.length||A([])}),[c]),a((()=>{if(void 0===o)throw new Error("Array nao pode ser undefined");const e=nc(o,l);if(h(e),(!g||!g.length)&&c&&c.length){const t=e.filter((e=>!!c.filter((t=>e.value==t)).length));t.length&&A(t)}if(g&&g.length){const t=e.filter((e=>!!g.filter((t=>t.value==e.value)).length));t.length&&!ac(t,g)&&A(t)}}),[o]),t(wc,{className:d,children:[e("label",Object.assign({className:"_Unused"},x(),{children:"Lista de Itens de Múltipla Escolha"})),e("button",Object.assign({type:"button",className:"_Unused"},b())),t("ul",Object.assign({},f({disabled:s}),{className:"_Checkbox_Group_List",children:[!u.length&&e($l,p?{status:"info",description:p}:{status:"info",description:"Nenhum item localizado"}),u.length>0&&u.map(((t,o)=>e("li",Object.assign({className:"_Checkbox_Item"},v({item:t,index:o,disabled:!!s||!!(null==t?void 0:t.disabled)}),{children:m({disabled:!!s||!!(null==t?void 0:t.disabled),item:t,highlighted:w==o,index:o,selected:!!g.filter((e=>e.value==t.value)).length})}),`${t.value}`)))]}))]})}const Ec=h("button")`
  display: flex;
  flex-direction: row;
  align-items: start;
  border: none;
  border-radius: 4px;

  ._Checkbox_Label {
    font-size: 1rem;
    line-height: 1.25rem;
    margin-right: 0.5rem;
    text-align: left;
    //manter cor black por compatibilidade com safari mobile
    color: black !important;
    @supports selector(:nth-child(1 of x)) {
      color: black !important;
    }
  }
  ._Checkbox_Check_Icon {
    margin-right: 0.5rem;
    margin-left: -0.2rem;
    height: 1.4rem;
    padding: 0.1rem;
    min-width: 1.4rem;
    width: 1.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition-duration: 200ms;
    border-radius: 2px;
    color: ${f.bg01};
  }
  :disabled {
    cursor: not-allowed;
    color: ${f.color08} !important;
    ._Checkbox_Check_Icon {
      color: ${f.color08} !important;
    }
  }
  :hover :not(:disabled) {
    ._Checkbox_Check_Icon {
      background-color: rgba(${f.RGB01}, 0.2);
    }
  }
  :focus-visible :not(:disabled) {
    outline: none;
    ._Checkbox_Check_Icon {
      background-color: rgba(${f.RGB01}, 0.2);
    }
  }
`,Bc=({checked:t})=>t?e(X,{title:"ícone marcado",className:"_Checkbox_Check_Icon"}):e(_,{title:"ícone desmarcado",className:"_Checkbox_Check_Icon"}),kc=({value:i,onChange:n,disabled:l,label:d,className:s,onClick:c})=>{const[p,m]=r(!1);return a((()=>{null!=i&&i!==p&&m(i)}),[i]),t(Ec,{className:s,type:"button",disabled:l,role:"checkbox",onClick:function(){c?c():(m(!p),n&&n(!p))},children:[e(Bc,{checked:p}),e(o,{children:e("p","string"==typeof d?{className:"_Checkbox_Label",role:"label",dangerouslySetInnerHTML:{__html:d}}:{className:"_Checkbox_Label",role:"label",children:d})})]})},Ic=h("div")`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  width: 100%;
  position: relative;

  font-weight: 400;
  color: ${f.color04};
  cursor: pointer;

  ._Unused {
    display: none;
  }

  //LABEL
  .__RadioBase_Label_Wrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: start;
  }
  ._Radio_Label_Text {
    font-size: 0.875rem;
    line-height: 1.063rem;
    line-height: 1.063rem;
    padding-bottom: 0.75rem;
  }

  //FIM LABEL
  //LISTA
  ._Radio_Item_List {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex-wrap: wrap;
    background-color: ${f.bg03};
    overflow: show;
    outline: none;
  }
  ._Radio_Item {
    display: flex;
    align-items: center;
    justify-items: start;
    text-align: left;
    padding-bottom: 0.75rem;
    padding-top: 0.75rem;
    padding-right: 1.5rem;

    cursor: pointer;
    background-color: rgba(0, 0, 0, 0);
    transition-duration: 200ms;
    font-size: 0.875rem;
    line-height: 1.063rem;
    border: none;
    outline: none;
  }

  ._Radio_Item_Text {
    flex: 1 1 auto;
    font-size: 0.875rem;
    line-height: 1.063rem;
  }

  //FIM LISTA

  ._Radio_Icon {
    color: ${f.bg01};
    margin-right: 0.5rem;
  }
  .focused._Radio_Icon {
    transition-duration: 100ms;
    transform: scale(1.2);
    border-radius: 999px;
    background-color: rgba(${f.RGB01}, 0.2);
    box-shadow: 0 0 0 3px rgba(${f.RGB01}, 0.2);
  }
  ._RadioBase_Helper_Text {
    font-size: 0.875rem;
    line-height: 1.063rem;
    color: ${f.color08};
    padding-top: 0.5rem;
  }

  ._RadioBase_Status_Icon {
    margin: 0rem 0.8rem 0rem 0.4rem;
    min-width: 16px;
  }
`;function Nc(e,t){const{changes:o,type:i}=t;switch(i){case jo.stateChangeTypes.FunctionToggleMenu:return Object.assign(Object.assign({},o),{isOpen:!0});case jo.stateChangeTypes.MenuKeyDownEnter:case jo.stateChangeTypes.MenuKeyDownSpaceButton:case jo.stateChangeTypes.ItemClick:return Object.assign(Object.assign({},o),{isOpen:!0,highlightedIndex:e.highlightedIndex});case jo.stateChangeTypes.MenuBlur:return Object.assign(Object.assign({},o),{isOpen:!0});default:return o}}function Sc({label:o,items:i,onChange:n,onChangeItem:l,parser:d,className:s,message:c,disabled:p,value:m}){const[u,h]=r([]),{getToggleButtonProps:g,getLabelProps:A,getMenuProps:f,getItemProps:v,selectItem:x,setHighlightedIndex:b,selectedItem:w,highlightedIndex:y}=jo({stateReducer:Nc,items:u,itemToString:rc,defaultIsOpen:!0,onSelectedItemChange:e=>{var t;e.selectedItem&&e.selectedItem.value!=m&&(n&&n((null===(t=e.selectedItem)||void 0===t?void 0:t.value)||""),l&&l(e.selectedItem))}});return a((()=>{if(!w&&m||w&&m&&m!==w.value){const e=u.filter((e=>m==e.value))[0];e&&x(e)}""===m&&x(Object.assign({},lc(u)))}),[m]),a((()=>{if(void 0===i)throw new Error("Array nao pode ser undefined");const e=nc(i,d);if(h(e),(!w||""===w.value)&&m){const t=e.filter((e=>m==e.value))[0];t&&x(t)}if(w){const t=e.filter((e=>w.value==e.value))[0];t&&t.value!=w.value&&x(t)}}),[i]),t(Ic,{status:p?"disabled":status,onFocus:()=>{y<0&&!p&&b(0)},className:s,children:[o&&e("label",Object.assign({className:"_RadioBase_Label_Wrapper"},A(),{children:e("p",{className:"_Radio_Label_Text",children:o||"‎"})})),e("button",Object.assign({type:"button"},g({disabled:p}),{className:"_Unused",children:"oi"})),t("ul",Object.assign({},f({disabled:p}),{className:"_Radio_Item_List",children:[!u.length&&e("button",{className:"_Radio_Item",children:"Nada encontrado"}),u.length>0&&u.map(((o,i)=>t("button",Object.assign({className:"_Radio_Item"},v({item:o,index:i,disabled:p,type:"button"}),{children:[(null==w?void 0:w.value)==o.value?e($,{title:"Opção escolhida",className:`_Radio_Icon ${y==i&&"focused"}`}):e(ee,{title:"Opção não escolhida",className:`_Radio_Icon ${y==i&&"focused"} `}),e("p",{className:"_Radio_Item_Text",children:o.title})]}),`${o.value}`)))]})),c&&e("p",{className:"_RadioBase_Helper_Text",children:c})]})}const Oc=h("div")`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  width: 100%;
  position: relative;

  font-weight: 400;
  color: ${f.color04};

  ._Unused {
    display: none;
  }

  //LISTA
  ._Radio_Item_List {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    outline: none;
  }
  ._Radio_Item {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 0 0 0 0;
    background-color: rgba(0, 0, 0, 0);

    @media (min-width: 420px) {
      cursor: pointer;
    }
  }

  .not_found {
    padding: 1rem;
    border-left: 4px solid ${f.bg02};
    font-size: 0.875rem;
    line-height: 1.063rem;
  }
  //FIM LISTA
`;function Pc(e,t){const{changes:o,type:i}=t;switch(i){case jo.stateChangeTypes.FunctionToggleMenu:return Object.assign(Object.assign({},o),{isOpen:!0});case jo.stateChangeTypes.MenuKeyDownEnter:case jo.stateChangeTypes.MenuKeyDownSpaceButton:case jo.stateChangeTypes.ItemClick:return Object.assign(Object.assign({},o),{isOpen:!0,highlightedIndex:e.highlightedIndex});case jo.stateChangeTypes.MenuBlur:return Object.assign(Object.assign({},o),{isOpen:!0});default:return o}}function Qc({items:o,onChange:i,onChangeItem:n,parser:l,className:d,disabled:s,value:c,notFound:p,render:m}){const[u,h]=r([]),{getToggleButtonProps:g,getLabelProps:A,getMenuProps:f,getItemProps:v,selectItem:x,setHighlightedIndex:b,selectedItem:w,highlightedIndex:y}=jo({stateReducer:Pc,items:u,itemToString:rc,defaultIsOpen:!0,onSelectedItemChange:e=>{var t;e.selectedItem&&e.selectedItem.value!=c&&(i&&i((null===(t=e.selectedItem)||void 0===t?void 0:t.value)||""),n&&n(e.selectedItem))}});return a((()=>{if(!w&&c||w&&c&&c!==w.value){const e=u.filter((e=>c==e.value))[0];e&&x(e)}""===c&&x(Object.assign({},lc(u)))}),[c]),a((()=>{if(void 0===o)throw new Error("Array nao pode ser undefined");const e=nc(o,l);if(h(e),(!w||""===w.value)&&c){const t=e.filter((e=>c==e.value))[0];t&&x(t)}if(w){const t=e.filter((e=>w.value==e.value))[0];t&&t.value!=w.value&&x(t)}}),[o]),t(Oc,{status:s?"disabled":status,onFocus:()=>{y<0&&!s&&b(0)},className:d,children:[e("label",Object.assign({className:"_Unused"},A(),{children:"Lista de Itens de Escolha Única"})),e("button",Object.assign({className:"_Unused"},g())),t("ul",Object.assign({},f({disabled:s}),{className:"_Radio_Item_List",children:[!u.length&&e("div",{className:"_Radio_Item not_found",children:p||"Nada encontrado"}),u.length>0&&u.map(((t,o)=>e("li",Object.assign({className:"_Radio_Item"},v({item:t,index:o,disabled:s,type:"button"}),{children:m({item:t,disabled:!!s,highlighted:y==o,index:o,selected:(null==w?void 0:w.value)==t.value})}),`${t.value}`)))]}))]})}function zc(e,t,o){return(o||"")+e.toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:2})+(t||"")}function Mc({label:t,value:o,onChange:i,suffix:n,prefix:l,startAdornment:d,endAdornment:s,status:c,disabled:p,placeholder:m,className:u,onBlur:h,message:g,integerLength:A}){const[f,v]=r(""),[x,b]=r(null);function w(e,t){const o=function(e,t,o){var i;return null===(i=null==e?void 0:e.replaceAll(t||"",""))||void 0===i?void 0:i.replaceAll(o||"","").replace(/\D/g,"")}(e,n,l);if(null==e||""===o||"00"==o)return v(zc(0,n,l)),b(0),void(t&&t(0));{if(!e.includes(l||"")||!e.includes(n||"")){if("000"==o)return v(zc(0,n,l)),b(0),void(t&&t(0));let e=parseInt(o)/10;e=Math.trunc(e)/10;const i=zc(e,n,l),r=e;return b(e),v(i),void(t&&t(Math.round(100*r)/100))}if(o.length-2>(A||0))return;const i=parseInt(o)/100,r=zc(i,n,l),a=i;return b(a),v(r),void(t&&t(a))}}return a((()=>{if("string"==typeof o&&null!==o)throw new Error("valor deve ser numero");null==o&&null!==x&&(b(null),v("")),"number"==typeof o&&o!==x&&(b(o),v(zc(o,n,l)))}),[o]),e(Zs,{value:f,onBlur:e=>{w(e,h)},label:t,disabled:p,onChange:e=>{w(e,i)},placeholder:m,startAdornment:d,endAdornment:s,status:c,message:g,className:u})}Mc.defaultProps={integerLength:8};const Dc=h(ro)`
  flex: 1 1 1px;

  align-items: stretch;

  min-height: 2.5rem;
  min-width: 15.25rem;

  .bx--search-magnifier-icon {
    fill: ${f.color08};
  }

  input {
    border-radius: 8px;
    border: 1px solid ${f.color08};
    background: ${f.bg03};

    padding-right: 23px;

    &::placeholder {
      color: ${f.color08};
    }

    &:disabled {
      border-bottom: 1px solid ${f.color08};
      background: ${f.bg03};
    }
  }

  .bx--search-close {
    display: none;
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    min-width: 11rem;
  }

  @media (max-width: 320px) {
  }
`,jc=t=>{var o=Jl(t,[]);return e(Dc,Object.assign({size:"md",type:"text"},o))};function Tc(e,t,o){return(o||"")+e.toLocaleString("pt-BR",{minimumFractionDigits:4,maximumFractionDigits:4})+(t||"")}function Rc({label:t,value:o,onChange:i,suffix:n,prefix:l,startAdornment:d,endAdornment:s,status:c,disabled:p,placeholder:m,className:u,onBlur:h,message:g,integerLength:A}){const[f,v]=r(""),[x,b]=r(null);function w(e,t){const o=function(e,t,o){var i;return null===(i=null==e?void 0:e.replaceAll(t||"",""))||void 0===i?void 0:i.replaceAll(o||"","").replace(/\D/g,"")}(e,n,l);if(null==e||""===o||"0000"==o)return v(""),b(null),void(t&&t(null));{if(!e.includes(l||"")||!e.includes(n||"")){if("00000"==o)return v(""),b(null),void(t&&t(null));let e=parseInt(o)/1e4;e=Math.trunc(e)/1e4;const i=Tc(e,n,l),r=e;return b(e),v(i),void(t&&t(Math.round(1e4*r)/1e4))}if(o.length-4>(A||0))return;const i=parseInt(o)/1e4,r=Tc(i,n,l),a=i;return b(a),v(r),void(t&&t(a))}}return a((()=>{if("string"==typeof o&&null!==o)throw new Error("valor deve ser numero");null==o&&null!==x&&(b(null),v("")),"number"==typeof o&&o!==x&&(b(o),v(Tc(o,n,l)))}),[o]),e(Zs,{value:f,onBlur:e=>{w(e,h)},label:t,disabled:p,onChange:e=>{w(e,i)},placeholder:m,startAdornment:d,endAdornment:s,status:c,message:g,className:u})}Rc.defaultProps={integerLength:8};const Lc=h("div")`
  position: relative;
  width: 100%;
`,Uc=h("div")`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  width: 100%;

  font-weight: 400;
  color: ${f.color04};

  .hide {
    color: transparent;
  }
  .show {
    color: ${f.bg04};
  }

  /* Data input styles */
  input[type='date'] {
    cursor: text;
  }
  /* Removing default calendar icon */
  input[type='date']::-webkit-inner-spin-button,
  input[type='date']::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }

  ._InputBase_Label_Wrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: start;
    transition-duration: 100ms;
    :focus-within ._InputBase_Border_Box {
      border: 2px solid ${f.bg02};
      transition-duration: 200ms;
    }
  }
  ._InputBase_Label_Text {
    font-size: 0.875rem;
    line-height: 1.063rem;
    padding-bottom: 0.4rem;
  }
  ._InputBase_Border_Box {
    min-height: 40px;
    max-height: 40px;
    height: 40px;
    overflow: hidden;
    display: flex;
    justify-content: start;
    align-items: center;
    flex: 1 1 auto;
    border: 1px solid ${f.color08};
    border-radius: 8px;
    outline: 0px solid rgba(0, 0, 0, 0);
    transition-duration: 200ms;
  }

  ._InputBase_Input_Text {
    flex: 1 1 auto;
    font-size: 1rem;
    background-color: transparent;
    overflow-x: hidden;
    word-break: break-all;
    border: none;

    :focus-visible {
      outline: none;
    }
    :first-child {
      margin-left: 0.875rem;
    }
    :last-child {
      margin-right: 0.875rem;
    }

    :disabled {
      background-color: transparent;
      color: ${f.color08};
    }
    ::placeholder {
      color: ${f.color08};
    }
  }
  ._InputBase_Helper_Text {
    font-size: 0.875rem;
    line-height: 1.063rem;
    color: ${f.color08};
    padding-top: 0.5rem;
  }
  /* ESTADOS DO INPUT */
  ._InputBase_Status_Icon {
    position: absolute;
    right: 30px;
    margin-right: 0;
    min-width: 16px;
  }

  ${e=>{switch(e.status){case"error":return g`
          ._InputBase_Status_Icon {
            color: ${f.colorError};
          }
          ._InputBase_Border_Box {
            border: 1px solid ${f.colorError};
          }
          ._InputBase_Label_Wrapper {
            :focus-within ._InputBase_Border_Box {
              border: 2px solid ${f.colorError};
              transition-duration: 200ms;
            }
          }
          ._InputBase_Helper_Text {
            color: ${f.colorError};
          }
        `;case"success":return g`
          ._InputBase_Status_Icon {
            color: ${f.colorSuccess};
          }
          ._InputBase_Border_Box {
            border: 1px solid ${f.colorSuccess};
          }
          ._InputBase_Label_Wrapper {
            :focus-within ._InputBase_Border_Box {
              border: 2px solid ${f.colorSuccess};
              transition-duration: 200ms;
            }
          }
          ._InputBase_Helper_Text {
            color: ${f.colorSuccess};
          }
        `;case"warning":return g`
          ._InputBase_Status_Icon {
            color: ${f.colorWarning};
          }
          ._InputBase_Border_Box {
            border: 1px solid ${f.colorWarning};
          }
          ._InputBase_Label_Wrapper {
            :focus-within ._InputBase_Border_Box {
              border: 2px solid ${f.colorWarning};
              transition-duration: 200ms;
            }
          }
          ._InputBase_Helper_Text {
            color: ${f.colorWarning};
          }
        `;case"disabled":return g`
          ._InputBase_Status_Icon {
            color: ${f.color08};
          }
          ._InputBase_Border_Box {
            border: 1px solid ${f.color07};
            background-color: ${f.color06};
          }
          ._InputBase_Label_Text {
            color: ${f.color08};
          }
          .open-calendar-button {
            background-color: rgba(0, 0, 0, 0) !important;
          }
        `;default:return""}}}

  /* ADORNAMENTOS */
  .open-calendar-button {
    display: flex;
    position: absolute;
    right: -2px;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: none;
    min-height: 24px;
    max-height: 24px;
    min-width: 24px;
    max-width: 24px;
    background-color: ${f.bg03};
    transition-duration: 200ms;
    outline: none;
    cursor: pointer;

    svg {
      fill: ${f.color08};
      margin: 0;
      min-width: 18px;
      min-height: 18px;
    }

    :hover {
      svg {
        filter: brightness(0.8);
      }
    }

    :focus-within,
    :focus {
      svg {
        fill: ${f.color02};
      }
    }
  }

  .open-calendar-button {
    :last-child {
      margin-right: 0.3rem;
    }
    margin-right: 0.3rem;
    margin-left: 0.3rem;
  }
`,qc=({status:t})=>{switch(t){case"error":return e(D,{className:"_InputBase_Status_Icon error"});case"success":return e(M,{className:"_InputBase_Status_Icon success"});case"warning":return e(K,{className:"_InputBase_Status_Icon warning"});default:return null}},Wc=h.div`
  position: absolute;
  visibility: hidden;
  opacity: 0;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  background-color: ${f.bg03};
  height: fit-content;
  min-width: 300px;
  width: 100%;
  box-shadow: 0px 2px 8px #00000029;
  margin-top: 0.5rem;
  padding: 1rem;
  z-index: 10;

  .flex-header {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    h1 {
      font-weight: ${f.fontWeight03};
      font-size: ${f.fontSize02};
    }

    svg {
      margin: 0;
      min-height: 16px;
      min-width: 16px;
    }
  }

  .plain-button {
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: none;
    min-height: 32px;
    max-height: 32px;
    min-width: 32px;
    max-width: 32px;
    border-radius: 9999px;
    background-color: rgba(0, 0, 0, 0);
    transition-duration: 200ms;
    outline: none;
    color: ${f.bg04};

    :not(:disabled):hover {
      transition-duration: 200ms;
      background-color: ${f.color06};
    }

    :active {
      filter: brightness(0.95);
    }
  }

  &.calendar-show {
    animation: 200ms fade-in forwards;
  }

  &.calendar-hide {
    animation: 200ms fade-out forwards;
  }

  @keyframes fade-in {
    0% {
      opacity: 0;
    }

    100% {
      visibility: visible;
      opacity: 1;
    }
  }

  @keyframes fade-out {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0;
      visibility: hidden;
    }
  }

  .header-buttons-wrapper {
    display: flex;
    flex-direction: row;
  }

  .header-button {
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: none;
    min-height: 32px;
    min-width: 32px;
    border-radius: 0.5rem;
    background-color: rgba(0, 0, 0, 0);
    transition-duration: 200ms;
    outline: none;
    padding: 0.3rem;
    font-weight: ${f.fontWeight03};
    font-size: ${f.fontSize02};
    color: ${f.bg04};

    :disabled {
      cursor: default;
    }

    :not(:disabled):hover {
      transition-duration: 200ms;
      background-color: ${f.color06};
    }

    :not(:disabled):active {
      filter: brightness(0.95);
    }
  }
`,Gc=h.div`
  display: grid;
  grid-template-columns: auto auto auto auto auto auto auto; // 7 rows grid
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  font-size: 1rem;

  .tb-hdr {
    min-width: 32px;
    max-width: 32px;
    min-height: 32px;
    max-height: 32px;
    text-align: center;
  }

  .fc-blue {
    color: ${f.bg02} !important;
    font-weight: ${f.fontWeight03};
  }

  .fc-red {
    color: ${f.colorError} !important;
    font-weight: ${f.fontWeight03};
  }

  .day-button {
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: none;
    min-height: 32px;
    max-height: 32px;
    min-width: 32px;
    max-width: 32px;
    border-radius: 9999px;
    background-color: rgba(0, 0, 0, 0);
    transition-duration: 200ms;
    outline: none;
    color: ${f.bg04};

    :disabled {
      cursor: default;
      color: #a7a8ac;
    }

    :not(:disabled):hover {
      transition-duration: 200ms;
      background-color: ${f.color06};
    }

    :not(:disabled):focus-within,
    :focus {
      color: ${f.bg02};
      font-weight: ${f.fontWeight03};
    }

    :not(:disabled):active {
      color: ${f.bg02};
      font-weight: ${f.fontWeight03};
      filter: brightness(0.95);
    }
  }

  .other-month {
    color: ${f.color08};
  }
`,Hc=h.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  h1 {
    font-weight: ${f.fontWeight03};
    font-size: ${f.fontSize02};
  }

  .fc-red {
    color: ${f.colorError} !important;
    font-weight: ${f.fontWeight03};
  }

  .common-button {
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border: none;
    min-height: 32px;
    min-width: 32px;
    border-radius: 0.5rem;
    background-color: rgba(0, 0, 0, 0);
    transition-duration: 200ms;
    outline: none;
    padding: 0.3rem;
    font-size: ${f.fontSize02};
    color: ${f.bg04};

    :disabled {
      cursor: default;
    }

    :not(:disabled):hover {
      transition-duration: 200ms;
      background-color: ${f.color06};
    }

    :not(:disabled):focus-within,
    :focus {
      color: ${f.bg02};
      font-weight: ${f.fontWeight03};
    }

    :not(:disabled):active {
      color: ${f.bg02};
      font-weight: ${f.fontWeight03};
      filter: brightness(0.95);
    }
  }
`,Fc=h.div`
  display: grid;
  margin-top: 1rem;
  width: 100%;
  gap: 1rem;
  grid-template-columns: auto auto auto; // 3 rows grid
`,Vc={1:"Janeiro",2:"Fevereiro",3:"Março",4:"Abril",5:"Maio",6:"Junho",7:"Julho",8:"Agosto",9:"Setembro",10:"Outubro",11:"Novembro",12:"Dezembro"},Kc={0:"Sunday",1:"Monday",2:"Tuesday",3:"Wednesday",4:"Thursday",5:"Friday",6:"Saturday"};function Jc(e){return`${e.getUTCFullYear().toString()}-${(e.getUTCMonth()+1).toString().padStart(2,"0")}-${e.getUTCDate().toString().padStart(2,"0")}`}const Yc="pt-br",Zc={year:"numeric",month:"long",weekday:"long",day:"numeric"};function Xc(e,t,o,i){return"past-month"===i?new Date(o,t-2,e).toLocaleDateString(Yc,Zc):"next-month"===i?new Date(o,t,e).toLocaleDateString(Yc,Zc):new Date(o,t-1,e).toLocaleDateString(Yc,Zc)}const _c=[{monthNum:0,description:"Janeiro"},{monthNum:1,description:"Fevereiro"},{monthNum:2,description:"Março"},{monthNum:3,description:"Abril"},{monthNum:4,description:"Maio"},{monthNum:5,description:"Junho"},{monthNum:6,description:"Julho"},{monthNum:7,description:"Agosto"},{monthNum:8,description:"Setembro"},{monthNum:9,description:"Outubro"},{monthNum:10,description:"Novembro"},{monthNum:11,description:"Dezembro"}],$c=({month:o,onChangeMonth:i})=>t(Hc,{children:[e("h1",{children:"Selecione o mês:"}),e(Fc,{children:_c.map(((t,n)=>{const r=`${t.description}-${n}`;return e("button",{className:`common-button ${o-1===t.monthNum?"fc-red":void 0}`,type:"button",onClick:()=>i(t.monthNum+1),children:t.description},r)}))})]}),ep=({year:o,onChangeYear:i})=>{const n=[];let r=o-4;for(;n.length<12;)n.push(r),r++;return t(Hc,{children:[e("h1",{children:"Selecione o ano:"}),e(Fc,{children:n.map(((t,n)=>e("button",{className:`common-button ${o===t?"fc-red":void 0}`,type:"button",onClick:()=>i(t),children:t},`${t}-${n}`)))})]})},tp=({calendarValues:i,getChoosenDate:n,isVisible:l,visibilityCallback:d,checkDisabledZARC:c,periodCalendarZarc:p})=>{const[m,u]=r("day-picker"),[h,g]=r([]),[A,f]=r(0),[v,x]=r(0),[b,w]=r(l||!1),y=s(null),C=e=>{y.current&&!y.current.contains(e.target)&&d&&d(!1)};function E(e,t){if("backwards"===t)return e-1<1?(f(12),x((e=>e-1))):f((e=>e-1)),!0;if("upwards"===t)return e+1>12?(f(1),x((e=>e+1))):f((e=>e+1)),!0;throw new Error("There is no updateType that matches your request.")}function B(e){if(d&&d(!1),e&&"number"==typeof e)return n&&n(Jc(new Date(v,A-1,e))),!0;if(e&&"number"!=typeof e)return n&&n(Jc(e)),!0;throw new Error("There is no selected day to change.")}function k(e){const[t,o,i]=e.split("-");return new Date(parseInt(t),parseInt(o)-1,parseInt(i))}return a((()=>(document.addEventListener("click",C,!0),()=>{document.removeEventListener("click",C,!0)})),[]),a((()=>{l&&(u("day-picker"),function(){const e=new Date;i&&i.day&&i.month&&i.year||(i={year:e.getUTCFullYear(),month:e.getUTCMonth()+1,day:e.getUTCDate()}),f(i.month),x(i.year)}()),w(!!l)}),[l]),a((()=>{g(function(e,t){let o=[];const i=Array.from({length:new Date(t,e,0).getDate()},((o,i)=>new Date(t,e-1,i+1).getDate())),n=new Date(t,e-1,i[0]).getUTCDay(),r=new Date(t,e-1,0).getUTCDate();let a=new Date(t,e-1,0).getUTCDay();if(0!==n){let i=r-a;for(;a>=0;)o.push({day:i,dayOfTheWeek:"past-month",month:e-1,year:t}),i++,a--}o=[...o,...i.map((o=>({day:o,dayOfTheWeek:Kc[new Date(t,e,o).getUTCDay()],month:e,year:t})))];let l=1;for(;o.length<42;)o.push({day:l,dayOfTheWeek:"next-month",month:e+1,year:t}),l++;return o}(A,v))}),[A,v]),t(Wc,{ref:y,className:""+(b?"calendar-show":"calendar-hide"),children:["day-picker"===m&&t(o,{children:[t("div",{className:"flex-header",children:[e("button",{type:"button",className:"plain-button",title:"Mês anterior",onClick:()=>E(A,"backwards"),children:e(te,{})}),t("div",{className:"header-buttons-wrapper",children:[e("button",{onClick:()=>u("month-picker"),type:"button",className:"header-button",children:`${I=A,Vc[I]}`}),e("button",{onClick:()=>u("year-picker"),type:"button",className:"header-button",children:`${v}`})]}),e("button",{type:"button",className:"plain-button",title:"Próximo mês",onClick:()=>E(A,"upwards"),children:e(oe,{})})]}),t(Gc,{children:[e("span",{className:"tb-hdr",title:"Domingo",children:"D"}),e("span",{className:"tb-hdr",title:"Segunda-feira",children:"S"}),e("span",{className:"tb-hdr",title:"Terça-feira",children:"T"}),e("span",{className:"tb-hdr",title:"Quarta-feira",children:"Q"}),e("span",{className:"tb-hdr",title:"Quinta-feira",children:"Q"}),e("span",{className:"tb-hdr",title:"Sexta-feira",children:"S"}),e("span",{className:"tb-hdr",title:"Sábado",children:"S"}),h.map((t=>{let o=!1;c&&(o=function(e){const t=k(`${e.year}-${e.month}-${e.day}`);let o=!0;if(!(p&&p.length>0))return!1;const i=p;for(let e=0;e<i.length;e++){const n=i[e],r=k(n.beginDate),a=k(n.endDate),l=Ro(t,r),d=Ro(t,a),s=Lo(t,a);if((Uo(t,r)||l)&&(s||d)){o=!1;break}}return o}(t));const n=`${t.year}${t.month}${t.day}`;return e("div",{className:`calendar-element.${n}`,children:e("button",{onClick:()=>function(e,t){if(e&&t)return"past-month"===e?(E(A,"backwards"),B(new Date(A-1<0?v-1:v,(A-1<0?12:A-1)-1,t))):"next-month"===e?(E(A,"upwards"),B(new Date(A+1>12?v+1:v,(A+1>12?1:A+1)-1,t))):B(t);throw new Error("Application failed to propagate a calendar day change.")}(t.dayOfTheWeek,t.day),disabled:o,type:"button",title:Xc(t.day,A,v,t.dayOfTheWeek),className:`day-button ${"past-month"===t.dayOfTheWeek||"next-month"===t.dayOfTheWeek?"other-month":""} ${"past-month"!==t.dayOfTheWeek&&"next-month"!==t.dayOfTheWeek&&t.day===(null==i?void 0:i.day)&&A===i.month?"fc-blue":""} ${t.day===(new Date).getUTCDate()&&A===(new Date).getUTCMonth()+1&&v===(new Date).getUTCFullYear()?"fc-red":""}`,children:t.day})},`calendar-element.${n}`)}))]})]}),"month-picker"===m&&e($c,{onChangeMonth:e=>(f(e),void u("day-picker")),month:A}),"year-picker"===m&&e(ep,{onChangeYear:e=>(x(e),void u("day-picker")),year:v})]});var I};function op(e){return e.preventDefault(),e.stopPropagation(),!1}const ip=n.forwardRef((({label:o,value:i,onChange:n,status:l,disabled:d,placeholder:c,className:p,onBlur:m,message:u,checkDisabledZARC:h=!1,periodCalendarZarc:g},A)=>{var f;const v=s(null),[x,b]=r(A?i:i||""),[w,y]=r(!1),[C,E]=r(!1);a((()=>{i&&E(!0),i&&i!==x&&b(i)}),[i]);const B=/iPad|iPhone|iPod|e-Agro-App/.test(navigator.userAgent);return t(Lc,{children:[e(Uc,{status:d?"disabled":l,className:p,onClick:()=>B&&y(!w),children:t("label",{title:o,className:"_InputBase_Label_Wrapper",style:B?{pointerEvents:"none"}:void 0,children:[o&&e("p",{className:"_InputBase_Label_Text",children:o}),t("div",{className:"_InputBase_Border_Box",children:[e("input",{type:"date",min:"1979-12-31",max:"2999-12-31",onBlur:e=>{m&&m(e.target.value),!x&&C&&E(!1)},ref:A||v,placeholder:c,disabled:d,readOnly:B,onFocus:()=>{y(!1),!C&&E(!0)},className:"_InputBase_Input_Text"+(C?" show":" hide"),value:x,onChange:e=>{b(e.target.value),n&&n(e.target.value)},onClick:op,required:(null===(f=null===navigator||void 0===navigator?void 0:navigator.userAgent)||void 0===f?void 0:f.indexOf("Firefox"))>-1}),e(qc,{status:l}),e("button",{type:"button",title:"Abrir calendário",disabled:d,onClick:()=>y(!w),className:"open-calendar-button",children:e(ie,{})})]}),u&&e("p",{className:"_InputBase_Helper_Text",children:u})]})}),w&&e(tp,{calendarValues:{day:x?+x.replace(/^\d{4}-\d{2}-(\d{2})/g,"$1"):void 0,month:x?+x.replace(/^\d{4}-(\d{2})-\d+/g,"$1"):void 0,year:x?+x.replace(/^(\d{4})-\d{2}-\d{2}/g,"$1"):void 0},checkDisabledZARC:h,getChoosenDate:e=>{return t=e,E(!0),b(t),void(n&&n(t));var t},isVisible:w,visibilityCallback:e=>function(e){y(e)}(e),periodCalendarZarc:g})]})})),np=h.button`
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  border-radius: 999px;
  border: 2px solid ${f.bg01};
  background-color: ${f.bg01};
  color: ${f.bg03};
  padding: 0.875rem 0rem;
  font-weight: ${f.fontWeight03};
  font-size: 0.875rem;
  line-height: 1.063rem;
  transition-duration: 200ms;
  text-align: center;

  @media only screen and (min-width: 0px) {
    ${e=>e.responsive.xs}
  }
  @media only screen and (min-width: 420px) {
    ${e=>e.responsive.sm}
  }

  @media only screen and (min-width: 670px) {
    ${e=>e.responsive.md}
  }

  @media only screen and (min-width: 1024px) {
    ${e=>e.responsive.lg}
  }

  :not(:disabled) :hover {
    background-color: ${f.color01Dark};
    border-color: ${f.color01Dark};
    transition-duration: 200ms;
  }
  :not(:disabled) :active {
    filter: brightness(0.95);
    transition-duration: 200ms;
  }
  :focus-visible {
    outline: 2px solid ${f.color05};
  }
  :disabled {
    border: 2px solid ${f.color08};
    color: ${f.color09};
    background-color: ${f.color08};
  }
`,rp=h.button`
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  border-radius: 999px;
  border: 2px solid ${f.bg01};
  background-color: rgba(0, 0, 0, 0);
  transition-duration: 200ms;
  color: ${f.bg01};
  padding: 0.875rem 0rem;
  font-weight: ${f.fontWeight03};
  font-size: 0.875rem;
  line-height: 1.063rem;
  text-align: center;

  @media only screen and (min-width: 0px) {
    ${e=>e.responsive.xs}
  }
  @media only screen and (min-width: 420px) {
    ${e=>e.responsive.sm}
  }

  @media only screen and (min-width: 670px) {
    ${e=>e.responsive.md}
  }

  @media only screen and (min-width: 1024px) {
    ${e=>e.responsive.lg}
  }
  :not(:disabled) :hover {
    filter: brightness(0.95);
    background-color: ${f.bg03};
    transition-duration: 200ms;
  }
  :not(:disabled) :active {
    filter: brightness(0.9);
    transition-duration: 200ms;
  }
  :focus-visible {
    outline: 2px solid ${f.color05};
  }
  :disabled {
    border: 2px solid ${f.color08};
    color: ${f.color08};
  }
`,ap=h.button`
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  border-radius: 999px;
  border: 2px solid rgba(0, 0, 0, 0);
  background-color: rgba(0, 0, 0, 0);
  color: ${f.bg01};
  padding: 0.875rem 0rem;
  font-weight: ${f.fontWeight03};
  font-size: 0.875rem;
  line-height: 1.063rem;
  transition-duration: 200ms;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  ${e=>e.hasIcon&&"\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n  "}

  ._Visual_Area {
    display: flex;
    column-gap: 0.5rem;
    align-items: center;
    justify-content: center;
  }

  @media only screen and (min-width: 0px) {
    ${e=>e.responsive.xs}
  }
  @media only screen and (min-width: 420px) {
    ${e=>e.responsive.sm}
  }

  @media only screen and (min-width: 670px) {
    ${e=>e.responsive.md}
  }

  @media only screen and (min-width: 1024px) {
    ${e=>e.responsive.lg}
  }

  :not(:disabled) :hover {
    transition-duration: 200ms;
    ${({transparent:e})=>e?" text-decoration: underline; ":` background-color: ${f.color06}; `}
  }
  :not(:disabled) :active {
    filter: brightness(0.95);
    transition-duration: 200ms;
  }
  :focus-visible {
    ${({transparent:e})=>e?" text-decoration: underline; ":`  outline: 2px solid ${f.bg01};`}
  }
  :disabled {
    color: ${f.color08};
  }
`,lp=h.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${e=>"right"===e.iconPosition?"0":"0.5rem"};
  margin-left: ${e=>"right"===e.iconPosition?"0.5rem":"0"};
`;function dp({disabled:o,className:i,text:n,responsive:r,onClick:a,id:l,type:d="submit",formId:s,icon:c,iconPosition:p="left"}){return t(np,{disabled:o,responsive:r,id:l,title:n,className:`_Button_Filled ${i}`,onClick:a,type:d,form:s,hasIcon:!!c,children:[c&&"left"===p&&e(lp,{iconPosition:p,children:c}),n,c&&"right"===p&&e(lp,{iconPosition:p,children:c})]})}function sp({disabled:o,className:i,text:n,responsive:r,onClick:a,id:l,type:d="submit",icon:s,iconPosition:c="left"}){return t(rp,{disabled:o,id:l,title:n,responsive:r,className:`_Button_Outline ${i}`,onClick:a,type:d,hasIcon:!!s,children:[s&&"left"===c&&e(lp,{iconPosition:c,children:s}),n,s&&"right"===c&&e(lp,{iconPosition:c,children:s})]})}function cp({disabled:o,className:i,text:n,onClick:r,responsive:a,id:l,transparent:d,type:s="submit",formId:c,icon:p,iconPosition:m,visual:u}){return e(ap,{transparent:d,responsive:a,disabled:o,id:l,title:n,className:`_Button_Text ${i}`,onClick:r,type:s,form:c,hasIcon:void 0!==!!p?!!p:null==u?void 0:u.hasIcon,children:t("span",void 0!==!!p?{className:"_Visual_Area",children:[p&&"left"===m&&e(lp,{iconPosition:m,children:p}),n,p&&"right"===m&&e(lp,{iconPosition:m,children:p})]}:{className:"_Visual_Area",children:[!!u&&!!u.hasIcon&&u.icon,e("span",{children:n})]})})}sp.defaultProps={responsive:{xs:"max-width:270px; padding:1rem 3rem",sm:"max-width:270px;",md:"max-width:270px;",lg:"max-width:270px;"},type:"button",className:"",onClick:()=>{}},cp.defaultProps={responsive:{xs:"max-width:270px; padding:1rem 3rem",sm:"max-width:270px;",md:"max-width:270px;",lg:"max-width:270px;"},type:"button",className:"",onClick:()=>{}},dp.defaultProps={responsive:{xs:"max-width:270px; padding:1rem 3rem",sm:"max-width:270px;",md:"max-width:270px;",lg:"max-width:270px;"},type:"button",className:"",onClick:()=>{}};const pp=h(yo)`
  border-radius: 999px;
  border: 0px solid rgba(0, 0, 0, 0);
  background-color: ${f.bg01};
  color: ${f.bg03};
  padding: 1rem 0rem;
  font-weight: ${f.fontWeight03};
  font-size: 0.875rem;
  line-height: 1.063rem;
  transition-duration: 200ms;
  text-align: center;

  @media only screen and (min-width: 0px) {
    ${e=>e.responsive.xs}
  }
  @media only screen and (min-width: 420px) {
    ${e=>e.responsive.sm}
  }

  @media only screen and (min-width: 670px) {
    ${e=>e.responsive.md}
  }

  @media only screen and (min-width: 1024px) {
    ${e=>e.responsive.lg}
  }

  :focus-visible {
    outline: 2px solid ${f.color05};
  }
  ${({disabled:e})=>e?`\n      pointer-events: none;\n      background-color: ${f.color08};\n    `:"\n    :hover {\n      filter: brightness(1.1);\n      transition-duration: 200ms;\n    }\n    :active {\n      filter: brightness(0.95);\n      transition-duration: 200ms;\n  }\n    "}
`,mp=h(yo)`
  border-radius: 999px;
  border: 2px solid ${f.bg01};
  background-color: rgba(0, 0, 0, 0);
  transition-duration: 200ms;
  color: ${f.bg01};
  padding: 1rem 0rem;
  font-weight: ${f.fontWeight03};
  font-size: 0.875rem;
  line-height: 1.063rem;
  text-align: center;

  @media only screen and (min-width: 0px) {
    ${e=>e.responsive.xs}
  }
  @media only screen and (min-width: 420px) {
    ${e=>e.responsive.sm}
  }

  @media only screen and (min-width: 670px) {
    ${e=>e.responsive.md}
  }

  @media only screen and (min-width: 1024px) {
    ${e=>e.responsive.lg}
  }

  :focus-visible {
    outline: 2px solid ${f.color05};
  }

  ${({disabled:e})=>e?`\n      pointer-events: none;\n      border: 2px solid ${f.color08};\n      color: ${f.color08};\n    `:`\n    :hover {\n      filter: brightness(0.95);\n      background-color: ${f.bg03};\n      transition-duration: 200ms;\n    }\n    :active {\n      filter: brightness(0.9);\n      transition-duration: 200ms;\n    }\n    `}
`,up=h(yo)`
  border-radius: 999px;
  border: 0px solid rgba(0, 0, 0, 0);
  background-color: ${f.bg03};
  color: ${f.bg01};
  padding: 1rem 0rem;
  font-weight: ${f.fontWeight03};
  font-size: 0.875rem;
  line-height: 1.063rem;
  transition-duration: 200ms;
  text-align: center;

  @media only screen and (min-width: 0px) {
    ${e=>e.responsive.xs}
  }
  @media only screen and (min-width: 420px) {
    ${e=>e.responsive.sm}
  }

  @media only screen and (min-width: 670px) {
    ${e=>e.responsive.md}
  }

  @media only screen and (min-width: 1024px) {
    ${e=>e.responsive.lg}
  }

  ${({disabled:e,transparent:t})=>e?`\n      pointer-events: none;\n      color: ${f.color08};\n    `:t?"\n      :focus-visible {\n      outline: none;\n      text-decoration: underline;\n    }\n    :hover {\n      background-color: rgba(0,0,0,0);\n      text-decoration: underline;\n      transition-duration: 200ms;\n    }\n    :active {\n      filter: brightness(0.95);\n      transition-duration: 200ms;\n    }\n    ":`\n    :focus-visible {\n      outline: 2px solid ${f.bg01};\n      text-decoration: underline;\n    }\n    :hover {\n      background-color: ${f.color06};\n      text-decoration: underline;\n      transition-duration: 200ms;\n    }\n    :active {\n      filter: brightness(0.95);\n      transition-duration: 200ms;\n    }`}
`;function hp({className:t,text:o,href:i,disabled:n,responsive:r,onClick:a,id:l}){return e(pp,{role:"link",disabled:n,"aria-disabled":n,responsive:r,id:l,title:o,to:i,alt:o||"",className:`_Link_Filled ${t}`,onClick:a,children:o})}function gp({className:t,text:o,responsive:i,disabled:n,onClick:r,href:a,id:l}){return e(mp,{role:"link","aria-disabled":n,disabled:n,id:l,title:o,to:n?"":a,alt:o||"",responsive:i,className:`_Link_Outline ${t}`,onClick:r,children:o})}function Ap({className:t,text:o,href:i,onClick:n,responsive:r,disabled:a,id:l,transparent:d}){return e(up,{role:"link",transparent:d,"aria-disabled":a,disabled:a,responsive:r,id:l,title:o,to:a?"":i,alt:o||"",className:`_Link_Text ${t}`,onClick:n,children:o})}gp.defaultProps={responsive:{xs:"max-width:270px; padding:1rem 3rem",sm:"max-width:270px;",md:"max-width:270px;",lg:"max-width:270px;"},className:"",onClick:()=>{}},Ap.defaultProps={responsive:{xs:"max-width:270px; padding:1rem 3rem",sm:"max-width:270px;",md:"max-width:270px;",lg:"max-width:270px;"},className:"",onClick:()=>{}},hp.defaultProps={responsive:{xs:"max-width:270px; padding:1rem 3rem",sm:"max-width:270px;",md:"max-width:270px;",lg:"max-width:270px;"},className:"",onClick:()=>{}};const fp=h.div`
  min-width: 48px;
  width: 48px;
  min-height: 24px;
  height: 24px;
  background-color: ${({isActive:e})=>e?`${f.bg01}`:`${f.color09}`};
  border-radius: 15px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
`,vp=h.div`
  min-width: 18px;
  width: 18px;
  min-height: 18px;
  height: 18px;
  background-color: ${({isActive:e})=>e?`${f.bg03}`:`${f.color16}`};
  border-radius: 50%;
  position: absolute;
  top: 3px;
  left: 3px;
  transition: all 0.3s ease;
  transform: ${({isActive:e})=>e?"translateX(24px)":"translateX(0px)"};
`,xp=({isActive:t,onChange:o})=>{const[i,n]=r(t);return a((()=>{n(t)}),[t]),e(fp,{isActive:i,onClick:()=>o(!i),children:e(vp,{isActive:i})})},bp=h(lo)`
  .bx--pagination-nav__list {
    flex-wrap: wrap;
    justify-content: flex-end;

    .bx--pagination-nav__page--active {
      color: ${f.color01};
    }

    .bx--pagination-nav__page:not(.bx--pagination-nav__page--direction)::after {
      background: ${f.bg01};
      border-radius: 8px;
    }
  }
`,wp={"carbon.pagination-nav.next":"Próxima página","carbon.pagination-nav.previous":"Página anterior","carbon.pagination-nav.item":"Página","carbon.pagination-nav.active":"Ativo","carbon.pagination-nav.of":"de"},yp=({className:t,page:o,totalPages:i,itemsShown:n=7,onPageChange:r})=>e(bp,{className:t,page:o-1,itemsShown:n,totalItems:i,translateWithId:e=>wp[e],onChange:e=>null==r?void 0:r({page:e+1})}),Cp=h.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`,Ep=h.button`
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5rem;
  flex-wrap: nowrap;

  padding: 1rem 0;

  border: 0;
  border-bottom: 2px solid ${f.color07};
  background: ${f.bg03};
  color: ${f.color04};

  transition: background-color 0.2s;

  cursor: pointer;

  &:hover:not(:active) {
    background: ${f.bg07};
  }

  > svg {
    min-width: 1.5rem;
  }

  .client-info {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    flex: 1;

    text-align: start;

    > p {
      color: ${f.color04};
      font-size: ${f.fontSize03};
      font-weight: ${f.fontWeight03};
    }

    .client-data {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 1rem;

      width: 100%;

      .client-cpf {
        width: 9.5rem;
      }

      .client-phone {
        width: 11.55rem;
      }

      .client-email {
        flex: 1;
        min-width: 12rem;
        max-width: 18rem;
      }
    }
  }

  @media (max-width: 1312px) {
    .client-data {
      justify-content: space-between;
    }
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    gap: 1rem;

    &:active {
      background: ${f.bg07};
    }

    .mobile-hidden {
      display: none;
    }

    .client-info {
      > p {
        font-size: ${f.fontSize02};
      }

      .client-data {
        align-items: flex-start;
        flex-direction: column;
        gap: 0.5rem;
      }
    }
  }

  @media (max-width: 320px) {
  }
`,Bp=h.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;

  color: ${f.color09};
  font-size: ${f.fontSize01};

  span {
    white-space: nowrap;
  }

  strong {
    color: ${f.color04};
    font-weight: ${f.fontWeight01};
    word-break: break-all;
  }
`,kp=h(yp)`
  margin-top: 2.5rem;

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    .bx--btn--icon-only {
      justify-content: center;

      width: 2.25rem;

      padding: 0;
    }

    .bx--pagination-nav__page,
    .bx--pagination-nav__page--select {
      width: 2rem;
      min-width: 0;

      padding: 1.0625rem 0;
    }
  }

  @media (max-width: 320px) {
  }
`,Ip=({data:o=[],isLoading:i=!1,hasPagination:n=!1,page:r=0,perPage:a=10,totalItems:l=0,tagging:d,onClick:s,onPageChange:c,partnerCnpj:p})=>{const m=wo();return t(Cp,{children:[i?e(Vt,{withOverlay:!1}):null==o?void 0:o.map((o=>{var i;return t(Ep,{onClick:e=>((e,t)=>{null==s||s(e,t),d&&Je.interact(Ye.Click,"botao","detalhes do cliente",d.flow,d.loggedUser,d.firebaseScreen,null,{userId:d.userId}),m.push("/clients/view",{cpf:null==t?void 0:t.cpf,inviteCode:null==t?void 0:t.inviteCode,partnerCnpj:p,isTrusted:!0,psidOrigin:m.location})})(e,o),children:[t("div",{className:"client-info",children:[e("p",{children:null==o?void 0:o.fullName}),t("div",{className:"client-data",children:[t(Bp,{className:"client-cpf",children:[e("span",{children:"CPF"}),e("strong",{children:$e(null==o?void 0:o.cpf,{allowCNPJ:!0,allowMask:!0})})]}),t(Bp,{className:"client-phone",children:[e("span",{children:"Telefone"}),e("strong",{children:_e(null==o?void 0:o.phoneNumber,{allowMask:!0})})]}),t(Bp,{className:"client-email",children:[e("span",{children:"E-mail"}),e("strong",{children:null==o?void 0:o.email})]}),t(Bp,{children:[e("span",{children:"Contratos em Andamento"}),e("strong",{children:null!==(i=null==o?void 0:o.contractsInProgress)&&void 0!==i?i:0})]})]})]}),e(oe,{})]},null==o?void 0:o.cpf)})),n&&l>0&&e(kp,{page:r,totalPages:Math.ceil(l/a),onPageChange:e=>null==c?void 0:c({page:e.page,perPage:a})})]})},Np=h.div`
  width: min(100% - 10.125rem, 78.875rem);
  margin-inline: auto;

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    width: min(100% - 2rem, 71.75rem);
  }

  @media (max-width: 320px) {
  }
`,Sp=({children:t,className:o})=>e(Np,{className:o,children:t});var Op,Pp;function Qp(){return Qp=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},Qp.apply(null,arguments)}const zp=A`
  html {
    overflow: hidden;
  }
`,Mp=h.div`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;

  cursor: pointer;

  svg {
  }
`,Dp=h((e=>i.createElement("svg",Qp({xmlns:"http://www.w3.org/2000/svg",width:109.888,height:24,"data-name":"White logo \\u2022 E-Agro"},e),Op||(Op=i.createElement("defs",null,i.createElement("clipPath",{id:"logo_eagro_svg__a"},i.createElement("path",{fill:"none",d:"M0 0h109.888v24H0z","data-name":"Ret\\xE2ngulo 14864"})))),Pp||(Pp=i.createElement("g",{fill:"#fff",clipPath:"url(#logo_eagro_svg__a)","data-name":"Grupo 81164"},i.createElement("path",{d:"M102.966 4.661a6.921 6.921 0 1 0 6.921 6.921 6.92 6.92 0 0 0-6.921-6.921m0 3.1a3.817 3.817 0 1 1-3.817 3.817 3.82 3.82 0 0 1 3.817-3.817","data-name":"Caminho 39010"}),i.createElement("path",{d:"M37.21 7.814a3.82 3.82 0 0 1 3.213 1.754h-6.426a3.82 3.82 0 0 1 3.213-1.754m6.925 3.821a7 7 0 0 0-.314-2.067 6.938 6.938 0 0 0-13.219 0 6.9 6.9 0 0 0-.293 2.579 6.935 6.935 0 0 0 12.882 2.982l-2.68-1.566a3.827 3.827 0 0 1-7.084-1.416H44.11a7 7 0 0 0 .021-.511","data-name":"Caminho 39011"}),i.createElement("path",{d:"M61.041 15.45a3.817 3.817 0 1 1 3.817-3.817 3.82 3.82 0 0 1-3.817 3.817M65.35 4.712V6.22a6.921 6.921 0 1 0 0 10.829v.975h3.1V4.713Z","data-name":"Caminho 39012"}),i.createElement("path",{d:"M77.164 15.45a3.817 3.817 0 1 1 3.8-4.145v.656a3.82 3.82 0 0 1-3.8 3.489m6.921-3.817a7 7 0 0 0-.015-.435v-.077h-.006a6.922 6.922 0 1 0-3.153 6.33 4.11 4.11 0 0 1-6.977 2.223l-2.207 2.183a7.214 7.214 0 0 0 12.343-5.074v-4.714a7 7 0 0 0 .015-.435","data-name":"Caminho 39013"}),i.createElement("path",{d:"M89.259 18.545h-3.1v-6.243a7.8 7.8 0 0 1 9.376-7.635l-.627 3.04a4.7 4.7 0 0 0-5.644 4.594Z","data-name":"Caminho 39014"}),i.createElement("path",{d:"M50.283 13.309H47.96a1.783 1.783 0 1 1 0-3.566h2.323a1.783 1.783 0 1 1 0 3.566","data-name":"Caminho 39015"}),i.createElement("path",{d:"M0 11.646v.134a11.78 11.78 0 0 0 11.776 11.78v-.134A11.78 11.78 0 0 0 0 11.646","data-name":"Caminho 39016"}),i.createElement("path",{d:"M23.56 11.78v-.134a11.78 11.78 0 0 0-11.776 11.78v.134A11.78 11.78 0 0 0 23.56 11.78","data-name":"Caminho 39017"}),i.createElement("path",{d:"M11.78 4.69a7.09 7.09 0 0 0-6.463 4.176l2.138.964a4.744 4.744 0 0 1 8.65 0l2.138-.964A7.09 7.09 0 0 0 11.78 4.69","data-name":"Caminho 39018"}),i.createElement("path",{d:"M11.78 9.38a2.4 2.4 0 0 0-2.186 1.419l2.186.985 2.186-.985a2.4 2.4 0 0 0-2.186-1.414","data-name":"Caminho 39019"}),i.createElement("path",{d:"M11.78 0A11.78 11.78 0 0 0 1.041 6.94l2.138.96a9.434 9.434 0 0 1 17.2 0l2.139-.96A11.78 11.78 0 0 0 11.78 0","data-name":"Caminho 39020"}))))))`
  width: 6.875rem;
  height: 1.5rem;
`,jp=h.div`
  background-color: ${f.bg01};

  width: 100%;
  height: 3.5rem;

  .especialista-menu-hamburger {
    display: none;
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    .especialista-menu-hamburger {
      display: flex;
    }
  }

  @media (max-width: 320px) {
  }
`,Tp=h(Sp)`
  display: flex;
  align-items: center;
  gap: 3rem;

  height: 100%;

  color: ${f.color03};

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    justify-content: space-between;
    gap: 2rem;
  }

  @media (max-width: 320px) {
  }
`,Rp=h.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 3rem;

  .menu-list {
    flex: 1;
    display: flex;

    gap: 1rem;
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    display: none;
  }

  @media (max-width: 320px) {
  }
`,Lp=h.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  color: ${f.color03};

  &.logout {
    margin-top: 1rem;
  }

  svg {
    height: 1rem;
    width: 1rem;

    ${({isActive:e})=>e&&`\n        color: ${f.color03};\n    `};
  }

  a,
  span {
    padding: 0.25rem 0;
    color: ${f.color03};
    font-size: ${f.fontSize01};
    font-weight: ${f.fontWeight01};
    text-align: center;
    text-decoration: none;

    cursor: pointer;

    &:hover {
      color: ${f.color03};
    }

    ${({isActive:e})=>e&&`\n        color: ${f.color03};\n        border-bottom: 1px solid ${f.color03};\n        font-weight: ${f.fontWeight02};\n    `};
  }
`,Up=h.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;

  .bx--tooltip__trigger {
    svg {
      width: 1rem;
      height: 1rem;
      fill: ${f.color03};
    }
  }
`,qp=h(ne)`
  color: ${f.color03};
  margin-right: 8px;

  width: 1rem;
  height: 1rem;
`,Wp=h(Xo)`
  min-width: 9rem;

  .bx--tooltip__content {
    display: flex !important;
    flex-direction: column;

    gap: 1rem;
  }

  .logout {
    display: block;

    button {
      justify-content: flex-start;
      gap: 0.3rem;

      width: 100%;
      min-height: 1.875rem;
      padding: 0;
    }

    button,
    svg {
      font-size: ${f.fontSize01};
      font-weight: ${f.fontWeight01};
      color: ${f.color03} !important;
    }

    svg {
      height: 1rem !important;
      margin-right: 0 !important;
    }
  }
`,Gp=h.a`
  .btn-logout {
    font-size: ${v.fontSize03};
    color: ${v.color03};
    border-color: initial;
    border: initial;

    .icon-logout {
      color: ${v.color01};
      width: 24px;
      margin-right: 8px;
    }
  }

  .btn-logout:hover {
    background-color: initial;
    border-color: initial;
    border: initial;
  }
`,Hp=({className:o,alt:i,title:n,onStartLoading:r,onStopLoading:a})=>{const l=wo(),{logout:d}=pt(),{agroLogout:s}=mt(),c=new Mo,p=()=>{var e;null==r||r(),null===(e=null===window||void 0===window?void 0:window.ReactNativeWebView)||void 0===e||e.postMessage("logout"),s().then((e=>{e.data.agroLogout.logout&&(c.remove("permissions"),c.remove("_ga"),c.remove("psid",{path:"/"}),c.remove("logged"),c.remove("registerRedirect"),d())})).catch((e=>console.log(e))).finally((()=>{null==a||a(),l.replace("/")}))};return e(Gp,{className:o,"data-testid":"button-logout-id",alt:i,title:n,children:t(Ft,{kind:"ghost",className:"btn-logout",onClick:()=>p(),children:[e(re,{className:"icon-logout"}),"Sair"]})})},Fp=o=>{var{username:i,onStartLoading:n,onStopLoading:a}=o,l=Jl(o,["username","onStartLoading","onStopLoading"]);const[d,s]=r(!1);return t(Up,Object.assign({},l,{children:[e(qp,{}),e(ba,{color:"color03",size:"fontSize01",weight:"fontWeight01",text:"Olá"+(i?`, ${i}`:"")}),e(Wp,{align:"end",renderIcon:d?J:Y,onChange:(e,{open:t})=>s(t),children:e(Hp,{className:"logout",alt:"Sair",title:"Sair",onStartLoading:n,onStopLoading:a})})]}))},Vp=_o`
  query GetRepresentativesPartnerName {
    getRepresentatives {
      partner {
        name
        cnpjNumber
        category
      }
    }
  }
`;var Kp,Jp,Yp;function Zp(){return Zp=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},Zp.apply(null,arguments)}const Xp=e=>i.createElement("svg",Zp({xmlns:"http://www.w3.org/2000/svg",width:21.895,height:16},e),Kp||(Kp=i.createElement("path",{fill:"#fff",d:"M21.895 2H0V0h21.895Z","data-name":"Linha 1"})),Jp||(Jp=i.createElement("path",{fill:"#fff",d:"M21.895 9.412H0v-2h21.895Z","data-name":"Linha 2"})),Yp||(Yp=i.createElement("path",{fill:"#fff",d:"M21.895 16H0v-2h21.895Z","data-name":"Linha 3"}))),_p=A`
  html {
    overflow: hidden;
  }
`,$p=h.div`
  display: flex;
  align-items: center;
  justify-content: center;
`,em=h(Xp)`
  max-width: 1.375rem;
  max-height: 1.375rem;

  margin-right: 0.25rem;

  cursor: pointer;
`,tm=h(mr)`
  width: 2rem;
  height: 2rem;

  color: ${f.color03};

  cursor: pointer;
`,om=h.div`
  position: absolute;

  inset: 0;
  z-index: 70;

  background: ${f.bg13};
  visibility: visible;

  transition:
    background-color 0.2s,
    visibility 0.2s;

  ${({isOpen:e,isLoading:t})=>!e&&!t&&"\n    background: transparent;\n    visibility: hidden;\n  "}

  ${({isLoading:e})=>e&&"\n    background: transparent;\n  "}
`,im=h.div`
  height: 100%;
  max-width: 16.5rem;
  width: 100%;

  padding: 1rem;

  color: ${f.color04};
  background: ${f.bg03};

  transform: translateX(0);

  transition: transform 0.2s;

  ${({isOpen:e})=>!e&&"\n    transform: translateX(-100%);\n  "}

  .user {
    display: flex;
    align-items: center;
    gap: 1rem;

    padding-bottom: 1.2rem;
    margin-bottom: 1.2rem;
    border-bottom: 2px solid ${f.color06};

    font-size: 1rem;
    font-weight: ${f.fontWeight03};

    svg {
      width: 2rem;
      color: ${f.color07};
    }
  }

  .menu-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.5rem;
  }
`,nm=h.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  color: ${f.color04};

  &.logout {
    margin-top: 1rem;
  }

  svg {
    height: 1rem;
    width: 1rem;

    ${({isActive:e})=>e&&`\n        color: ${f.color02};\n    `};
  }

  a,
  span {
    color: ${f.color04};
    font-size: ${f.fontSize01};
    font-weight: ${f.fontWeight01};
    text-decoration: none;

    cursor: pointer;

    &:hover {
      color: ${f.color02};
    }

    ${({isActive:e})=>e&&`\n        padding: 4px 0;\n        color: ${f.color02};\n        border-bottom: 1px solid ${f.color02};\n        font-weight: ${f.fontWeight02};\n    `};
  }
`,rm=({className:i,backdropProps:n,menuProps:a,username:l,anchors:d=[],isLoading:s=!1,onStartLoading:c,onStopLoading:p})=>{const[m,u]=r(!1),h=wo(),{logout:g}=pt(),{agroLogout:A}=mt(),f=()=>{s||(document.documentElement.scrollTop=0,u((e=>!e)))},v=()=>{setTimeout((()=>{var e;null==c||c(),(null===window||void 0===window?void 0:window.isWebView)?null===(e=null===window||void 0===window?void 0:window.ReactNativeWebView)||void 0===e||e.postMessage(JSON.stringify({event:"logout"})):A().then((e=>{e.data.agroLogout.logout&&((()=>{const e=new Mo;e.remove("permissions"),e.remove("_ga"),e.remove("psid",{path:"/"}),e.remove("logged"),e.remove("registerRedirect")})(),g(),h.replace("/"))})).finally((()=>null==p?void 0:p()))}),150)};return t($p,{className:i,children:[m?t(o,{children:[e(_p,{}),e(tm,{onClick:f})]}):e(em,{onClick:f}),e(om,Object.assign({},n,{isOpen:m,isLoading:s,onClick:f,children:t(im,Object.assign({},a,{isOpen:m,onClick:e=>e.stopPropagation(),children:[t("div",{className:"user",children:[e(ae,{}),t("span",{children:["Olá",l?`, ${l}`:"","!"]})]}),t("nav",{className:"menu-list",children:[d.map((o=>t(nm,{isActive:window.location.href.toLowerCase().includes(o.exact?o.path.toLowerCase():o.parentPath.toLowerCase())&&"#"!==o.path,children:[o.icon,e(yo,{title:o.title,to:o.path,onClick:f,children:o.name})]},o.name))),t(nm,{isActive:!1,className:"logout",children:[e(re,{}),e("span",{title:"Sair",onClick:()=>{f(),v()},children:"Sair"})]})]})]}))}))]})};var am,lm,dm,sm;!function(e){e.LoggedIn="logado",e.LoggedOut="deslogado"}(am||(am={})),function(e){e.CLIENTE="CLIENTE",e.ESPECIALISTA="ESPECIALISTA",e.ASSESSOR="ASSESSOR_TECNICO",e.FINANCE="EAGRO_FINANCE"}(lm||(lm={})),function(e){e.CLIENTE="client",e.CLIENTE_CONVIDADO="guest_client",e.ESPECIALISTA="specialist",e.ESPECIALISTA_CONVIDADO="guest_specialist",e.ASSESSOR="advisor"}(dm||(dm={})),function(e){e.ME="SPECIALIST",e.SPECIALIST="OTHER_SPECIALIST",e.CLIENT="CLIENT",e.OTHER="OTHER"}(sm||(sm={}));const cm=[{name:"Início",parentPath:"/dashboard",path:"/dashboardPartner/home",exact:!1,alt:"Início",title:"Início",icon:e(le,{})},{name:"Pedidos de Crédito",parentPath:"/orders",path:"/orders/creditOrders",exact:!0,alt:"Pedidos de Crédito",title:"Pedidos de Crédito",icon:e(de,{})},{name:"Meus Clientes",parentPath:"/clients",path:"/clients/myClients",exact:!0,alt:"Meus Clientes",title:"Meus Clientes",icon:e(se,{})}],pm={name:"Cotações",parentPath:"/cotacoes",path:"/cotacoes/cotacoes-solicitadas",exact:!0,alt:"Cotações",title:"Cotações",icon:e(ce,{})},mm=()=>{var i,n;const a=ut().split(" ")[0],l=wo(),d=(null===(i=qt().profile)||void 0===i?void 0:i.profileAccess)===Wt.ASSESSOR,{data:s}=((e=!1)=>{var t;const o=$o(Vp,{skip:e});return Object.assign(Object.assign({},o),{data:null===(t=o.data)||void 0===t?void 0:t.getRepresentatives})})(!d),[c,p]=r(!1),m=(null===(n=null==s?void 0:s.partner)||void 0===n?void 0:n.category)===lm.FINANCE?[...cm,pm]:cm;return t(jp,{children:[c&&t(o,{children:[e(zp,{}),e(Jo,{type:"fullscreen"})]}),t(Tp,{children:[e(Mp,{onClick:()=>{l.push("/dashboard")},children:e(Dp,{})}),t(Rp,{children:[e("nav",{className:"menu-list",children:m.map((t=>e(Lp,{isActive:window.location.href.toLowerCase().includes(t.exact?t.path.toLowerCase():t.parentPath.toLowerCase())&&"#"!==t.path,children:e(yo,{title:t.title,to:t.path,children:t.name})},t.name)))}),e(Fp,{className:"especialista-toggle-tip",username:a,onStartLoading:()=>p(!0),onStopLoading:()=>p(!1)})]}),e(rm,{className:"especialista-menu-hamburger",anchors:m,backdropProps:{style:{top:"3.5rem"}},username:a,isLoading:c,onStartLoading:()=>p(!0),onStopLoading:()=>p(!1)})]})]})},um=h("div")`
  display: flex;
  flex-direction: column;
`,hm=h("div")`
  padding-bottom: 2.5rem;
`,gm=({children:o})=>t(um,{children:[e(mm,{}),e(hm,{children:e(Ho,{fallbackComponent:Fo,children:o})})]}),Am=h.div`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;

  width: fit-content;
  padding: 0.25rem 0.5rem;

  border: 1px solid;
  border-radius: 6.25rem;

  font-size: ${f.fontSize07};
  font-weight: ${f.fontWeight01};
  line-height: ${f.lineHeight04};

  user-select: none;

  svg {
    height: 0.75rem;
    width: 0.75rem;
    min-width: 0.75rem;
  }

  ${({type:e})=>"primary"===e?`\n    border-color: ${f.bg02};\n    background: ${f.bg07};\n    color: ${f.color02};\n    fill: ${f.color02};\n  `:"danger"===e&&`\n    border-color: ${f.color03Dark};\n    background: ${f.colorAlertLight};\n    color: ${f.color03Dark};\n    fill: ${f.color03Dark};\n  `}
`,fm=({orderUserId:i="",orderUserProfile:n,className:r})=>{const a=ti().getOrderLabel({orderUserId:i,orderUserProfile:n});return a?t(Am,{type:a.type,className:r,children:[a.icon,e("span",{children:a.label})]}):e(o,{})},vm=h.button`
  width: 100%;

  text-align: start;

  padding: 0.875rem 1rem 1rem;

  background: ${f.bg03};
  box-shadow: 0px 2px 8px ${f.bx01};

  border: 1px solid ${f.color07};
  border-radius: 4px;

  cursor: pointer;

  .arrow-right-icon {
    border-radius: 100%;
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    transition-duration: 200ms;
  }

  :hover:not(:disabled),
  :focus:not(:disabled) {
    .arrow-right-icon {
      background: ${f.color06};
      box-shadow: 0 0 0 3px ${f.color06};
    }
  }

  :disabled {
    cursor: not-allowed;
  }
`,xm=h.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;

  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${f.color07};

  > svg {
    min-width: 1.5rem;

    margin-top: 0.0625rem;
  }

  .info {
    display: flex;
    align-items: baseline;
    gap: 1rem;
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    .info {
      flex-direction: column;
      gap: 0.5rem;
    }
  }

  @media (max-width: 320px) {
  }
`,bm=h.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 1rem;

  max-width: 44rem;
`,wm=h.div`
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;

  min-width: fit-content;

  color: ${f.bg04};
  font-size: ${f.fontSize01};
  line-height: ${f.lineHeight02};

  strong {
    font-weight: ${f.fontWeight01};
    line-height: ${f.lineHeight01};
  }

  span {
    color: ${f.color09};

    &.status {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
  }

  &:nth-child(2) {
    flex: 1.3;
  }

  &:nth-child(4) {
    flex: 1.2;
  }

  ${({isLarge:e})=>e&&`\n    font-size: ${f.fontSize02};\n\n    strong {\n      font-weight: ${f.fontWeight03};\n    }\n  `}

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    flex: 1 1 6.125rem;

    &:nth-child(2) {
      flex: 1.5 1 10rem;
    }

    &:nth-child(4) {
      flex: 1.5 1 10rem;
    }

    ${({isLarge:e})=>e&&"\n      flex-basis: unset;\n    "}
  }

  @media (max-width: 320px) {
  }
`,ym=u((({order:i,isDisabled:n=!1,tagging:a,clientProfile:l,onToggleLoading:d,onClick:s,originLocation:c})=>{const p=wo(),{createPrivilegedUserSession:m}=ht(),{updatePrivilegedSessionId:u}=gt(),{canAccessOrderVerify:h,getStatusComponent:g}=ti(),{updateOrderViewed:A}=At(),[f,v]=r(!1),[x,b]=r({isOpen:!1,title:"Acesso não permitido",message:""}),w=(e="")=>{const t=qo(e);return e&&Wo(t)?Go(t,"dd/MM/yyyy",{locale:ei}):""},y=()=>{b((e=>Object.assign(Object.assign({},e),{isOpen:!1})))};return t(o,{children:[e(Us,Object.assign({},x,{icon:e(ce,{}),onConfirm:y,onCancel:y})),t(vm,{disabled:n||f,onClick:e=>((e,t)=>{null==s||s(e);const o=`/formalization/timeline/${null==t?void 0:t.id}`,{message:n,canAccess:r}=h(t);a&&Je.interact(Ye.Click,"botao",`pedido - ${(null==i?void 0:i.numeroPedido)||""}`,a.flow,a.loggedUser,a.firebaseScreen,null,{userId:a.userId}),r?(null==d||d(!0),v(!0),m(l).then((e=>{var t,n;const r=String(null!==(t=null==i?void 0:i.numeroPedido)&&void 0!==t?t:""),{privilegedSessionId:a=""}=(null===(n=e.data)||void 0===n?void 0:n.createPrivilegedUserSession)||{};a&&(u(a,c),A(r),p.push(o,{order:i,isTrusted:!0}))})).catch((()=>{p.push("/partner/error")})).finally((()=>{null==d||d(!1),v(!1)}))):b((e=>Object.assign(Object.assign({},e),{isOpen:!0,message:n,tagging:a&&{firebaseScreen:a.firebaseScreen,flow:a.flow,loggedUser:a.loggedUser,userId:a.userId}})))})(e,i),children:[t(xm,{children:[t("div",{className:"info",children:[t(wm,{isLarge:!0,children:[t("strong",{children:[null==i?void 0:i.modalidadeCredito,(null==i?void 0:i.produto)&&` - ${i.produto}`]}),e("span",{children:Ze(null==i?void 0:i.valorTotalFormalizacao)})]}),e(fm,{orderUserId:null==i?void 0:i.idUsuarioSolicitacaoPedido,orderUserProfile:null==i?void 0:i.perfilUsuarioSolicitacaoPedido})]}),e(oe,{className:"arrow-right-icon"})]}),t(bm,{children:[t(wm,{children:[e("strong",{children:"Nº do pedido"}),e("span",{children:null==i?void 0:i.numeroPedido})]}),t(wm,{children:[e("strong",{children:"Data da solicitação"}),e("span",{children:w(null==i?void 0:i.datahoraInclusaoFormalizacao)})]}),t(wm,{children:[e("strong",{children:"Expira em"}),e("span",{children:w(null==i?void 0:i.dataExpiracao)})]}),t(wm,{children:[e("strong",{children:"Status"}),e("span",{className:"status",children:g((null==i?void 0:i.situacaoFormalizacao)||"")})]})]})]})]})})),Cm=h.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .capitalize {
    text-transform: capitalize;
  }
`,Em=h.button`
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5rem;
  flex-wrap: nowrap;

  padding: 1rem 0;

  border: 0;
  border-bottom: 2px solid ${f.color07};
  background: ${f.bg03};
  color: ${f.color04};

  transition: background-color 0.2s;

  cursor: pointer;

  &:hover:not(:active):not(:disabled) {
    background: ${f.bg07};
  }

  > svg {
    min-width: 1.5rem;
  }

  .icon-disabled {
    color: ${f.color23};
  }

  .order-info {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 1rem;

    text-align: start;

    .order-data {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 1rem 2rem;
    }
  }

  :disabled {
    cursor: not-allowed;
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    gap: 1rem;

    &:active:not(:disabled) {
      background: ${f.bg07};
    }

    .order-info {
      .order-data {
        align-items: flex-start;
        flex-direction: column;
        gap: 0.5rem;
      }
    }
  }

  @media (max-width: 320px) {
  }
`,Bm=h.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;

  .content {
    color: ${f.color04};
    font-size: ${f.fontSize04};
    font-weight: ${f.fontWeight01};

    strong {
      font-weight: ${f.fontWeight03};
    }

    .order-number {
      color: ${f.color10};
      font-size: ${f.fontSize01};
    }
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    flex-direction: column;
    align-items: flex-start;

    .content {
      font-size: ${f.fontSize02};
      line-height: ${f.lineHeight01};

      .order-number {
        font-size: ${f.fontSize07};
      }
    }
  }

  @media (max-width: 320px) {
  }
`,km=h.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;

  color: ${f.color09};
  font-size: ${f.fontSize01};

  &:first-child {
    width: 13.25rem;
  }

  span {
    white-space: nowrap;
  }

  strong {
    color: ${f.color04};
    font-weight: ${f.fontWeight01};

    &.status {
      gap: 0.5rem;
      display: flex;
      align-items: center;
    }
  }
`,Im=h(yp)`
  margin-top: 2.5rem;

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    .bx--btn--icon-only {
      justify-content: center;

      width: 2.25rem;

      padding: 0;
    }

    .bx--pagination-nav__page,
    .bx--pagination-nav__page--select {
      width: 2rem;
      min-width: 0;

      padding: 1.0625rem 0;
    }
  }

  @media (max-width: 320px) {
  }
`,Nm=({data:o=[],isLoading:i=!1,hasPagination:n=!1,page:l=0,perPage:d=10,totalItems:s=0,tagging:c,onClick:p,onPageChange:m})=>{var u;const h=wo(),g=ti(),A=qt(),{createPrivilegedUserSession:f}=ht(),{updatePrivilegedSessionId:v}=oi(),{clientProfileResponse:x,getClientProfile:b}=ft().getClientProfileLazy(),{updateOrderViewed:w}=At(),[y,C]=r(!1),[E,B]=r({pathname:"#"}),[k,I]=r({isOpen:!1,title:"Acesso não permitido",message:""}),N=(null===(u=A.profile)||void 0===u?void 0:u.profileAccess)===Wt.ASSESSOR?"e-agro/assessor/cliente":"e-agro/especialista/cliente",S=(e="")=>{const t=qo(e);return e&&Wo(t)?Go(t,"dd/MM/yyyy",{locale:ei}):""},O=()=>{I((e=>Object.assign(Object.assign({},e),{isOpen:!1})))};return a((()=>{var e;E.order&&(E.order.numeroCPFCNPJ?b(null===(e=E.order)||void 0===e?void 0:e.numeroCPFCNPJ):h.push("/partner/error"))}),[E.order]),a((()=>{x.error&&h.push("/partner/error")}),[x.error]),a((()=>{var e,t,o,i;if((null===(e=x.data)||void 0===e?void 0:e.getClientProfile)&&(null===(t=E.order)||void 0===t?void 0:t.numeroCPFCNPJ)===(null===(o=x.data)||void 0===o?void 0:o.getClientProfile.cpf)){const{cpf:e="",email:t="",fullName:o="",phoneNumber:n=""}=(null===(i=x.data)||void 0===i?void 0:i.getClientProfile)||{};C(!0),f({clientCPFCNPJ:e,clientEmail:t,clientName:o,clientPhone:n}).then((e=>{var t,o,i;const n=String(null!==(o=null===(t=E.order)||void 0===t?void 0:t.numeroPedido)&&void 0!==o?o:""),{privilegedSessionId:r=""}=(null===(i=e.data)||void 0===i?void 0:i.createPrivilegedUserSession)||{};r&&(v(r),w(n),h.push(E.pathname,{selectedOrder:E.order,isTrusted:!0}))})).catch((()=>{h.push("/partner/error")})).finally((()=>{C(!1)}))}}),[E,x]),t(Cm,{children:[e(Us,Object.assign({},k,{icon:e(ce,{}),onConfirm:O,onCancel:O})),i?e(Vt,{withOverlay:!1}):null==o?void 0:o.map((o=>{var i;return t(Em,{onClick:e=>((e,t)=>{null==p||p(e,t);const{message:o,canAccess:i,pathname:n}=g.canAccessOrderVerify(t);c&&Je.interact(Ye.Click,"botao",`pedido - ${(null==t?void 0:t.numeroPedido)||""}`,c.flow,c.loggedUser,c.firebaseScreen,null,{userId:c.userId}),i?B({order:t,pathname:n}):I((e=>Object.assign(Object.assign({},e),{isOpen:!0,message:o,tagging:c&&{firebaseScreen:`${N}/acesso-nao-permitido`,flow:c.flow,loggedUser:c.loggedUser,userId:c.userId}})))})(e,o),disabled:y||x.loading,type:"button",children:[t("div",{className:"order-info",children:[t(Bm,{children:[t("div",{className:"content",children:[e("strong",{children:null==o?void 0:o.modalidadeCredito})," ",e("span",{className:"capitalize",children:null===(i=null==o?void 0:o.produto)||void 0===i?void 0:i.toLocaleLowerCase()})," ",t("span",{className:"order-number",children:["(nº ",null==o?void 0:o.numeroPedido,")"]})]}),e("div",{children:e(fm,{className:"made-by-label",orderUserId:null==o?void 0:o.idUsuarioSolicitacaoPedido,orderUserProfile:null==o?void 0:o.perfilUsuarioSolicitacaoPedido})})]}),t("div",{className:"order-data",children:[t(km,{children:[e("span",{children:"Cliente"}),e("strong",{children:null==o?void 0:o.nomeCliente})]}),t(km,{children:[e("span",{children:"Valor"}),e("strong",{children:Ze(null==o?void 0:o.valorTotalFormalizacao)})]}),t(km,{children:[e("span",{children:"Expira em"}),e("strong",{children:S(null==o?void 0:o.dataExpiracao)})]}),t(km,{children:[e("span",{children:"Status"}),e("strong",{className:"status",children:g.getStatusComponent((null==o?void 0:o.situacaoFormalizacao)||"")})]})]})]}),e(oe,{className:y||!g.canAccessOrderVerify(o).canAccess?"icon-disabled":""})]},null==o?void 0:o.numeroPedido)})),n&&s>0&&e(Im,{page:l,totalPages:Math.ceil(s/d),onPageChange:e=>null==m?void 0:m({page:e.page,perPage:d})})]})},Sm=h("div")`
  border: 1px solid ${f.color07};
  padding: 16px 16px 16px 12px;
  border-radius: 4px;
  box-shadow: none;
  width: 100%;
  text-align: left;
  display: flex;
  flex-direction: row;

  ${({statusVariation:e})=>"success"===e&&`background-color: ${f.bg06};\n    border-left: 4px solid ${f.colorSuccess};`};

  ${({statusVariation:e})=>"warning"===e&&`background-color: ${f.bg09};\n    border-left: 4px solid ${f.colorWarning};`};

  ${({statusVariation:e})=>"error"===e&&`background-color: ${f.colorAlertLight};\n      border-left: 4px solid ${f.colorError};`};

  .success-icon {
    color: ${f.colorSuccess};
  }

  .warning-icon {
    color: ${f.colorWarning};
  }

  .error-icon {
    color: ${f.colorError};
  }

  .content-container {
    margin-left: 1rem;
  }

  .remove-margin {
    margin-bottom: 0;
  }
`,Om=h("div")`
  color: ${f.color04};
  font-size: ${f.fontSize01};
  font-weight: ${f.fontWeight02};
  margin-bottom: 0.563rem;
  }
`,Pm=h("div")`
  color: ${f.color09};
  font-size: ${f.fontSize01};
  line-height: ${f.lineHeight01};
`,Qm=({cardTitle:o,cardText:i,className:n,isSuccessful:r,isWarning:a,hasError:l,statusVariation:d})=>t(Sm,{"data-testid":"alert-card",statusVariation:d,className:n,children:[t("div",{id:"icon-status",children:[r&&e(M,{"data-testid":"icon",className:"success-icon"}),a&&e(D,{"data-testid":"icon",className:"warning-icon"}),l&&e(z,{"data-testid":"icon",className:"error-icon"})]}),t("div",{className:"content-container",children:[e(Om,{id:"title-card",className:l?"remove-margin":"",children:o}),e(Pm,{id:"subtitle-card",children:i})]})]});var zm=[],Mm=[],Dm="undefined"!=typeof Uint8Array?Uint8Array:Array,jm=!1;function Tm(){jm=!0;for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",t=0;t<64;++t)zm[t]=e[t],Mm[e.charCodeAt(t)]=t;Mm["-".charCodeAt(0)]=62,Mm["_".charCodeAt(0)]=63}function Rm(e,t,o){for(var i,n,r=[],a=t;a<o;a+=3)i=(e[a]<<16)+(e[a+1]<<8)+e[a+2],r.push(zm[(n=i)>>18&63]+zm[n>>12&63]+zm[n>>6&63]+zm[63&n]);return r.join("")}function Lm(e){var t;jm||Tm();for(var o=e.length,i=o%3,n="",r=[],a=16383,l=0,d=o-i;l<d;l+=a)r.push(Rm(e,l,l+a>d?d:l+a));return 1===i?(t=e[o-1],n+=zm[t>>2],n+=zm[t<<4&63],n+="=="):2===i&&(t=(e[o-2]<<8)+e[o-1],n+=zm[t>>10],n+=zm[t>>4&63],n+=zm[t<<2&63],n+="="),r.push(n),r.join("")}function Um(e,t,o,i,n){var r,a,l=8*n-i-1,d=(1<<l)-1,s=d>>1,c=-7,p=o?n-1:0,m=o?-1:1,u=e[t+p];for(p+=m,r=u&(1<<-c)-1,u>>=-c,c+=l;c>0;r=256*r+e[t+p],p+=m,c-=8);for(a=r&(1<<-c)-1,r>>=-c,c+=i;c>0;a=256*a+e[t+p],p+=m,c-=8);if(0===r)r=1-s;else{if(r===d)return a?NaN:1/0*(u?-1:1);a+=Math.pow(2,i),r-=s}return(u?-1:1)*a*Math.pow(2,r-i)}function qm(e,t,o,i,n,r){var a,l,d,s=8*r-n-1,c=(1<<s)-1,p=c>>1,m=23===n?Math.pow(2,-24)-Math.pow(2,-77):0,u=i?0:r-1,h=i?1:-1,g=t<0||0===t&&1/t<0?1:0;for(t=Math.abs(t),isNaN(t)||t===1/0?(l=isNaN(t)?1:0,a=c):(a=Math.floor(Math.log(t)/Math.LN2),t*(d=Math.pow(2,-a))<1&&(a--,d*=2),(t+=a+p>=1?m/d:m*Math.pow(2,1-p))*d>=2&&(a++,d/=2),a+p>=c?(l=0,a=c):a+p>=1?(l=(t*d-1)*Math.pow(2,n),a+=p):(l=t*Math.pow(2,p-1)*Math.pow(2,n),a=0));n>=8;e[o+u]=255&l,u+=h,l/=256,n-=8);for(a=a<<n|l,s+=n;s>0;e[o+u]=255&a,u+=h,a/=256,s-=8);e[o+u-h]|=128*g}var Wm={}.toString,Gm=Array.isArray||function(e){return"[object Array]"==Wm.call(e)};function Hm(){return Vm.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function Fm(e,t){if(Hm()<t)throw new RangeError("Invalid typed array length");return Vm.TYPED_ARRAY_SUPPORT?(e=new Uint8Array(t)).__proto__=Vm.prototype:(null===e&&(e=new Vm(t)),e.length=t),e}function Vm(e,t,o){if(!(Vm.TYPED_ARRAY_SUPPORT||this instanceof Vm))return new Vm(e,t,o);if("number"==typeof e){if("string"==typeof t)throw new Error("If encoding is specified then the first argument must be a string");return Ym(this,e)}return Km(this,e,t,o)}function Km(e,t,o,i){if("number"==typeof t)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&t instanceof ArrayBuffer?function(e,t,o,i){if(t.byteLength,o<0||t.byteLength<o)throw new RangeError("'offset' is out of bounds");if(t.byteLength<o+(i||0))throw new RangeError("'length' is out of bounds");t=void 0===o&&void 0===i?new Uint8Array(t):void 0===i?new Uint8Array(t,o):new Uint8Array(t,o,i);Vm.TYPED_ARRAY_SUPPORT?(e=t).__proto__=Vm.prototype:e=Zm(e,t);return e}(e,t,o,i):"string"==typeof t?function(e,t,o){"string"==typeof o&&""!==o||(o="utf8");if(!Vm.isEncoding(o))throw new TypeError('"encoding" must be a valid string encoding');var i=0|$m(t,o);e=Fm(e,i);var n=e.write(t,o);n!==i&&(e=e.slice(0,n));return e}(e,t,o):function(e,t){if(_m(t)){var o=0|Xm(t.length);return 0===(e=Fm(e,o)).length||t.copy(e,0,0,o),e}if(t){if("undefined"!=typeof ArrayBuffer&&t.buffer instanceof ArrayBuffer||"length"in t)return"number"!=typeof t.length||(i=t.length)!=i?Fm(e,0):Zm(e,t);if("Buffer"===t.type&&Gm(t.data))return Zm(e,t.data)}var i;throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}(e,t)}function Jm(e){if("number"!=typeof e)throw new TypeError('"size" argument must be a number');if(e<0)throw new RangeError('"size" argument must not be negative')}function Ym(e,t){if(Jm(t),e=Fm(e,t<0?0:0|Xm(t)),!Vm.TYPED_ARRAY_SUPPORT)for(var o=0;o<t;++o)e[o]=0;return e}function Zm(e,t){var o=t.length<0?0:0|Xm(t.length);e=Fm(e,o);for(var i=0;i<o;i+=1)e[i]=255&t[i];return e}function Xm(e){if(e>=Hm())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+Hm().toString(16)+" bytes");return 0|e}function _m(e){return!(null==e||!e._isBuffer)}function $m(e,t){if(_m(e))return e.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(e)||e instanceof ArrayBuffer))return e.byteLength;"string"!=typeof e&&(e=""+e);var o=e.length;if(0===o)return 0;for(var i=!1;;)switch(t){case"ascii":case"latin1":case"binary":return o;case"utf8":case"utf-8":case void 0:return ku(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*o;case"hex":return o>>>1;case"base64":return Iu(e).length;default:if(i)return ku(e).length;t=(""+t).toLowerCase(),i=!0}}function eu(e,t,o){var i=!1;if((void 0===t||t<0)&&(t=0),t>this.length)return"";if((void 0===o||o>this.length)&&(o=this.length),o<=0)return"";if((o>>>=0)<=(t>>>=0))return"";for(e||(e="utf8");;)switch(e){case"hex":return gu(this,t,o);case"utf8":case"utf-8":return pu(this,t,o);case"ascii":return uu(this,t,o);case"latin1":case"binary":return hu(this,t,o);case"base64":return cu(this,t,o);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return Au(this,t,o);default:if(i)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase(),i=!0}}function tu(e,t,o){var i=e[t];e[t]=e[o],e[o]=i}function ou(e,t,o,i,n){if(0===e.length)return-1;if("string"==typeof o?(i=o,o=0):o>2147483647?o=2147483647:o<-2147483648&&(o=-2147483648),o=+o,isNaN(o)&&(o=n?0:e.length-1),o<0&&(o=e.length+o),o>=e.length){if(n)return-1;o=e.length-1}else if(o<0){if(!n)return-1;o=0}if("string"==typeof t&&(t=Vm.from(t,i)),_m(t))return 0===t.length?-1:iu(e,t,o,i,n);if("number"==typeof t)return t&=255,Vm.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?n?Uint8Array.prototype.indexOf.call(e,t,o):Uint8Array.prototype.lastIndexOf.call(e,t,o):iu(e,[t],o,i,n);throw new TypeError("val must be string, number or Buffer")}function iu(e,t,o,i,n){var r,a=1,l=e.length,d=t.length;if(void 0!==i&&("ucs2"===(i=String(i).toLowerCase())||"ucs-2"===i||"utf16le"===i||"utf-16le"===i)){if(e.length<2||t.length<2)return-1;a=2,l/=2,d/=2,o/=2}function s(e,t){return 1===a?e[t]:e.readUInt16BE(t*a)}if(n){var c=-1;for(r=o;r<l;r++)if(s(e,r)===s(t,-1===c?0:r-c)){if(-1===c&&(c=r),r-c+1===d)return c*a}else-1!==c&&(r-=r-c),c=-1}else for(o+d>l&&(o=l-d),r=o;r>=0;r--){for(var p=!0,m=0;m<d;m++)if(s(e,r+m)!==s(t,m)){p=!1;break}if(p)return r}return-1}function nu(e,t,o,i){o=Number(o)||0;var n=e.length-o;i?(i=Number(i))>n&&(i=n):i=n;var r=t.length;if(r%2!=0)throw new TypeError("Invalid hex string");i>r/2&&(i=r/2);for(var a=0;a<i;++a){var l=parseInt(t.substr(2*a,2),16);if(isNaN(l))return a;e[o+a]=l}return a}function ru(e,t,o,i){return Nu(ku(t,e.length-o),e,o,i)}function au(e,t,o,i){return Nu(function(e){for(var t=[],o=0;o<e.length;++o)t.push(255&e.charCodeAt(o));return t}(t),e,o,i)}function lu(e,t,o,i){return au(e,t,o,i)}function du(e,t,o,i){return Nu(Iu(t),e,o,i)}function su(e,t,o,i){return Nu(function(e,t){for(var o,i,n,r=[],a=0;a<e.length&&!((t-=2)<0);++a)i=(o=e.charCodeAt(a))>>8,n=o%256,r.push(n),r.push(i);return r}(t,e.length-o),e,o,i)}function cu(e,t,o){return 0===t&&o===e.length?Lm(e):Lm(e.slice(t,o))}function pu(e,t,o){o=Math.min(e.length,o);for(var i=[],n=t;n<o;){var r,a,l,d,s=e[n],c=null,p=s>239?4:s>223?3:s>191?2:1;if(n+p<=o)switch(p){case 1:s<128&&(c=s);break;case 2:128==(192&(r=e[n+1]))&&(d=(31&s)<<6|63&r)>127&&(c=d);break;case 3:r=e[n+1],a=e[n+2],128==(192&r)&&128==(192&a)&&(d=(15&s)<<12|(63&r)<<6|63&a)>2047&&(d<55296||d>57343)&&(c=d);break;case 4:r=e[n+1],a=e[n+2],l=e[n+3],128==(192&r)&&128==(192&a)&&128==(192&l)&&(d=(15&s)<<18|(63&r)<<12|(63&a)<<6|63&l)>65535&&d<1114112&&(c=d)}null===c?(c=65533,p=1):c>65535&&(c-=65536,i.push(c>>>10&1023|55296),c=56320|1023&c),i.push(c),n+=p}return function(e){var t=e.length;if(t<=mu)return String.fromCharCode.apply(String,e);var o="",i=0;for(;i<t;)o+=String.fromCharCode.apply(String,e.slice(i,i+=mu));return o}(i)}Vm.TYPED_ARRAY_SUPPORT=void 0===Hi.TYPED_ARRAY_SUPPORT||Hi.TYPED_ARRAY_SUPPORT,Hm(),Vm.poolSize=8192,Vm._augment=function(e){return e.__proto__=Vm.prototype,e},Vm.from=function(e,t,o){return Km(null,e,t,o)},Vm.TYPED_ARRAY_SUPPORT&&(Vm.prototype.__proto__=Uint8Array.prototype,Vm.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&Vm[Symbol.species]),Vm.alloc=function(e,t,o){return function(e,t,o,i){return Jm(t),t<=0?Fm(e,t):void 0!==o?"string"==typeof i?Fm(e,t).fill(o,i):Fm(e,t).fill(o):Fm(e,t)}(null,e,t,o)},Vm.allocUnsafe=function(e){return Ym(null,e)},Vm.allocUnsafeSlow=function(e){return Ym(null,e)},Vm.isBuffer=function(e){return null!=e&&(!!e._isBuffer||Su(e)||function(e){return"function"==typeof e.readFloatLE&&"function"==typeof e.slice&&Su(e.slice(0,0))}(e))},Vm.compare=function(e,t){if(!_m(e)||!_m(t))throw new TypeError("Arguments must be Buffers");if(e===t)return 0;for(var o=e.length,i=t.length,n=0,r=Math.min(o,i);n<r;++n)if(e[n]!==t[n]){o=e[n],i=t[n];break}return o<i?-1:i<o?1:0},Vm.isEncoding=function(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},Vm.concat=function(e,t){if(!Gm(e))throw new TypeError('"list" argument must be an Array of Buffers');if(0===e.length)return Vm.alloc(0);var o;if(void 0===t)for(t=0,o=0;o<e.length;++o)t+=e[o].length;var i=Vm.allocUnsafe(t),n=0;for(o=0;o<e.length;++o){var r=e[o];if(!_m(r))throw new TypeError('"list" argument must be an Array of Buffers');r.copy(i,n),n+=r.length}return i},Vm.byteLength=$m,Vm.prototype._isBuffer=!0,Vm.prototype.swap16=function(){var e=this.length;if(e%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var t=0;t<e;t+=2)tu(this,t,t+1);return this},Vm.prototype.swap32=function(){var e=this.length;if(e%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var t=0;t<e;t+=4)tu(this,t,t+3),tu(this,t+1,t+2);return this},Vm.prototype.swap64=function(){var e=this.length;if(e%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var t=0;t<e;t+=8)tu(this,t,t+7),tu(this,t+1,t+6),tu(this,t+2,t+5),tu(this,t+3,t+4);return this},Vm.prototype.toString=function(){var e=0|this.length;return 0===e?"":0===arguments.length?pu(this,0,e):eu.apply(this,arguments)},Vm.prototype.equals=function(e){if(!_m(e))throw new TypeError("Argument must be a Buffer");return this===e||0===Vm.compare(this,e)},Vm.prototype.inspect=function(){var e="";return this.length>0&&(e=this.toString("hex",0,50).match(/.{2}/g).join(" "),this.length>50&&(e+=" ... ")),"<Buffer "+e+">"},Vm.prototype.compare=function(e,t,o,i,n){if(!_m(e))throw new TypeError("Argument must be a Buffer");if(void 0===t&&(t=0),void 0===o&&(o=e?e.length:0),void 0===i&&(i=0),void 0===n&&(n=this.length),t<0||o>e.length||i<0||n>this.length)throw new RangeError("out of range index");if(i>=n&&t>=o)return 0;if(i>=n)return-1;if(t>=o)return 1;if(this===e)return 0;for(var r=(n>>>=0)-(i>>>=0),a=(o>>>=0)-(t>>>=0),l=Math.min(r,a),d=this.slice(i,n),s=e.slice(t,o),c=0;c<l;++c)if(d[c]!==s[c]){r=d[c],a=s[c];break}return r<a?-1:a<r?1:0},Vm.prototype.includes=function(e,t,o){return-1!==this.indexOf(e,t,o)},Vm.prototype.indexOf=function(e,t,o){return ou(this,e,t,o,!0)},Vm.prototype.lastIndexOf=function(e,t,o){return ou(this,e,t,o,!1)},Vm.prototype.write=function(e,t,o,i){if(void 0===t)i="utf8",o=this.length,t=0;else if(void 0===o&&"string"==typeof t)i=t,o=this.length,t=0;else{if(!isFinite(t))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");t|=0,isFinite(o)?(o|=0,void 0===i&&(i="utf8")):(i=o,o=void 0)}var n=this.length-t;if((void 0===o||o>n)&&(o=n),e.length>0&&(o<0||t<0)||t>this.length)throw new RangeError("Attempt to write outside buffer bounds");i||(i="utf8");for(var r=!1;;)switch(i){case"hex":return nu(this,e,t,o);case"utf8":case"utf-8":return ru(this,e,t,o);case"ascii":return au(this,e,t,o);case"latin1":case"binary":return lu(this,e,t,o);case"base64":return du(this,e,t,o);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return su(this,e,t,o);default:if(r)throw new TypeError("Unknown encoding: "+i);i=(""+i).toLowerCase(),r=!0}},Vm.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var mu=4096;function uu(e,t,o){var i="";o=Math.min(e.length,o);for(var n=t;n<o;++n)i+=String.fromCharCode(127&e[n]);return i}function hu(e,t,o){var i="";o=Math.min(e.length,o);for(var n=t;n<o;++n)i+=String.fromCharCode(e[n]);return i}function gu(e,t,o){var i=e.length;(!t||t<0)&&(t=0),(!o||o<0||o>i)&&(o=i);for(var n="",r=t;r<o;++r)n+=Bu(e[r]);return n}function Au(e,t,o){for(var i=e.slice(t,o),n="",r=0;r<i.length;r+=2)n+=String.fromCharCode(i[r]+256*i[r+1]);return n}function fu(e,t,o){if(e%1!=0||e<0)throw new RangeError("offset is not uint");if(e+t>o)throw new RangeError("Trying to access beyond buffer length")}function vu(e,t,o,i,n,r){if(!_m(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(t>n||t<r)throw new RangeError('"value" argument is out of bounds');if(o+i>e.length)throw new RangeError("Index out of range")}function xu(e,t,o,i){t<0&&(t=65535+t+1);for(var n=0,r=Math.min(e.length-o,2);n<r;++n)e[o+n]=(t&255<<8*(i?n:1-n))>>>8*(i?n:1-n)}function bu(e,t,o,i){t<0&&(t=4294967295+t+1);for(var n=0,r=Math.min(e.length-o,4);n<r;++n)e[o+n]=t>>>8*(i?n:3-n)&255}function wu(e,t,o,i,n,r){if(o+i>e.length)throw new RangeError("Index out of range");if(o<0)throw new RangeError("Index out of range")}function yu(e,t,o,i,n){return n||wu(e,0,o,4),qm(e,t,o,i,23,4),o+4}function Cu(e,t,o,i,n){return n||wu(e,0,o,8),qm(e,t,o,i,52,8),o+8}Vm.prototype.slice=function(e,t){var o,i=this.length;if((e=~~e)<0?(e+=i)<0&&(e=0):e>i&&(e=i),(t=void 0===t?i:~~t)<0?(t+=i)<0&&(t=0):t>i&&(t=i),t<e&&(t=e),Vm.TYPED_ARRAY_SUPPORT)(o=this.subarray(e,t)).__proto__=Vm.prototype;else{var n=t-e;o=new Vm(n,void 0);for(var r=0;r<n;++r)o[r]=this[r+e]}return o},Vm.prototype.readUIntLE=function(e,t,o){e|=0,t|=0,o||fu(e,t,this.length);for(var i=this[e],n=1,r=0;++r<t&&(n*=256);)i+=this[e+r]*n;return i},Vm.prototype.readUIntBE=function(e,t,o){e|=0,t|=0,o||fu(e,t,this.length);for(var i=this[e+--t],n=1;t>0&&(n*=256);)i+=this[e+--t]*n;return i},Vm.prototype.readUInt8=function(e,t){return t||fu(e,1,this.length),this[e]},Vm.prototype.readUInt16LE=function(e,t){return t||fu(e,2,this.length),this[e]|this[e+1]<<8},Vm.prototype.readUInt16BE=function(e,t){return t||fu(e,2,this.length),this[e]<<8|this[e+1]},Vm.prototype.readUInt32LE=function(e,t){return t||fu(e,4,this.length),(this[e]|this[e+1]<<8|this[e+2]<<16)+16777216*this[e+3]},Vm.prototype.readUInt32BE=function(e,t){return t||fu(e,4,this.length),16777216*this[e]+(this[e+1]<<16|this[e+2]<<8|this[e+3])},Vm.prototype.readIntLE=function(e,t,o){e|=0,t|=0,o||fu(e,t,this.length);for(var i=this[e],n=1,r=0;++r<t&&(n*=256);)i+=this[e+r]*n;return i>=(n*=128)&&(i-=Math.pow(2,8*t)),i},Vm.prototype.readIntBE=function(e,t,o){e|=0,t|=0,o||fu(e,t,this.length);for(var i=t,n=1,r=this[e+--i];i>0&&(n*=256);)r+=this[e+--i]*n;return r>=(n*=128)&&(r-=Math.pow(2,8*t)),r},Vm.prototype.readInt8=function(e,t){return t||fu(e,1,this.length),128&this[e]?-1*(255-this[e]+1):this[e]},Vm.prototype.readInt16LE=function(e,t){t||fu(e,2,this.length);var o=this[e]|this[e+1]<<8;return 32768&o?4294901760|o:o},Vm.prototype.readInt16BE=function(e,t){t||fu(e,2,this.length);var o=this[e+1]|this[e]<<8;return 32768&o?4294901760|o:o},Vm.prototype.readInt32LE=function(e,t){return t||fu(e,4,this.length),this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24},Vm.prototype.readInt32BE=function(e,t){return t||fu(e,4,this.length),this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]},Vm.prototype.readFloatLE=function(e,t){return t||fu(e,4,this.length),Um(this,e,!0,23,4)},Vm.prototype.readFloatBE=function(e,t){return t||fu(e,4,this.length),Um(this,e,!1,23,4)},Vm.prototype.readDoubleLE=function(e,t){return t||fu(e,8,this.length),Um(this,e,!0,52,8)},Vm.prototype.readDoubleBE=function(e,t){return t||fu(e,8,this.length),Um(this,e,!1,52,8)},Vm.prototype.writeUIntLE=function(e,t,o,i){(e=+e,t|=0,o|=0,i)||vu(this,e,t,o,Math.pow(2,8*o)-1,0);var n=1,r=0;for(this[t]=255&e;++r<o&&(n*=256);)this[t+r]=e/n&255;return t+o},Vm.prototype.writeUIntBE=function(e,t,o,i){(e=+e,t|=0,o|=0,i)||vu(this,e,t,o,Math.pow(2,8*o)-1,0);var n=o-1,r=1;for(this[t+n]=255&e;--n>=0&&(r*=256);)this[t+n]=e/r&255;return t+o},Vm.prototype.writeUInt8=function(e,t,o){return e=+e,t|=0,o||vu(this,e,t,1,255,0),Vm.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),this[t]=255&e,t+1},Vm.prototype.writeUInt16LE=function(e,t,o){return e=+e,t|=0,o||vu(this,e,t,2,65535,0),Vm.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):xu(this,e,t,!0),t+2},Vm.prototype.writeUInt16BE=function(e,t,o){return e=+e,t|=0,o||vu(this,e,t,2,65535,0),Vm.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):xu(this,e,t,!1),t+2},Vm.prototype.writeUInt32LE=function(e,t,o){return e=+e,t|=0,o||vu(this,e,t,4,4294967295,0),Vm.TYPED_ARRAY_SUPPORT?(this[t+3]=e>>>24,this[t+2]=e>>>16,this[t+1]=e>>>8,this[t]=255&e):bu(this,e,t,!0),t+4},Vm.prototype.writeUInt32BE=function(e,t,o){return e=+e,t|=0,o||vu(this,e,t,4,4294967295,0),Vm.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):bu(this,e,t,!1),t+4},Vm.prototype.writeIntLE=function(e,t,o,i){if(e=+e,t|=0,!i){var n=Math.pow(2,8*o-1);vu(this,e,t,o,n-1,-n)}var r=0,a=1,l=0;for(this[t]=255&e;++r<o&&(a*=256);)e<0&&0===l&&0!==this[t+r-1]&&(l=1),this[t+r]=(e/a|0)-l&255;return t+o},Vm.prototype.writeIntBE=function(e,t,o,i){if(e=+e,t|=0,!i){var n=Math.pow(2,8*o-1);vu(this,e,t,o,n-1,-n)}var r=o-1,a=1,l=0;for(this[t+r]=255&e;--r>=0&&(a*=256);)e<0&&0===l&&0!==this[t+r+1]&&(l=1),this[t+r]=(e/a|0)-l&255;return t+o},Vm.prototype.writeInt8=function(e,t,o){return e=+e,t|=0,o||vu(this,e,t,1,127,-128),Vm.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),e<0&&(e=255+e+1),this[t]=255&e,t+1},Vm.prototype.writeInt16LE=function(e,t,o){return e=+e,t|=0,o||vu(this,e,t,2,32767,-32768),Vm.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):xu(this,e,t,!0),t+2},Vm.prototype.writeInt16BE=function(e,t,o){return e=+e,t|=0,o||vu(this,e,t,2,32767,-32768),Vm.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):xu(this,e,t,!1),t+2},Vm.prototype.writeInt32LE=function(e,t,o){return e=+e,t|=0,o||vu(this,e,t,4,2147483647,-2147483648),Vm.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8,this[t+2]=e>>>16,this[t+3]=e>>>24):bu(this,e,t,!0),t+4},Vm.prototype.writeInt32BE=function(e,t,o){return e=+e,t|=0,o||vu(this,e,t,4,2147483647,-2147483648),e<0&&(e=4294967295+e+1),Vm.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):bu(this,e,t,!1),t+4},Vm.prototype.writeFloatLE=function(e,t,o){return yu(this,e,t,!0,o)},Vm.prototype.writeFloatBE=function(e,t,o){return yu(this,e,t,!1,o)},Vm.prototype.writeDoubleLE=function(e,t,o){return Cu(this,e,t,!0,o)},Vm.prototype.writeDoubleBE=function(e,t,o){return Cu(this,e,t,!1,o)},Vm.prototype.copy=function(e,t,o,i){if(o||(o=0),i||0===i||(i=this.length),t>=e.length&&(t=e.length),t||(t=0),i>0&&i<o&&(i=o),i===o)return 0;if(0===e.length||0===this.length)return 0;if(t<0)throw new RangeError("targetStart out of bounds");if(o<0||o>=this.length)throw new RangeError("sourceStart out of bounds");if(i<0)throw new RangeError("sourceEnd out of bounds");i>this.length&&(i=this.length),e.length-t<i-o&&(i=e.length-t+o);var n,r=i-o;if(this===e&&o<t&&t<i)for(n=r-1;n>=0;--n)e[n+t]=this[n+o];else if(r<1e3||!Vm.TYPED_ARRAY_SUPPORT)for(n=0;n<r;++n)e[n+t]=this[n+o];else Uint8Array.prototype.set.call(e,this.subarray(o,o+r),t);return r},Vm.prototype.fill=function(e,t,o,i){if("string"==typeof e){if("string"==typeof t?(i=t,t=0,o=this.length):"string"==typeof o&&(i=o,o=this.length),1===e.length){var n=e.charCodeAt(0);n<256&&(e=n)}if(void 0!==i&&"string"!=typeof i)throw new TypeError("encoding must be a string");if("string"==typeof i&&!Vm.isEncoding(i))throw new TypeError("Unknown encoding: "+i)}else"number"==typeof e&&(e&=255);if(t<0||this.length<t||this.length<o)throw new RangeError("Out of range index");if(o<=t)return this;var r;if(t>>>=0,o=void 0===o?this.length:o>>>0,e||(e=0),"number"==typeof e)for(r=t;r<o;++r)this[r]=e;else{var a=_m(e)?e:ku(new Vm(e,i).toString()),l=a.length;for(r=0;r<o-t;++r)this[r+t]=a[r%l]}return this};var Eu=/[^+\/0-9A-Za-z-_]/g;function Bu(e){return e<16?"0"+e.toString(16):e.toString(16)}function ku(e,t){var o;t=t||1/0;for(var i=e.length,n=null,r=[],a=0;a<i;++a){if((o=e.charCodeAt(a))>55295&&o<57344){if(!n){if(o>56319){(t-=3)>-1&&r.push(239,191,189);continue}if(a+1===i){(t-=3)>-1&&r.push(239,191,189);continue}n=o;continue}if(o<56320){(t-=3)>-1&&r.push(239,191,189),n=o;continue}o=65536+(n-55296<<10|o-56320)}else n&&(t-=3)>-1&&r.push(239,191,189);if(n=null,o<128){if((t-=1)<0)break;r.push(o)}else if(o<2048){if((t-=2)<0)break;r.push(o>>6|192,63&o|128)}else if(o<65536){if((t-=3)<0)break;r.push(o>>12|224,o>>6&63|128,63&o|128)}else{if(!(o<1114112))throw new Error("Invalid code point");if((t-=4)<0)break;r.push(o>>18|240,o>>12&63|128,o>>6&63|128,63&o|128)}}return r}function Iu(e){return function(e){var t,o,i,n,r,a;jm||Tm();var l=e.length;if(l%4>0)throw new Error("Invalid string. Length must be a multiple of 4");r="="===e[l-2]?2:"="===e[l-1]?1:0,a=new Dm(3*l/4-r),i=r>0?l-4:l;var d=0;for(t=0,o=0;t<i;t+=4,o+=3)n=Mm[e.charCodeAt(t)]<<18|Mm[e.charCodeAt(t+1)]<<12|Mm[e.charCodeAt(t+2)]<<6|Mm[e.charCodeAt(t+3)],a[d++]=n>>16&255,a[d++]=n>>8&255,a[d++]=255&n;return 2===r?(n=Mm[e.charCodeAt(t)]<<2|Mm[e.charCodeAt(t+1)]>>4,a[d++]=255&n):1===r&&(n=Mm[e.charCodeAt(t)]<<10|Mm[e.charCodeAt(t+1)]<<4|Mm[e.charCodeAt(t+2)]>>2,a[d++]=n>>8&255,a[d++]=255&n),a}(function(e){if((e=function(e){return e.trim?e.trim():e.replace(/^\s+|\s+$/g,"")}(e).replace(Eu,"")).length<2)return"";for(;e.length%4!=0;)e+="=";return e}(e))}function Nu(e,t,o,i){for(var n=0;n<i&&!(n+o>=t.length||n>=e.length);++n)t[n+o]=e[n];return n}function Su(e){return!!e.constructor&&"function"==typeof e.constructor.isBuffer&&e.constructor.isBuffer(e)}const Ou="#0C881E",Pu="#FFFFFF";h(Vt)`
  display: flex;
  justify-content: center;
  margin-left: 2.5rem;
  margin-top: 1rem;
`;const Qu=h("div")`
  label {
    color: ${Ou};
    background-color: ${Pu};
    text-decoration: underline;
  }

  label:hover {
    color: ${Ou};
    background-color: ${Pu};
  }

  .bx--file-container {
    display: none;
  }
`,zu=h("div")`
  display: flex;
  justify-content: center;
  width: 6.063rem;
  height: 6.063rem;
  border-radius: 50%;
  background-color: ${f.color06};
  padding-top: 32px;
  margin-left: 1.4rem;
  margin-right: 4.1rem;
  margin-bottom: 1rem;

  > svg {
    color: ${f.color01};
    width: 36px;
    height: 36px;
  }

  ${({activeCursor:e})=>e&&"\n        cursor:pointer;\n   "};
`,Mu=h("input")`
  visibility: hidden;
  width: 0px;

  /* Safari Only */
  @supports selector(:nth-child(1 of x)) {
    display: none;
  }
`,Du=h("label")`
  margin-left: 2rem;
  color: ${Ou};
  cursor: pointer;
  ${({alignLabel:e})=>e&&"\n    margin-left: 2rem !important;\n    "};

  position: absolute;
  margin-top: 9rem;
  font-size: ${f.fontSize01};
  font-weight: ${f.fontWeight03};
`,ju=h("img")`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
  margin-left: 1.4rem;
  margin-right: 4.1rem;
  max-width: 6rem;
  width: 6rem;
  max-height: 6rem;
  height: 6rem;
  aspect-ratio: 1/1;
  border-radius: 50%;
  object-fit: cover;
`;var Tu;!function(e){e.PNG="image/png",e.JPEG="image/jpeg",e.TIFF="image/tiff",e.PDF="application/pdf"}(Tu||(Tu={}));const Ru=new ii,Lu=({imageSrc:i,isEditableAvatar:n,hasLabel:l})=>{const[d,s]=r(),[c,p]=r(!1),[m,u]=r(!1),{createNotification:h}=ni(),{user:g,profilePhotoUri:A,profilePhotoUriLoading:f,loadProfilePhotoUri:v}=qt(),{getUploadUserFileUrl:x,validateUserFile:b}=vt(),w=()=>{if(n){document.getElementById("imageInput").click()}};return a((()=>{if(null==g?void 0:g.sub){const e=Gt(g.sub);e&&s(e)}}),[null==g?void 0:g.sub]),a((()=>{u(n)}),[n]),t(o,{children:[(f||c)&&e(Vt,{withOverlay:!0}),e(Mu,{id:"imageInput",type:"file",accept:"image/png, image/jpg, image/tiff",onChange:e=>Yl(void 0,void 0,void 0,(function*(){var t;const o=null===(t=e.target)||void 0===t?void 0:t.files[0];if(null==g?void 0:g.sub)if(!o||o.type!==Tu.JPEG&&o.type!==Tu.PNG&&o.type!==Tu.TIFF)h({kind:"error",title:JSON.stringify("Formato de imagem inválido! Formatos aceitos: PNG, JPG e TIFF")});else{p(!0);const e=Vm.from(yield o.arrayBuffer());((e,t,o)=>Yl(void 0,void 0,void 0,(function*(){var i,n;if(!(null==d?void 0:d.trim()))throw new Error("Cannot find Object Key");const r=yield x(d);if(!(null===(i=r.data)||void 0===i?void 0:i.getUploadUserFileUrl.url))throw new Error("Upload URL not found");if(yield Ru.photoUpload(r.data.getUploadUserFileUrl.url,t,{contentType:o,objectKey:d,userId:e}),!(null===(n=(yield b(d)).data)||void 0===n?void 0:n.validateUserFile.clean))throw new Error("File contains virus")})))(g.sub,e,o.type).then((()=>{v()})).catch((()=>{h({kind:"error",title:JSON.stringify("Não foi possível atualizar a foto!")})})).finally((()=>{p(!1)}))}})),value:""}),(i||A)&&!f&&e(ju,{src:A||i,alt:"Imagem de perfil",id:"output"}),!i&&!A&&!f&&e(zu,{onClick:w,activeCursor:m,id:"profilePhoto",children:n?e(pe,{}):null}),e("br",{}),l&&e(Du,{onClick:w,alignLabel:!A&&!i,children:"Editar foto de perfil"}),e(Qu,{})]})};var Uu;function qu(){return qu=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},qu.apply(null,arguments)}const Wu=e=>i.createElement("svg",qu({xmlns:"http://www.w3.org/2000/svg",width:16,height:16,"data-name":"Actions / Navigation / chevron--down / 16"},e),Uu||(Uu=i.createElement("path",{fill:"#0f881e",d:"M8 11 3 6l.7-.7L8 9.6l4.3-4.3.7.7Z"}))),Gu=h.div`
  display: flex;
  justify-content: center;
  align-items: center;
  input {
    width: 100%;
    padding: 10px;
    border: 1px solid #a7a8ac;
    border-radius: 5px;
    text-align: left;
    padding-left: 45px;
    background: url(${Wu}) top left no-repeat;
  }

  .input-icons i {
    position: absolute;
    margin-top: 44px;
  }
  .label {
    color: #0670bf;
    font-weight: 600;
  }
  .input-icons {
    width: 100%;
  }

  .icon {
    padding: 10px;
    color: green;
    min-width: 50px;
    text-align: center;
  }
`;var Hu;function Fu(){return Fu=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},Fu.apply(null,arguments)}const Vu=e=>i.createElement("svg",Fu({xmlns:"http://www.w3.org/2000/svg",width:13.948,height:13.947},e),Hu||(Hu=i.createElement("path",{fill:"#a7a8ac",d:"m13.248 13.947-4.3-4.3a5.44 5.44 0 0 1-7 0 5.37 5.37 0 0 1-1.925-3.7 5.47 5.47 0 0 1 1.225-4A5.42 5.42 0 0 1 5.448 0a5.5 5.5 0 0 1 3.5 1.247 5.37 5.37 0 0 1 1.925 3.7 5.47 5.47 0 0 1-1.225 4l4.3 4.3zm-7.8-13A4.482 4.482 0 1 0 8.635 2.26 4.47 4.47 0 0 0 5.448.948Z"})));function Ku(o){const{placeholder:i,onChange:n,label:r}=o;return e(Gu,{children:t("div",{className:"input-icons",children:[e("i",{className:"icon",children:e(Vu,{})}),e("p",{className:"label",style:{marginBottom:"1rem"},children:r}),e("input",{className:"input",placeholder:i,defaultValue:"",onChange:n})]})})}const Ju=h.div`
  border: 1px solid black;
  border-radius: 0.5rem;
  font-size: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px;
  width: fit-content;
  height: auto;
  column-gap: 8px;
  .removeIcon {
    cursor: pointer;
  }
`,Yu=h.div`
  font-size: 14px;
`,Zu=({label:o,onChipClick:i})=>t(Ju,{children:[e(Yu,{children:o}),e(F,{className:"removeIcon",onClick:()=>{i&&i(o)}})]}),Xu=h("div")`
  display: flex;
  flex-direction: column;
`;h("div")`
  width: 100%;
  z-index: 10;
`,h("div")``;const _u=h("div")``,$u=h.div`
  ._LoaderBase {
    display: flex;
    width: 100%;
    height: 100%;
    overflow-y: show;
    flex-direction: column;
    align-items: stretch;
    justify-content: start;
  }
`,eh=h("div")`
  flex: 1 1 auto;
  display: ${e=>"done"==e.status?"none":"flex"};
  justify-content: center;
  align-items: center;
  padding: 3rem 1rem;

  ${e=>"loading"==e.status?g`
          ._LoaderBase_Placeholder {
            min-height: 500px;
          }
          ._LoaderBase_Foreground {
            position: fixed;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 1.5rem;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.45);
          }
          ._LoaderBase_Message {
            text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);
            margin-top: 1.5rem;
            text-align: center;
            color: ${f.bg03};
            font-weight: ${f.fontWeight01};
            font-size: 0.875rem;
            line-height: 1rem;
          }

          ._LoaderBase_Spinner,
          ._LoaderBase_Spinner:after {
            border-radius: 50%;
            width: 7em;
            height: 7em;
          }

          ._LoaderBase_Spinner {
            background: transparent;

            font-size: 10px;
            position: relative;
            text-indent: -9999em;
            border-top: 0.5em solid transparent;
            border-right: 0.5em solid ${f.bg10};
            border-bottom: 0.5em solid ${f.bg10};
            border-left: 0.5em solid ${f.bg10};
            -webkit-transform: translateZ(0);
            -ms-transform: translateZ(0);
            transform: translateZ(0);
            -webkit-animation: load8 1.1s infinite linear;
            animation: load8 1.1s infinite linear;
          }

          @-webkit-keyframes load8 {
            0% {
              -webkit-transform: rotate(0deg);
              transform: rotate(0deg);
            }
            100% {
              -webkit-transform: rotate(360deg);
              transform: rotate(360deg);
            }
          }

          @keyframes load8 {
            0% {
              -webkit-transform: rotate(0deg);
              transform: rotate(0deg);
            }
            100% {
              -webkit-transform: rotate(360deg);
              transform: rotate(360deg);
            }
          }
        `:g`
          ._LoaderBase_Spinner {
            display: none;
          }
          ._LoaderBase_Foreground {
            display: none;
          }
          ._LoaderBase_Message {
            display: none;
          }
          ._LoaderBase_Placeholder {
            display: none;
          }
        `}

  ${e=>"error"==e.status?`\n\n      ._LoaderBase_Error_Svg{\n        color:${f.colorError};\n        margin-bottom:1rem;\n      }\n     ._LoaderBase_Error_Box{\n       display:flex;\n       flex-direction:column;\n       justify-content:start;\n       align-items:center;\n       padding:10rem 1rem;\n     }\n\n      ._LoaderBase_Error_Formalization_Box{\n        display:flex;\n        flex-direction:column;\n        justify-content:start;\n        align-items:center;\n        padding:10rem 1rem;\n        width: 320px;\n      }\n\n      ._LoaderBase_Error_Title{\n        font-weight:${f.fontWeight03};\n        font-size:1.125rem;\n        margin-bottom:1rem;\n        line-height:1.25rem;\n        text-align:center;\n\n      }\n      ._LoaderBase_Error_Subtitle{\n        text-align:center;\n        font-weight:${f.fontWeight01};\n        line-height:1.063rem;\n        font-size:0.875rem;\n        margin-bottom:0.5rem;\n      }\n\n      ._LoaderBase_Error_Formalization_Subtitle{\n        text-align:center;\n        font-weight:${f.fontWeight01};\n        line-height:1.25rem;\n        font-size:0.875rem;\n        margin-bottom:0.5rem;\n      }\n\n      ._LoaderBase_Link {\n        padding:0.5rem 3rem;\n            :hover,\n            :focus,\n            :focus-visible {\n              text-decoration: underline;\n            }\n          }\n        `:g`
          ._LoaderBase_Error_Box {
            display: none;
          }
        `}
`,th=h.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;

  .bx--loading__stroke {
    stroke: ${f.color01};
  }
`,oh=h.div`
  margin: auto;
  margin-top: 2rem;
  border-top: 1px solid ${f.color28};

  @media (min-width: 1312px) {
    width: 78rem;
  }

  @media (min-width: 1056px) and (max-width: 1312px) {
    width: 64rem;
  }

  @media (min-width: 320px) and (max-width: 1056px) {
    margin: 0 1rem;
  }
`,ih=h.div`
  margin: auto;

  @media (max-width: 1055px) {
    border-top: 1px solid rgb(0, 0, 0, 0.25);
  }
`,nh=h.div`
  padding: 40px 0 40px 0;
  background-color: ${f.bg14};
  margin: 0;
`,rh=h.div`
  @media (min-width: 1312px) {
    width: 80rem;
  }

  @media (min-width: 1056px) and (max-width: 1312px) {
    width: 66rem;
  }

  @media (min-width: 320px) and (max-width: 1056px) {
    width: 100%;
  }

  margin: auto;
  max-width: 80rem;
  display: flex;
  justify-content: space-between;
`,ah=h.p`
  margin-bottom: 16px;
  padding-top: 16px;
  font-weight: ${f.fontWeight03};
  font-size: ${f.fontSize02};
`,lh=h(yo)`
  border: none;
  text-decoration: none;
  color: ${f.color10};
  display: flex;
  margin-bottom: 8px;
  font-size: ${f.fontSize01};
  font-weight: normal;
  align-items: center;
  text-align: left;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 1rem;
  width: 10rem;

  :hover {
    color: ${f.color20};

    .arrow-icon {
      margin-left: 6px;
      display: block;
      transition: transform 2000ms;
      transform: translateX(0.25rem);
    }
  }

  &:after {
    content: '→';
    opacity: 0;
  }

  &:hover:after {
    opacity: 1;
    transition: transform 500ms;
    transform: translateX(1rem);
  }

  .arrow-icon {
    display: none;
  }
`,dh=h.button`
  border: none;
  text-decoration: none;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0 16px 0 0;

  .hide {
    display: none;
  }

  .no-margin {
    margin: 0px;
  }
`,sh=h.p`
  margin-bottom: 8px;
  font-size: ${f.fontSize07};
  color: ${f.color10};
`,ch=h.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (min-width: 1312px) {
    margin-left: 3rem;
  }

  @media (min-width: 1056px) and (max-width: 1312px) {
    flex-direction: column;
    margin-left: 1rem;
  }

  @media (max-width: 1055px) {
    justify-content: flex-start;
    padding-top: 24px;
  }

  @media (max-width: 671px) {
    flex-direction: column;
  }

  .row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }

  .column {
    display: flex;
    flex-direction: column;
  }

  .column-top {
    display: flex;
    flex-direction: column;

    @media (min-width: 1056px) and (max-width: 1312px) {
      margin-bottom: 1rem;
    }

    @media (max-width: 1055px) {
      margin-right: 3rem;
    }

    @media (max-width: 671px) {
      margin-bottom: 1rem;
    }
  }
`,ph=h.img`
  width: 119px;
`,mh=h.div`
  display: flex;
  background-color: ${f.color03};
  justify-content: center;
  align-items: center;
  align-self: flex-end;
  width: 80px;
  height: 80px;
`,uh=h.img`
  width: 72px;
  height: 72px;
  align-self: center;
`,hh=h.div`
  @media (max-width: 1055px) {
    margin-top: 24px;
  }

  @media (min-width: 1056px) {
    border-left: 1px solid rgb(0, 0, 0, 0.1);
  }
`,gh=h.div`
  background-image: url('${({logo_url:e})=>e}');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  height: 3.5rem;
  width: 7.125rem;
  cursor: pointer;
  @media (min-width: 1056px) {
    margin-right: 1.5625rem;
  }
`,Ah=h.div`
  width: 100%;
  background-color: ${f.bg01};
  margin: 0 0 0 0;
  padding: 20px;
  display: flex;
  justify-content: center;

  @media (max-width: 1055px) {
    justify-content: flex-start;
    flex-direction: column;
  }
`,fh=h.p`
  font-size: ${f.fontSize07};
  color: ${f.color03};
  margin: 0 2rem 0 0;

  @media (max-width: 1055px) {
    text-align: left;
    margin: 0px;
  }
`;var vh;function xh(){return xh=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},xh.apply(null,arguments)}const bh=e=>i.createElement("svg",xh({xmlns:"http://www.w3.org/2000/svg",width:119.664,height:40},e),i.createElement("path",{d:"M110.135 0H9.535Q8.986 0 8.44.002q-.457.004-.919.013A13 13 0 0 0 5.517.19a6.7 6.7 0 0 0-1.9.627 6.4 6.4 0 0 0-1.62 1.18A6.3 6.3 0 0 0 .82 3.617a6.6 6.6 0 0 0-.625 1.903 13 13 0 0 0-.179 2.002c-.01.307-.01.615-.015.921V31.56c.005.31.006.61.015.921a13 13 0 0 0 .18 2.002 6.6 6.6 0 0 0 .624 1.905A6.2 6.2 0 0 0 1.998 38a6.3 6.3 0 0 0 1.618 1.179 6.7 6.7 0 0 0 1.901.63 13.5 13.5 0 0 0 2.004.177c.31.007.613.011.919.011.366.002.728.002 1.095.002h100.6c.36 0 .724 0 1.084-.002.304 0 .617-.004.922-.01a13 13 0 0 0 2-.178 6.8 6.8 0 0 0 1.908-.63A6.3 6.3 0 0 0 117.666 38a6.4 6.4 0 0 0 1.182-1.614 6.6 6.6 0 0 0 .619-1.905 13.5 13.5 0 0 0 .185-2.002c.004-.31.004-.61.004-.921.008-.364.008-.725.008-1.094V9.536q.002-.549-.008-1.092.001-.46-.004-.92a13.5 13.5 0 0 0-.185-2.003 6.6 6.6 0 0 0-.62-1.903 6.47 6.47 0 0 0-2.798-2.8 6.8 6.8 0 0 0-1.908-.627 13 13 0 0 0-2-.176c-.305-.005-.618-.011-.922-.013-.36-.002-.725-.002-1.084-.002Z",style:{fill:"#a6a6a6"}}),vh||(vh=i.createElement("path",{d:"M8.445 39.125c-.305 0-.602-.004-.904-.01a13 13 0 0 1-1.87-.164 5.9 5.9 0 0 1-1.656-.548 5.4 5.4 0 0 1-1.397-1.016 5.3 5.3 0 0 1-1.02-1.397 5.7 5.7 0 0 1-.544-1.657 12.4 12.4 0 0 1-.166-1.875c-.007-.21-.015-.913-.015-.913v-23.1s.009-.692.015-.895a12.4 12.4 0 0 1 .165-1.872 5.8 5.8 0 0 1 .544-1.662 5.4 5.4 0 0 1 1.015-1.398 5.6 5.6 0 0 1 1.402-1.023 5.8 5.8 0 0 1 1.653-.544A12.6 12.6 0 0 1 7.543.887l.902-.012h102.769l.913.013a12.4 12.4 0 0 1 1.858.162 6 6 0 0 1 1.671.548 5.6 5.6 0 0 1 2.415 2.42 5.8 5.8 0 0 1 .535 1.649 13 13 0 0 1 .174 1.887c.003.283.003.588.003.89.008.375.008.732.008 1.092v20.929c0 .363 0 .718-.008 1.075 0 .325 0 .623-.004.93a13 13 0 0 1-.17 1.853 5.7 5.7 0 0 1-.54 1.67 5.5 5.5 0 0 1-1.016 1.386 5.4 5.4 0 0 1-1.4 1.022 5.9 5.9 0 0 1-1.668.55 12.5 12.5 0 0 1-1.869.163c-.293.007-.6.011-.897.011l-1.084.002Z"})),i.createElement("g",{"data-name":"<Group>"},i.createElement("g",{"data-name":"<Group>"},i.createElement("path",{d:"M24.769 20.3a4.95 4.95 0 0 1 2.356-4.151 5.07 5.07 0 0 0-3.99-2.158c-1.68-.176-3.308 1.005-4.164 1.005-.872 0-2.19-.988-3.608-.958a5.32 5.32 0 0 0-4.473 2.728c-1.934 3.348-.491 8.269 1.361 10.976.927 1.325 2.01 2.805 3.428 2.753 1.387-.058 1.905-.885 3.58-.885 1.658 0 2.144.885 3.59.852 1.489-.025 2.426-1.332 3.32-2.67a11 11 0 0 0 1.52-3.092 4.78 4.78 0 0 1-2.92-4.4M22.037 12.21a4.87 4.87 0 0 0 1.115-3.49 4.96 4.96 0 0 0-3.208 1.66A4.64 4.64 0 0 0 18.8 13.74a4.1 4.1 0 0 0 3.237-1.53","data-name":"<Path>",style:{fill:"#fff"}})),i.createElement("path",{d:"M42.302 27.14H37.57l-1.137 3.356h-2.005l4.484-12.418h2.083l4.483 12.418h-2.039Zm-4.243-1.55h3.752l-1.85-5.446h-.051ZM55.16 25.97c0 2.813-1.506 4.62-3.779 4.62a3.07 3.07 0 0 1-2.848-1.583h-.043v4.484H46.63V21.442h1.8v1.506h.033a3.21 3.21 0 0 1 2.883-1.6c2.298 0 3.813 1.816 3.813 4.622m-1.91 0c0-1.833-.948-3.038-2.393-3.038-1.42 0-2.375 1.23-2.375 3.038 0 1.824.955 3.046 2.375 3.046 1.445 0 2.393-1.197 2.393-3.046M65.125 25.97c0 2.813-1.506 4.62-3.779 4.62a3.07 3.07 0 0 1-2.848-1.583h-.043v4.484h-1.859V21.442h1.799v1.506h.034a3.21 3.21 0 0 1 2.883-1.6c2.298 0 3.813 1.816 3.813 4.622m-1.91 0c0-1.833-.948-3.038-2.393-3.038-1.42 0-2.375 1.23-2.375 3.038 0 1.824.955 3.046 2.375 3.046 1.445 0 2.392-1.197 2.392-3.046M71.71 27.036c.138 1.232 1.334 2.04 2.97 2.04 1.566 0 2.693-.808 2.693-1.919 0-.964-.68-1.54-2.29-1.936l-1.609-.388c-2.28-.55-3.339-1.617-3.339-3.348 0-2.142 1.867-3.614 4.519-3.614 2.624 0 4.423 1.472 4.483 3.614h-1.876c-.112-1.239-1.136-1.987-2.634-1.987s-2.521.757-2.521 1.858c0 .878.654 1.395 2.255 1.79l1.368.336c2.548.603 3.606 1.626 3.606 3.443 0 2.323-1.85 3.778-4.793 3.778-2.754 0-4.614-1.42-4.734-3.667ZM83.346 19.3v2.142h1.722v1.472h-1.722v4.991c0 .776.345 1.137 1.102 1.137a6 6 0 0 0 .611-.043v1.463a5 5 0 0 1-1.032.086c-1.833 0-2.548-.689-2.548-2.445v-5.189h-1.316v-1.472h1.316V19.3ZM86.065 25.97c0-2.849 1.678-4.639 4.294-4.639 2.625 0 4.295 1.79 4.295 4.639 0 2.856-1.661 4.638-4.295 4.638s-4.294-1.782-4.294-4.638m6.695 0c0-1.954-.895-3.108-2.401-3.108s-2.4 1.162-2.4 3.108c0 1.962.894 3.106 2.4 3.106s2.401-1.144 2.401-3.106M96.186 21.442h1.773v1.541h.043a2.16 2.16 0 0 1 2.177-1.635 3 3 0 0 1 .637.069v1.738a2.6 2.6 0 0 0-.835-.112 1.873 1.873 0 0 0-1.937 2.083v5.37h-1.858ZM109.384 27.837c-.25 1.643-1.85 2.771-3.898 2.771-2.634 0-4.269-1.764-4.269-4.595 0-2.84 1.644-4.682 4.19-4.682 2.506 0 4.08 1.72 4.08 4.466v.637h-6.394v.112a2.358 2.358 0 0 0 2.436 2.564 2.05 2.05 0 0 0 2.09-1.273Zm-6.282-2.702h4.526a2.177 2.177 0 0 0-2.22-2.298 2.29 2.29 0 0 0-2.306 2.298",style:{fill:"#fff"}})),i.createElement("g",{"data-name":"<Group>"},i.createElement("path",{d:"M35.67 14.698V8.73h2.4c1.12 0 1.794.57 1.794 1.488a1.31 1.31 0 0 1-1.046 1.283v.07a1.41 1.41 0 0 1 1.344 1.434c0 1.05-.765 1.692-2.039 1.692Zm.928-3.44h1.1c.819 0 1.244-.302 1.244-.869 0-.55-.401-.872-1.087-.872h-1.257Zm1.34 2.654c.835 0 1.277-.34 1.277-.972 0-.624-.46-.95-1.331-.95h-1.286v1.922ZM41.114 13.424c0-.81.604-1.278 1.675-1.344l1.22-.07v-.389c0-.475-.315-.744-.922-.744-.496 0-.84.182-.939.5h-.86c.09-.773.818-1.27 1.84-1.27 1.129 0 1.766.563 1.766 1.514v3.077h-.856v-.633h-.07a1.52 1.52 0 0 1-1.353.707 1.36 1.36 0 0 1-1.5-1.348m2.895-.384v-.377l-1.1.07c-.62.042-.901.253-.901.65 0 .405.351.64.835.64a1.06 1.06 0 0 0 1.166-.983M46.169 8.863a.576.576 0 1 1 .575.542.547.547 0 0 1-.575-.542m.132 1.332h.886v4.503H46.3ZM50.236 13.102l-.984 1.596h-.976l1.494-2.241-1.506-2.262h1.038l.968 1.588h.07l.959-1.588h.988l-1.484 2.224 1.5 2.279h-1.02l-.98-1.596ZM53.088 13.424c0-.81.603-1.278 1.675-1.344l1.22-.07v-.389c0-.475-.315-.744-.922-.744-.497 0-.84.182-.939.5h-.86c.09-.773.818-1.27 1.84-1.27 1.128 0 1.765.563 1.765 1.514v3.077h-.855v-.633h-.07a1.52 1.52 0 0 1-1.353.707 1.36 1.36 0 0 1-1.501-1.348m2.894-.384v-.377l-1.1.07c-.62.042-.9.253-.9.65 0 .405.351.64.834.64a1.06 1.06 0 0 0 1.166-.983M58.259 10.195h.855v.69h.067a1.22 1.22 0 0 1 1.216-.765 2 2 0 0 1 .396.037v.877a2.4 2.4 0 0 0-.496-.053 1.055 1.055 0 0 0-1.15 1.058v2.659h-.888ZM64.218 10.195h.856v.715h.066a1.35 1.35 0 0 1 1.344-.802 1.465 1.465 0 0 1 1.559 1.675v2.915h-.89v-2.692c0-.724-.314-1.084-.97-1.084a1.033 1.033 0 0 0-1.076 1.141v2.635h-.89ZM69.16 13.424c0-.81.604-1.278 1.675-1.344l1.22-.07v-.389c0-.475-.314-.744-.922-.744-.496 0-.84.182-.938.5h-.86c.09-.773.818-1.27 1.84-1.27 1.128 0 1.765.563 1.765 1.514v3.077h-.856v-.633h-.07a1.52 1.52 0 0 1-1.352.707 1.36 1.36 0 0 1-1.501-1.348m2.895-.384v-.377l-1.1.07c-.62.042-.9.253-.9.65 0 .405.35.64.834.64a1.06 1.06 0 0 0 1.166-.983",style:{fill:"#fff"}})));var wh,yh;function Ch(){return Ch=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},Ch.apply(null,arguments)}const Eh=e=>i.createElement("svg",Ch({xmlns:"http://www.w3.org/2000/svg",width:24.004,height:24},e),wh||(wh=i.createElement("defs",null,i.createElement("clipPath",{id:"icone_linkedin_svg__a"},i.createElement("path",{d:"M0 0h24.004v24H0z","data-name":"Ret\\xE2ngulo 113423"})))),yh||(yh=i.createElement("g",{"data-name":"Grupo 146063"},i.createElement("g",{clipPath:"url(#icone_linkedin_svg__a)","data-name":"Grupo 146038"},i.createElement("path",{fill:"#6d6e71",d:"M0 11.684v-.457c.052-.408.042-.821.082-1.229a9.2 9.2 0 0 1 .637-2.414A12.1 12.1 0 0 1 9.5.152a12 12 0 0 1 1.481-.127c.082-.006.169.026.246-.025h.407a1.5 1.5 0 0 0 .609 0h.457c.425.05.855.042 1.281.084a9 9 0 0 1 2.433.645 12.2 12.2 0 0 1 6.966 7.2 10.4 10.4 0 0 1 .608 3.272 17 17 0 0 1-.088 2.77 11.2 11.2 0 0 1-1.662 4.436 11.7 11.7 0 0 1-1.619 2.047 12.1 12.1 0 0 1-3.661 2.558 10.2 10.2 0 0 1-3.031.9 20.5 20.5 0 0 1-3.146.059 10.5 10.5 0 0 1-4.249-1.191 11.6 11.6 0 0 1-2.665-1.84 12.1 12.1 0 0 1-3.611-5.973 10.2 10.2 0 0 1-.231-2.02C.019 12.865.05 12.778 0 12.7v-.406a1.5 1.5 0 0 0 0-.61","data-name":"Caminho 713387"}),i.createElement("path",{fill:"#89b2da",d:"M0 11.684a.83.83 0 0 1 0 .61Z","data-name":"Caminho 713388"}),i.createElement("path",{fill:"#8ab3da",d:"M12.243 0a.82.82 0 0 1-.61 0Z","data-name":"Caminho 713389"}),i.createElement("path",{fill:"#f7f7f7",d:"m17.115 9.137.2.055a.65.65 0 0 1 .445.163l.471.291a.78.78 0 0 1 .411.411 5 5 0 0 1 .456.866 2.7 2.7 0 0 1 .22.773 1 1 0 0 0 .025.21c-.012.181.064.354.054.535v5.6a3 3 0 0 0 .008.329c.021.08-.026.122-.086.157-.667.046-1.335.013-2 .017a3 3 0 0 1-.757-.028c-.078-.052-.059-.131-.059-.206v-3.605c0-.6-.01-1.2-.048-1.8l-.012-.1a2 2 0 0 1-.145-.507c.008-.03-.007-.046-.035-.054a.25.25 0 0 1-.07-.2.44.44 0 0 0-.146-.211c-.095-.033-.143-.119-.208-.185a.93.93 0 0 0-.61-.259 5 5 0 0 1-.641.021 2.1 2.1 0 0 0-.815.329.97.97 0 0 0-.424.752 4 4 0 0 0-.122.481 1 1 0 0 1-.013.2 2.4 2.4 0 0 0-.015.4v4.6a.56.56 0 0 1-.04.321.38.38 0 0 1-.243.044h-2.245c-.09 0-.188.019-.262-.059 0-.219-.009-.439-.009-.658V9.33c0-.11.006-.219.009-.329.069-.074.159-.037.238-.037h2.22c.148-.012.211.054.208.2q-.008.375 0 .749c0 .052-.058.179.1.132.13-.151.223-.34.433-.406l.469-.293a.64.64 0 0 1 .446-.164l.155-.052a2.1 2.1 0 0 1 .605-.144 1.5 1.5 0 0 0 .376-.024h.424a2 2 0 0 0 .421.024 2 2 0 0 1 .61.144","data-name":"Caminho 713390"}),i.createElement("path",{fill:"#f7f7f7",d:"M8.527 6.084a1.93 1.93 0 0 1-.653 1.183c-.038.052-.078.1-.153.1l-.305.156a1.29 1.29 0 0 1-1.117 0l-.511-.3c-.122-.005-.165-.108-.233-.183-.023-.086-.144-.12-.123-.23l-.154-.306a1.3 1.3 0 0 1 .017-1.146 1.87 1.87 0 0 1 1.008-.984 1.36 1.36 0 0 1 1.315.1 1.77 1.77 0 0 1 .907 1.337.28.28 0 0 1 0 .28","data-name":"Caminho 713391"}),i.createElement("path",{fill:"#4982be",d:"M16.463 12.902a3 3 0 0 1 .073.879c.005 1.477 0 2.955 0 4.432a.6.6 0 0 0 .024.274.03.03 0 0 1 .02.041l-.017.018c-.132-.1-.106-.239-.106-.371v-4.729c0-.181-.1-.363 0-.544","data-name":"Caminho 713392"}),i.createElement("path",{fill:"#528cc6",d:"M13.152 18.479q0-2.32.005-4.639c0-.11.006-.219.009-.329.035-.065 0-.139.029-.2a.05.05 0 0 1 .062 0v4.916c0 .118.011.24-.1.321l-.019-.018a.05.05 0 0 1 .017-.046","data-name":"Caminho 713393"}),i.createElement("path",{fill:"#4a82c0",d:"M5.238 18.546a.32.32 0 0 1-.107-.3V9.232a.38.38 0 0 1 .056-.233l.039.031a.46.46 0 0 1 .075.314c0 3.026.01 6.052 0 9.077a.3.3 0 0 1-.028.095l-.034.036","data-name":"Caminho 713394"}),i.createElement("path",{fill:"#4274ba",d:"M8.582 9.044v9.2a.32.32 0 0 1-.105.3l-.034-.036a.3.3 0 0 1-.029-.095c-.015-1.278 0-2.556-.006-3.834V9.526a.7.7 0 0 1 .077-.465.09.09 0 0 1 .092-.019","data-name":"Caminho 713395"}),i.createElement("path",{fill:"#4880bf",d:"M10.31 9.095c.1 0 .046.082.046.118q.005 4.528 0 9.057a1 1 0 0 1-.011.125s-.013.009-.018.008-.013-.01-.019-.015a.4.4 0 0 1-.023-.223V9.32a.4.4 0 0 1 .023-.224","data-name":"Caminho 713396"}),i.createElement("path",{fill:"#5e98cb",d:"M10.31 9.095v9.292a.57.57 0 0 1-.049-.321v-8.65a.57.57 0 0 1 .049-.321","data-name":"Caminho 713397"}),i.createElement("path",{fill:"#4a82c0",d:"m19.353 18.487.048-.085a.3.3 0 0 1-.02-.149v-5.72q.015-.06.071-.036v5.7c0 .126.018.258-.106.346l-.017-.018a.03.03 0 0 1 .02-.041","data-name":"Caminho 713398"}),i.createElement("path",{fill:"#467cbf",d:"M8.586 9.044h-.05a.63.63 0 0 1-.367.07H5.588c-.141 0-.291.015-.4-.115a.4.4 0 0 1 .267-.053H8.26c.117 0 .24-.016.32.1","data-name":"Caminho 713399"}),i.createElement("path",{fill:"#5f99cc",d:"M8.481 18.545a.5.5 0 0 1-.27.048H5.508a.5.5 0 0 1-.27-.047l-.005-.007a.36.36 0 0 1 .285-.073h2.681a.4.4 0 0 1 .287.067Z","data-name":"Caminho 713400"}),i.createElement("path",{fill:"#5f99cc",d:"M19.35 18.546a.44.44 0 0 1-.244.047h-2.3a.43.43 0 0 1-.244-.047v-.008c.536-.047 1.074-.017 1.612-.018a9 9 0 0 1 1.183.019Z","data-name":"Caminho 713401"}),i.createElement("path",{fill:"#5f99cc",d:"M13.155 18.544a.43.43 0 0 1-.244.049h-2.253a.43.43 0 0 1-.244-.05.8.8 0 0 1 .348-.024h2.146a.56.56 0 0 1 .248.02Z","data-name":"Caminho 713402"}),i.createElement("path",{fill:"#4071b8",d:"M13.156 18.536h-2.742v-.06h2.735v.059","data-name":"Caminho 713403"}),i.createElement("path",{fill:"#467cbf",d:"m12.954 8.993-2.537.012a.4.4 0 0 1 .288-.065h2.249q.027.016.018.033c-.009.017-.012.017-.018.017","data-name":"Caminho 713404"}),i.createElement("path",{fill:"#558dc6",d:"M7.62 4.466a1.93 1.93 0 0 0-1.315-.1c-.04-.022-.046-.056 0-.07a1.77 1.77 0 0 1 1.214.031.18.18 0 0 1 .1.135","data-name":"Caminho 713405"}),i.createElement("path",{fill:"#538bc5",d:"m15.292 9.035-.61.1a1.06 1.06 0 0 1 .738-.189c.361-.027.727-.007 1.09-.007a.045.045 0 0 1-.025.071 1.4 1.4 0 0 1-.41-.017 1 1 0 0 1-.4 0c-.124.049-.259-.005-.383.039","data-name":"Caminho 713406"}),i.createElement("path",{fill:"#5990c8",d:"M6.299 7.52a2.15 2.15 0 0 0 1.117 0 .21.21 0 0 1-.175.126 2.5 2.5 0 0 1-.769 0 .2.2 0 0 1-.173-.127","data-name":"Caminho 713407"}),i.createElement("path",{fill:"#558cc6",d:"M5.297 5.356a2.06 2.06 0 0 0-.017 1.146 1.05 1.05 0 0 1 .017-1.146","data-name":"Caminho 713408"}),i.createElement("path",{fill:"#467cbe",d:"M12.954 8.994v-.05c.137.033.152.139.152.254v.628c0 .076-.034.177.091.2l.005.021-.108.2h-.052V9.26c0-.093.046-.21-.089-.26","data-name":"Caminho 713409"}),i.createElement("path",{fill:"#568dc6",d:"M13.782 11.737a1.13 1.13 0 0 1 .751-.348.06.06 0 0 1 .048.043l-.8.3","data-name":"Caminho 713410"}),i.createElement("path",{fill:"#578ec7",d:"m19.295 11.7-.188-.777c.226.169.156.448.246.667-.037.028 0 .091-.058.111","data-name":"Caminho 713411"}),i.createElement("path",{fill:"#5288c4",d:"M19.455 12.498h-.046c-.042-.022-.019-.073-.046-.1 0-.172-.1-.335-.05-.511a.07.07 0 0 1 .044-.049 2.8 2.8 0 0 1 .1.662","data-name":"Caminho 713412"}),i.createElement("path",{fill:"#558dc6",d:"M16.51 8.992v-.05c.2.081.447 0 .609.195l-.608-.1q-.054-.021 0-.044","data-name":"Caminho 713413"}),i.createElement("path",{fill:"#4c84c2",d:"m18.651 10.055-.411-.411a.47.47 0 0 1 .411.411","data-name":"Caminho 713414"}),i.createElement("path",{fill:"#548cc6",d:"M16.306 12.294a.97.97 0 0 1 .145.507.55.55 0 0 1-.145-.507","data-name":"Caminho 713415"}),i.createElement("path",{fill:"#5088c4",d:"m13.204 10.053-.005-.021c.085-.184.176-.362.414-.381l-.408.4","data-name":"Caminho 713416"}),i.createElement("path",{fill:"#558bc5",d:"m17.766 9.354-.445-.163a.35.35 0 0 1 .445.163","data-name":"Caminho 713417"}),i.createElement("path",{fill:"#5189c4",d:"m14.527 9.189-.446.164a.357.357 0 0 1 .446-.164","data-name":"Caminho 713418"}),i.createElement("path",{fill:"#4071b9",d:"m14.58 11.436-.047-.043a2.6 2.6 0 0 1 .7 0 2.3 2.3 0 0 1-.658.045","data-name":"Caminho 713419"}),i.createElement("path",{fill:"#4d86c3",d:"M13.217 12.96a.65.65 0 0 1 .141-.466 1.1 1.1 0 0 1-.1.465q-.019.056-.041 0","data-name":"Caminho 713420"}),i.createElement("path",{fill:"#4173ba",d:"M8.527 6.084v-.28c.121.087.046.2.038.3l-.02-.005-.017-.017","data-name":"Caminho 713421"}),i.createElement("path",{fill:"#4b83c1",d:"m5.58 7.012.21.208c-.147.046-.181-.085-.251-.16-.028-.052 0-.055.042-.049","data-name":"Caminho 713422"}),i.createElement("path",{fill:"#5088c4",d:"M15.848 11.641a.42.42 0 0 1 .208.185c-.141.019-.165-.094-.208-.185","data-name":"Caminho 713423"}),i.createElement("path",{fill:"#5288c4",d:"m5.582 7.013-.042.049c-.053-.077-.161-.131-.1-.253l.145.2","data-name":"Caminho 713424"}),i.createElement("path",{fill:"#4071b9",d:"M13.217 12.955h.041v.353l-.039-.007c-.055-.046-.037-.1-.015-.152l.014-.193","data-name":"Caminho 713425"}),i.createElement("path",{fill:"#4478bc",d:"m19.357 11.836-.044.049-.018-.185.057-.111v.247","data-name":"Caminho 713426"}),i.createElement("path",{fill:"#5a8fc7",d:"m7.722 7.366.153-.1c-.024.074-.045.153-.153.1","data-name":"Caminho 713427"}),i.createElement("path",{fill:"#487ec0",d:"M16.202 12.041a.27.27 0 0 1 .07.2c-.064-.052-.121-.106-.07-.2","data-name":"Caminho 713428"}),i.createElement("path",{fill:"#5b95cb",d:"m19.363 12.396.046.1v5.524c0 .127-.008.253-.012.379a1 1 0 0 1-.022-.123q-.009-2.941-.016-5.883","data-name":"Caminho 713429"}),i.createElement("path",{fill:"#4071b8",d:"M19.355 18.539h-2.794v-.05h2.79v.052","data-name":"Caminho 713430"}),i.createElement("path",{fill:"#5b95cb",d:"M16.511 8.992v.044a1.2 1.2 0 0 1-.435-.041h.435","data-name":"Caminho 713431"}),i.createElement("path",{fill:"#5b95cb",d:"m13.203 13.148.015.152-.052.211a.7.7 0 0 1 .036-.363","data-name":"Caminho 713432"}),i.createElement("path",{fill:"#5b95cb",d:"M15.292 9.035a.75.75 0 0 1 .383-.039.9.9 0 0 1-.383.039","data-name":"Caminho 713433"}),i.createElement("path",{fill:"#f7f7f7",d:"m5.186 8.998 3.046.012a.55.55 0 0 1 .3.033c0 .186-.009.371-.009.557v8.6c0 .1.032.2-.038.294a.17.17 0 0 1-.1.026H5.329a.15.15 0 0 1-.094-.029c-.069-.091-.037-.2-.037-.294V9.381q.002-.19-.007-.38","data-name":"Caminho 713434"}),i.createElement("path",{fill:"#4071b8",d:"M5.234 18.488h3.249v.044l-3.253.005v-.051","data-name":"Caminho 713435"}))))),Bh=()=>{var i,l,d,s,c;const[p,m]=r(),u=qt(),h=xt(),g=bt(),A=Boolean((null==u?void 0:u.token)&&"GUEST"!==(null==u?void 0:u.type)),{data:f,loading:v}=h.getFooter(),{data:x}=g.getHeader();a((()=>{const t=e=>{var t,o;if((null==e?void 0:e.length)>1){return(null===(t=null==e?void 0:e.charAt(0))||void 0===t?void 0:t.toUpperCase())+(null===(o=null==e?void 0:e.slice(1))||void 0===o?void 0:o.toLowerCase())}return e};if(!v&&f){const o={instagram:e(he,{color:"#6D6E71"}),facebook:e(ue,{color:"#6D6E71"}),linkedin:e(Eh,{color:"#6D6E71"}),youtube:e(me,{color:"#6D6E71"})},i=Object.entries((null==f?void 0:f.footer)||{}).filter((([e,t])=>(null==e?void 0:e.startsWith("link_"))&&""!==t&&void 0!==o[null==e?void 0:e.replace("link_","")])).map((([e,i])=>({label:t(null==e?void 0:e.replace("link_","")),icon:o[null==e?void 0:e.replace("link_","")],path:i})));m(i)}}),[v,f]);const b=[{title:"Sobre nós",values:[{label:"Página inicial",path:""+(A?"/dashboard/DashboardPage":"/"),alt:"Página inicial"},{label:"Quem somos",path:"/sobre",title:"Quem somos"},{label:"Privacidade",path:"/aviso-de-privacidade",title:"Privacidade"},{label:"Área do assessor",path:"/authenticator/login?canal=parceiros",title:"Área do assessor"}]},{title:"Crédito",values:[{label:"Linhas de crédito",path:""+(A?"/simulationLogged/AvailableProducts":"/simulacao-de-credito"),title:"Linhas de crédito"},{label:"Simular CPR Digital",path:"/simulacao-de-cpr",title:"Simular CPR Digital"},{label:"Simular Crédito Rural",path:"/simulacao-credito-rural",title:"Simular Crédito Rural",state:{finantialInstitution:"237",creditModality:"1019"}}]},{title:"Produtos",values:[{label:"Ir para a loja",path:"/loja",title:"Ir para a loja"},{label:"Meu carrinho",path:"/checkout/checkout-page",title:"Meu carrinho"},{label:"Seja parceiro",path:"/seja-parceiro",title:"Seja parceiro"}]}];return t(o,{children:[!(null===window||void 0===window?void 0:window.isWebView)&&e(oh,{}),e(so,{as:nh,fullWidth:!0,children:t(co,{as:rh,children:[e(po,{sm:4,md:8,lg:2,xlg:2,children:e(gh,{logo_url:null===(l=null===(i=null==x?void 0:x.onboard)||void 0===i?void 0:i.logo)||void 0===l?void 0:l.logo_e_agro_url,"aria-label":null===(s=null===(d=null==x?void 0:x.onboard)||void 0===d?void 0:d.logo)||void 0===s?void 0:s.logo_e_agro_url_alt})}),e(po,{sm:4,md:8,lg:6,xlg:5,children:e(co,{children:b.map(((o,i)=>e(n.Fragment,{children:t(po,{sm:4,md:2,lg:4,xlg:4,children:[e(ah,{children:o.title},o.title),o.values.map((t=>e(lh,{to:(null==t?void 0:t.state)?{pathname:t.path,state:t.state}:t.path,onClick:e=>{Je.overrideFirebaseScreenClass("footer"),Je.interact(Ye.Click,Je.getActionLocation(),`${t.label}`,"footer",Je.getUserStatus(u),"e-agro/footer",null,{userId:Je.getUserId(u)}),"/loja"===t.path&&(e.preventDefault(),window.location.href="/loja")},children:t.label},t.label)))]},o.title)},i)))})}),t(po,{as:hh,sm:4,md:8,lg:3,xlg:5,fullWidth:!0,children:[e(ih,{}),t(ch,{children:[t("div",{className:"column-top",children:[e(sh,{children:"Siga o E-agro"}),e("div",{className:"row",children:null==p?void 0:p.map((t=>{var o;return e(dh,{"aria-label":t.label,className:(null==t?void 0:t.path)&&(null===(o=null==t?void 0:t.path)||void 0===o?void 0:o.length)>0?"":"hide",onClick:()=>{Je.interact(Ye.Click,Je.getActionLocation(),`${t.label}`,"redes-sociais",Je.getUserStatus(u),"e-agro/footer",null,{userId:Je.getUserId(u)}),window.open(null==t?void 0:t.path)},children:t.icon},t.label)}))})]}),t("div",{className:"column",children:[e(sh,{children:"Baixe o app"}),t("div",{className:"row",children:[t("div",{className:"column",children:[e(dh,{"aria-label":"Google Play",className:"no-margin",onClick:()=>{var e;Je.interact(Ye.Click,Je.getActionLocation(),"Disponivel no google play","baixar-app",Je.getUserStatus(u),"e-agro/footer",null,{userId:Je.getUserId(u)}),window.open(null===(e=null==f?void 0:f.footer)||void 0===e?void 0:e.link_loja_google)},children:e(ph,{src:"data:image/png;base64,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",alt:"Google Play"})}),e(dh,{"aria-label":"App Store",className:"no-margin",onClick:()=>{var e;Je.interact(Ye.Click,Je.getActionLocation(),"Disponivel na AppStore","baixar-app",Je.getUserStatus(u),"e-agro/footer",null,{userId:Je.getUserId(u)}),window.open(null===(e=null==f?void 0:f.footer)||void 0===e?void 0:e.link_loja_apple)},children:e(bh,{})})]}),e(mh,{children:e(uh,{src:null===(c=null==f?void 0:f.footer)||void 0===c?void 0:c.link_qr_code,alt:"Qr Code"})})]})]})]})]})]})}),t(Ah,{children:[e(fh,{children:"© 2022 e-agro - Soluções em Comércio Eletrônico S.A."}),e(fh,{children:"CNPJ: 15.010.931/0001-48"}),e(fh,{children:"Cidade de Deus, s/nº Vila Yara Osasco | SP | CEP: 06029-900."})]})]})},kh=h.div``,Ih=A`
html {
  overflow: hidden;
}
`,Nh=h.div`
  background-color: ${f.color03};
  height: 4.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`,Sh=h.div`
  @media (min-width: 1312px) {
    width: 78rem;
  }

  @media (min-width: 1056px) and (max-width: 1312px) {
    width: 64rem;
  }

  @media (min-width: 320px) and (max-width: 1056px) {
    width: 100%;
    padding: 0 1rem;
  }

  display: flex;
  justify-content: space-between;
  align-items: center;

  & > svg {
    cursor: pointer;
    width: 1.3125rem;
    height: 1.3125rem;
  }

  .smaller-icon {
    width: 1.75rem;
    height: 1.75rem;
  }

  .left-icon {
    margin-right: 2rem;

    @media (max-width: 1056px) {
      margin-right: 1rem;
    }
  }

  .chevronDown-up {
    transform: rotate(-0.5turn);
  }
`,Oh=h.div`
  svg.categorias {
    display: none;
  }

  svg.chevronDown,
  svg.chevronDown-up {
    margin-left: 0.25rem;
    color: ${f.color01};
  }

  p.categorias {
    color: ${f.color04};
    font-size: ${f.fontSize01};
  }

  #separator {
    border: none !important;
    border-bottom: 2px solid #008aeb !important;
    top: 0 !important;
  }

  margin: 0 1.25rem;

  @media (min-width: 1312px) {
    .chevronDown,
    .chevronDown-up {
      width: 22px;
      height: 22px;
    }

    p.categorias {
      font-size: ${f.fontSize02};
    }
  }
`,Ph=h.div`
  display: flex;
  align-items: center;

  & > a.link-header,
  & > p {
    color: ${f.color04};
    font-size: ${f.fontSize01};
    margin: 0 1.25rem;
    height: fit-content;
  }

  & > a:hover,
  & > p:hover,
  & > a.active-route {
    border-bottom: 2px solid ${f.color20};
    padding-bottom: 0.25rem;
    margin-top: 0.25rem;
  }

  #categs {
    height: 3.5rem;
  }

  #separator {
    border: none !important;
    border-bottom: 2px solid #008aeb !important;
    top: 0 !important;
  }

  @media (min-width: 1312px) {
    & > a.link-header {
      font-size: ${f.fontSize02};
    }
  }
`,Qh=h.div`
  .btn-signin {
    margin-right: 1rem;
  }

  display: flex;
  align-items: center;
  position: relative;

  @media (max-width: 1056px) {
    display: none;
    color: blue;
  }

  & > svg {
    cursor: pointer;
  }
`,zh=h.div`
  background-color: ${f.bg14};
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;

  .searchIcon {
    width: 2.5rem;
  }

  @media (max-width: 1056px) {
    height: 6rem;
  }

  @media (min-width: 1312px) {
    .icon-region-container > p {
      font-size: ${f.fontSize02} !important;
    }
  }
`;h.div``;const Mh=h(qr)`
  @media (min-width: 1056px) and (max-width: 1312px) {
    width: 7.125rem;
  }

  width: 8.875rem;
  height: 2rem;
`,Dh=h.div`
  height: 9rem;
  width: 9.5rem;
  background: white;
  position: absolute;
  box-shadow:
    0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  top: 3rem;
  right: -1rem;
  z-index: 1;
  padding: 1rem;
  border-radius: 4px;

  &:before {
    content: '';
    display: block;
    position: absolute;
    right: 1rem;
    top: -15px;
    border-bottom: 15px solid #fff;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
  }

  @media (max-width: 1056px) {
    top: 4rem;
    right: 0rem;
  }
`,jh=h.div`
  & > p {
    font-weight: 600;
  }

  padding-bottom: 0.5rem;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.3);
`,Th=h.div`
  margin: 1rem 0;
  cursor: pointer;
  display: flex;
  align-items: center;

  & > svg {
    margin-right: 0.25rem;
  }
`,Rh=h.div`
  background-image: url('${({logo_url:e})=>e}');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  height: 3.5rem;
  width: 7.125rem;
  cursor: pointer;
  @media (min-width: 1056px) {
    margin-right: 1.5625rem;
  }
`,Lh=h.img`
  height: 3.5rem;
  width: 7.125rem;
  object-fit: contain;
`,Uh=h.img`
  height: 3.5rem;
  width: 7.125rem;
  object-fit: contain;
  margin-left: 2.6rem;
`,qh="/loja",Wh=h.img`
  width: 208px;
  height: 400px;
`,Gh=h.div`
  width: 220px;
  max-height: 100%;
  display: flex;

  flex-direction: column;
`;h.p`
  text-align: left;
  font: normal normal 600 16px/24px Bradesco Sans;
  letter-spacing: 0px;
  color: ${f.color04};
  max-width: 200px;
  margin-right: 14px !important;
  width: fit-content;

  a {
    color: ${f.color04};
  }
`;const Hh=h.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: inline-block;
`,Fh=h.div`
  display: flex;
  align-items: center;
`,Vh=h.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
  top: 1.7px;

  .chevronDown-up {
    transform: rotate(-0.5turn);
  }

  #separator {
    border: 1px solid ${f.bg01};
    position: relative;
    top: 9px;
    width: 100%;
    height: 2px;
  }

  #separator-hidden {
    border: 1px solid transparent;
    position: relative;
    top: 9px;
    width: 100%;
    height: 2px;
  }
`,Kh=h.div``,Jh=h.div`
  ${e=>e.show?"display:block;":"display:none;"}

  position: absolute;
  top: 55.5px;
  width: 500vw;
  height: 500vw;
  z-index: 998;

  .overlay {
    background: rgba(0, 0, 0, 0.5) no-repeat padding-box;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 997;
  }

  @media (min-width: 1313px) {
    left: -1250px;
  }

  @media (min-width: 1056px) {
    left: -1250px;
  }
`,Yh=h.li`
  font: normal normal normal 14px/17px Bradesco Sans;
  letter-spacing: 0.16px;
  color: ${f.color04};
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  margin-bottom: 8px;
  width: fit-content;

  .link {
    font: normal normal normal 14px/17px Bradesco Sans;
    letter-spacing: 0.16px;
    color: ${f.color04};
    cursor: pointer;
    display: inline;
    box-sizing: border-box;
    word-wrap: break-word;
    width: fit-content;
    word-wrap: break-word;
    white-space: normal;
  }

  .link-title {
    font: normal normal normal 14px/17px Bradesco Sans;
    letter-spacing: 0.16px;
    color: ${f.color04};
    cursor: pointer;
  }
`,Zh=h.div`
  z-index: 998;
  color: black;
  width: 100%;
  height: 100%;

  .content {
    cursor: default;
    width: 770px;
    height: 452px;
    z-index: 1009;
    display: none;

    background-color: ${f.bg14};
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0px;
    left: 1000px;

    @media (max-width: 1076px) and (max-width: 1170px) {
      top: 0px;
      left: 1450px;
    }

    @media (max-width: 1076px) {
      top: 0px;
      left: 915px;
    }

    opacity: 1;
    border-radius: 0px 0px 8px 8px;

    .separator {
      background-color: ${f.bg15};
      height: 400px;
      width: 1px;
      margin: 0px 32px 0 0px;
    }

    .text-container {
      width: 457px;
      height: 400px;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      position: relative;

      .title-grid {
        display: inline-flex;
        width: fit-content;
        flex-direction: column;
        text-align: left;
        margin-right: 15px;
        margin-bottom: 15px;

        .arrow-hidden {
          opacity: 0;
        }
      }

      ul {
        text-align: left;
        width: 100%;

        display: inline-flex;
        flex-direction: column;

        .first {
          margin-top: 5px;
        }

        .normal-li {
          margin-top: 5px;
          width: 70%;
        }
      }
      #long-text {
        align-items: center;
      }

      .not-hovered {
        color: ${f.color20} !important;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;

        img {
          opacity: 0;
          max-width: 12px;
          max-height: 9px;
          margin-left: 9px;
          margin-top: 3px;
        }
      }

      #long-text-hovered {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;

        img {
          max-width: 12px;
          max-height: 9px;
          margin-left: 9px;
          margin-top: auto;
          margin-bottom: auto;
          margin-right: 0px;
        }
      }

      .hovered {
        color: ${f.color20} !important;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;

        img {
          max-width: 12px;
          max-height: 9px;
          margin-left: 9px;
          margin-top: 3px;
        }
      }
    }

    .low-size-container-to-txts {
      width: 100%;
      height: 408px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }

    .text-container-low-size {
      width: 100%;
      max-height: 400px;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      align-items: flex-start;
      position: relative;
      top: 15px;
      justify-content: flex-start;
      margin-left: 32px;
      margin-right: -32px;
      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 4px;
        background-color: transparent;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-track {
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.2);
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: rgba(136, 136, 136);
      }

      &::-webkit-scrollbar-thumb:hover {
        border-radius: 4px;
        background-color: rgba(161, 161, 161);
      }

      .title-grid {
        display: inline-flex;
        width: 232px;
        flex-direction: column;
        text-align: left;
        margin-bottom: 1rem;

        .arrow-hidden {
          opacity: 0;
        }
      }

      ul {
        text-align: left;
        width: fit-content;

        margin-bottom: 4px;
        display: inline-flex;
        flex-direction: column;

        .first {
          margin-top: 5px;
        }

        #long-text {
          width: 70%;
          align-items: center;
        }
      }

      .not-hovered {
        color: ${f.color20} !important;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: first baseline;

        img {
          opacity: 0;
          max-width: 12px;
          max-height: 9px;
          margin-left: 9px;
          margin-top: 3px;
        }
      }

      .hovered {
        color: ${f.color20} !important;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;

        align-items: first baseline;

        img {
          max-width: 12px;
          max-height: 9px;
          margin-left: 9px;
          margin-top: 1px;
          margin-right: 5px;
        }
      }

      #long-text-hovered {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;

        img {
          max-width: 12px;
          max-height: 9px;
          margin-left: 9px;
          margin-top: auto;
          margin-bottom: auto;
          margin-right: 0px;
        }
      }
    }
  }

  .title-menu-categories {
    text-align: left;
    font: normal normal 600 16px/24px Bradesco Sans;
    letter-spacing: 0px;
    color: ${f.color04};
    max-width: 200px;
    margin-right: 14px !important;
    width: fit-content;

    a {
      color: ${f.color04};
    }
  }
`,Xh=h.div`
  z-index: 998;
  color: black;
  width: 100%;
  height: 100%;

  .content-three-columns {
    cursor: default;
    width: 972px;
    height: 452px;
    z-index: 1009;
    display: none;
    background-color: ${f.bg14};
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0px;
    left: 1000px;

    @media (max-width: 1170px) {
      top: 0px;
      left: 1450px;
    }

    @media (max-width: 1057px) {
      top: 0px;
      left: 780px;
    }

    @media (min-width: 1057px) and (max-width: 1137px) {
      top: 0px;
      left: 800px;
    }

    @media (min-width: 1137px) and (max-width: 1200px) {
      top: 0px;
      left: 850px;
    }

    @media (min-width: 1200px) and (max-width: 1300px) {
      top: 0px;
      left: 900px;
    }

    @media (min-width: 1300px) and (max-width: 1400px) {
      top: 0px;
      left: 970px;
    }

    opacity: 1;
    border-radius: 0px 0px 8px 8px;

    .separator {
      background-color: ${f.bg15};
      height: 400px;
      width: 1px;
      margin: 0 32px 0 25px;
    }

    .banner {
      width: 208px;
      height: 400px;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }

    .text-container {
      min-width: 660px;
      height: 408px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      position: relative;
      top: 10px;
      overflow-y: auto;
      overflow-x: hidden;

      &::-webkit-scrollbar {
        width: 4px;
        background-color: transparent;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-track {
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.2);
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: rgba(136, 136, 136);
      }

      &::-webkit-scrollbar-thumb:hover {
        border-radius: 4px;
        background-color: rgba(161, 161, 161);
      }

      .title-grid {
        display: inline-flex;
        width: 232px;
        flex-direction: column;
        text-align: left;

        .arrow-hidden {
          opacity: 0;
        }
      }

      ul {
        text-align: left;
        width: fit-content;

        margin-bottom: 4px;
        display: inline-flex;
        flex-direction: column;

        .first {
          margin-top: 5px;
        }

        #long-text {
          align-items: center;
        }
      }
      .not-hovered {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: first baseline;

        img {
          opacity: 0;
          max-width: 12px;
          max-height: 9px;
          margin-left: 9px;
          margin-right: 5px;
          margin-top: 1px;
        }
      }

      #long-text-hovered {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;

        img {
          max-width: 12px;
          max-height: 9px;
          margin-left: 9px;
          margin-top: auto;
          margin-bottom: auto;
          margin-right: 0px;
        }
      }

      .hovered {
        color: ${f.color20} !important;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;

        align-items: first baseline;

        img {
          max-width: 12px;
          max-height: 9px;
          margin-left: 9px;
          margin-top: 1px;
          margin-right: 5px;
        }
      }
    }
  }

  .title-menu-categories {
    text-align: left;
    font: normal normal 600 16px/24px Bradesco Sans;
    letter-spacing: 0px;
    color: ${f.color04};
    max-width: 200px;
    margin-right: 14px !important;
    width: fit-content;

    a {
      color: ${f.color04};
    }
  }
`,_h=h(Xl)`
  font: normal normal normal 14px/17px Bradesco Sans;
  letter-spacing: 0.16px;
  color: ${f.color04};
  cursor: pointer;
  display: inline;
  box-sizing: border-box;
  word-wrap: break-word;
  width: fit-content;
  word-wrap: break-word;
  white-space: normal;

  :hover {
    color: ${f.color20} !important;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }

  &:after {
    content: '→';
    opacity: 0;
  }

  &:hover:after {
    opacity: 1;
    transition: transform 500ms;
    transform: translateX(0.5rem);
  }
`,$h=h.ul`
  margin-bottom: 1rem !important;
`,eg=({categoriesData:i,closeRegionOnCategoriesHover:n,showRegionModal:l,isFromHome:d})=>{var s,c,p,m,u,h,g,A,f,v,x,b,w,y,C;const E=wo(),B=qt(),{data:k}=wt(),[I,N]=r(!1),[S,O]=r(""),P=e=>{E.push(`/loja/${null==e?void 0:e.url_path}`)},Q=e=>{O(e)};a((()=>{I&&l&&n()}),[I]);const z=null==i?void 0:i.reduce(((e,t)=>{var o;return e+(null===(o=null==t?void 0:t.children)||void 0===o?void 0:o.length)}),0);const M=i&&function(e){var t;const o=e||[],i=z>24?3:2,n=Array.from({length:i},(()=>[]));function r(e){return e.reduce(((e,t)=>{var o;return e+1+((null===(o=null==t?void 0:t.children)||void 0===o?void 0:o.length)||0)}),0)}const a=o.slice().sort(((e,t)=>{var o,i;return((null===(o=null==t?void 0:t.children)||void 0===o?void 0:o.length)||0)-((null===(i=null==e?void 0:e.children)||void 0===i?void 0:i.length)||0)}));for(const e of a){let o=!1;for(let a=0;a<i;a++){const i=n[a];if(r(i)+1+((null===(t=null==e?void 0:e.children)||void 0===t?void 0:t.length)||0)<=12){i.push(e),o=!0;break}}if(!o){const t=n.reduce(((e,t,o)=>{const i=r(t);return i<(z>=37?r(n[e]):r(n[e])-i)?o:e}),0);n[t].push(e)}}return n}(i)||[];return e(o,{children:z>24?e(Xh,{children:t(Hh,{children:[t(Vh,{onMouseOver:()=>{i&&N(!0)},onMouseLeave:()=>{N(!1)},children:[e(yo,{to:qh,onClick:e=>{e.preventDefault(),window.location.href=qh},children:t(Fh,{children:[e(ge,{className:"categorias"}),e(ba,{className:"categorias",text:d?"Produtos da loja":"Categorias",color:"color01",size:"fontSize02",weight:"fontWeight01"}),e(Y,{className:I?"chevronDown-up":"chevronDown"})]})}),e(Kh,{id:I?"separator":"separator-hidden"})]}),t(Jh,{show:I,children:[t("nav",{className:"content-three-columns",onMouseOver:()=>{i&&N(!0)},onMouseLeave:()=>{N(!1)},children:[t("div",{className:"text-container",children:[e(Gh,{children:i&&(null===(s=M[0])||void 0===s?void 0:s.map((i=>{var n,r,a;const l=null===(r=null===(n=null==i?void 0:i.children)||void 0===n?void 0:n.slice())||void 0===r?void 0:r.sort(((e,t)=>{var o;return null===(o=null==e?void 0:e.name)||void 0===o?void 0:o.localeCompare(null==t?void 0:t.name)}));return null==l||l.forEach(((e,t)=>{"Outros"===e.name&&(l.splice(t,1),l.push(e))})),e(o,{children:(null===(a=null==i?void 0:i.children)||void 0===a?void 0:a.length)>0&&t("div",{className:"title-grid",children:[e(Xl,{title:null==i?void 0:i.name,href:`/loja/${null==i?void 0:i.url_path}`,className:"title-menu-categories",onClick:e=>{var t;e.preventDefault(),Je.interact(Ye.Click,Je.getActionLocation(),`${null===(t=et(null==i?void 0:i.name))||void 0===t?void 0:t.toLowerCase()}`,"header",Je.getUserStatus(B),"e-agro/header",null,{userId:Je.getUserId(B)}),P(i)},children:null==i?void 0:i.name}),e($h,{children:null==l?void 0:l.map(((t,o)=>{var i,n;return e("div",{className:S===(null==t?void 0:t.id)?"hovered":"not-hovered",id:(null===(i=null==t?void 0:t.name)||void 0===i?void 0:i.length)>=25?"long-text-hovered":"",children:e(Yh,{className:0===o?"first":"",id:(null===(n=null==t?void 0:t.name)||void 0===n?void 0:n.length)>=25?"long-text":"",children:e(_h,{title:null==t?void 0:t.name,href:`/loja/${null==t?void 0:t.url_path}`,onMouseOver:()=>{Q(null==t?void 0:t.id)},onMouseOut:()=>{Q("")},onClick:e=>{var o;e.preventDefault(),N(!1),Je.interact(Ye.Click,Je.getActionLocation(),`${null===(o=et(null==t?void 0:t.name))||void 0===o?void 0:o.toLowerCase()}`,"header",Je.getUserStatus(B),"e-agro/header",null,{userId:Je.getUserId(B)}),P(t)},children:null==t?void 0:t.name})},null==t?void 0:t.id)},o)}))})]})})})))}),e(Gh,{children:i&&(null===(c=M[1])||void 0===c?void 0:c.map((i=>{var n,r,a;const l=null===(r=null===(n=null==i?void 0:i.children)||void 0===n?void 0:n.slice())||void 0===r?void 0:r.sort(((e,t)=>{var o;return null===(o=null==e?void 0:e.name)||void 0===o?void 0:o.localeCompare(null==t?void 0:t.name)}));return null==l||l.forEach(((e,t)=>{"Outros"===e.name&&(l.splice(t,1),l.push(e))})),e(o,{children:(null===(a=null==i?void 0:i.children)||void 0===a?void 0:a.length)>0&&t("div",{className:"title-grid",children:[e(Xl,{title:null==i?void 0:i.name,href:`/loja/${null==i?void 0:i.url_path}`,className:"title-menu-categories",onClick:e=>{var t;e.preventDefault(),Je.interact(Ye.Click,Je.getActionLocation(),`${null===(t=et(null==i?void 0:i.name))||void 0===t?void 0:t.toLowerCase()}`,"header",Je.getUserStatus(B),"e-agro/header",null,{userId:Je.getUserId(B)}),P(i)},children:null==i?void 0:i.name}),e($h,{children:null==l?void 0:l.map(((t,o)=>{var i,n;return e("div",{className:S===(null==t?void 0:t.id)?"hovered":"not-hovered",id:(null===(i=null==t?void 0:t.name)||void 0===i?void 0:i.length)>=25?"long-text-hovered":"",children:e(Yh,{className:0===o?"first":"",id:(null===(n=null==t?void 0:t.name)||void 0===n?void 0:n.length)>=25?"long-text":"",children:e(_h,{title:null==t?void 0:t.name,href:`/loja/${null==t?void 0:t.url_path}`,onMouseOver:()=>{Q(null==t?void 0:t.id)},onMouseOut:()=>{Q("")},onClick:e=>{var o;e.preventDefault(),N(!1),Je.interact(Ye.Click,Je.getActionLocation(),`${null===(o=et(null==t?void 0:t.name))||void 0===o?void 0:o.toLowerCase()}`,"header",Je.getUserStatus(B),"e-agro/header",null,{userId:Je.getUserId(B)}),P(t)},children:null==t?void 0:t.name})},null==t?void 0:t.id)},o)}))})]})})})))}),e(Gh,{children:i&&(null===(p=M[2])||void 0===p?void 0:p.map((i=>{var n,r,a;const l=null===(r=null===(n=null==i?void 0:i.children)||void 0===n?void 0:n.slice())||void 0===r?void 0:r.sort(((e,t)=>{var o;return null===(o=null==e?void 0:e.name)||void 0===o?void 0:o.localeCompare(null==t?void 0:t.name)}));return null==l||l.forEach(((e,t)=>{"Outros"===e.name&&(l.splice(t,1),l.push(e))})),e(o,{children:(null===(a=null==i?void 0:i.children)||void 0===a?void 0:a.length)>0&&t("div",{className:"title-grid",children:[e(Xl,{title:null==i?void 0:i.name,href:`/loja/${null==i?void 0:i.url_path}`,className:"title-menu-categories",onClick:e=>{var t;e.preventDefault(),Je.interact(Ye.Click,Je.getActionLocation(),`${null===(t=et(null==i?void 0:i.name))||void 0===t?void 0:t.toLowerCase()}`,"header",Je.getUserStatus(B),"e-agro/header",null,{userId:Je.getUserId(B)}),P(i)},children:null==i?void 0:i.name}),e($h,{children:null==l?void 0:l.map(((t,o)=>{var i,n;return e("div",{className:S===(null==t?void 0:t.id)?"hovered":"not-hovered",id:(null===(i=null==t?void 0:t.name)||void 0===i?void 0:i.length)>=25?"long-text-hovered":"",children:e(Yh,{className:0===o?"first":"",id:(null===(n=null==t?void 0:t.name)||void 0===n?void 0:n.length)>=25?"long-text":"",children:e(_h,{title:null==t?void 0:t.name,href:`/loja/${null==t?void 0:t.url_path}`,onMouseOver:()=>{Q(null==t?void 0:t.id)},onMouseOut:()=>{Q("")},onClick:e=>{var o;e.preventDefault(),N(!1),Je.interact(Ye.Click,Je.getActionLocation(),`${null===(o=et(null==t?void 0:t.name))||void 0===o?void 0:o.toLowerCase()}`,"header",Je.getUserStatus(B),"e-agro/header",null,{userId:Je.getUserId(B)}),P(t)},children:null==t?void 0:t.name})},null==t?void 0:t.id)},o)}))})]})})})))})]}),e("div",{className:"separator"}),e(Xl,{title:null===(m=null==k?void 0:k.getMenuMarketplace)||void 0===m?void 0:m.title,href:null===(u=null==k?void 0:k.getMenuMarketplace)||void 0===u?void 0:u.link,onClick:e=>{var t;e.preventDefault(),E.push(null===(t=null==k?void 0:k.getMenuMarketplace)||void 0===t?void 0:t.link)},children:e(Wh,{src:null===(h=null==k?void 0:k.getMenuMarketplace)||void 0===h?void 0:h.image_url,alt:null===(g=null==k?void 0:k.getMenuMarketplace)||void 0===g?void 0:g.alt,title:null===(A=null==k?void 0:k.getMenuMarketplace)||void 0===A?void 0:A.title})})]}),e("div",{className:"overlay",onMouseOver:()=>{N(!1)}})]})]})}):e(Zh,{children:t(Hh,{children:[t(Vh,{onMouseOver:()=>{i&&N(!0)},onMouseLeave:()=>{N(!1)},children:[e(yo,{to:qh,onClick:e=>{e.preventDefault(),window.location.href=qh},children:t(Fh,{children:[e(ge,{className:"categorias"}),e(ba,{className:"categorias",text:d?"Produtos da loja":"Categorias",color:"color01",size:"fontSize02",weight:"fontWeight01"}),e(Y,{className:I?"chevronDown-up":"chevronDown"})]})}),e(Kh,{id:I?"separator":"separator-hidden"})]}),t(Jh,{show:I,children:[t("nav",{className:"content",onMouseOver:()=>{i&&N(!0)},onMouseLeave:()=>{N(!1)},children:[e("div",{className:"low-size-container-to-txts",children:t("div",{className:"text-container-low-size",id:"text-container-low-size",children:[e(Gh,{children:i&&(null===(f=M[0])||void 0===f?void 0:f.map((i=>{var n,r,a;const l=null===(r=null===(n=null==i?void 0:i.children)||void 0===n?void 0:n.slice())||void 0===r?void 0:r.sort(((e,t)=>{var o;return null===(o=null==e?void 0:e.name)||void 0===o?void 0:o.localeCompare(null==t?void 0:t.name)}));return e(o,{children:(null===(a=null==i?void 0:i.children)||void 0===a?void 0:a.length)>0&&t("div",{className:"title-grid",children:[e(Xl,{title:null==i?void 0:i.name,href:`/loja/${null==i?void 0:i.url_path}`,className:"title-menu-categories",onClick:e=>{var t;e.preventDefault(),Je.interact(Ye.Click,Je.getActionLocation(),`${null===(t=et(null==i?void 0:i.name))||void 0===t?void 0:t.toLowerCase()}`,"header",Je.getUserStatus(B),"e-agro/header",null,{userId:Je.getUserId(B)}),P(i)},children:null==i?void 0:i.name}),e($h,{children:l.map(((t,o)=>{var i,n;return e("div",{className:S===(null==t?void 0:t.id)?"hovered":"not-hovered",id:(null===(i=null==t?void 0:t.name)||void 0===i?void 0:i.length)>=25?"long-text-hovered":"",children:e(Yh,{className:0===o?"first":"",id:(null===(n=null==t?void 0:t.name)||void 0===n?void 0:n.length)>=25?"long-text":"",children:e(_h,{title:null==t?void 0:t.name,href:`/loja/${null==t?void 0:t.url_path}`,onMouseOver:()=>{Q(null==t?void 0:t.id)},onMouseOut:()=>{Q("")},onClick:e=>{var o;e.preventDefault(),N(!1),Je.interact(Ye.Click,Je.getActionLocation(),`${null===(o=et(null==t?void 0:t.name))||void 0===o?void 0:o.toLowerCase()}`,"header",Je.getUserStatus(B),"e-agro/header",null,{userId:Je.getUserId(B)}),P(t)},children:null==t?void 0:t.name})},null==t?void 0:t.id)},o)}))})]})})})))}),e(Gh,{children:i&&(null===(v=M[1])||void 0===v?void 0:v.map((i=>{var n,r,a;const l=null===(r=null===(n=null==i?void 0:i.children)||void 0===n?void 0:n.slice())||void 0===r?void 0:r.sort(((e,t)=>{var o;return null===(o=null==e?void 0:e.name)||void 0===o?void 0:o.localeCompare(null==t?void 0:t.name)}));return e(o,{children:(null===(a=null==i?void 0:i.children)||void 0===a?void 0:a.length)>0&&t("div",{className:"title-grid",children:[e(Xl,{title:null==i?void 0:i.name,href:`/loja/${null==i?void 0:i.url_path}`,className:"title-menu-categories",onClick:e=>{var t;e.preventDefault(),Je.interact(Ye.Click,Je.getActionLocation(),`${null===(t=et(null==i?void 0:i.name))||void 0===t?void 0:t.toLowerCase()}`,"header",Je.getUserStatus(B),"e-agro/header",null,{userId:Je.getUserId(B)}),P(i)},children:null==i?void 0:i.name}),e($h,{children:l.map(((t,o)=>{var i,n;return e("div",{className:S===(null==t?void 0:t.id)?"hovered":"not-hovered",id:(null===(i=null==t?void 0:t.name)||void 0===i?void 0:i.length)>=25?"long-text-hovered":"",children:e(Yh,{className:0===o?"first":"",id:(null===(n=null==t?void 0:t.name)||void 0===n?void 0:n.length)>=25?"long-text":"",children:e(_h,{title:null==t?void 0:t.name,href:`/loja/${null==t?void 0:t.url_path}`,onMouseOver:()=>{Q(null==t?void 0:t.id)},onMouseOut:()=>{Q("")},onClick:e=>{var o;e.preventDefault(),N(!1),Je.interact(Ye.Click,Je.getActionLocation(),`${null===(o=et(null==t?void 0:t.name))||void 0===o?void 0:o.toLowerCase()}`,"header",Je.getUserStatus(B),"e-agro/header",null,{userId:Je.getUserId(B)}),P(t)},children:null==t?void 0:t.name})},null==t?void 0:t.id)},o)}))})]})})})))})]})}),e("div",{className:"separator"}),e(Xl,{title:null===(x=null==k?void 0:k.getMenuMarketplace)||void 0===x?void 0:x.title,href:null===(b=null==k?void 0:k.getMenuMarketplace)||void 0===b?void 0:b.link,onClick:e=>{var t;e.preventDefault(),E.push(null===(t=null==k?void 0:k.getMenuMarketplace)||void 0===t?void 0:t.link)},children:e(Wh,{style:{marginRight:z<=17?"32px":"30px"},src:null===(w=null==k?void 0:k.getMenuMarketplace)||void 0===w?void 0:w.image_url,alt:null===(y=null==k?void 0:k.getMenuMarketplace)||void 0===y?void 0:y.alt,title:null===(C=null==k?void 0:k.getMenuMarketplace)||void 0===C?void 0:C.title})})]}),e("div",{className:"overlay",onMouseOver:()=>{N(!1)}})]})]})})})},tg=h.div`
  position: absolute;
  z-index: 9999999999;
  height: stretch;
  width: 100%;
  background: rgba(0, 0, 0, 0.65);
`,og=h.div`
  background: white;
  height: stretch;
  width: 18rem;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  overflow-y: auto;
`,ig=h.div`
  display: flex;
  align-items: center;
  margin-left: 0.5rem;
  height: 30px;

  & > a.link-header {
    color: ${f.color04};
    font-size: ${f.fontSize01};
    margin: 0.5rem;
    height: fit-content;
  }

  & > a:hover,
  & > a.active-route {
    border-bottom: 2px solid ${f.color20};
    padding-bottom: 0.25rem;
    margin-top: 0.25rem;
  }

  & > a.active-route {
    margin-bottom: 0;
  }

  & > svg {
    fill: ${f.bg01};
    width: 1.25rem;
    height: 1.25rem;
  }

  & > p {
    cursor: pointer;
    font-size: 14px;
    margin-left: 0.5rem;
  }

  & > p::after {
    content: '>';
    margin-left: 0.5rem;
  }
`,ng=h.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  margin-left: 1rem;
  padding-bottom: 0.75rem;
  margin-bottom: 0.75rem;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.65);

  & > svg {
    fill: ${f.bc01};
  }
`,rg=h.div`
  display: flex;
  justify-content: space-between;
  margin-left: 1rem;
  margin-bottom: 1rem;

  & > p {
    font-weight: 600;
  }

  & > svg {
    cursor: pointer;
  }
`,ag=h.div`
  cursor: pointer;
  display: flex;
  align-items: center;

  & > svg {
    fill: ${f.bc01};
  }

  & > p {
    font-size: 14px;
    margin-left: 0.5rem;
  }
`,lg=h.p``,dg=h.img`
  width: 208px;
  height: 400px;
  margin-left: 1rem;
`,sg=_o`
  query GetPostStaticContent {
    getPostStaticContent {
      enabled
    }
  }
`,cg=()=>{const{loading:e,error:t,data:o}=$o(sg,{fetchPolicy:"cache-and-network"});return{loading:e,error:t,data:o}};var pg,mg;function ug(){return ug=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},ug.apply(null,arguments)}const hg=e=>i.createElement("svg",ug({xmlns:"http://www.w3.org/2000/svg",fill:"none",viewBox:"0 0 14 14"},e),pg||(pg=i.createElement("g",{fill:"#0C881E",clipPath:"url(#e-agro-logo-filled_svg__a)"},i.createElement("path",{d:"m.135 6.932-.002.079c0 1.83.725 3.587 2.015 4.882a6.87 6.87 0 0 0 4.864 2.023l.002-.078A6.92 6.92 0 0 0 5 8.955 6.87 6.87 0 0 0 .135 6.932"}),i.createElement("path",{d:"m13.896 7.01-.002-.078a6.87 6.87 0 0 0-4.865 2.023 6.92 6.92 0 0 0-2.015 4.883l.002.078a6.87 6.87 0 0 0 4.865-2.023 6.92 6.92 0 0 0 2.015-4.882M7.014 2.855a4.13 4.13 0 0 0-2.247.665 4.15 4.15 0 0 0-1.528 1.783l1.249.565A2.78 2.78 0 0 1 7.014 4.23a2.76 2.76 0 0 1 2.527 1.64l1.249-.566A4.15 4.15 0 0 0 9.262 3.52a4.13 4.13 0 0 0-2.248-.665"}),i.createElement("path",{d:"M7.014 5.604a1.4 1.4 0 0 0-1.277.83l1.277.577 1.277-.578a1.4 1.4 0 0 0-1.277-.829M7.014.105A6.86 6.86 0 0 0 3.28 1.211 6.9 6.9 0 0 0 .74 4.174l1.25.565a5.53 5.53 0 0 1 2.032-2.373 5.5 5.5 0 0 1 5.983 0 5.53 5.53 0 0 1 2.033 2.373l1.249-.565a6.9 6.9 0 0 0-2.54-2.963A6.86 6.86 0 0 0 7.015.105"}))),mg||(mg=i.createElement("defs",null,i.createElement("clipPath",{id:"e-agro-logo-filled_svg__a"},i.createElement("path",{fill:"#fff",d:"M0 0h14v14H0z"}))))),gg={logged:[{name:"Início",url:"/",svg:e(Ae,{color:f.bg01})},{name:"Meu painel",url:"/dashboard/DashboardPage",svg:e(ve,{color:f.bg01})},{name:"Quem somos",url:"sobre",svg:e(hg,{})},{name:"Linhas de crédito",url:"simulacao-de-credito",svg:e(fe,{color:f.bg01})}],guest:[{name:"Início",url:"/",svg:e(Ae,{color:f.bg01})},{name:"Quem somos",url:"sobre",svg:e(hg,{})},{name:"Linhas de crédito",url:"simulacao-de-credito",svg:e(fe,{color:f.bg01})}]},Ag=e=>e?gg.logged:gg.guest,fg=o=>{var i,n,d,s,c;const[p,m]=r(),[u,h]=r(""),[g,A]=r(0),[v,x]=r(),b=wo(),{data:w}=wt(),{loading:y,error:C,data:E}=cg(),B=l((()=>{var e;return!y&&!C&&((null===(e=null==E?void 0:E.getPostStaticContent)||void 0===e?void 0:e.enabled)||!1)}),[E,y,C]),k=qt(),I=k.token&&"GUEST"!==k.type,N=()=>{const t=[...Ag(I)];o.menuItems&&t.push({name:"Produtos da loja",svg:e(ye,{color:f.bg01}),children:!0}),B&&t.push({name:"Blog",url:"/blog",svg:e(Ce,{color:f.bg01})}),m(t)};a((()=>{N()}),[o.menuItems]);const S=e=>{A(e?g-1:g+1)},O=e=>{(e=>{var t;0===g?m(null===(t=o.menuItems)||void 0===t?void 0:t.sort(((e,t)=>e.name<t.name?1:t.name>e.name?-1:0))):1===g?m(e.children):(b.push(`/loja/${e.url_path}`),null==o||o.onClickDiv()),S()})(e)};a((()=>{2!==g?(1===g?h("Categorias"):0===g&&h(""),x(null)):h((null==v?void 0:v.name)||"")}),[g,v]);return e(tg,{onClick:()=>o.onClickDiv(),children:t(og,{onClick:e=>{e.stopPropagation(),e.nativeEvent.stopPropagation(),e.nativeEvent.stopImmediatePropagation()},children:[1===g&&t(rg,{children:[e(lg,{children:u}),e(xe,{onClick:()=>o.onClickDiv()})]}),2===g&&t(rg,{children:[t(ag,{onClick:()=>{var e;2===g?m(null===(e=o.menuItems)||void 0===e?void 0:e.sort(((e,t)=>e.name<t.name?1:t.name>e.name?-1:0))):1===g&&N(),S(!0)},children:[e(be,{}),e("p",{children:"Voltar"})]}),e(xe,{onClick:()=>o.onClickDiv()})]}),null==p?void 0:p.map(((o,i)=>{return o.children?!0===o.children?t(ig,{children:[o.svg&&o.svg,e("p",{onClick:()=>O(o),children:o.name})]},i):t(ng,{onClick:()=>O(o),children:[o.name," ",e(we,{})]},i):t(ig,{children:[o.svg,e(yo,{className:"link-header "+(n=o.url||"",(null===window||void 0===window?void 0:window.location.pathname.toLowerCase())===n.toLowerCase()&&"#"!==n?"active-route":""),to:o.url||"/",onClick:()=>{var e;const t={event:"exitWebview/"+o.url,url:window.location.href};"Início"!==o.name&&(null===(e=null===window||void 0===window?void 0:window.ReactNativeWebView)||void 0===e||e.postMessage(JSON.stringify(t)))},children:o.name})]},i);var n})),1===g&&e(yo,{title:null===(i=null==w?void 0:w.getMenuMarketplace)||void 0===i?void 0:i.title,href:null===(n=null==w?void 0:w.getMenuMarketplace)||void 0===n?void 0:n.link,onClick:e=>{var t;e.preventDefault(),b.push(null===(t=null==w?void 0:w.getMenuMarketplace)||void 0===t?void 0:t.link)},to:"",children:e(dg,{src:null===(d=null==w?void 0:w.getMenuMarketplace)||void 0===d?void 0:d.image_url,alt:null===(s=null==w?void 0:w.getMenuMarketplace)||void 0===s?void 0:s.alt,title:null===(c=null==w?void 0:w.getMenuMarketplace)||void 0===c?void 0:c.title})})]})})},vg=h.div`
  @media (min-width: 1312px) {
    width: 78rem;
  }

  @media (min-width: 1056px) and (max-width: 1312px) {
    width: 64rem;
  }

  @media (min-width: 320px) and (max-width: 1056px) {
    width: 100%;
    padding: 0 0 0 1rem;
    display: block;
  }

  display: flex;
  justify-content: space-between;

  .searchInputs:focus-within {
    box-shadow: 0px 0px 2px 2px ${f.color02};
  }

  input:focus {
    outline: none;
  }

  #searchField::placeholder {
    color: #a7a8ac;
  }
`,xg=h.div`
  @media (min-width: 1312px) {
    width: 18.5rem;
  }

  @media (min-width: 1056px) and (max-width: 1312px) {
    width: 15.25rem;
  }

  @media (min-width: 320px) and (max-width: 1056px) {
    width: 100%;
    padding: 0 1rem 0 0;
  }
`,bg=h.div`
  display: flex;

  @media (max-width: 1056px) {
    margin-top: 0.5rem;
  }
`,wg=h.div`
  display: flex;
  border-style: solid;
  border-width: 1px;
  border-radius: 0.625rem;
  border-color: #a7a8ac;
  background-color: #ffffff;

  svg:hover {
    cursor: pointer;
  }

  svg {
    font-size: 2rem;
  }

  svg.search-icon {
    fill: ${f.color01};
    width: 1rem;
    height: 1rem;
  }
`,yg=h.div`
  width: 3.125rem;
  display: grid;
  place-items: center;
`,Cg=h.input`
  border-width: 0px;
  font-size: 0.875rem;
  height: 2rem;

  @media (min-width: 1312px) {
    width: 80%;
  }

  @media (min-width: 1056px) and (max-width: 1312px) {
    width: 75%;
  }

  @media (min-width: 320px) and (max-width: 1056px) {
    width: 80%;
  }
`,Eg=h.div`
  padding-right: 1rem;
  border-right: 1px solid ${f.color08};
  display: flex;
  width: max-content;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  p.hover-header {
    width: 100%;
    padding: 0.5rem;
  }

  svg {
    color: ${f.color01};
    width: 1rem;
    height: 1rem;
    cursor: pointer;
  }

  h4 {
    text-overflow: initial;
    overflow: initial;
  }
`;h.div`
  display: flex;
  height: 35px;
  position: relative;
  justify-content: start;
`;const Bg=h("div")`
  display: flex;
  flex-direction: row;
  position: relative;
  padding-left: 1rem;
`;h("div")`
  display: flex;
  flex-direction: row;
  color: ${f.color01};
  user-select: none;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  text-align: center;
`;const kg=h("div")`
  position: relative;
  display: flex;
`,Ig=h.div`
  display: flex;
  width: max-content;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    color: ${f.color01};
    width: 1rem;
    height: 1rem;
    cursor: pointer;
  }

  p {
    padding-left: 0.5rem;
  }
`,Ng=h("p")`
  color: ${f.color04};
  font-size: ${f.fontSize01};
  font-weight: ${f.fontWeight01};
  text-align: left;

  @media (max-width: 445px) {
    width: 48vw;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`,Sg=h.p`
  color: ${f.color04};
  font-size: ${f.fontSize01};
  font-weight: ${f.fontWeight01};
`,Og=h.div`
  background: ${f.bg14} 0% 0% no-repeat padding-box;
  box-shadow: 0px 4px 12px ${f.bx01};
  border: 1px solid ${f.bg16};
  position: absolute;
  min-width: 288px;
  min-height: 278px;
  padding-bottom: 16px;
  padding-top: 16px;

  top: 53px;
  right: 0px;
  z-index: 1000;
  border-radius: 4px;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 1056px) and (min-width: 445px) {
    left: 10px;
  }

  &:after,
  &:before {
    content: ' ';
    position: absolute;
    right: 25px;
    top: -7px;
    border-top: none;
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
    border-bottom: 7px solid ${f.bg14};
    /* background: transparent 0% 0% no-repeat padding-box; */
  }
`,Pg=h.div`
  &:after,
  &:before {
    content: ' ';
    position: absolute;
    left: 50px;
    top: -7.5px;
    border-top: none;
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
    border-bottom: 7px solid ${f.bg16};
  }
`,Qg=h.div`
  height: 95%;
  display: flex;
  flex-direction: column;
  z-index: 1000;

  @media (min-width: 363px) {
    width: ${e=>!0===e.isModal?"320px":"260px"};
  }

  @media (max-width: 363px) {
    width: ${e=>!0===e.isModal?"250px":"260px"} !important;
  }
`,zg=h.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  margin-top: 5px;
  color: black;
  justify-content: space-between;

  .close {
    min-width: 32px;
    min-height: 32px;
    padding: 8px;
    margin-top: -8px;

    :hover {
      border-radius: 25px;
      background-color: ${f.bg15};
      cursor: pointer;
    }
  }
`,Mg=h.div`
  background: ${f.bg12} 0% 0% no-repeat padding-box;
  border: 1px solid #008aeb40;

  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: ${f.bc01};
  }

  width: 40px;
  height: 40px;
`;function Dg({setIsMenuRegionOpen:o}){return t(zg,{children:[e(Mg,{children:e(Ar,{width:40,height:24})}),e(ur,{color:"black !important",width:8,className:"close",height:8,onClick:o})]})}const jg=h.div`
  height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 16px;
  margin-bottom: 24px;
`,Tg=h.div`
  text-align: left;
  font: normal normal 600 16px/24px Bradesco Sans;
  letter-spacing: 0px;
  color: black;
  opacity: 1;
`,Rg=h.div`
  text-align: left;
  font: normal normal normal 14px/20px Bradesco Sans;
  letter-spacing: 0px;
  color: black;
  opacity: 1;
`;function Lg(){return t(jg,{children:[e(Tg,{children:"Qual a região de entrega?"}),e(Rg,{children:"Informe a cidade para conferir preços e ofertas personalizadas."})]})}const Ug=h.div`
  background: ${f.bg03} 0% 0% no-repeat padding-box;
  border-radius: 8px;
  opacity: 1;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid
    ${e=>e.focused?`${f.bg02}`:`${f.color08}`};

  svg {
    margin-right: 16px;
    cursor: pointer;

    min-width: 32px;
    min-height: 32px;
    padding: 8px;

    :hover {
      border-radius: 25px;
      background-color: ${f.bg15};
      cursor: pointer;
    }
  }

  #input-wrapper {
    display: flex;
    width: 100%;

    div {
      width: 180px;
      margin-left: 18px;
      color: black;
      text-align: left;
      font: normal normal normal 14px/20px Bradesco Sans;
      letter-spacing: 0px;
      opacity: 1;
      background: ${f.bg03} 0% 0% no-repeat padding-box;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  input {
    margin-left: 18px;
    height: 90%;
    width: 100%;
    width: calc(100% + 10px);
    border: none;
    outline: none;
    appearance: none;
    color: black;
    text-align: left;
    font: normal normal normal 14px/20px Bradesco Sans;
    letter-spacing: 0px;
    opacity: 1;
    background: ${f.bg03} 0% 0% no-repeat padding-box;
  }

  input:focus {
    outline: none;
  }
`;function qg({onChange:o,value:i,setRegionSelected:n,setInputChange:a,isModal:l,regionSelected:d,hasCityOnCookie:s,isRegionOptionClicked:c,setIsInputSelected:p,isInputSelected:m,classNameInput:u,classNameDiv:h,classNameinputWrapper:g}){var A,f,v;const[x,b]=r(!1),w=s.length>0?s.toLocaleLowerCase():`${null===(A=null==d?void 0:d.nome_municipio)||void 0===A?void 0:A.toLowerCase()}, ${null===(v=null===(f=null==d?void 0:d.region_uf_code)||void 0===f?void 0:f.replace("UF_",""))||void 0===v?void 0:v.toLowerCase()}`,y=(null==i?void 0:i.toLowerCase())===w&&i.length>0||c;return t(Ug,{focused:x,isModal:l,children:[e("div",{id:"input-wrapper",className:g?u:"",children:m&&i.length>=0?e("input",{type:"text",value:i,name:"Busque por uma cidade",placeholder:"Busque por uma cidade",className:u||"",onChange:o,autoFocus:x,onFocus:()=>{b(!0),p(!0)},onBlur:()=>{b(!1),y&&p(!1)}}):e("div",{onClick:()=>{p(!0),b(!0)},className:h||"",children:i})}),y&&void 0!==d&&e(ur,{color:"black !important",width:16,height:16,onClick:()=>{n(void 0),a(""),p(!0)}})]})}const Wg=h.div`
  width: 100%;
  height: ${e=>"1"===e.citiesQuantity?"48px":"2"===e.citiesQuantity?"100px":"144px"};
  background-color: ${f.bg03};
  justify-self: none;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  margin-top: 5px;
  flex-direction: column;
  box-shadow:
    rgba(0, 0, 0, 0.16) 0px 10px 36px 0px,
    rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;

  &::-webkit-scrollbar {
    width: 20px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-track {
    width: 6px;
    border-radius: 4px;
    margin-left: 5px;
  }

  &::-webkit-scrollbar-thumb {
    width: 1px;
    background: ${f.color16} 0% 0% no-repeat padding-box;
    border-radius: 1000px;
    margin-left: 5px;

    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${f.color16} 0% 0% no-repeat padding-box;
    border-radius: 1000px;
  }

  .hovered {
    background-color: ${f.color16};
    transition-duration: 200ms;
  }

  ul {
    width: 100%;
    height: ${e=>"1"===e.citiesQuantity?"100%":"33px"};

    height: 33px;
    text-align: left;

    li {
      font: normal normal normal 14px/20px Bradesco Sans;
      display: flex;
      align-items: center;
      padding: 0.8rem;
      border-bottom: 1px solid ${f.color16};
      cursor: pointer;
      transition-duration: 200ms;
      line-height: 1.063rem;
    }

    div {
      cursor: pointer;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 15px;
    }

    .separator {
      border-top: 1px solid ${f.color16};
      width: 96%;
      height: 2px;
    }
  }
`;function Gg({municipios:t,setRegionSelected:i,setInputChange:n,setIsRegionOptionClicked:a,isRegionOptionClicked:l,inputChange:d,regionSelected:s,setIsInputSelected:c}){var p;const[m,u]=r(""),h=(null==s?void 0:s.nome_municipio)?`${null==s?void 0:s.nome_municipio.toLowerCase()}, ${null===(p=null==s?void 0:s.region_uf_code)||void 0===p?void 0:p.replace("UF_","").toLowerCase()}`:null==s?void 0:s.toLowerCase();return e(o,{children:(null==t?void 0:t.length)>0&&!l&&d.toLowerCase()!==h?e(Wg,{id:"ddl-list-region",citiesQuantity:(null==t?void 0:t.length)>=3?"3+":2===(null==t?void 0:t.length)?"2":"1",children:e("ul",{children:null==t?void 0:t.map((t=>{var o,r;return e("li",{onClick:()=>{var e;i(t),n(`${null==t?void 0:t.nome_municipio}, ${null===(e=null==t?void 0:t.region_uf_code)||void 0===e?void 0:e.replace("UF_","")}`),a(!0),c(!1)},onMouseOver:()=>{var e;u(`${null==t?void 0:t.nome_municipio}, ${null===(e=null==t?void 0:t.region_uf_code)||void 0===e?void 0:e.replace("UF_","")}`)},className:`${null==t?void 0:t.nome_municipio}, ${null===(o=null==t?void 0:t.region_uf_code)||void 0===o?void 0:o.replace("UF_","")}`===m?"hovered":"",children:`${null==t?void 0:t.nome_municipio}, ${null===(r=null==t?void 0:t.region_uf_code)||void 0===r?void 0:r.replace("UF_","")}`},t.id)}))})}):e(o,{})})}const Hg=h.div`
  .button-definir-regiao:disabled:hover {
    background: ${f.color08} 0% 0% no-repeat padding-box !important;
  }

  .button-definir-regiao:hover {
    background-color: ${e=>e.active?`${f.bg17}`:""};
  }

  .button-definir-regiao {
    background: ${e=>e.active?`${f.bg01}`:`${f.color08}`}
      0% 0% no-repeat padding-box;
    border-radius: 100px;
    opacity: 1;
    width: 100%;
    height: 33px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
    border: none;

    text-align: center;
    font: normal normal 600 14px/20px Bradesco Sans;
    letter-spacing: 0px;
    color: ${e=>e.active?`${f.color03}`:`${f.color09}`};
  }
`,Fg=[{name:"Acre",sigla:"AC"},{name:"Alagoas",sigla:"AL"},{name:"Amapá",sigla:"AP"},{name:"Amazonas",sigla:"AM"},{name:"Bahia",sigla:"BA"},{name:"Ceará",sigla:"CE"},{name:"Distrito Federal",sigla:"DF"},{name:"Espírito Santo",sigla:"ES"},{name:"Goiás",sigla:"GO"},{name:"Maranhão",sigla:"MA"},{name:"Mato Grosso",sigla:"MT"},{name:"Mato Grosso do Sul",sigla:"MS"},{name:"Minas Gerais",sigla:"MG"},{name:"Pará",sigla:"PA"},{name:"Paraíba",sigla:"PB"},{name:"Paraná",sigla:"PR"},{name:"Pernambuco",sigla:"PE"},{name:"Piauí",sigla:"PI"},{name:"Rio de Janeiro",sigla:"RJ"},{name:"Rio Grande do Norte",sigla:"RN"},{name:"Rio Grande do Sul",sigla:"RS"},{name:"Rondônia",sigla:"RO"},{name:"Roraima",sigla:"RR"},{name:"Santa Catarina",sigla:"SC"},{name:"São Paulo",sigla:"SP"},{name:"Sergipe",sigla:"SE"},{name:"Tocantins",sigla:"TO"}];function Vg({isActive:t,regionSelected:o,setIsMenuRegionOpen:i,isModal:n}){var a,l,d,s,c,p,m,u,h,g,A,f;const v=qt(),{setSelectedRegion:x}=di(),b=fi(),{data:w}=yt(null==v?void 0:v.cartId),y=wo(),{toggleRegionModal:C}=di(),[E,B]=r(!1),k=null===(c=null===(s=null===(d=null===(l=null===(a=null==w?void 0:w.me)||void 0===a?void 0:a.carts)||void 0===l?void 0:l[0])||void 0===d?void 0:d.lineItems)||void 0===s?void 0:s[0])||void 0===c?void 0:c.id,I=null===(g=null===(h=null===(u=null===(m=null===(p=null==w?void 0:w.me)||void 0===p?void 0:p.carts)||void 0===m?void 0:m[0])||void 0===u?void 0:u.lineItems)||void 0===h?void 0:h[0])||void 0===g?void 0:g.quantity,N=null===(A=null==o?void 0:o.region_uf_code)||void 0===A?void 0:A.replace("UF_",""),S=null===(f=null==Fg?void 0:Fg.find((e=>(null==e?void 0:e.sigla)===N)))||void 0===f?void 0:f.name;return e(Hg,{active:t,children:e(pl,{size:"small",variant:"primary",disabled:E||!t,label:E?e(Vt,{small:!0,withOverlay:!1}):"Definir Região",alt:"Definir Região",title:"Definir Região",className:"button-definir-regiao",onClick:()=>Yl(this,void 0,void 0,(function*(){var e,t,r,a,l,d;B(!0),Je.interact(Ye.Click,Je.getActionLocation(),"definir-regiao","marketplace",Je.getUserStatus(v),"e-agro/modal-regiao",null,{userId:Je.getUserId(v)}),(null==v?void 0:v.cartCount)&&(null==v?void 0:v.cartId)?b.update({id:k,quantity:I}).then((()=>{var e,t,r,a,l,d;x({miraklRegion:[(null===(e=null==o?void 0:o.region_rgi_id)||void 0===e?void 0:e.toString())||"",(null===(t=null==o?void 0:o.region_rg_int_id)||void 0===t?void 0:t.toString())||"",(null===(r=null==o?void 0:o.region_uf_id)||void 0===r?void 0:r.toString())||"",(null===(a=null==o?void 0:o.region_rb_id)||void 0===a?void 0:a.toString())||"",(null===(l=null==o?void 0:o.region_pais_id)||void 0===l?void 0:l.toString())||"",(null===(d=null==o?void 0:o.region_municipio_id)||void 0===d?void 0:d.toString())||""],state:S,uf:N,city:null==o?void 0:o.nome_municipio,regionList:[(null==o?void 0:o.region_rb_code)||"",(null==o?void 0:o.region_rg_int_code)||"",(null==o?void 0:o.region_rgi_code)||"",(null==o?void 0:o.region_uf_code)||"",(null==o?void 0:o.region_pais_code)||"",(null==o?void 0:o.region_municipio_code)||""]}),n&&i&&i(),!n&&C(),y.go(0)})).catch((()=>{})):(x({miraklRegion:[(null===(e=null==o?void 0:o.region_rgi_id)||void 0===e?void 0:e.toString())||"",(null===(t=null==o?void 0:o.region_rg_int_id)||void 0===t?void 0:t.toString())||"",(null===(r=null==o?void 0:o.region_uf_id)||void 0===r?void 0:r.toString())||"",(null===(a=null==o?void 0:o.region_rb_id)||void 0===a?void 0:a.toString())||"",(null===(l=null==o?void 0:o.region_pais_id)||void 0===l?void 0:l.toString())||"",(null===(d=null==o?void 0:o.region_municipio_id)||void 0===d?void 0:d.toString())||""],state:S,uf:N,city:null==o?void 0:o.nome_municipio,regionList:[(null==o?void 0:o.region_rb_code)||"",(null==o?void 0:o.region_rg_int_code)||"",(null==o?void 0:o.region_rgi_code)||"",(null==o?void 0:o.region_uf_code)||"",(null==o?void 0:o.region_pais_code)||"",(null==o?void 0:o.region_municipio_code)||""]}),n&&i&&i(),!n&&C(),y.go(0))}))})})}function Kg({setIsMenuRegionOpen:o,isModal:i,setIsModalOpen:n}){var l,d,s,c;const p=(new Mo).get("marketplace"),m=void 0!==(null==p?void 0:p.city)?`${null==p?void 0:p.city}, ${null===(l=null==p?void 0:p.regionList[3])||void 0===l?void 0:l.replace("UF_","")}`:"",[u,h]=r(m),[g,A]=r(m),{data:f}=Ct(),[v,x]=r(!1),[b,w]=r(!0),y=qt(),C=e=>null==e?void 0:e.normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/[^a-zA-Z]/g,"").toLowerCase();a((()=>{Je.pageview(Ye.PageView,"regiao-de-entrega",Je.getUserStatus(y),"e-agro/modal-regiao",Je.getActionLocation(),null,{userId:Je.getUserId(y)})}),[]);const E=f&&(null===(d=JSON.parse(null==f?void 0:f.getMunicipio))||void 0===d?void 0:d.map((e=>e)).sort(null===(s=null===Intl||void 0===Intl?void 0:Intl.Collator())||void 0===s?void 0:s.compare)),B=null===(c=null==E?void 0:E.filter((e=>{var t,o;return null===(o=C(`${null==e?void 0:e.nome_municipio}, ${null===(t=null==e?void 0:e.region_uf_code)||void 0===t?void 0:t.replace("UF_","")}`))||void 0===o?void 0:o.includes(C(u))})))||void 0===c?void 0:c.sort(((e,t)=>{var o;return null===(o=null==e?void 0:e.label)||void 0===o?void 0:o.localeCompare(null==t?void 0:t.label)}));return t(Qg,{isModal:i,children:[e(Dg,i?{setIsMenuRegionOpen:()=>{n&&n()}}:{setIsMenuRegionOpen:()=>{o&&o(!1)}}),e(Lg,{}),e(qg,{onChange:e=>{h(e.target.value),x(!1)},isModal:i,value:u,hasCityOnCookie:m,regionSelected:g,isRegionOptionClicked:v,setRegionSelected:A,setInputChange:h,setIsInputSelected:w,isInputSelected:b}),(null==B?void 0:B.length)>0&&u.length>0&&!v&&u!==g&&e(Gg,{municipios:null==B?void 0:B.slice(0,10),inputChange:u,setRegionSelected:A,regionSelected:g,setInputChange:h,setIsRegionOptionClicked:x,isRegionOptionClicked:v,setIsInputSelected:w}),e(Vg,{regionSelected:g,isActive:!(void 0===g||!v),setIsMenuRegionOpen:n,isModal:i})]})}const Jg=({onChangeUserInteraction:o})=>{const{context:i,toggleRegionModal:n}=di();return(null==i?void 0:i.showRegionModal)?t(Og,{onClick:e=>{e.stopPropagation(),o&&o()},children:[e(Pg,{}),e(Kg,{setIsMenuRegionOpen:()=>n(!1),isModal:!1})]}):null};var Yg=e=>{var t;return Object.assign({padding:e.theme.spacing.inset.XL,buttonHeight:"4rem",top:"0",bottom:"0",zIndex:"16"},null===(t=e.theme)||void 0===t?void 0:t.byComponent.core_sidePanel)};const Zg={s:"20rem",m:"28rem",l:"60vw",xl:"75vw"},Xg=h("div")``,_g=h("div")`
  background-color: white;
  bottom: ${e=>Yg(e).bottom};
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 9999;
  top: ${e=>Yg(e).top};
  transition: transform 0.25s ease-out;
  width: 100vw;
  overflow-y: auto;
  /* Position outside of screen */
  ${e=>"left"===e.position&&"left: calc(-100vw - 1rem);"}
  ${e=>"right"===e.position&&"right: calc(-100vw - 1rem);"}

  /* Move into screen when open */
  ${e=>"left"===e.position&&e.isOpen&&"transform: translateX(calc(100vw + 1rem));"}
  ${e=>"right"===e.position&&e.isOpen&&"transform: translateX(calc(-100vw - 1rem));"}

  /* Shift the main panel as needed */
  ${e=>"push"===e.mode&&g`
      & ~ ${Xg} {
        ${"left"===e.position&&e.isOpen&&"transform: translateX(100vw);"}
        ${"right"===e.position&&e.isOpen&&"transform: translateX(-100vw);"}
      }
    `}

  ${e=>Bo.greaterThan(e,"medium").then(g`
      width: ${Zg[e.size]};
      overflow-y: auto;
      overflow-x: hidden;
      /* Position outside of screen */
      ${"left"===e.position&&`left: calc(-${Zg[e.size]} - 1rem);`}
      ${"right"===e.position&&`right: calc(-${Zg[e.size]} - 1rem);`}

    /* Move into screen when open */
    ${"left"===e.position&&e.isOpen&&`transform: translateX(calc(${Zg[e.size]} + 1rem));`}
    ${"right"===e.position&&e.isOpen&&`transform: translateX(calc(-${Zg[e.size]} - 1rem));`}

    /* Shift the main panel as needed */
    ${Eo(e,"mode").switch([ko.eq("compress").then(g`
          & ~ ${Xg} {
            position: relative;
            ${"left"===e.position&&e.isOpen&&`margin-left: ${Zg[e.size]};`};
            ${"right"===e.position&&e.isOpen&&`margin-right: ${Zg[e.size]};`};
          }
        `),ko.eq("push").then(g`
          & ~ ${Xg} {
            position: relative;
            ${"left"===e.position&&e.isOpen&&`transform: translateX(${Zg[e.size]});`}
            ${"right"===e.position&&e.isOpen&&`transform: translateX(-${Zg[e.size]});`}
          }
        `)])};
    `)}

  & ~ ${Xg} {
    transition:
      transform 0.25s ease-out,
      margin 0.25s ease-out;
  }
`;h("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fffb;
`,h("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fd;
`,h("div")`
  font-weight: bold;
  font-size: 20px;
  padding: 1rem;
`,h("div")`
  font-size: 20px;
  padding: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
`,h("div")`
  font-weight: bold;
  font-size: 20px;
  padding: 0.4rem;
  margin-left: 1.8rem;
  margin-bottom: 1rem;
`,h("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -40%;
  left: 47%;
  transform: translate(-50%, -50%);
`,h("div")`
  font-weight: bold;
  font-size: 20px;
  padding: 0.4rem;
  margin-left: 1.8rem;
  margin-bottom: 2rem;
`,h(wi)`
  width: 100%;
  padding: ${e=>e.theme.spacing.inset.L};
  background-color: ${f.color01};
  color: ${f.color03};
  border: none;
  border-radius: 30px;
  font-weight: ${f.fontWeight02};
  justify-content: center;
  align-items: center;
  :hover {
    cursor: pointer;
    background-color: ${f.color01Dark};
    color: ${f.color03};
    border: none;
  }
  ${e=>Bo.lessThan(e,"medium").then(g`
      flex-direction: column;
    `)}
`,h("div")`
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
`;const $g=h("button")`
  ${e=>!e.show&&"visibility: hidden;"}
  margin-left: 90%;
  margin-top: 0.5rem;
  margin-bottom: auto;
  border: none;
  position: absolute;
  cursor: pointer;
  padding: 2px;
  color: ${f.color04};
  /* stylelint-disable-next-line selector-max-universal */
  & > *:hover {
    color: ${e=>e.theme.colors.interactive.primary.hover.bg};
  }
`,eA=h("div")`
  height: 100%;
  margin-bottom: ${e=>Io(No(Yg(e).padding,{}))};
  ${e=>e.isScrolling&&"overflow-y: auto;"};
  ${e=>!e.isScrolling&&"overflow: hidden;"};
  padding: ${e=>No(Yg(e).padding,{vertical:"0"})};

  &::-webkit-scrollbar {
    width: 0;
  }
`,tA=h("div")`
  padding: ${e=>No(Yg(e).padding,{vertical:"0"})};
`,oA=h("div")`
  margin-bottom: ${e=>Io(No(Yg(e).padding,{}))};
  margin-top: calc(
    -1 * ${e=>Io(No(Yg(e).padding,{}))}
  );
  padding: ${e=>No(Yg(e).padding,{vertical:"0"})};
`,iA=h(Yo)`
  height: ${e=>Yg(e).buttonHeight};
  margin-top: auto;
  width: 100%;

  /* stylelint-disable-next-line selector-max-universal */
  & > * {
    height: ${e=>Yg(e).buttonHeight};
    width: 50%;
  }
`,nA=h("div")`
  ${e=>e.isVisible&&`background: ${e.theme.colors.backgrounds.overlay};`}
  ${e=>!e.isVisible&&"background: transparent;"}

  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9998;
  overscroll-behavior: none;
  transition: background 0.25s ease-out;
`,rA=h.ul`
  /* stylelint-disable-next-line */
  li:last-child {
    border-bottom: none;
  }
`,aA=h.div`
  display: flex;
  justify-content: center;

  .spinner {
    margin-left: 10px;
  }

  .button-cart {
    height: 48px !important;
    max-width: -webkit-fill-available;
    width: -webkit-fill-available;
  }
`,lA=h.div`
  display: flex;
  justify-content: center;

  .spinner {
    margin-left: 10px;
  }

  .button-cart {
    height: 48px !important;
    max-width: -webkit-fill-available;
    width: -webkit-fill-available;
  }

  .bx--btn--primary:hover {
    border-color: ${f.color01Dark};
    box-shadow: none;
    color: ${f.color01Dark};
  }

  .bx--btn--primary:focus {
    border-color: ${f.color01Dark};
    box-shadow: none;
  }
`,dA=h("div")`
  font-size: 20px;
  padding: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
`,sA=h("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fffb;
`,cA=h("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fd;
`,pA=h("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -40%;
  left: 47%;
  transform: translate(-50%, -50%);
`,mA=h("div")`
  font-weight: bold;
  font-size: 18px;
  padding: 0.4rem;
  margin-bottom: 2rem;

  text-align: center;
`,uA=h("div")`
  flex-wrap: wrap;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: max-content;

  .button-cart {
    min-width: 16.5rem !important;
    height: 48px !important;
  }
`,hA=h.div`
  display: flex;
  margin: 16px;
`,gA=h("div")`
  flex-direction: column;
  padding: 2rem;
`;h("div")`
  display: flex;
  justify-content: space-between;
  font-size: 20px;
`,h("div")`
  display: flex;
  justify-content: space-between;
  /* color: {agroTheme.ui05}; UNIFICAR CORES*/
  margin-bottom: 16px;
`,h("div")`
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  margin-bottom: 16px;
`,h("div")`
  display: flex;
  justify-content: space-between;
  /* color: {agroTheme.ui05}; UNIFICAR CORES */
`;const AA=h("div")`
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  @media (min-width: 320px) and (max-width: 671px) {
    font-size: 15px;
    justify-content: space-between;
  }
`,fA=h.div`
  display: flex;
  justify-content: space-between;
  /* color: {agroTheme.ui05}; UNIFICAR CORES*/
  margin-bottom: 16px;
  color: ${({isDisabled:e})=>e?`${f.color09}`:`${f.color04}`};
`,vA=h("div")`
  display: flex;
  margin-top: 1rem;
  justify-content: space-between;
  margin-bottom: 1.5rem;
`,xA=h("div")`
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  color: ${f.color04};
  font-weight: bold;
  margin-bottom: 20px;
  @media (min-width: 320px) and (max-width: 671px) {
    font-size: 15px;
    justify-content: space-between;
    font-weight: bold;
  }
`;h("button")`
  width: 100%;
  margin-top: 1rem;
  padding: ${e=>e.theme.spacing.inset.M};
  background-color: ${e=>!0===e.isAvailable?f.color08:f.color01};
  color: ${f.color03};
  border: none;
  border-radius: 30px;
  font-weight: ${f.fontWeight02};
  justify-content: center;
  align-items: center;
  :hover {
    cursor: pointer;
    background-color: ${e=>!0===e.isAvailable?f.color08:f.color01Dark};
    color: ${f.color03};
    border: none;
  }
`;const bA=h("button")`
  width: 100%;
  margin-top: 1rem;
  padding: ${e=>e.theme.spacing.inset.M};
  background-color: ${f.color03};
  border: none;
  color: ${f.color01};
  :hover {
    cursor: pointer;
    background-color: ${f.color03};
    color: ${f.color01Dark};
  }
  font-weight: ${f.fontWeight02};
  justify-content: center;
  align-items: center;
`,wA=h.hr`
  margin-bottom: 1rem;
  background-color: ${f.color04};
`;var yA=e=>{var t,o,i,n;return Object.assign(Object.assign({border:e.theme.colors.delimiters.lowContrast,descriptionColor:e.theme.colors.text.secondary,propertyColor:e.theme.colors.text.secondary,priceColor:e.theme.colors.text.tertiary},null===(o=null===(t=e.theme)||void 0===t?void 0:t.cart)||void 0===o?void 0:o.cartItem),null===(n=null===(i=e.theme)||void 0===i?void 0:i.byComponent)||void 0===n?void 0:n.cart_ui_cartItem)};const CA=h("li")`
  border-top: solid 0.03rem ${e=>yA(e).border};
  display: flex;
  flex-direction: column;
  padding: 2rem 1rem 1rem 0;
  .justify-select {
    justify-content: flex-start !important;
    width: 120px;
  }
`,EA=h("div")`
  display: flex;
  flex-direction: row;
`,BA=h("div")`
  display: none;
  flex-direction: column;
  margin: 0 1rem 0 0;

  ${e=>Bo.greaterThan(e,"small").then(g`
      display: flex;
      margin-left: 1rem;
    `)}
`,kA=h("div")`
  display: flex !important;
  justify-content: flex-start !important;
  align-items: center !important;
  .cart-error__text {
    color: ${f.colorError};
    font-size: 13px;
    font-weight: 400;
    width: 150px;
  }

  .stock-quantity__text {
    color: ${f.color08};
    font-size: 13px;
    font-weight: 400;
    width: 175px;
  }
  .spinner {
    margin-top: 1.5rem;
    margin-left: 1.3rem;
  }
`,IA=h("div")`
  align-items: center;
  border: solid 0.0625rem ${e=>yA(e).border};
  border-radius: 0.3rem;
  display: flex;
  justify-content: center;
  overflow: hidden;
  width: 75px;
  height: 76px;

  & .thumbnail {
    height: 100%;
    width: auto;
  }

  ${e=>Bo.greaterThan(e,"small").then(g`
      width: 75px;
      height: 76px;
      margin-left: 15px;
    `)}

  ${e=>Bo.greaterThan(e,"medium").then(g`
      width: 75px;
      height: 76px;
      margin-left: 15px;
    `)}

  ${e=>Bo.greaterThan(e,"large").then(g`
      width: 75px;
      height: 76px;
      margin-left: 15px;
    `)}
`,NA=h("div")`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${e=>Bo.greaterThan(e,"small").then(g`
      flex-direction: row;
    `)}
`,SA=h("div")`
  padding: 0.5rem;
  max-width: 320px;
  overflow: hidden;
`,OA=h("div")`
  display: flex;
  flex-direction: row;
`;h("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fffb;
`,h("div")`
  font-weight: bold;
  font-size: 20px;
  padding: 1rem;
`,h("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fd;
`,h("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fffb;
`,h("div")`
  font-weight: bold;
  font-size: 20px;
  padding: 0.4rem;
`,h("div")`
  font-size: 20px;
  padding: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;const PA=h("button")`
  background: none;
  border: none;
  flex-shrink: 0;
  height: 2.5rem;
  outline: none;
  padding: 0 0.25rem;
  transition: outline 200ms ease-out;
  width: 2.5rem;
  margin-top: 1.5rem;
  &:hover {
    outline: none;
    cursor: pointer;
  }

  & .icon {
    color: ${e=>e.theme.colors.icon.primary};
    transform: scale(0.75);
  }
`,QA=h("div")`
  flex-grow: 1;
`,zA=h("div")`
  margin-bottom: 10px;
  padding: 2px 6px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 19px;
  text-align: center;
  font: normal normal 600 12px/16px Bradesco Sans;
  letter-spacing: 0;
  color: ${f.color03};
  opacity: 1;
  z-index: 9;
  background: ${f.color20} 0% 0% no-repeat padding-box;
  border-radius: 4px;
`,MA=h("div")`
  color: #034e88;
  font-weight: bold;
  font-size: 14px;
`;h("div")`
  display: flex;
  align-items: center;
  font-size: 14px;
  justify-content: left;
  margin-top: 0.5rem;
  svg {
    width: 18px;
    margin-right: 0.5rem;
    color: #0d881d;
  }
`;const DA=h("div")`
  color: ${e=>{var t;return null===(t=yA(e))||void 0===t?void 0:t.descriptionColor}};
  font-size: 15px;
  opacity: 1;
  margin-top: 15px;
  margin-bottom: 15px;
`,jA=h("div")`
  display: flex;
  margin-top: 1rem;

  & .column-alt {
    display: flex;

    ${e=>Bo.greaterThan(e,"small").then(g`
        display: none;
      `)}
  }
`,TA=h("div")`
  display: flex;
  flex: 1;
  flex-direction: column;
`,RA=h("div")`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(6.5rem, 1fr));
`,LA=h("h3")`
  color: ${e=>yA(e).propertyColor};
  ${e=>So(e.theme.typography.body.short.S)};
  letter-spacing: 0.05rem;
  vertical-align: baseline;
`,UA=h("div")`
  padding-top: 0.5rem;
`,qA=h("div")`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`,WA=h("span")`
  color: #034e88;
  font-size: 20px;
  font-weight: bold;
  align-items: center;
  justify-content: flex-end;
`,GA=h("span")`
  color: ${e=>yA(e).priceColor};
  ${e=>So(e.theme.typography.body.short.M)};

  & .price-list {
    display: inline;
    margin-right: 0.25rem;
  }

  & .price-offer {
    display: inline;
  }
`,HA=h("div")`
  display: flex;
  width: 100%;

  flex-direction: row;
`,FA=h("div")`
  display: flex;
  align-items: center;
  justify-content: left;
  margin-top: 0.5rem;
  svg {
    width: 18px;
    margin-right: 0.5rem;
    color: ${f.colorError};
  }
`;h("button")`
  background: none;
  border: none;
  flex-shrink: 0;
  height: 2.5rem;
  outline: none;
  padding: 0 0.25rem;
  transition: outline 200ms ease-out;
  width: 2.5rem;
  &:hover {
    outline: none;
    cursor: pointer;
  }
  svg {
    width: 18px;
  }
`;const VA=h.div`
  margin: 1rem 1.1rem 0rem 2rem;
`,KA=h.p`
  font-size: 13px;
  font-weight: 600;
  margin-top: 5px;
  color: ${f.colorError};
  text-wrap: balance;
`,JA=h.p`
  font-size: 13px;
  font-weight: 400;
  margin-top: 5px;
  color: ${f.color10};
  text-wrap: balance;
`,YA=h.div`
  display: flex;
  align-items: center;
  justify-content: left;
  margin-top: 0.5rem;
  color: ${f.color09};
  font-size: ${f.fontSize01};

  svg {
    width: 14px;
    height: 14px;
    margin-right: 0.5rem;
    color: ${({isAvailable:e})=>e?`${f.color01}`:`${f.colorError}`};
  }
`,ZA=h.div`
  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
  .product-qtd {
    align-items: center;
    flex-direction: column;
  }
  .product-qtd__flex {
    display: flex;
    margin-top: 0.4rem;
    align-items: center;
    justify-content: flex-start;
    margin-left: -0.3rem;
    @media (max-width: 365px) {
      justify-content: flex-start;
      flex-wrap: wrap;
      font-size: 14px;
      justify-content: flex-start;
    }
  }
  .product-qtd__label {
    margin-bottom: 8px;
    font-weight: 400;
    font-size: 14px;
    margin-right: 0.3rem;
  }

  .product-qtd__btn {
    display: inline-block;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    margin: 0.3rem;
    background-color: #f5f5f5;
    border: none;
    color: ${f.color04};
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    @media (max-width: 410px) {
      width: 24px;
      height: 24px;
    }
  }

  .product-qtd__btn:hover {
    background-color: #dcdcdc;
  }

  .product-qtd__btn:active {
    transform: scale(0.9);
  }

  .product-qtd__btn:disabled {
    opacity: 0.5;
    border: none;
    cursor: not-allowed;
  }

  .product-qtd__input {
    height: 30px;
    width: 120px;
    border: 1px solid ${f.color08};
    border-radius: 8px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    outline: none;
    font-family: 'Bradesco Sans', 'IBM Plex Sans', 'Helvetica Neue', Arial,
      sans-serif;
    @media (max-width: 410px) {
      width: 45px;
    }
  }

  .cart-error__text {
    color: ${f.colorError};
    font-size: 13px;
    font-weight: 400;
  }

  .stock-quantity__text {
    color: ${f.color08};
    font-size: 13px;
    font-weight: 400;
  }

  .product-delete__btn {
    align-items: center !important;
    display: flex;
    justify-content: center;
    .spinner {
      margin-left: 0.5rem;
    }
  }
`,XA=h.div`
  display: flex;
  width: auto;
  align-items: center;
  margin-left: 1rem;
  font-size: 14px;
  svg {
    width: 18px;
    margin-right: 0.5rem;
    color: #f12;
  }
  @media (max-width: 450px) {
    margin-left: 0;
    margin-top: 0;
  }
`,_A=h.div`
  display: flex;
  width: auto;
  align-items: center;
  margin-left: 1rem;
  font-size: 14px;
  svg {
    width: 18px;
    margin-right: 0.5rem;
    color: #0d881d;
  }
  @media (max-width: 410px) {
    margin-left: 0;
  }
`,$A=h("button")`
  background: none;
  border: none;
  flex-shrink: 0;
  height: 2.5rem;
  outline: none;
  padding: 0 0.25rem;
  transition: outline 200ms ease-out;
  width: 2.5rem;
  &:hover {
    outline: none;
    cursor: pointer;
  }
  & .icon {
    color: ${e=>e.theme.colors.icon.primary};
    transform: scale(0.75);
  }
`,ef=n.forwardRef((({label:o,value:i,disponibility:n,quantities:l,onStateChange:d,onBlur:c,itemId:p,isReadOnly:m,onChange:u,onClick:h,className:g,update:A=()=>{},deleteButton:f,disabled:v,errorMsg:x,hasStock:b,handleClickTagueamento:w,minValue:y},C)=>{const E=s(null),[B,k]=r(i||0);a((()=>{null!=i&&i!==B&&k(i)}),[i]);return e(ZA,{className:g,children:t("div",{className:"product-qtd",children:[t("span",{className:"product-qtd__label",children:[o,":"]}),t("div",{className:"product-qtd__flex",children:[e("button",{className:"product-qtd__btn decrease","aria-label":"diminuir a quantidade",onClick:()=>{const e=B-1;k(e),u&&u(e),h&&h(e),d&&d(e),w&&w(1,"deleted")},disabled:isNaN(B)||B<=(y||1)||v,type:"button",children:e(yr,{})}),e("input",{ref:C||E,className:"product-qtd__input",type:"number",onBlur:e=>{const t=parseInt(e.target.value)||0;y&&t<y||(k(t),c&&c(t),i!==Number(e.target.value)&&A(p,t),w&&t>i?w&&w(t-i,"add"):w&&w(i-t,"delete"))},value:B,disabled:v,"aria-label":"quantidade do produto",onChange:e=>{const t=parseInt(e.target.value);k(t),u&&u(t),h&&h(t)}}),e("button",{className:"product-qtd__btn increase","aria-label":"aumentar a quantidade",onClick:()=>{const e=B+1;k(e),u&&u(e),h&&h(e),d&&d(e),w&&w(1,"add")},disabled:B>=l||v,type:"button",children:e(_n,{})}),e("div",{className:"product-delete__btn",children:f&&!m&&(v?e(Vt,{small:!0,withOverlay:!1}):e($A,{onClick:()=>Yl(void 0,void 0,void 0,(function*(){return A(p,0)})),"data-testid":"cart-CartItem-Delete",type:"button",name:"Delete Item","aria-label":"Delete Item",children:e(Er,{className:"icon"})}))}),n&&e("div",{className:"hasStock",children:b?t(XA,{children:[e(hr,{})," Sem estoque"]}):t(_A,{children:[e(ar,{})," Em estoque"]})})]}),e("div",{className:"cart-error__text",children:x})]})})})),tf=e=>{var t;if(null===(t=null===window||void 0===window?void 0:window.gtm)||void 0===t?void 0:t.utmCampaign){const t=e.split(","),o={};return t.forEach((e=>{const t=e.split("="),i=t[0],n=t.slice(1).join("=");if("utm_content"===i){n.split(",").forEach((e=>{const t=e.split("="),i=t[0],n=t[1];o[i]=n}))}else o[i]=n})),o}},of=({listProductsAvailability:i,item:n,quantities:l,isReadOnly:d=!1,hasStock:s,onStateChange:c,onSave:p,onEdit:m,tagueamentoProductData:u,onUpdate:h=()=>{},showOfferErrorQuantity:g})=>{var A,f,v,x,b,w,y,C,E,B,k,I,N;const[S,O]=r(!1),[P,Q]=r(!1),[z,M]=r(!1),[D,j]=r(0),[T]=r(null==i?void 0:i.find((e=>(null==e?void 0:e.offerId)===(null==n?void 0:n.offer_id)))),R=qt(),{itemCreditUser:L}=si(),[U,q]=r(),W=Co(),G=null===(b=null===(x=null===(v=null===(f=null===(A=null==n?void 0:n.mp_info)||void 0===A?void 0:A.offers)||void 0===f?void 0:f.find((e=>(null==e?void 0:e.offer_id)===(null==n?void 0:n.offer_id))))||void 0===v?void 0:v.shop)||void 0===x?void 0:x.additional_info)||void 0===b?void 0:b.json_string,H=G&&(null===(w=JSON.parse(G))||void 0===w?void 0:w.additional_field_values),F="true"===(null===(C=null===(y=null==H?void 0:H.find((e=>{var t;return"cpr-outras-garantias"===(null===(t=null==e?void 0:e.code)||void 0===t?void 0:t.toLocaleLowerCase())})))||void 0===y?void 0:y.value)||void 0===C?void 0:C.toLocaleLowerCase()),V="true"===(null===(B=null===(E=null==H?void 0:H.find((e=>{var t;return"cpr-avalista"===(null===(t=null==e?void 0:e.code)||void 0===t?void 0:t.toLocaleLowerCase())})))||void 0===E?void 0:E.value)||void 0===B?void 0:B.toLocaleLowerCase()),K=(null===(I=null===(k=null==L?void 0:L.cprData)||void 0===k?void 0:k.creditStoreName)||void 0===I?void 0:I.toLocaleLowerCase())===(null===(N=null==n?void 0:n.shop_name)||void 0===N?void 0:N.toLocaleLowerCase()),J=null==L?void 0:L.cprData,Y=(null==n?void 0:n.cpr_available)&&(F||V)&&((null==R?void 0:R.username)&&(null==J?void 0:J.hasCredit)&&!(null==J?void 0:J.correntista)&&K&&"L"===(null==J?void 0:J.creditType)&&V||(null==R?void 0:R.username)&&(null==J?void 0:J.hasCredit)&&(null==J?void 0:J.correntista)&&!(null==J?void 0:J.creditStoreName)&&"B"===(null==J?void 0:J.creditType)&&F||!(null==J?void 0:J.hasCredit)&&!(null==J?void 0:J.correntista)&&!(null==J?void 0:J.creditStoreName)&&F&&!(null==J?void 0:J.creditType));function Z(e,t){isNaN(e)||(setTimeout((()=>{Je.tagecommerce({event:"add"===t?tt.AddToCard:tt.RemoveCart,items:[{item_id:null==U?void 0:U.item_id,item_name:null==U?void 0:U.item_name,affiliation:null==U?void 0:U.affiliation,currency:"BRL",item_brand:null==U?void 0:U.item_brand,item_category:null==U?void 0:U.item_category,price:null==U?void 0:U.price,quantity:0===e?null==n?void 0:n.quantity:e}]})}),100),Je.interact(Ye.Click,"botao","add"===t?"add-to-cart":"delete-item-cart","produtos",Je.getUserStatus(R),`e-agro${null==W?void 0:W.pathname}`,null,{userId:Je.getUserId(R)}))}a((()=>{const e=u&&(null==u?void 0:u.find((e=>e.item_id===(null==n?void 0:n.partnumber))));q(e)}),[u]),a((()=>{var e,t;const o=null===(e=null==n?void 0:n.mp_info)||void 0===e?void 0:e.offers;o&&j((null===(t=o.find((e=>(null==e?void 0:e.offer_id)===(null==n?void 0:n.offer_id))))||void 0===t?void 0:t.min_order_quantity)||0)}),[n]),a((()=>{M(n.quantity<D)}),[n.quantity,D]),a((()=>{if(g&&""!==g){const e=document.getElementById(g||"");e&&e.scrollIntoView({behavior:"smooth"})}}),[g]);const X=(e,t)=>Yl(void 0,void 0,void 0,(function*(){O(!0),Q(!1),M(t<D);try{yield h(e,t),Q(!1),c(!1),0===t&&Z(0,"delete")}catch(e){Q(!0),c(!0),O(!1)}}));const _=()=>{let e="";return Y?e="Pague com CPR":(null==n?void 0:n.grande_desconto)?e="Grande desconto":(null==n?void 0:n.entrega_expressa)&&(e="Entrega rápida"),e};return t(CA,{id:(null==n?void 0:n.partnumber)||"",children:[t(EA,{children:[t(BA,{children:[e(IA,{children:e("img",{className:"thumbnail",src:Bi(n.thumbnail),alt:n.name})}),t(NA,{children:[p&&e(Zo,{variant:"link",onClick:p,label:"Save for Later"}),m&&e(Zo,{variant:"link",onClick:m,label:"Edit"})]})]}),t(SA,{children:[e(OA,{children:t(QA,{children:[""!==_()&&e(zA,{children:_()}),e(MA,{children:null==n?void 0:n.name}),t(DA,{children:["Ref: ",null==n?void 0:n.partnumber]})]})}),s?t(o,{children:[e(qA,{children:(null==n?void 0:n.price)&&e(WA,{children:e(yi,{mp_info:null==n?void 0:n.mp_info,value:null==n?void 0:n.price,offerId:null==n?void 0:n.offer_id,currency:"BRL"})})}),t(jA,{children:[t(BA,{className:"column-alt",children:[e(IA,{children:e("img",{src:Bi(null==n?void 0:n.thumbnail),alt:null==n?void 0:n.name})}),t(NA,{children:[p&&e(Zo,{variant:"link",onClick:p,label:"Save for Later"}),m&&e(Zo,{variant:"link",onClick:m,label:"Edit"})]})]}),t(TA,{children:[t(kA,{children:[d?t("div",{children:[e(LA,{children:"Quantidade"}),e(UA,{children:n.quantity})]}):e(ef,{hasStock:!0,disponibility:!1,update:X,onStateChange:function(e){c(e),O(!0),X(null==n?void 0:n.id,e)},handleClickTagueamento:Z,deleteButton:!0,itemId:null==n?void 0:n.id,label:"Quantidade",disabled:S,value:null==n?void 0:n.quantity,quantities:l,isReadOnly:d,minValue:D,errorMsg:t("div",{className:""+(P?"cart-error__text":"stock-quantity__text"),children:["Estoque disponível: ",l," unidades"]})}),!d&&e(PA,{onClick:()=>Yl(void 0,void 0,void 0,(function*(){X(n.id,0)})),"data-testid":"cart-CartItem-Delete",type:"button",name:"Delete Item","aria-label":"Delete Item"})]}),z?e(KA,{children:`A quantidade mínima para compra deste produto é de ${D} ${1===D?"unidade":"unidades"}.`}):D>0?e(JA,{children:`Compre este produto a partir de ${D} ${1===D?"unidade":"unidades"}.`}):null]})]})]}):t(HA,{children:[e("div",{children:t(FA,{children:[e(kr,{})," Indisponível em estoque"]})}),e("div",{children:!d&&(S?e(Vt,{small:!0,withOverlay:!1,className:"spinner"}):e(PA,{onClick:()=>Yl(void 0,void 0,void 0,(function*(){X(n.id,0)})),"data-testid":"cart-CartItem-Delete",type:"button",name:"Delete Item","aria-label":"Delete Item",children:e(Er,{className:"icon"})}))})]}),T&&e(YA,{isAvailable:T.isAvailable,children:T.isAvailable?t(o,{children:[e(ar,{})," Em estoque"]}):t(o,{children:[e(vr,{})," Indisponível na sua região"]})})]})]}),n.precisa_de_receita&&e(VA,{children:e($l,{status:"warning",title:"Este produto requer receita agronômica.",description:"Por favor, anexe o arquivo após a finalização do pedido."})})]})};of.Skeleton=()=>t(EA,{children:[t(BA,{children:[e(IA,{children:e("img",{className:"thumbnail",src:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP88B8AAuUB8e2ujYwAAAAASUVORK5CYII="})}),e(NA,{})]}),t(SA,{children:[e(OA,{children:t(QA,{children:[e(MA,{children:e(Ci,{})}),e(DA,{children:e(Ci,{})})]})}),t(jA,{children:[t(BA,{className:"column-alt",children:[e(IA,{children:e("img",{className:"thumbnail",src:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP88B8AAuUB8e2ujYwAAAAASUVORK5CYII="})}),e(NA,{})]}),t(TA,{children:[e(RA,{}),t(RA,{children:[e(Ci,{}),t(qA,{children:[e(GA,{children:e(Ci,{})}),e(WA,{children:e(Ci,{})})]})]})]})]})]})]});var nf=e=>{var t,o,i,n;return Object.assign(Object.assign({iconColor:"unset",countBg:e.theme.colors.brand.brand1.base,countFg:e.theme.colors.brand.brand1.contrast},null===(o=null===(t=e.theme)||void 0===t?void 0:t.byComponent)||void 0===o?void 0:o.cart_ui_miniCart),null===(n=null===(i=e.theme)||void 0===i?void 0:i.commerce)||void 0===n?void 0:n.miniCart)};const rf="0.8rem";h("div")`
  align-items: center;
  color: ${e=>nf(e).iconColor};
  display: flex;
  height: 100%;
  justify-content: center;
  padding: 0.75rem;
  position: relative;
  width: 3rem;
`;const af=h("div")`
  font-size: 20px;
  padding: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;

  .title {
    font-weight: bold;
  }
`;h("span")`
  background-color: red;
  border-radius: calc(${rf} * 0.5);
  color: red;
  font-size: calc(${rf} * 0.8);
  font-weight: 700;
  height: ${rf};
  left: calc(0.675rem + 50%);
  line-height: calc(${rf} * 1.1);
  min-width: ${rf};
  padding: 0 0.25rem;
  position: absolute;
  top: 0.5rem;
  transform: translateX(-50%);
`,h(br)`
  color: ${e=>nf(e).iconColor};
  height: 100%;
  width: 100%;
`;const lf=({count:i=0})=>{const n=ki("features.cart.cart-ui.components");return e(o,{children:t(af,{className:"hover-header","aria-label":"Cart Link",children:[i>0?t("span",{className:"title",children:["Seu carrinho (",i," ",e("span",i>1?{children:"itens"}:{children:"item"}),")"]}):e("span",{className:"title",children:" Seu carrinho (0 item)"}),e("span",{className:"sr",children:n.msg("MiniCart.Title","Cart")})]})})},df=h.div`
  display: flex;
  flex-direction: column;
  background-color: ${f.bg14};
  padding: 16px;
  gap: 16px;
  width: -webkit-fill-available;
  border-radius: 8px;
`,sf=h.p`
  font-size: ${f.fontSize02};
  font-weight: ${f.fontWeight03};
  line-height: ${f.lineHeight01};
  color: ${f.color04};
`,cf=h.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .zipcode-field {
    background-color: ${f.bg03};
  }

  .zipcode-field ._InputBase_Input_Text {
    font-size: ${f.fontSize01};
  }

  .zipcode-field ._InputBase_Helper_Text {
    background-color: ${f.bg14};
  }

  @media (max-width: 364px) {
    .zipcode-field {
      max-width: 160px;
    }
  }
`,pf=h.button`
  display: flex;
  flex-direction: row;
  margin-left: 16px;
  height: 40px;
  width: 103px;
  padding: 11px 17px;
  word-wrap: nowrap;
  font-size: ${f.fontSize01};
  font-weight: ${f.fontWeight03};
  border: 2px solid ${f.color01};
  color: ${f.color01};
  border-radius: 25px;
  min-height: 40px;
  text-align: center;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:disabled {
    border: 2px solid ${f.color08};
    cursor: default;
    color: ${f.color08};
  }

  @media (max-width: 320px) {
    margin-left: 8px;
    max-width: 88px;
  }
`,mf=h.div`
  margin-right: 8px;
`,uf=h.p`
  font-size: ${f.fontSize01};
  font-weight: ${f.fontWeight04};
  line-height: ${f.lineHeight01};
  color: ${({status:e})=>e===hf.Error?`${f.colorError}`:"#067316"};
`;var hf;!function(e){e[e.Error=0]="Error",e[e.Success=1]="Success"}(hf||(hf={}));const gf=[{name:"Acre",sigla:"AC"},{name:"Alagoas",sigla:"AL"},{name:"Amapá",sigla:"AP"},{name:"Amazonas",sigla:"AM"},{name:"Bahia",sigla:"BA"},{name:"Ceará",sigla:"CE"},{name:"Distrito Federal",sigla:"DF"},{name:"Espírito Santo",sigla:"ES"},{name:"Goiás",sigla:"GO"},{name:"Maranhão",sigla:"MA"},{name:"Mato Grosso",sigla:"MT"},{name:"Mato Grosso do Sul",sigla:"MS"},{name:"Minas Gerais",sigla:"MG"},{name:"Pará",sigla:"PA"},{name:"Paraíba",sigla:"PB"},{name:"Paraná",sigla:"PR"},{name:"Pernambuco",sigla:"PE"},{name:"Piauí",sigla:"PI"},{name:"Rio de Janeiro",sigla:"RJ"},{name:"Rio Grande do Norte",sigla:"RN"},{name:"Rio Grande do Sul",sigla:"RS"},{name:"Rondônia",sigla:"RO"},{name:"Roraima",sigla:"RR"},{name:"Santa Catarina",sigla:"SC"},{name:"São Paulo",sigla:"SP"},{name:"Sergipe",sigla:"SE"},{name:"Tocantins",sigla:"TO"}],Af=({cartData:o,isLoadingProductAvailability:i,checkAvailability:n,onCheckAvailability:l})=>{const[d,s]=r(""),[c,p]=r(),[m,u]=r(!1),h=qt(),{fetchAddressByZipcode:g}=Et(),{cartSetShippingInfo:A}=Bt(),f=()=>Yl(void 0,void 0,void 0,(function*(){var e,t,o,i,n,r,a,l,s,c,m,f,x,b,w,y;u(!0),p(void 0);try{const u=yield g({variables:{input:{cep:d.replace(/\D/g,"")}}});if(null===(t=null===(e=u.data)||void 0===e?void 0:e.getAddressByZipcode)||void 0===t?void 0:t.cep){const e=u.data.getAddressByZipcode,t=null===(o=gf.find((t=>t.sigla===e.siglaEstado)))||void 0===o?void 0:o.name,g={address1:e.logradouro,address2:"",city:e.municipio,firstName:(null===(r=null===(n=null===(i=null==h?void 0:h.user)||void 0===i?void 0:i.name)||void 0===n?void 0:n.split(" "))||void 0===r?void 0:r[0])||"fake",lastName:(null===(s=null===(l=null===(a=null==h?void 0:h.user)||void 0===a?void 0:a.name)||void 0===l?void 0:l.split(" "))||void 0===s?void 0:s[1])?null===(f=null===(m=null===(c=null==h?void 0:h.user)||void 0===c?void 0:c.name)||void 0===m?void 0:m.split(" "))||void 0===f?void 0:f[1]:(null===(w=null===(b=null===(x=null==h?void 0:h.user)||void 0===x?void 0:x.name)||void 0===b?void 0:b.split(" "))||void 0===w?void 0:w[0])||"name",phone:null===(y=null==h?void 0:h.user)||void 0===y?void 0:y.cellphone,zip:d,province:t,email:h.username||"",type_address:1,countryName:"Brazil",neighborhood_address:e.bairro,additional_shipping_info:"",recieve_shipping_phone:"",recieve_shipping_name:"",recieve_shipping:!1,number_address:"",name_address:"",cnpj:"",inscricao_estadual:"",default_billing:!1,default_shipping:!1};try{yield A(null==h?void 0:h.cartId,g);const e=v();p({message:e?"Todos os itens estão disponíveis na sua região!":"Alguns itens não estão disponíveis. Remova-os para continuar a compra.",type:e?hf.Success:hf.Error})}catch(e){p({message:"Não foi possível definir o endereço como forma de entrega",type:hf.Error})}}else p({message:"CEP Inválido",type:hf.Error})}catch(e){p({message:"Não foi possível buscar as informações do CEP",type:hf.Error})}finally{u(!1)}})),v=()=>{var e,t;const i=[],n=null===(e=null==o?void 0:o.mp_info)||void 0===e?void 0:e.orders;null===(t=null==o?void 0:o.lineItems)||void 0===t||t.forEach((e=>{var t;const o=null==n?void 0:n.find((t=>{var o;return null===(o=null==t?void 0:t.offers)||void 0===o?void 0:o.find((t=>{var o,i,n;return(null===(o=null==t?void 0:t.id)||void 0===o?void 0:o.toString())===(null===(n=null===(i=null==e?void 0:e.mp_info)||void 0===i?void 0:i.offer_id)||void 0===n?void 0:n.toString())}))}));i.push({offerId:null===(t=null==e?void 0:e.mp_info)||void 0===t?void 0:t.offer_id,isAvailable:void 0!==o})}));const r=-1===(null==i?void 0:i.findIndex((e=>!(null==e?void 0:e.isAvailable))));return l(i,r),r};return a((()=>{u(i)}),[i]),t(df,{children:[e(sf,{children:"Verifique a disponibilidade dos produtos"}),t(cf,{children:[e(Xs,{className:"zipcode-field",value:d,mask:$s,type:"text",inputMode:"numeric",onChange:e=>{s(e),p(void 0)},placeholder:"Informe seu CEP",onKeyDown:e=>"Enter"===(null==e?void 0:e.key)&&f()}),t(pf,{"aria-label":"Calcular",onClick:()=>f(),disabled:8!=(null==d?void 0:d.length)||m,children:[m&&e(mf,{children:e(Vt,{withOverlay:!1,small:!0})}),"Calcular"]})]}),c&&e(uf,{status:null==c?void 0:c.type,children:null==c?void 0:c.message})]})};function ff({listProductsAvailability:i,products:r,leadTimeIndex:a,shopIndex:l,control:d,isReadOnly:s,onItemUpdate:c,tagueamentoProductData:p,showOfferErrorQuantity:m}){function u(e){return e}return e(o,{children:null==r?void 0:r.map(((r,h)=>t(n.Fragment,{children:[e(Si,{name:`shop.${l}.leadtime_group.${a}.products.${h}.offer_id`,control:d,render:()=>e(o,{})}),e(of,{tagueamentoProductData:p,onStateChange:u,item:r,onUpdate:c,isReadOnly:s,hasStock:!!r.availableQuantity,quantities:r.availableQuantity,showOfferErrorQuantity:m,listProductsAvailability:i},r.partnumber)]},h)))})}function vf({listProductsAvailability:t,leadTimeGroup:i,control:n,index:r,isReadOnly:a,setValue:l,onItemUpdate:d,tagueamentoProductData:s,showOfferErrorQuantity:c}){const{fields:p}=Ni({control:n,name:`shop.${r}.leadtime_group`});return e(rA,{children:null==p?void 0:p.map(((l,p)=>{var m;return e(o,{children:e(ff,{control:n,tagueamentoProductData:s,onItemUpdate:d,leadTimeIndex:p,shopIndex:r,isReadOnly:a,products:null===(m=i[p])||void 0===m?void 0:m.products,showOfferErrorQuantity:c,listProductsAvailability:t})})}))})}let xf=!1;const bf=({cart:i,onItemUpdate:l=()=>{},setOpenModal:d=()=>!1,setLoginModalPage:s,isOpen:c,isReadOnly:p=!1,tagueamentoProductData:m,loading:u})=>{var h,g,A,f;const v=wo(),[x,b]=r(void 0),[w,y]=r(i),[C,E]=r(!1),[B,k]=r(!1),[I,N]=r(""),[S,O]=r([]),[P,Q]=r(!1),z=qt(),{setCartSideMenu:M}=ci(),{context:D}=di(),j=kt(),{setShipping:T,loading:R}=Pi();null==D||D.state;const{initiateCheckout:L}=pi();a((()=>{E(u)}),[u]);let U=[];null===(h=null==x?void 0:x.shop)||void 0===h||h.map((e=>{var t;U=(null===(t=null==e?void 0:e.leadtime_group)||void 0===t?void 0:t.map((e=>{var t;return 0===(null===(t=null==e?void 0:e.shipping_types)||void 0===t?void 0:t.length)})))||[]}));const q=null==U?void 0:U.includes(!0),{control:W,watch:G,reset:H,setValue:F,handleSubmit:V}=Ii(),{setCartFields:K,cart:J}=mi(),{fields:Y}=Ni({control:W,name:"shop"}),Z=It(),{refetch:X}=Z,_=()=>Yl(void 0,void 0,void 0,(function*(){return new Promise(((e,t)=>{var o;let i="";null===(o=X({id:z.cartId}).then((t=>{var o,n,r,a,l,d,s,c,p;if(t){y(null===(r=null===(n=null===(o=null==t?void 0:t.data)||void 0===o?void 0:o.me)||void 0===n?void 0:n.carts)||void 0===r?void 0:r[0]);const m=[];return null===(p=null===(c=null===(s=null===(d=null===(l=null===(a=null==t?void 0:t.data)||void 0===a?void 0:a.me)||void 0===l?void 0:l.carts)||void 0===d?void 0:d[0])||void 0===s?void 0:s.mp_info)||void 0===c?void 0:c.orders)||void 0===p||p.forEach((e=>{var o;null===(o=null==e?void 0:e.offers)||void 0===o||o.forEach((e=>{var o,n,r,a;m.push(e),null===(a=null===(r=null===(n=null===(o=null==t?void 0:t.data)||void 0===o?void 0:o.me)||void 0===n?void 0:n.carts)||void 0===r?void 0:r[0])||void 0===a||a.lineItems.forEach((t=>{var o,n,r;const a=null===(n=null===(o=null==t?void 0:t.product.mp_info)||void 0===o?void 0:o.offers)||void 0===n?void 0:n.find((t=>(null==t?void 0:t.offer_id)===e.id));a&&e.line_quantity<a.min_order_quantity&&(i=null===(r=null==t?void 0:t.product)||void 0===r?void 0:r.partnumber)}))}))})),xf=!m.find((e=>0===e.quantity)),e(i)}})))||void 0===o||o.catch((e=>t(e)))}))})),$=null===(g=null==w?void 0:w.lineItems)||void 0===g?void 0:g.map((e=>{var t;return null!=(null==e?void 0:e.adjustments)||null!=(null==e?void 0:e.adjustments)?null===(t=null==e?void 0:e.adjustments)||void 0===t?void 0:t.map((e=>{var t;return Number(null===(t=null==e?void 0:e.amount)||void 0===t?void 0:t.value)})):0}));let ee=0;for(let e=0;e<(null==$?void 0:$.length);e++)ee+=Number($[e]);const te=null===(A=null==w?void 0:w.lineItems)||void 0===A?void 0:A.map((e=>{var t;return Number(null===(t=null==e?void 0:e.linePrice)||void 0===t?void 0:t.value)})).reduce((function(e,t){return Number(e)+Number(t)}),0),oe=()=>Ze(Number(te)-Number(ee));a((()=>{var e,t,o;xf=!1;const i=[],n=[],r=[],a=[];null===(e=null==w?void 0:w.lineItems)||void 0===e||e.forEach((e=>{var t,o,i,r,a,l,d,s,c,p,m,u,h;n.push({shop_id:null===(t=null==e?void 0:e.mp_info)||void 0===t?void 0:t.shop_id,offer_id:null===(o=null==e?void 0:e.mp_info)||void 0===o?void 0:o.offer_id,shop_name:null===(i=null==e?void 0:e.mp_info)||void 0===i?void 0:i.shop_name,name:null===(r=null==e?void 0:e.product)||void 0===r?void 0:r.name,precisa_de_receita:null===(a=null==e?void 0:e.product)||void 0===a?void 0:a.precisa_de_receita,cpr_available:null===(l=null==e?void 0:e.product)||void 0===l?void 0:l.accepts_cpr_payment,thumbnail:null===(d=null==e?void 0:e.product)||void 0===d?void 0:d.thumbnail,type:null===(s=null==e?void 0:e.product)||void 0===s?void 0:s.type,partnumber:null===(c=null==e?void 0:e.product)||void 0===c?void 0:c.partnumber,description:null===(p=null==e?void 0:e.product)||void 0===p?void 0:p.description,quantity:null==e?void 0:e.quantity,adjustments:null==e?void 0:e.adjustments,mp_info:null===(m=null==e?void 0:e.product)||void 0===m?void 0:m.mp_info,id:null==e?void 0:e.id,price:0,leadtime_to_ship:0,selected_shipping_type:null,shipping_types:[],grande_desconto:null===(u=null==e?void 0:e.product)||void 0===u?void 0:u.grande_desconto,entrega_expressa:null===(h=null==e?void 0:e.product)||void 0===h?void 0:h.entrega_expressa})})),null===(o=null===(t=null==w?void 0:w.mp_info)||void 0===t?void 0:t.orders)||void 0===o||o.forEach((e=>{var t;null===(t=null==e?void 0:e.offers)||void 0===t||t.forEach((t=>{i.push(t),null==n||n.forEach((o=>{(null==t?void 0:t.id)==(null==o?void 0:o.offer_id)&&(o.leadtime_to_ship=null==e?void 0:e.leadtime_to_ship,o.selected_shipping_type=null==e?void 0:e.selected_shipping_type,o.shipping_types=null==e?void 0:e.shipping_types,o.price=null==t?void 0:t.price)}))}))})),null==n||n.forEach((e=>{var t,o,i,n;const a=null==r?void 0:r.filter((t=>t.shop_id==(null==e?void 0:e.shop_id)&&t.leadtime_to_ship==(null==e?void 0:e.leadtime_to_ship)));a.length<1?null==r||r.push({shop_id:null==e?void 0:e.shop_id,shop_name:null==e?void 0:e.shop_name,leadtime_to_ship:null==e?void 0:e.leadtime_to_ship,selected_shipping_type:null==e?void 0:e.selected_shipping_type,shipping_types:null==e?void 0:e.shipping_types,shipping_price:(null===(o=null===(t=null==e?void 0:e.shipping_types)||void 0===t?void 0:t.filter((t=>{var o;return t.code==(null===(o=null==e?void 0:e.selected_shipping_type)||void 0===o?void 0:o.code)}))[0])||void 0===o?void 0:o.total_shipping_price)||0,products:[e]}):null===(n=null===(i=a[0])||void 0===i?void 0:i.products)||void 0===n||n.push(e)})),null==r||r.forEach((e=>{var t,o;const i=null==a?void 0:a.filter((t=>(null==t?void 0:t.shop_id)===(null==e?void 0:e.shop_id)));e.products.map((e=>{var t,o;const i=null===(o=null===(t=null==e?void 0:e.mp_info)||void 0===t?void 0:t.offers)||void 0===o?void 0:o.find((t=>(null==t?void 0:t.offer_id)===(null==e?void 0:e.offer_id)));e.availableQuantity=null==i?void 0:i.quantity,e.price=null==i?void 0:i.price})),i.length<1?null==a||a.push({shop_id:null==e?void 0:e.shop_id,leadtime_group:[e],shop_name:null==e?void 0:e.shop_name}):null===(o=null===(t=i[0])||void 0===t?void 0:t.leadtime_group)||void 0===o||o.push(e)})),xf=!i.find((e=>0===e.quantity));const l={shop:a,grandTotal:null==w?void 0:w.grandTotal,frete:0,desconto:0};b(l),H(l)}),[i,w]),a((()=>{c&&J.cartTotalPrice!==oe()&&K({cartTotalPrice:oe()})}),[c,i,w]),a((()=>{i&&y(i)}),[i]),a((()=>{i&&y(i)}),[R]);return t(o,{children:[e(sA,{children:t(dA,{children:[e(Ee,{}),e(vi,{render:t=>e(lf,Object.assign({},t))})]})}),0===(null===(f=null==x?void 0:x.shop)||void 0===f?void 0:f.length)||void 0===x?t(uA,{children:[e(pA,{children:e(Be,{})}),e(mA,{style:{color:"#000000"},children:e("span",{children:"Seu carrinho está vazio "})}),e(pl,{size:"medium",variant:"primary",label:"Confira as ofertas da sua região",alt:"Confira as ofertas da sua região",title:"Confira as ofertas da sua região",className:"button-cart",onClick:()=>{window.location.href="/loja",M({openSideMenu:!1}),Je.interact(Ye.Click,"botao","Confira as ofertas da sua região","marketplace",Je.getUserStatus(z),`e-agro${null===location||void 0===location?void 0:location.pathname}`,null,{userId:Je.getUserId(z)})}})]}):e(o,{children:t("form",{onSubmit:V((e=>Yl(void 0,void 0,void 0,(function*(){var t;if(e){E(!0);let o="";if(o=yield _(),""!==o)return N(o),void E(!1);const i=JSON.parse(JSON.stringify(e)),n=[];null===(t=null==i?void 0:i.shop)||void 0===t||t.map((e=>{var t;null===(t=null==e?void 0:e.leadtime_group)||void 0===t||t.map((e=>{var t;null===(t=null==e?void 0:e.products)||void 0===t||t.map((t=>{var o;n.push({offer_id:t.offer_id,shipping_type_code:null===(o=null==e?void 0:e.selected_shipping_type)||void 0===o?void 0:o.code}),t.offer_id}))}))})),xf&&(yield T({variables:{cartId:null==z?void 0:z.cartId,shippingMethods:{carrier_code:"freeshipping",method_code:"freeshipping"},mpShippingMethods:n}}).then((()=>{z.username?window.location.href.includes("/checkout")?v.go(0):(L(),v.push("/checkout/checkout-page")):(M({openSideMenu:!1}),s({loginModalAfterRegister:"/checkout/checkout-page",loginModalPage:"/checkout/checkout-page"}),d(!0))}))),E(!1)}})))),children:[Y&&(null==Y?void 0:Y.map(((i,r)=>{var a;return t(n.Fragment,{children:[e(Si,{control:W,name:`shop.${r}.shop_id`,render:()=>e(o,{})}),e(Si,{control:W,name:`shop.${r}.shop_name`,render:()=>e(o,{})}),e(cA,{children:t(dA,{children:[e("div",{style:{marginRight:"1rem"},children:e(ke,{})}),"Vendido por ",i.shop_name]})}),e(vf,{listProductsAvailability:S,tagueamentoProductData:m,leadTimeGroup:null===(a=null==x?void 0:x.shop[r])||void 0===a?void 0:a.leadtime_group,control:W,index:r,onItemUpdate:l,isReadOnly:p,setValue:F,showOfferErrorQuantity:I})]},i.id)}))),e(hA,{children:e(Af,{cartData:w,isLoadingProductAvailability:B,checkAvailability:()=>Yl(void 0,void 0,void 0,(function*(){k(!0),yield _(),k(!1)})),onCheckAvailability:(e,t)=>{O(e),Q(t)}})}),t(gA,{children:[e(wA,{}),t(AA,{children:[e(fA,{children:"Subtotal do pedido"}),e(fA,{children:Ze(Number(te))})]}),t(AA,{children:[e(fA,{children:"Total de descontos"}),t(fA,{children:["- ",Ze(ee)]})]}),t(AA,{children:[e(fA,{children:"Frete"}),e(fA,{isDisabled:!0,children:"a definir"})]}),e(wA,{}),t(vA,{children:[e(xA,{children:"Total do pedido"}),e(xA,{children:oe()})]}),e(Xl,{alt:"Continuar",title:"Continuar",children:e(aA,{children:e(pl,{size:"large",variant:"primary",type:"submit",label:"Continuar para entrega",alt:"Continuar para entrega",title:"Continuar para entrega",className:"button-cart",onClick:()=>{Je.interact(Ye.Click,"botao","Continuar para entrega","checkout",Je.getUserStatus(z),null===location||void 0===location?void 0:location.pathname,null,{userId:Je.getUserId(z)})},disabled:C||q||!xf,children:C&&e(Vt,{small:!0,withOverlay:!1,className:"spinner"})})})}),e(lA,{children:e(pl,{size:"large",variant:"secondary",label:"Continuar comprando",alt:"Continuar comprando",title:"Continuar comprando",className:"button-cart",onClick:()=>{M({openSideMenu:!1}),Je.interact(Ye.Click,"botao","Continuar comprando","marketplace",Je.getUserStatus(z),`e-agro${null===location||void 0===location?void 0:location.pathname}`,null,{userId:Je.getUserId(z)})},disabled:C})}),!z.username&&e(Xl,{alt:"acesse a sua conta",title:"acesse a sua conta",children:e(bA,{type:"button",onClick:()=>{j.redirectLogin(v.location.pathname),Je.interact(Ye.Click,"botao","Acessar sua conta","marketplace",Je.getUserStatus(z),null===location||void 0===location?void 0:location.pathname,null,{userId:Je.getUserId(z)})},children:"Acesse sua conta"})})]})]})})]})};bf.Skeleton=()=>e(rA,{children:e(of.Skeleton,{})});const wf=({children:i,isOpen:n=!1,size:l="m",position:d="left",mode:s="onTop",isClosable:c=!0,onClose:p=()=>{},title:m,hasOverlay:u=!0,isCloseOnOverlayClick:h=!0,isDanger:g=!1,elevation:A,buttons:f=[],className:v})=>{var x,b,w;const{toggleLoginModal:y,setLoginModalPage:C}=di();a((()=>{const e=document.body.style.overflow;return document.body.style.overflow=n&&u?"hidden":"auto",()=>{document.body.style.overflow=e}}),[u,n]);const E=qt(),B=g?"danger":"primary",{hasNewItemAddedToCart:k,cartItems:I,setHasNewItemAddedToCartState:N,setCartItens:S}=ui(),{data:O,loading:P}=xi({cartId:null==E?void 0:E.cartId,skip:!n},bi.fragment),{getTagueamento:Q,data:z}=Nt(),{getTagueamento:M,data:D}=Nt(),[j,T]=r(!1),R=null===(w=null===(b=null===(x=null==O?void 0:O.me)||void 0===x?void 0:x.carts)||void 0===b?void 0:b[0])||void 0===w?void 0:w.lineItems,[L,U]=r(),[q,W]=r(),[G,H]=r([]);function F(e){var t;return Array.isArray(e)&&(null===(t=null==e?void 0:e.map((e=>{var t;return Number(null===(t=null==e?void 0:e.linePrice)||void 0===t?void 0:t.value)})))||void 0===t?void 0:t.reduce((function(e,t){return Number(e)+Number(t)}),0))||0}function V(e,t){var o;return void 0!==e?null===(o=null==e?void 0:e.getTagueamento)||void 0===o?void 0:o.map((e=>{var o;const i=null===(o=null==t?void 0:t.find((t=>{var o;return parseInt(null===(o=null==t?void 0:t.unitPrice)||void 0===o?void 0:o.value)===(null==e?void 0:e.price)&&(null==t?void 0:t.partnumber)===(null==e?void 0:e.id)||(null==t?void 0:t.partnumber)===(null==e?void 0:e.id)})))||void 0===o?void 0:o.quantity;return{item_id:null==e?void 0:e.id,item_name:null==e?void 0:e.name,affiliation:null==e?void 0:e.affiliation,currency:"BRL",item_brand:null==e?void 0:e.brand,item_category:null==e?void 0:e.category,price:null==e?void 0:e.price,quantity:i}})):[]}return a((()=>{U(F(k?I:R))}),[n,k,I,R]),a((()=>{var e;if(k&&(null===(e=null==D?void 0:D.getTagueamento)||void 0===e?void 0:e.length)!==(null==I?void 0:I.length)){const e=[];I&&(null==I||I.map((t=>{var o;null==e||e.push({id:null==t?void 0:t.partnumber,offer:null===(o=null==t?void 0:t.mp_info)||void 0===o?void 0:o.offer_id})}))),(null==e?void 0:e.length)>0&&M({variables:{input:e}})}}),[n,k,I,D]),a((()=>{if(void 0===z&&R){const e=[];null==R||R.map((t=>{var o;null==e||e.push({id:null==t?void 0:t.partnumber,offer:null===(o=null==t?void 0:t.mp_info)||void 0===o?void 0:o.offer_id})})),(null==e?void 0:e.length)>0&&Q({variables:{input:e}})}}),[n,R,z]),a((()=>{var e;void 0!==I&&k&&void 0!==D&&(null===(e=null==D?void 0:D.getTagueamento)||void 0===e?void 0:e.length)===(null==I?void 0:I.length)&&H(V(D,I))}),[k,D,I,R]),a((()=>{H(V(z,R))}),[z]),a((()=>{var e,t;const o=n&&!j&&!isNaN(L),i=q||G,r=o&&k&&(null==G?void 0:G.length)===(null==I?void 0:I.length)&&(null==I?void 0:I.length)>0&&void 0!==D&&!j,a=o&&(null==i?void 0:i.length)>0&&!k&&!j;r?(W(G),T(!0),N(!1),S([]),Je.tagecommerce({event:tt.ViewCart,items:G,value:L,datasType:"CARRINHO_CURRENCY"}),H([]),M({variables:{input:[]}})):a?(T(!0),Je.tagecommerce({event:tt.ViewCart,items:i,value:L,datasType:"CARRINHO_CURRENCY"})):!j&&(null==I?void 0:I.length)>0?L&&L>0&&(null===(t=null===(e=I[0])||void 0===e?void 0:e.item_name)||void 0===t?void 0:t.length)>0&&(T(!0),Je.tagecommerce({event:tt.ViewCart,items:I,value:L,datasType:"CARRINHO_CURRENCY"})):n||T(!1)}),[n,k,z,D,I,L,G]),a((()=>{var e,t,o,i;if(O){const n=null===(i=null===(o=null===(t=null===(e=null==O?void 0:O.me)||void 0===e?void 0:e.carts)||void 0===t?void 0:t[0])||void 0===o?void 0:o.lineItems)||void 0===i?void 0:i.map((e=>null==e?void 0:e.quantity)).reduce(((e,t)=>e+t),0);(null==E?void 0:E.cartCount)!==n&&(null==E||E.set({cartCount:n}))}}),[O]),t(o,{children:[t(_g,{className:v,size:l,position:d,mode:s,isOpen:n,elevation:A,id:"SidePanel",children:[(m||c)&&t(o,{children:[n&&e(bi,{render:t=>e(bf,{loading:t.loading,cart:t.cart,isOpen:!0,tagueamentoProductData:q||G,onItemUpdate:t.onItemUpdate,setOpenModal:y,setLoginModalPage:C,refetch:t.refetch}),renderLoading:()=>e(bf.Skeleton,{})}),e($g,{show:c,onClick:()=>p(),children:e(ur,{})})]}),i,f.length>0&&e(iA,{isCompact:!0,children:f.map((t=>e(Zo,{disabled:t.disabled,variant:t.isPrimary?B:"secondary",label:t.label},t.label)))})]}),u&&n&&e(nA,{isVisible:u&&n,onClick:()=>h&&p()})]})};wf.Body=({children:t,isScrolling:o=!0})=>e(eA,{isScrolling:o,children:t}),wf.Section=({children:t})=>e(tA,{children:t}),wf.Footer=({children:t})=>e(oA,{children:t}),wf.Main=({children:t})=>e(Xg,{children:t});const yf=n.memo(wf),Cf=()=>{var o;const i=l((()=>window.location.href.includes("?openCart=true")),[window.location.href]),[n,d]=r(),c=wo(),{cartSideMenu:p,setCartSideMenu:m}=ci(),u=qt(),[h]=r(),g=s(null),{context:A,toggleRegionModal:f}=di(),[v,x]=r(void 0!==(null==A?void 0:A.city)?`${null==A?void 0:A.city}, ${(null==A?void 0:A.regionList)&&(null===(o=null==A?void 0:A.regionList[3])||void 0===o?void 0:o.replace("UF_",""))}`:"Região de entrega"),{data:b}=hi(),w=e=>{var t,o,i,n;const r=null===(o=null===(t=null==e?void 0:e.trim())||void 0===t?void 0:t.toLowerCase())||void 0===o?void 0:o.replace(/\s+/g," ");return null===(n=null===(i=null==r?void 0:r.normalize("NFD"))||void 0===i?void 0:i.replace(/[\u0300-\u036f]/g,""))||void 0===n?void 0:n.replace(/[^\w\s]/gi,"")},y=()=>{var e;let t=!1;if(b&&b.searchQuery&&n){const o=((e,t)=>{var o;let i=null,n=0;const r=null===(o=w(e))||void 0===o?void 0:o.split(/\s+/);return t.forEach((e=>{var t;const o=null===(t=w(null==e?void 0:e.search_term))||void 0===t?void 0:t.split(/\s+/);let a=0,l=-1;null==r||r.forEach(((e,t)=>{(null==o?void 0:o.includes(e))&&(null==o?void 0:o.indexOf(e))>l&&(a+=(null==r?void 0:r.length)-t,l=null==o?void 0:o.indexOf(e))})),a>n&&(n=a,i=e)})),i})(n,null==b?void 0:b.searchQuery);if(o){if((null===window||void 0===window?void 0:window.isWebView)&&""!==(null==o?void 0:o.redirect_url_mobile))(e=>{var t;const o={event:"redirect-search",value:e};null===(t=null===window||void 0===window?void 0:window.ReactNativeWebView)||void 0===t||t.postMessage(JSON.stringify(o))})(null==o?void 0:o.redirect_url_mobile);else{const t=process.env.OIDC_PUBLIC_URL||"",i=null===(e=null==o?void 0:o.redirect_url)||void 0===e?void 0:e.replace(t,"");(null==i?void 0:i.includes("http"))?null===window||void 0===window||window.open(i):c.push(i)}t=!0,d("")}}!t&&n&&""!==(null==n?void 0:n.replace(/\s/g,""))&&(c.push(`/loja/resultado-busca/f/?busca=${n}`),d("")),gi.set({miraklShopIds:void 0,miraklShopName:void 0,sort:""})};a((()=>{i&&m({openSideMenu:!0})}),[i]);const C=e=>{m({openSideMenu:e}),Je.interact(Ye.Click,Je.getActionLocation(),"carrinho","carrinho",Je.getUserStatus(u),"e-agro/header",null,{userId:Je.getUserId(u)})};return a((()=>{var e;const t=(new Mo).get("marketplace");x(void 0!==(null==t?void 0:t.city)?`${null==t?void 0:t.city}, ${null===(e=null==t?void 0:t.regionList[3])||void 0===e?void 0:e.replace("UF_","")}`:"Região de entrega")}),[]),t(vg,{children:[e(yf,{isOpen:null==p?void 0:p.openSideMenu,position:"right",isCloseOnOverlayClick:!0,onClose:()=>C(!1),elevation:9999}),e(xg,{children:t(wg,{className:"searchInputs",children:[e(yg,{onClick:y,className:"searchIcon",children:e(V,{"aria-label":"Search",className:"search-icon"})}),e(Cg,{id:"searchField",placeholder:"Busca",value:n,onChange:e=>{var t;return d(null===(t=null==e?void 0:e.target)||void 0===t?void 0:t.value)},onKeyDown:e=>{"Enter"===(null==e?void 0:e.key)&&y()}})]})}),t(bg,{children:[t(Eg,{onClick:()=>{C(!0)},children:[e(Qi,{}),e(Sg,{className:"shopping",children:"Carrinho"})]}),e(Bg,{children:t(kg,{ref:g,onClick:()=>{f()},children:[e(Jg,{onChangeUserInteraction:()=>{h&&clearTimeout(h)}}),t(Ig,{className:"icon-region-container",children:[e(Ie,{className:"location-icon"}),e(Ng,{onClick:()=>{Je.interact(Ye.Click,Je.getActionLocation(),"regiao-de-entrega","header",Je.getUserStatus(u),"e-agro/header",null,{userId:Je.getUserId(u)})},children:v})]})]})})]})]})};var Ef,Bf,kf;function If(){return If=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},If.apply(null,arguments)}const Nf=e=>i.createElement("svg",If({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 21.895 16"},e),Ef||(Ef=i.createElement("path",{fill:"#0c881e",d:"M21.895 2H0V0h21.895Z","data-name":"Linha 1"})),Bf||(Bf=i.createElement("path",{fill:"#0c881e",d:"M21.895 9.412H0v-2h21.895Z","data-name":"Linha 2"})),kf||(kf=i.createElement("path",{fill:"#0c881e",d:"M21.895 16H0v-2h21.895Z","data-name":"Linha 3"}))),Sf=()=>{var i,n,d,s,c,p,m,u,h,g,A,f,v,x;const b=wo(),[w,y]=r(!1),C=kt(),{data:E}=bt().getHeader(),{context:B,toggleRegionModal:k,setSelectedRegion:I}=di(),{data:N}=St(),{data:S}=Ot(),{width:O}=lt(),P=qt(),Q=l((()=>O<=1056),[O]),{loading:z,error:M,data:D}=cg(),j=l((()=>{var e;return!z&&!M&&((null===(e=null==D?void 0:D.getPostStaticContent)||void 0===e?void 0:e.enabled)||!1)}),[D,z,M]),R=()=>{y(!w)};function L(e){Je.interact(Ye.Click,Je.getActionLocation(),""+(e?"criar-conta":"entrar"),e?"cadastro":"login",it.LoggedOut,"e-agro/header")}const U=()=>{var e;if(window.isWebView){const t={event:"login"};null===(e=null===window||void 0===window?void 0:window.ReactNativeWebView)||void 0===e||e.postMessage(JSON.stringify(t))}else b.push("/authenticator/login");L()},q=e=>(null===window||void 0===window?void 0:window.location.pathname.toLowerCase())===e.toLowerCase()&&"#"!==e,W=e=>{Je.interact(Ye.Click,Je.getActionLocation(),`${e}`,"header",Je.getUserStatus(P),"e-agro/header",null,{userId:Je.getUserId(P)})};return a((()=>{!function({region:e}){var t;!(null==e?void 0:e.miraklRegion)&&!(null==e?void 0:e.regionList)&&(null===(t=null==S?void 0:S.getRegionBR)||void 0===t?void 0:t.length)>0&&I({miraklRegion:[null==S?void 0:S.getRegionBR],regionList:["BR"]})}({region:B})}),[]),a((()=>{document.body.style.overflow=w?"hidden":"auto"}),[w]),t(o,{children:[t(kh,{children:[t(Nh,{children:[Q&&t(Sh,{children:[w&&e(T,{fill:"#0C881E",onClick:R}),!w&&e(Nf,{fill:"#0C881E",onClick:R}),e(Lh,{role:"img",src:null===(n=null===(i=null==E?void 0:E.onboard)||void 0===i?void 0:i.logo)||void 0===n?void 0:n.logo_e_agro_url,"aria-label":null===(s=null===(d=null==E?void 0:E.onboard)||void 0===d?void 0:d.logo)||void 0===s?void 0:s.logo_e_agro_url_alt,onClick:()=>{b.push("/")}}),e(Ne,{fill:"#0C881E",className:"smaller-icon",onClick:U})]}),!Q&&t(Sh,{children:[t(Ph,{children:[e(Rh,{logo_url:null===(p=null===(c=null==E?void 0:E.onboard)||void 0===c?void 0:c.logo)||void 0===p?void 0:p.logo_e_agro_url,"aria-label":null===(u=null===(m=null==E?void 0:E.onboard)||void 0===m?void 0:m.logo)||void 0===u?void 0:u.logo_e_agro_url_alt,onClick:()=>{b.push("/")}}),e(yo,{className:"link-header "+(q("/sobre")?"active-route":""),to:"/sobre",onClick:()=>W("quem-somos"),children:"Quem somos"}),e(yo,{className:"link-header "+(q("/simulacao-de-credito")?"active-route":""),to:"/simulacao-de-credito",onClick:()=>W("linhas-de-credito"),children:"Linhas de crédito"}),e(Oh,{id:"categs",children:e(eg,{isFromHome:!0,closeRegionOnCategoriesHover:()=>k(),showRegionModal:null==B?void 0:B.showRegionModal,categoriesData:null===(A=ot(null===(g=null===(h=null==N?void 0:N.getCategoriesAndSubcategories)||void 0===h?void 0:h.categories)||void 0===g?void 0:g.items)[0])||void 0===A?void 0:A.children})}),j&&e(yo,{className:"link-header "+(q("/blog")?"active-route":""),to:"/blog",onClick:()=>W("blog"),children:"Blog"})]}),e(Qh,{children:t(o,{children:[e(Mh,{label:"Entrar",size:"large",variant:"primary",className:"btn-signin",alt:"Entrar",title:"Entrar",onClick:U}),e(Mh,{label:"Criar conta",size:"large",variant:"secondary",className:"btn-signup",alt:"Criar conta",title:"Criar conta",onClick:()=>{var e;if(window.isWebView){const t={event:"createAccount"};null===(e=null===window||void 0===window?void 0:window.ReactNativeWebView)||void 0===e||e.postMessage(JSON.stringify(t))}else C.redirectRegister("/authentication/valid-user");L(!0)}})]})})]})]}),e(zh,{children:e(Cf,{})})]}),w&&t(o,{children:[e(Ih,{}),e(fg,{menuItems:null===(x=ot(null===(v=null===(f=null==N?void 0:N.getCategoriesAndSubcategories)||void 0===f?void 0:f.categories)||void 0===v?void 0:v.items)[0])||void 0===x?void 0:x.children,onClickDiv:R})]})]})},Of=()=>{var e,t;const{loading:o,data:i}=st();return(!o||i)&&null!==(t=null===(e=null==i?void 0:i.getProfile)||void 0===e?void 0:e.fullName)&&void 0!==t?t:""},Pf=()=>{var i,n,d,s,c,p,m,u,h,g,A,f,v,x,w,y;const C=wo(),[E,B]=r(!1),{data:k}=bt().getHeader(),{context:I,toggleRegionModal:N,setSelectedRegion:S}=di(),{data:O}=St(),[P,Q]=r(!1),{width:z}=lt(),[M,D]=r(!1),[j,R]=r(!1),L=Pt(),{logout:U}=pt(),{data:q}=Ot(),{agroLogout:W}=mt(),G=null===(n=null===(i=null==L?void 0:L.data)||void 0===i?void 0:i.getNotificationBell)||void 0===n?void 0:n.message,H=Of().split(" ")[0],F=new Mo,V=qt(),{loading:K,error:J,data:Y}=cg(),Z=l((()=>{var e;return!K&&!J&&((null===(e=null==Y?void 0:Y.getPostStaticContent)||void 0===e?void 0:e.enabled)||!1)}),[Y,K,J]);a((()=>{R(null!=G&&"Todas as notificações já foram lidas."!==G)}),[G]);const X=()=>(P||Q(!0),z<=1056),_=()=>{B(!E)},$=e=>(null===window||void 0===window?void 0:window.location.pathname.toLowerCase())===e.toLowerCase()&&"#"!==e,ee=()=>{C.push("/notification")},te=()=>{D(!M)},oe=()=>{C.push("/myProfile/myProfilePage")},ie=()=>{var e;null===(e=null===window||void 0===window?void 0:window.ReactNativeWebView)||void 0===e||e.postMessage("logout"),W().then((e=>{e.data.agroLogout.logout&&(F.remove("permissions"),F.remove("_ga"),F.remove("psid",{path:"/"}),F.remove("logged"),F.remove("registerRedirect"),U())})).catch((e=>console.log(e))).finally((()=>C.push("/")))},ne=e=>{Je.interact(Ye.Click,Je.getActionLocation(),`${e}`,"header",it.LoggedIn,"e-agro/header",null,{userId:Je.getUserId(V)})};return a((()=>{!function({region:e}){var t;!(null==e?void 0:e.miraklRegion)&&!(null==e?void 0:e.regionList)&&(null===(t=null==q?void 0:q.getRegionBR)||void 0===t?void 0:t.length)>0&&S({miraklRegion:[null==q?void 0:q.getRegionBR],regionList:["BR"]})}({region:I})}),[]),a((()=>{document.body.style.overflow=E?"hidden":"auto"}),[E]),t(o,{children:[t(kh,{children:[t(Nh,{children:[X()&&P&&t(Sh,{children:[E&&e(T,{fill:"#0C881E",onClick:_}),!E&&e(Nf,{fill:"#0C881E",onClick:_}),e(Uh,{role:"img",src:null===(s=null===(d=null==k?void 0:k.onboard)||void 0===d?void 0:d.logo)||void 0===s?void 0:s.logo_e_agro_url,"aria-label":null===(p=null===(c=null==k?void 0:k.onboard)||void 0===c?void 0:c.logo)||void 0===p?void 0:p.logo_e_agro_url_alt,onClick:()=>{C.push("/")}}),t("div",{children:[e(j?Se:Oe,{fill:"#0C881E",className:"smaller-icon left-icon",onClick:ee}),e(Ne,{fill:"#0C881E",className:"smaller-icon",onClick:te})]}),M&&t(Dh,{children:[e(jh,{children:t("p",{children:["Olá, ",H]})}),t(Th,{onClick:oe,children:[e(Pe,{fill:"#0C881E"})," Meu perfil"]}),t(Th,{onClick:ie,children:[e(Qe,{fill:"#0C881E"})," Sair"]})]})]}),!X()&&P&&t(Sh,{children:[t(Ph,{children:[e(Rh,{logo_url:null===(u=null===(m=null==k?void 0:k.onboard)||void 0===m?void 0:m.logo)||void 0===u?void 0:u.logo_e_agro_url,"aria-label":null===(g=null===(h=null==k?void 0:k.onboard)||void 0===h?void 0:h.logo)||void 0===g?void 0:g.logo_e_agro_url_alt,onClick:()=>C.push("/")}),e(yo,{className:"link-header "+($("/dashboard/DashboardPage")?"active-route":""),to:"/dashboard/DashboardPage",onClick:()=>ne("meu-painel"),children:"Meu painel"}),e(yo,{className:"link-header "+($("/sobre")?"active-route":""),to:"/sobre",onClick:()=>ne("quem-somos"),children:"Quem somos"}),e(yo,{className:"link-header "+($("/simulationLogged/AvailableProducts")?"active-route":""),to:"/simulationLogged/AvailableProducts",onClick:()=>ne("linhas-de-credito"),children:"Linhas de crédito"}),e(Oh,{id:"categs",children:e(eg,{isFromHome:!0,closeRegionOnCategoriesHover:()=>N(),showRegionModal:null==I?void 0:I.showRegionModal,categoriesData:null===(v=ot(null===(f=null===(A=null==O?void 0:O.getCategoriesAndSubcategories)||void 0===A?void 0:A.categories)||void 0===f?void 0:f.items)[0])||void 0===v?void 0:v.children})}),Z&&e(yo,{className:"link-header "+($("/blog")?"active-route":""),to:"/blog",onClick:()=>ne("blog"),children:"Blog"})]}),e(Qh,{children:t(o,{children:[e(j?Se:Oe,{fill:"#0C881E",className:"smaller-icon left-icon",onClick:ee}),e(Ne,{fill:"#0C881E",className:"smaller-icon",onClick:te}),e(b,{fill:"#0C881E",className:M?"chevronDown-up":"chevronDown",onClick:te}),M&&t(Dh,{children:[e(jh,{children:t("p",{children:["Olá, ",H]})}),t(Th,{onClick:oe,children:[e(Pe,{fill:"#0C881E"})," Meu perfil"]}),t(Th,{onClick:ie,children:[e(Qe,{fill:"#0C881E"})," Sair"]})]})]})})]})]}),e(zh,{children:e(Cf,{})})]}),E&&t(o,{children:[e(Ih,{}),e(fg,{menuItems:null===(y=ot(null===(w=null===(x=null==O?void 0:O.getCategoriesAndSubcategories)||void 0===x?void 0:x.categories)||void 0===w?void 0:w.items)[0])||void 0===y?void 0:y.children,onClickDiv:_})]})]})};const Qf=h.div`
  width: 100%;

  ${({hasOutline:e})=>e&&"\n    border: solid 1px;\n    border-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA34AAADHBAMAAAC0KpwHAAAAGFBMVEUAAADY3d3Z293a293Z3N3Z3N3Z3N3///9dsIgLAAAABnRSTlMAd4CItO+XN1MYAAAAAWJLR0QHFmGI6wAAAdRJREFUeNrt2aFtA0AQRcGLIgW7BCNjl5AqjJfk+i8hZayeNEOW74P/fO69z3POy03eOZTppx9bvvRL+9Ev3u/tCel+6Id+6KcfLd9eAIseXpA2XqAf+qGffqTY/9rsf/V+9r92P/RDP/TTjxb7H2yy/7WNF+iHfuinHyn2vzb7X72f/a/dD/3QD/30o8X+B5vsf23jBfqhH/rpR4r9r83+V+9n/2v3Qz/0Qz/9aLH/wSb7X9t4gX7oh376kWL/a7P/1fvZ/9r90A/90E8/Wux/sMn+1zZeoB/6oZ9+pNj/2ux/9X72v3Y/9EM/9NOPFvsfbLL/tY0X6Id+6KcfKfa/NvtfvZ/9r90P/dAP/fSjxf4Hm+x/beMF+qEf+ulHiv2vzf5X72f/a/dDP/RDP/1osf/BJvtf23iBfuiHfvqRYv9rs//V+9n/2v3QD/3QTz9a7H+wyf7XNl6gH/qhn36k2P/a7H/1fva/dj/0Qz/0048W+x9ssv+1jRfoh37opx8p9r82+1+9n/2v3Q/90A/99KPF/geb7H9t4wX6oR/66UeK/a/N/lfvZ/9r90M/9EM//Wix/8Em+1/beIF+6Id++pFi/2uz/9X7/Z5zXvfepxu8f/+obMr/x9w/oQAAAABJRU5ErkJggg==) 1 repeat;\n    padding: 1.5rem;\n  "}

  @media (max-width: 720px) {
    ${({hasOutline:e})=>e&&"\n      padding: 1rem;\n    "}
  }
`,zf=h.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  max-width: 29.375rem;
  margin-inline: auto;

  color: ${f.color04};
  text-align: center;

  svg {
    height: 2.5rem;
    width: 2.5rem;
    min-width: 2.5rem;
  }

  h4 {
    font-size: ${f.fontSize03};
    font-weight: ${f.fontWeight03};
  }

  p {
    color: ${f.color04};
    font-size: ${f.fontSize01};
    font-weight: ${f.lineHeight02};
    line-height: 24px;

    white-space: pre-wrap;
  }

  img {
    width: 21rem;
    max-width: 100%;
    margin-top: 1rem;
  }

  button {
    min-width: fit-content;

    border: 0;
    background: transparent;

    font-size: ${f.fontSize01};
    color: ${f.color01};
    font-weight: ${f.fontWeight03};

    cursor: pointer;
  }

  @media (max-width: 720px) {
    p {
      white-space: initial;
    }
  }
`,Mf=({icon:o,title:i,message:n,imageSrc:r,imageAlt:a,hasOutline:l,btnText:d,onBtnClick:s,className:c})=>e(Qf,{className:c,hasOutline:l,children:t(zf,{children:[o,e("h4",{children:i}),n&&e("p",{dangerouslySetInnerHTML:{__html:n}}),r&&e("img",{src:r,alt:a}),(null==d?void 0:d.trim())&&e("button",{onClick:s,children:d})]})}),Df=({status:i,children:n,errorParams:r,renderChild:a,goBack:l})=>t($u,{className:"_LoaderBase",children:[t(eh,{status:i||"",className:"_LoaderBase_Status",children:[e("div",{className:"_LoaderBase_Placeholder"}),t("div",{className:"_LoaderBase_Foreground",children:[e("div",{className:"_LoaderBase_Spinner "}),e("p",{className:"_LoaderBase_Message",children:"Espere alguns segundos enquanto as informações são processadas."})]}),t("div",{className:"_LoaderBase_Error_Box",children:[e(Mf,{icon:(null==r?void 0:r.icon)||e(ze,{className:"icon-error"}),title:(null==r?void 0:r.title)||"Poxa, não é possível acessar o site nesse momento",message:(null==r?void 0:r.message)||"Por favor, tente novamente mais tarde."}),e(cp,{className:"_LoaderBase_Link",text:"Voltar",onClick:l}),null==a?void 0:a()]})]}),"done"==i&&e(o,{children:n})]}),jf=({status:i,children:n,errorParams:r,renderChild:a,goBack:l})=>t($u,{className:"_LoaderBase",children:[t(eh,{status:i||"",className:"_LoaderBase_Status _LoaderBase_Status_FullPage",children:[e("div",{className:"_LoaderBase_Placeholder"}),t("div",{className:"_LoaderBase_Foreground",children:[e("div",{className:"_LoaderBase_Spinner "}),e("p",{className:"_LoaderBase_Message",children:"Espere alguns segundos enquanto as informações são processadas."})]}),t("div",{className:"_LoaderBase_Error_FullPage_BoxContainer",children:[e("div",{className:"_LoaderBase_BackButton_Container",children:e(Wa,{onClick:l})}),t("div",{className:"_LoaderBase_Error_Box",children:[e(Mf,{icon:(null==r?void 0:r.icon)||e(ze,{className:"icon-error"}),title:(null==r?void 0:r.title)||"Poxa, não é possível acessar o site nesse momento",message:(null==r?void 0:r.message)||"Por favor, tente novamente mais tarde."}),null==a?void 0:a()]})]})]}),"done"==i&&e(o,{children:n})]}),Tf=(t,o,i)=>{const[n,a]=r(t||"loading"),[d,s]=r({}),c=wo();const p=l((()=>{const t={base:Df,withArrowBack:jf}[d.loader||"base"];return({children:i,renderChild:r})=>e(t,{status:n,errorParams:d.errorParams,renderChild:r,goBack:()=>{o&&o(),c.go(-1)},children:i})}),[n]);return{loaderStatus:n,toggleMode:function(e,t,o="base"){var r;if(t&&s({loader:o,errorParams:t}),"error"==n&&"done"==e)throw new Error("Troca de estado inválida, trocar loader de erro para completo");0!==(null==i?void 0:i.toggleTimeout)?setTimeout((()=>{a(e)}),null!==(r=null==i?void 0:i.toggleTimeout)&&void 0!==r?r:1e3):a(e)},LoaderGate:p}},Rf=()=>e($u,{className:"_LoaderBase",children:t(eh,{status:"error",className:"_LoaderBase_Status",children:[e("div",{className:"_LoaderBase_Placeholder"}),t("div",{className:"_LoaderBase_Foreground",children:[e("div",{className:"_LoaderBase_Spinner "}),e("p",{className:"_LoaderBase_Message",children:"Espere alguns segundos enquanto as informações são processadas."})]}),t("div",{className:"_LoaderBase_Error_Box",children:[e(ze,{width:44,height:44,className:"_LoaderBase_Error_Svg"}),e("h1",{className:"_LoaderBase_Error_Title",children:"Poxa o sistema está fora do ar."}),e("p",{className:"_LoaderBase_Error_Subtitle",children:"Favor entre em contato com suporte."}),e(cp,{className:"_LoaderBase_Link",text:"Voltar",onClick:()=>{history.go(-1)}})]})]})}),Lf=()=>e($u,{className:"_LoaderBase",children:t(eh,{status:"error",className:"_LoaderBase_Status",children:[e("div",{className:"_LoaderBase_Placeholder"}),t("div",{className:"_LoaderBase_Foreground",children:[e("div",{className:"_LoaderBase_Spinner "}),e("p",{className:"_LoaderBase_Message",children:"Espere alguns segundos enquanto as informações são processadas."})]}),t("div",{className:"_LoaderBase_Error_Formalization_Box",children:[e(ze,{width:44,height:44,className:"_LoaderBase_Error_Svg"}),e("h1",{className:"_LoaderBase_Error_Title",children:"Desculpe, algo aconteceu."}),e("p",{className:"_LoaderBase_Error_Formalization_Subtitle",children:"Ocorreu alguma indisponibilidade no sistema e não foi possível continuar. Por avor, tente novamente mais tarde."}),e(cp,{className:"_LoaderBase_Link",text:"Voltar",onClick:()=>{history.go(-1)}})]})]})}),Uf=({error:i})=>{const n=qt(),[l,d]=r(!0);return a((()=>{void 0!==i&&void 0!==i.message?d(i.message.includes("O cliente atual não está autorizado.")):d(!1)}),[i]),t(o,{children:[(null==n?void 0:n.username)?e(Pf,{}):e(Sf,{}),e($u,{className:"_LoaderBase",children:l?e(th,{children:e(Vt,{withOverlay:!1})}):t(eh,{status:"error",className:"_LoaderBase_Status",children:[e("div",{className:"_LoaderBase_Placeholder"}),t("div",{className:"_LoaderBase_Foreground",children:[e("div",{className:"_LoaderBase_Spinner "}),e("p",{className:"_LoaderBase_Message",children:"Espere alguns segundos enquanto as informações são processadas."})]}),t("div",{className:"_LoaderBase_Error_Box",children:[e(ze,{width:44,height:44,className:"_LoaderBase_Error_Svg"}),e("h1",{className:"_LoaderBase_Error_Title",children:"Poxa o sistema está fora do ar."}),e("p",{className:"_LoaderBase_Error_Subtitle",children:"Favor entre em contato com suporte."}),e(cp,{className:"_LoaderBase_Link",text:"Voltar",onClick:()=>{history.go(-1)}})]})]})}),!(null===window||void 0===window?void 0:window.isWebView)&&e(Bh,{})]})},qf=()=>e($u,{className:"_LoaderBase",children:t(eh,{status:"error",className:"_LoaderBase_Status",children:[e("div",{className:"_LoaderBase_Placeholder"}),t("div",{className:"_LoaderBase_Foreground",children:[e("div",{className:"_LoaderBase_Spinner "}),e("p",{className:"_LoaderBase_Message",children:"Espere alguns segundos enquanto as informações são processadas."})]}),t("div",{className:"_LoaderBase_Error_Box",children:[e(ze,{width:44,height:44,className:"_LoaderBase_Error_Svg"}),e("h1",{className:"_LoaderBase_Error_Title",children:"Não Autorizado"}),e("p",{className:"_LoaderBase_Error_Subtitle",children:"Você não tem permissão para prosseguir."})]})]})}),Wf=({children:i,config:n,notifications:r,onRemoveNotification:a,styleLinks:l,seoData:d})=>{var s,c;const p=qt();return t(o,{children:[e(Vo,{}),t(ri,{children:[e("meta",{name:"charSet",charSet:"utf-8"}),e("title",{children:null!==(s=null==d?void 0:d.title)&&void 0!==s?s:n.meta.title}),e("meta",{name:"description",content:null==d?void 0:d.description}),e("meta",{name:"robots",content:null==d?void 0:d.robots}),e("link",{rel:"canonical",href:null==d?void 0:d.url_canonical}),e("meta",{name:"viewport",content:"minimum-scale=1,initial-scale=1, width=device-width, shrink-to-fit=no"}),e("meta",{name:"theme-color",content:"black"}),e("link",{rel:"icon",href:n.meta.icon}),l.map((t=>e("link",{rel:"stylesheet",href:t},t)))]}),(null===(c=p.profile)||void 0===c?void 0:c.isPrivilegedUser)?t(o,{children:[e(Ko,{notifications:r,onRemove:a}),e(gm,{children:i})]}):t(Xu,{children:[e(ai,{}),e(_u,{children:e(Ho,{fallbackComponent:Rf(),children:i})}),e(li,{})]})]})};const Gf=h.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  pointer-events: none;
  z-index: 9;
`;h.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #888888;
  opacity: 0.9;
  z-index: 1;
`;const Hf=h.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  bottom: 24px;
  height: 80px;
  width: 1148px;
  max-width: 90%;
  padding: 24px;
  z-index: 2;
  margin-bottom: 24px;
  pointer-events: all;
  background-color: #f5f5f5;
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.2);
  border-radius: 8px;

  .btn-accept {
    height: 32px;
    width: 178px;
    background: #0c881e 0% 0% no-repeat padding-box;
    border-radius: 100px;
    margin-left: 16px;

    @media (min-width: 672px) and (max-width: 1055px) {
      width: 148px;
    }

    @media (max-width: 671px) {
      width: 160px;
      margin-left: 0px;
      margin-bottom: 8px;
    }
  }

  .btn-refuse {
    width: 178px;
    height: 32px;
    border: 1px solid #3aa050;
    border-radius: 100px;

    @media (min-width: 672px) and (max-width: 1055px) {
      width: 148px;
    }

    @media (max-width: 671px) {
      width: 160px;
    }
  }

  div {
    display: flex;
    align-items: center;

    @media (max-width: 671px) {
      flex-direction: column;
    }
  }

  @media (min-width: 672px) and (max-width: 1055px) {
    width: 90%;
    margin-left: 24px;
    margin-right: 24px;
    .textWarning {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-left: 24px;
    }
  }

  @media (max-width: 671px) {
    flex-direction: column;
    height: 240px;

    .btns-container {
      flex-direction: column-reverse;
    }
  }
`,Ff=h.div`
  width: 32px;
  height: 32px;
  min-width: 32px;
  background: url(${"data:image/png;base64,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"});
  background-size: cover;

  @media (max-width: 671px) {
    margin-bottom: 16px;
  }
`,Vf=h.h2`
  font-size: 0.875rem;
  margin-left: 24px;
  line-height: 20px;

  @media (min-width: 672px) and (max-width: 1055px) {
    margin-left: 0px;
    font-size: 0.75rem;
  }

  @media (max-width: 671px) {
    font-size: 12px;
    margin-bottom: 8px;
    text-align: center;
    margin-left: 0px;
  }
`,Kf=h(il)`
  font-size: 0.875rem;
  color: #075512;
  text-decoration: underline;

  @media (min-width: 672px) and (max-width: 1055px) {
    margin-top: 5px;
    font-size: 0.75rem;
  }

  @media (max-width: 671px) {
    font-size: 12px;
  }
`,Jf=h.div`
  display: flex;
  flex-direction: column;
  bottom: 24px;
  height: auto;
  width: 1148px;
  max-width: 90%;
  background-color: white;
  padding: 24px;
  z-index: 2;
  margin-bottom: 24px;
  pointer-events: all;
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.2);
  border-radius: 8px;

  .btns-customize {
    display: flex;
    align-self: flex-end;
    margin-top: 8px;

    @media (min-width: 672px) and (max-width: 1055px) {
      align-self: center;
    }

    @media (max-width: 671px) {
      align-self: center;
      flex-direction: column-reverse;
    }
  }

  .btn-send-permissions {
    height: 32px;
    width: 162px;
    background: #0c881e 0% 0% no-repeat padding-box;
    border-radius: 100px;
    margin-left: 16px;
    font-size: 12px;

    @media (min-width: 672px) and (max-width: 1055px) {
      width: 148px;
    }

    @media (max-width: 671px) {
      width: 160px;
      margin-left: 0px;
      margin-bottom: 8px;
    }
  }

  .btn-accept-all {
    width: 172px;
    height: 32px;
    border: 1px solid #3aa050;
    border-radius: 100px;
    font-size: 12px;

    @media (min-width: 672px) and (max-width: 1055px) {
      width: 172px;
    }

    @media (max-width: 671px) {
      width: 160px;
    }
  }

  .titleContainer {
    display: flex;
    flex-direction: row;
    align-items: space-between;
    width: 100%;
    margin-bottom: 12px;

    @media (max-width: 671px) {
      flex-direction: row;
    }
  }

  @media (min-width: 672px) and (max-width: 1055px) {
    width: 90%;
    margin-left: 24px;
    margin-right: 24px;
    .textWarning {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-left: 24px;
    }
  }

  @media (max-width: 671px) {
    flex-direction: column;
    height: auto;

    .btns-container {
      flex-direction: column-reverse;
    }
  }
`,Yf=h.span`
  width: 100%;
  font-size: 16px;
  font-weight: bold;
`,Zf=h.div`
  background: url(${"data:image/png;base64,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"}) no-repeat;
  background-size: contain;
  height: 18px;
  width: 18px;
  margin-bottom: 16px;
`,Xf=h.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;

  .cookieHeader {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }

  .nameContainer {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
  }

  .cookieName {
    font-size: 14px;
    margin-left: 10px;
  }

  .toggleIcon {
    margin: 0;
    * {
      margin: 0%;
    }
  }

  .line-text {
    line-height: 1.3rem;
  }
`,_f=h.div`
  display: flex;
  margin: 12px 15px 0px 15px;
  font-size: 14px;
`,$f=({onClickCloseModal:o})=>{const[i,n]=r(!1),[a,l]=r(!0),[d,s]=r(!1),[c,p]=r(!1),[m,u]=r(!1),[h,g]=r(!1),[A,f]=r(!1),[v,x]=r(!1),[b,w]=r(!1),y=()=>{l(!0),p(!0),g(!0),x(!0),n(!0)},C=e=>{const t=new Mo,o=Object.assign(Object.assign({},e),{HttpOnly:!0,SameSite:"Lax",secure:!0,CookieSecureTLS:!0});t.set("permissions",JSON.stringify(o))};return e(Gf,{children:i?t(Jf,{children:[t("div",{className:"titleContainer",children:[e(Yf,{children:"Quais cookies você deseja aceitar?"}),e(Zf,{onClick:()=>n(!1),style:{cursor:"pointer"}})]}),t(Xf,{children:[t("div",{className:"cookieHeader",onClick:()=>s(!d),children:[t("div",{className:"nameContainer",children:[e(d?Me:De,{style:{marginTop:"0px"}}),e("span",{className:"cookieName",children:"Necessários"})]}),e(eo,{className:"toggleIcon",id:"1",name:"necessary",defaultToggled:a,disabled:!0})]}),d&&e(_f,{className:"expand line-text",children:"Os cookies essenciais são àqueles imprescindíveis para o correto funcionamento do site, bem como para sustentabilidade do financeira do negócio. Portanto, entre os cookies registrados como essenciais podem ser encontrados cookies de publicidade e performance."})]}),t(Xf,{children:[t("div",{className:"cookieHeader",onClick:()=>u(!m),children:[t("div",{className:"nameContainer",children:[e(m?Me:De,{style:{marginTop:"0px"}}),e("span",{className:"cookieName",children:"Navegação"})]}),e(eo,{className:"toggleIcon",id:"2",labelA:"",labelB:"",name:"navigation",defaultToggled:c,onToggle:e=>p(e),toggled:c})]}),m&&e(_f,{className:"expand line-text",children:"Coletam informações da interação do usuário com o site, por exemplo: sinalização de envio de formulários, definição de região favorita, entre outras interações. Tais informações permitem oferecer uma experiência de navegação personalizada e mais agradável para o usuário."})]}),t(Xf,{children:[t("div",{className:"cookieHeader",onClick:()=>f(!A),children:[t("div",{className:"nameContainer",children:[e(A?Me:De,{style:{marginTop:"0px"}}),e("span",{className:"cookieName",children:"Performance"})]}),e(eo,{className:"toggleIcon",id:"3",labelA:"",labelB:"",name:"performance",defaultToggled:h,onToggle:e=>g(e),toggled:h})]}),A&&e(_f,{className:"expand line-text",children:"Coletam informações sobre como os usuários utilizam e navegam no site, por exemplo: quais páginas os usuários acessam com mais frequência, e se recebem mensagens de erro de páginas da web. Esse tipo de cookie não coleta informações que identificam um usuário. Todas as informações que esses cookies coletam são agregadas e, portanto, anônimas, sendo usado apenas para melhorar o funcionamento do site (medição e melhoria de desempenho do site)."})]}),t(Xf,{children:[t("div",{className:"cookieHeader",onClick:()=>w(!b),children:[t("div",{className:"nameContainer",children:[e(b?Me:De,{style:{marginTop:"0px"}}),e("span",{className:"cookieName",children:"Publicidade"})]}),e(eo,{className:"toggleIcon",id:"4",labelA:"",labelB:"",name:"publicity",defaultToggled:v,onToggle:e=>x(e),toggled:v})]}),b&&e(_f,{className:"expand line-text",children:"Utilizados para fornecer anúncios mais relevantes para o usuário e seus interesses. Também são usados pra limitar o número de vezes que o usuário vê um anúncio, bem como, para ajudar a medir a eficácia de uma campanha publicitária. Normalmente são colocados por redes de publicidade com a permissão do operador do site. Eles se lembram de que o usuário visitou um site, e essas informações são compartilhadas com outras organizações, como anunciantes. Frequentemente, cookies de segmentação ou de publicidade são vinculados à funcionalidade fornecidas por outras empresas."})]}),t("div",{className:"btns-customize",children:[e(qr,{label:"Aceitar todos os cookies",onClick:()=>y(),alt:"Customizar",title:"Customizar",className:"btn-accept-all",variant:"secondary",size:"172px"}),e(qr,{label:"Enviar permissões",onClick:()=>(C({necessary:a,navigation:c,performance:h,publicity:v}),void o()),alt:"Enviar",title:"Enviar",className:"btn-send-permissions",variant:"primary",size:"172px"})]})]}):t(Hf,{children:[t("div",{children:[e(Ff,{}),e("div",{className:"textWarning",children:t(Vf,{children:["Usamos cookies para oferecer a melhor experiência e analisar o uso do nosso site, direcionar conteúdos e anúncio personalizados e facilitar a navegação de forma segura. Para mais informações, consulte nossa"," ",e(Kf,{title:"Diretiva de Privacidade.",target:"_blank",href:"/aviso-de-privacidade/DirectivePage",onClick:()=>console.log("Diretiva de Privacidade."),alt:"Diretiva de Privacidade.",label:"Diretiva de Privacidade."})]})})]}),e("div",{className:"btns-container",children:e(qr,{label:"Fechar",onClick:()=>{y(),C({necessary:!0,navigation:!0,performance:!0,publicity:!0}),o()},alt:"Fechar",title:"Fechar",className:"btn-accept",variant:"primary",size:"178px"})})]})})},ev=h("div")`
  @media only screen and (max-width: 672px) {
    align-self: center;
  }
`,tv=({label:t,time:o,className:i,onStop:n,active:l,refresh:d,onRefresh:s})=>{const[c,p]=r("00:00"),[m,u]=r(!1);function h(){for(let e=1;e<99999;e+=1)clearInterval(e)}const g=()=>{let e=o;return setInterval((function(){const t=Math.trunc(e/60).toString().padStart(2,"0"),o=(e%60).toString().padStart(2,"0");e>=0&&l?(e-=1,p(`${t}:${o}`)):(h(),u(!0))}),1e3)};return a((()=>{l?(u(!1),d||g()):h()}),[l]),a((()=>{n&&m&&n(m)}),[m]),a((()=>{d&&(s&&(u(!1),s(!1)),h(),g())}),[d]),e(ev,{children:e("span",{className:i,children:`${c} ${t}`})})},ov=h("div")`
  text-align: left;

  @media (min-width: 320px) and (max-width: 671px) {
    .title {
      width: 100% !important;
      padding-bottom: 5.87px !important;
      padding-left: 16px !important;
    }

    .titleSubTitle {
      width: 100% !important;
      padding-left: 16px !important;
    }

    .accountQuestion {
      width: 90% !important;

      padding-top: 26.13px !important;
      padding-left: 16px !important;
      padding-bottom: 16px !important;
    }

    .limitQuestion {
      width: 100% !important;
      padding-top: 31.5px !important;
      padding-left: 16px !important;
    }

    .limitQuestionInfo {
      padding-left: 16px !important;
      padding-top: 16px !important;
      padding-bottom: 23px !important;
      column-gap: 5px !important;
    }

    .accountQuestionRadioContainer,
    .limitQuestionRadioContainer {
      padding-left: 16px !important;
      font-size: 16px !important;
    }

    svg {
      width: 32px !important;
    }
  }

  .limitQuestion,
  .title {
    font-weight: bold;
    font-size: 16px;
    width: 60%;
    height: 90%;
    line-height: 20px;
    padding-top: 28.13px;
  }

  .accountQuestion {
    font-weight: bold;
    font-size: 16px;
    width: 55%;
    height: 90%;
    line-height: 20px;
    padding-top: 28.13px;
    padding-bottom: 24px;
  }

  .titleSubTitle {
    font-size: 16px;
    width: 52%;
    height: 90%;
    padding-top: 5.87px;
  }

  .limitQuestionInfo {
    display: flex;
    font-weight: regular;
    color: #767676;
    font-size: 14px;
    column-gap: 8px;

    padding-top: 16px;
    padding-bottom: 23px;
  }

  .accountQuestionRadioContainer,
  .limitQuestionRadioContainer {
    display: flex;
    flex-direction: column;
    font-size: 16px;
    width: fit-content;
    justify-content: space-between;
  }

  .radioSpacer {
    padding-bottom: 17.5px;
  }

  .bx--radio-button {
    width: 18px;
    height: 18px;
  }

  .bx--radio-button-wrapper .bx--radio-button__label {
    justify-content: left;
  }

  svg {
    color: #3ab19f;
    width: 16px;
    height: 16px;
  }
`,iv=({className:o,question:i,subTitle:n,info:r,children:a})=>t("div",{children:[e("div",{className:o,children:i}),n&&e("div",{className:`${o}SubTitle`,children:n}),r&&t("div",{className:`${o}Info`,children:[e(je,{}),r]}),a]}),nv=({onChange:i})=>{const[n,a]=r(void 0),[l,d]=r(void 0),s=e=>{const t="Sim"===e;a(t),i&&i(t,"LIMIT")},c=e=>{const t="Sim"===e;d(t),i&&i(t,"PARTIAL")};return e(o,{children:t(ov,{children:[e(iv,{className:"title",question:"Quando o pagamento será efetuado?",subTitle:"O pagamento será efetuado ao final do prazo de 12 meses após a confirmação da contratação."}),e(iv,{className:"accountQuestion",question:" Caso não haja saldo suficiente em conta para efetuar o pagamento, poderemos usar do limite da conta?",children:t("div",{className:"accountQuestionRadioContainer",children:[e(Yt,{value:"Sim",labelText:"Sim",labelPosition:"right",name:"radioAccountGrp",checked:null!=n&&n,onChange:s}),e("div",{className:"radioSpacer"}),e(Yt,{value:"Não",labelText:"Não",labelPosition:"right",name:"radioAccountGrp",checked:null!=n&&!n,onChange:s})]})}),e(iv,{className:"limitQuestion",question:"Podemos fazer débitos parciais na conta no dia do vencimento bem como débitos parciais ou totais de operações vencidas?",info:"Juros poderão ser cobrados de parcelas com o vencimento atrasado",children:t("div",{className:"limitQuestionRadioContainer",children:[e(Yt,{value:"Sim",labelText:"Sim",labelPosition:"right",name:"radioLimitGrp",checked:null!=l&&l,onChange:c}),e("div",{className:"radioSpacer"}),e(Yt,{value:"Não",labelText:"Não",labelPosition:"right",name:"radioLimitGrp",checked:null!=l&&!l,onChange:c})]})})]})})},rv=h.div`
  top: 0;

  .row-haderMKT {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    padding: 0 10%;
    height: 56px;
    box-shadow: 0px 2px 8px #22222229;
    svg.arrow {
      fill: #000000;
      width: 19px;
      height: 19px;
    }
    .arrow {
      @media (min-width: 1056px) {
        display: none;
      }
    }
    .categorias {
      @media (max-width: 1056px) {
        display: none;
      }
    }
    .favorite {
      @media (max-width: 1056px) {
        display: none;
      }
    }
    .shopping {
      @media (max-width: 1056px) {
        display: none;
      }
    }
  }

  @media (max-width: 1056px) {
    .searchContainer {
      display: none;
    }
  }

  .headerMKT-options {
    display: flex;
    flex-direction: row;
    gap: 8px;

    svg {
      color: #066113;
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
`,av=()=>e(rv,{children:t(co,{className:"row-haderMKT",children:[e("div",{className:"headerMKT-options",children:e(k,{className:"arrow"})}),t("div",{className:"headerMKT-options",children:[e(Ie,{}),e(ba,{text:"Santa Catarina",color:"color01",size:"fontSize01",weight:"fontWeight01"})]}),t("div",{className:"headerMKT-options",children:[e(ge,{className:"categorias"}),e(ba,{className:"categorias",text:"Categorias",color:"color01",size:"fontSize01",weight:"fontWeight01"})]}),e("div",{className:"searchContainer",children:e(Os,{})}),t("div",{className:"headerMKT-options",children:[e(Ee,{}),e(ba,{text:"Carrinho",color:"color01",size:"fontSize01",weight:"fontWeight01"})]})]})});h.div`
  .toggleLogin {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 1rem;

    .bx--toggle-input:checked
      + .bx--toggle-input__label
      > .bx--toggle__switch::before {
      background-color: ${v.bg03};
    }

    .description {
      font-size: 0.8rem;
      font-weight: 200;
      color: #000;
      margin: 1rem 0 0 1rem;
      cursor: pointer;
    }

    @media (min-width: 672px) and (max-width: 1055px) {
      .description {
        font-size: 1.4rem;
      }
    }

    @media (min-width: 1056px) {
      .description {
        font-size: ${v.fontSize08};
      }
    }
  }

  .bx--form-item {
    flex: none !important;
  }
`;const lv=h.div`
  position: relative;
  #content {
    display: none;
  }
  @media (min-width: 1056px) {
    display: none;
  }
  ${({isOpen:e})=>e&&`\n    height: 100vh;\n    width: 100vw;\n    background-color: ${f.color06};\n\n    `};
`,dv=h.div`
  display: block;
  text-decoration: none;
  font-size: 17px;
  ${({isOpen:e})=>e&&"\n      display: block !important;\n    "};
  ${({isOpen:e})=>!e&&"\n    display: none;\n  "};
`,sv=h(Xp)`
  cursor: pointer;
  float: right;
`,cv=h(mr)`
  cursor: pointer;
  float: right;
  margin-right: 0.5rem;
  margin-top: -2.75rem;
  color: ${f.color03};
`,pv=({Content:o,output:i})=>{const[n,a]=r(!1),l=()=>{a(!n),i()};return t(lv,{isOpen:n,"test-id":"menu-hamburger",children:[e(n?cv:sv,{onClick:()=>l()}),e(dv,{id:"content",isOpen:n,children:e(o,{})})]})},mv=({title:o,description:i,robots:n,url_canonical:r,icon:a})=>t(ri,{children:[e("meta",{name:"charSet",charSet:"utf-8"}),e("title",{children:o}),e("meta",{name:"description",content:i}),e("meta",{name:"robots",content:n}),e("link",{rel:"canonical",href:r}),e("meta",{name:"viewport",content:"minimum-scale=1,initial-scale=1, width=device-width, shrink-to-fit=no"}),e("meta",{name:"theme-color",content:"black"}),e("link",{rel:"icon",href:a})]}),uv=h.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`,hv=h("p")`
  cursor: pointer;
  font-size: 14px;
  color: ${f.color04};
  text-decoration: underline;
`,gv=h("div")`
  margin-top: 0.5rem;
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;
  padding: 10px;
  background-color: ${f.color06};
  border: 1px solid var(--cds-ui-04, ${f.color08});
  border-radius: 10px;
  width: 320px;

  .removeControl {
    cursor: pointer;
  }

  @media (max-width: 380px) {
    width: 288px;
  }
`,Av=h("div")`
  margin-left: auto;
`,fv=h("div")`
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;
  padding: 10px;
  width: 320px;

  @media (max-width: 380px) {
    width: 288px;
  }
`,vv=h("div")`
  margin-top: 0.5rem;
  background-color: ${f.color06};
  border: 1px solid ${f.colorError};
  border-radius: 10px;
  width: 320px;

  .removeControl {
    cursor: pointer;
  }

  @media (max-width: 380px) {
    width: 288px;
  }
`,xv=h("div")`
  display: flex;
  flex-direction: row;
  padding: 10px;

  svg {
    color: ${f.colorError};
    //width: 2rem;
    min-width: 1.2rem;
    margin-top: 0.2rem;
    margin-right: 0.2rem;
  }
`,bv=h("p")`
  font-size: 14px;
  color: ${f.colorError};
  text-align: left;
`,wv=h("div")`
  width: 318px;
  height: 2px;
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
  background-color: ${f.color08};

  @media (max-width: 380px) {
    width: 286px;
  }
`;let yv=[];const Cv=({label:o,acceptedFiles:i,maxFiles:n,maxFileSize:l,getFileMetaData:d,onChange:c,onRemove:p,uploadedFiles:m})=>{const[u,h]=r(yv),[g,A]=r();a((()=>{yv=m,h(m)}),[]);const f=s(null),v=e=>{e&&(A(e),yv=null==yv?void 0:yv.filter((t=>(null==t?void 0:t.file)!==e)),h(yv),p&&p(g),d&&d(yv),c&&c(yv))},x=e=>{e&&window.open(URL.createObjectURL(e))};return t(uv,{children:[e(pl,{alt:o,title:o,label:o,variant:"secondary",size:"1",onClick:()=>{var e;(null==f?void 0:f.current)&&(null===(e=null==f?void 0:f.current)||void 0===e||e.click())},disabled:(null==u?void 0:u.length)>=n}),e("input",{type:"file",id:"file",multiple:!0,disabled:(null==u?void 0:u.length)>=n,ref:f,style:{display:"none"},accept:i,onChange:e=>{var t;return(e=>{const t=Array.from(e),o=null==i?void 0:i.replaceAll(/[.,]/g,"").split(" ");Array.isArray(t)&&(null==t?void 0:t.length)>0&&(null==t||t.map((e=>{const t=/(?:\.([^.]+))?$/gi.exec(null==e?void 0:e.name)[1];(null==u?void 0:u.length)<n&&((null==e?void 0:e.size)<=l?(null==o?void 0:o.includes(t))?(null==yv||yv.push({file:e,name:null==e?void 0:e.name,type:null==e?void 0:e.type,uri:URL.createObjectURL(e),isUploaded:!0,hasError:!1,errorMsg:""}),A(e)):null==yv||yv.push({file:e,name:null==e?void 0:e.name,type:null==e?void 0:e.type,uri:URL.createObjectURL(e),isUploaded:!0,hasError:!0,errorMsg:"Formato não compatível. São aceitos apenas arquivos .jpg, .png ou .pdf."}):null==yv||yv.push({file:e,name:null==e?void 0:e.name,type:null==e?void 0:e.type,uri:URL.createObjectURL(e),isUploaded:!0,hasError:!0,errorMsg:"Tamanho ultrapassa o limite permitido de 1MB."}))})),h(yv),d&&d(u),c&&c(u))})(null===(t=null==e?void 0:e.target)||void 0===t?void 0:t.files)}}),null==u?void 0:u.map((o=>{var i,n,r,a;return(null==o?void 0:o.hasError)?t(vv,{children:[t(fv,{children:[e(Xl,{alt:null==o?void 0:o.name,title:null==o?void 0:o.name,onClick:()=>x(null==o?void 0:o.file),children:e(hv,{children:(null===(i=null==o?void 0:o.name)||void 0===i?void 0:i.length)>30?(null===(n=null==o?void 0:o.name)||void 0===n?void 0:n.substring(0,30))+"...":null==o?void 0:o.name})}),e(Av,{}),e(Te,{className:"removeControl",onClick:()=>v(null==o?void 0:o.file)})]}),e(wv,{}),t(xv,{children:[e(D,{}),e(bv,{children:null==o?void 0:o.errorMsg})]})]}):t(gv,{children:[e(Xl,{alt:null==o?void 0:o.name,title:null==o?void 0:o.name,onClick:()=>x(null==o?void 0:o.file),children:e(hv,{children:(null===(r=null==o?void 0:o.name)||void 0===r?void 0:r.length)>30?(null===(a=null==o?void 0:o.name)||void 0===a?void 0:a.substring(0,30))+"...":null==o?void 0:o.name})}),e(Av,{}),e(Te,{className:"removeControl",onClick:()=>v(null==o?void 0:o.file)})]})}))]})},Ev=h.div`
  svg {
    color: ${f.color03};
    circle {
      color: ${f.colorWarning};
    }
  }
`,Bv=({hasNotification:t,href:o,className:i})=>e(Ev,{className:i,children:e(tl,{label:t?e(Re,{"data-testid":"notification-new-test"}):e(Le,{"data-testid":"notification-test"}),href:o})}),kv=h("div")`
  text-align: center;
  .button {
    display: flex;
    padding: 25px;
    border-top: 1px;
    justify-content: center;
    border-top: 1px;
    border-style: solid;
    color: #a7a8ac;
    margin-top: 20px;
    button {
      background-color: green;
      width: 200px;
      height: 40px;
      color: white;
      border-radius: 20px;
      border-style: none;
      cursor: pointer;
    }
    button:hover {
      width: 200px;
      height: 40px;
      color: white;
      border-radius: 20px;
      border-style: none;
      cursor: pointer;
    }
  }
  .info {
    text-align: left;
    justify-items: left;
    padding: 15px;
    max-width: 567px;
    p {
      color: #a7a8ac;
    }
  }
  .container-404 {
    display: flex;
    justify-content: space-evenly;
    h3 {
      opacity: 1;
      font-size: 20px;
      font-weight: bold;
    }
    .page-not-found-title {
      font-size: 39px;
      color: ${v.interactive03};
      opacity: 1;
    }
    .image-container svg {
      padding: 1;
    }
  }
  @media (max-width: 672px) {
    .container-404 {
      flex-wrap: wrap-reverse;
      .page-not-found-title {
        font-size: 20px;
        text-align: left;
        width: 100%;
        margin-top: 1rem;
        margin-bottom: 1rem;
        color: ${v.interactive03};
      }
    }
  }
  ${e=>Bo.greaterThan(e,"medium").then(g`
      padding: 5rem;
      text-align: center;
    `)}
  ${e=>Bo.greaterThan(e,"small").then(g`
      padding: 5rem;
      text-align: center;
    `)}
`;var Iv,Nv;function Sv(){return Sv=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},Sv.apply(null,arguments)}const Ov=e=>i.createElement("svg",Sv({xmlns:"http://www.w3.org/2000/svg",width:225.493,height:241.969},e),Iv||(Iv=i.createElement("defs",null,i.createElement("clipPath",{id:"404_desktop_svg__a"},i.createElement("path",{fill:"#0670bf",d:"M15.536 2.589v20.715zM18.125 0h-5.178v20.715H5.179V0H0v25.894h12.947V36.25h5.179V25.894h2.589v-5.179h-2.589Z",clipRule:"evenodd","data-name":"Caminho 96077"})),i.createElement("clipPath",{id:"404_desktop_svg__b"},i.createElement("path",{fill:"#0670bf",d:"M15.536 36.25H5.179A5.18 5.18 0 0 1 0 31.073V5.179A5.18 5.18 0 0 1 5.179 0h10.357a5.18 5.18 0 0 1 5.179 5.179v25.894a5.18 5.18 0 0 1-5.179 5.177M5.179 5.179v25.894h10.357V5.179Zm2.589 10.357h5.179v5.179H7.768Z",clipRule:"evenodd","data-name":"Caminho 96079"})))),Nv||(Nv=i.createElement("g",{"data-name":"Grupo 103189",transform:"translate(-826 -229.016)"},i.createElement("circle",{cx:101.676,cy:101.676,r:101.676,fill:"#f5f7fd","data-name":"Elipse 1",transform:"translate(848.142 248.205)"}),i.createElement("g",{fill:"none",stroke:"#2e70b9",strokeDasharray:8,strokeWidth:2,"data-name":"Elipse 2",opacity:.2,transform:"translate(826 229.016)"},i.createElement("circle",{cx:101.676,cy:101.676,r:101.676,stroke:"none"}),i.createElement("circle",{cx:101.676,cy:101.676,r:100.676})),i.createElement("g",{"data-name":"Grupo 103187"},i.createElement("path",{fill:"#fff",d:"M837.03 336.063h135.118v90.7H837.03Z","data-name":"Caminho 96085"}),i.createElement("path",{fill:"#0670bf",d:"M971.7 325.288H837.207A11.207 11.207 0 0 0 826 336.495v89.66a11.207 11.207 0 0 0 11.207 11.207h44.83v22.416h-22.415v11.21h89.66v-11.21h-22.415v-22.415H971.7a11.207 11.207 0 0 0 11.2-11.208v-89.66a11.207 11.207 0 0 0-11.2-11.207m-56.04 134.49h-22.415v-22.415h22.415Zm56.04-33.623H837.207v-89.66H971.7Z","data-name":"Caminho 96065"}),i.createElement("g",{clipPath:"url(#404_desktop_svg__a)","data-name":"Grupo 103180",transform:"translate(866.073 363.408)"},i.createElement("path",{fill:"#0670bf",d:"M-3.453-3.453h27.62v43.156h-27.62Z","data-name":"Caminho 96076"})),i.createElement("g",{"data-name":"Grupo 103183"},i.createElement("g",{clipPath:"url(#404_desktop_svg__a)","data-name":"Grupo 103180",transform:"translate(922.832 363.408)"},i.createElement("path",{fill:"#0670bf",d:"M-3.453-3.453h27.62v43.156h-27.62Z","data-name":"Caminho 96076"}))),i.createElement("g",{"data-name":"Grupo 103182"},i.createElement("g",{clipPath:"url(#404_desktop_svg__b)","data-name":"Grupo 103181",transform:"translate(894.452 363.408)"},i.createElement("path",{fill:"#0670bf",d:"M-3.453-3.453h27.62v43.156h-27.62Z","data-name":"Caminho 96078"}))))))),Pv=({redirectUrl:o="/"})=>{const i=wo();return e(kv,{children:t("div",{className:"container-404",children:[t("div",{className:"info",children:[e("h3",{children:"Erro 404"}),e("div",{className:"page-not-found-title",children:"Página não encontrada!"}),e("p",{children:"Não foi possível encontrar a página solicitada."}),e("p",{children:"Por favor, verifique se você digitou o endereço do site corretamente."}),e("div",{className:"button",children:e("button",{onClick:function(){i.push(o)},children:" Ir para a página inicial "})})]}),e("div",{className:"image-container",children:e(Ov,{})})]})})},Qv={[dm.ESPECIALISTA_CONVIDADO]:["/","/specialist/loginPage","/auth/*","/authenticator/*","/authentication/*"],[dm.ESPECIALISTA]:["/dashboardPartner/*","/","/partner/*","/orders/*","/clients/*","/specialist/*","/auth/*","/authenticator/*","/authentication/*","/simulationLogged/*","/formalization/*"],[dm.ASSESSOR]:["/dashboardPartner/*","/","/partner/*","/orders/*","/clients/*","/auth/*","/authenticator/*","/authentication/*","/simulationLogged/*","/formalization/*"]},zv={[dm.CLIENTE_CONVIDADO]:[{path:"/specialist/*",redirectTo:"/"}],[dm.ESPECIALISTA_CONVIDADO]:[{path:"/",redirectTo:"/specialist/loginPage"}],[dm.CLIENTE]:[{path:"/specialist/*",redirectTo:"/"},{path:"/dashboardPartner/*",redirectTo:"/dashboard/DashboardPage"},{path:"/partner/*",redirectTo:"/dashboard/DashboardPage"},{path:"/orders/*",redirectTo:"/simulationLogged/CreditContractPage"},{path:"/clients/myClients",redirectTo:"/myProfile/myProfilePage"},{path:"/clients/view",redirectTo:"/myProfile/myProfilePage"},{path:"/clients/deleted/success",redirectTo:"/myProfile/myProfilePage"}],[dm.ASSESSOR]:[{path:"/",redirectTo:"/dashboardPartner"},{path:"/specialist/*",redirectTo:"/dashboardPartner"},{path:"/simulationLogged/BoostProduction",redirectTo:"/simulationLogged/CreditModalities"},{path:"/simulationLogged/CreditLinePage",redirectTo:"/simulationLogged/CreditModalities"},{path:"/simulationLogged/detail/*",redirectTo:"/simulationLogged/CreditModalities"},{path:"/simulationLogged/CreditUpdateSimulatorCPRFPage",redirectTo:"/simulationLogged/CreditModalities"},{path:"/simulationLogged/CreditRequest",redirectTo:"/simulationLogged/CreditModalities"},{path:"/simulationLogged/AvailableProducts",redirectTo:"/simulationLogged/CreditModalities"},{path:"/simulationLogged/CreditContractPage",redirectTo:"/orders/creditOrders"},{path:"/simulationLogged/RestrictionMessage",redirectTo:"/orders/creditOrders"},{path:"/formalization/signature/contract-info/*",redirectTo:"/orders/creditOrders"}],[dm.ESPECIALISTA]:[{path:"/",redirectTo:"/dashboardPartner"},{path:"/specialist/loginPage",redirectTo:"/"},{path:"/simulationLogged/BoostProduction",redirectTo:"/simulationLogged/CreditModalities"},{path:"/simulationLogged/CreditLinePage",redirectTo:"/simulationLogged/CreditModalities"},{path:"/simulationLogged/detail/*",redirectTo:"/simulationLogged/CreditModalities"},{path:"/simulationLogged/CreditUpdateSimulatorCPRFPage",redirectTo:"/simulationLogged/CreditModalities"},{path:"/simulationLogged/CreditRequest",redirectTo:"/simulationLogged/CreditModalities"},{path:"/simulationLogged/AvailableProducts",redirectTo:"/simulationLogged/CreditModalities"},{path:"/simulationLogged/CreditContractPage",redirectTo:"/orders/creditOrders"},{path:"/simulationLogged/RestrictionMessage",redirectTo:"/orders/creditOrders"},{path:"/formalization/signature/contract-info/*",redirectTo:"/orders/creditOrders"}]},Mv=h.div`
  .bx--loading__stroke {
    stroke: ${f.bg10};
  }

  .bx--loading__stroke {
    stroke: ${f.bg10};
  }

  .icon-info {
    color: ${f.colorInfo};
  }

  .icon-warn {
    color: ${f.colorWarning};
  }

  .icon-error {
    color: ${f.colorError};
  }

  .icon-success {
    color: ${f.colorSuccess};
  }

  .icon-help {
    color: ${f.color04};
  }
`;function Dv(e,t){const o=e.split("/"),i=t.split("/");if(o.length>i.length)return!1;for(let e=0;e<o.length;e++){const t=o[e],n=i[e];if("*"===t)return!0;if(t.toLowerCase()!==n.toLowerCase())return!1}return!0}var jv;!function(e){e.DEFAULT="DEFAULT",e.ISREDIRECTING="ISREDIRECTING",e.SUCCESS="SUCCESS"}(jv||(jv={}));const Tv=({children:t})=>{var i,n;const r=wo(),a=qt(),d=l((()=>({[jv.DEFAULT]:e(o,{children:"Erro de autenticação de perfil"}),[jv.ISREDIRECTING]:e(o,{children:"Você será redirecionado"}),[jv.SUCCESS]:e(Mv,{id:"PageWrapperContainer","data-testid":"page-wrapper",children:t})})),[t]),s=(null===(i=null==a?void 0:a.profile)||void 0===i?void 0:i.profileAccess)||"",c=l((()=>Qv[s]||[]),[s]),p=l((()=>zv[s]||[]),[s]);if(s){const e=r.location.pathname;if(c.length>0&&!c.some((t=>Dv(t,e)))){const e=null!==(n=c[0].split("/")[1])&&void 0!==n?n:"";return r.replace(`/${e}`),d[jv.ISREDIRECTING]}const t=p.find((t=>Dv(t.path,e)));return t?(r.replace(t.redirectTo),d[jv.ISREDIRECTING]):d[jv.SUCCESS]}return e(o,{children:d[jv.SUCCESS]})},Rv=({orderId:t,children:o})=>{const{canAccessOrderVerify:i}=ti(),{data:n,error:r,loading:l}=Qt(t),{canAccess:d,message:s}=i(null==n?void 0:n.getOrderData),{LoaderGate:c,toggleMode:p}=Tf("loading",void 0,{toggleTimeout:0});return a((()=>{l||p(!t||!r&&d?"done":"error")}),[d,t,n,r,l]),e(c,{children:o})},Lv=({isJustGuest:t=!1,isProtected:o=!1,target:i="/authentication/valid-user",children:n})=>{var d,s,c;const[p,m]=r(""),[u,h]=r({protected:!1,loading:!0}),[g,A]=r(!1),{data:f,loading:v}=zt(),x=wo(),b=qt(),{pathname:w}=Co(),y=l((()=>"/"===w),[w]);Mt(!!(null===(d=null==f?void 0:f.validateUser)||void 0===d?void 0:d.isValidToken));const C=()=>{Ht.set({roles:[]}),(()=>{const e=new Mo;e.remove("_ga"),e.remove("permissions"),e.remove("psid",{path:"/"}),e.remove("logged"),e.remove("registerRedirect")})()},E=()=>{var e,t;if("/authenticator/login"===w.toLowerCase())return;const o=null!==(t=null===(e=b.profile)||void 0===e?void 0:e.channel)&&void 0!==t?t:"";C(),document.cookie=`registerRedirect=${w}; path=/;`;let i="/authenticator/login";o&&(i+=`?canal=${o}`),x.push(i)};return a((()=>(document.addEventListener("refresh-token-expired",(()=>{E()})),()=>document.removeEventListener("refresh-token-expired",(()=>{})))),[]),a((()=>{if(null===window||void 0===window?void 0:window.isWebView){const e="registerRedirect=";let t=document.cookie;-1!==t.indexOf(e)&&(t=t.substr(t.indexOf(e),t.length),-1!==t.indexOf(";")&&(t=t.substr(0,t.indexOf(";"))),t=t.split("=")[1],t&&m(t))}}),[]),a((()=>{var e;const t="registerRedirect=",i=document.cookie;let n;-1!==i.indexOf(t)&&(n=i.substr(i.indexOf(t),i.length),-1!==n.indexOf(";")&&(n=n.substr(0,n.indexOf(";"))),n=n.split("=")[1]),!o||(null===window||void 0===window?void 0:window.isWebView)||v||((null===(e=null==f?void 0:f.validateUser)||void 0===e?void 0:e.isValidToken)?n?(x.push(n),document.cookie="registerRedirect=; path=/;",h({protected:!1,loading:!0})):h({protected:!0,loading:!1}):(E(),h({protected:!0,loading:!1})))}),[v]),a((()=>{var e;window&&o&&(null===window||void 0===window?void 0:window.isWebView)&&(null===(e=null==f?void 0:f.validateUser)||void 0===e?void 0:e.isValidToken)&&(p?(x.push(p),document.cookie="registerRedirect=; path=/;",h({protected:!1,loading:!0})):h({protected:!0,loading:!1}))}),[null===(s=null==f?void 0:f.validateUser)||void 0===s?void 0:s.isValidToken,p]),a((()=>{A(!0)}),[]),u.protected?n:o&&u.loading?e(Vt,{}):v&&y?n:v?g?e(Vt,{}):null:t?(null===(c=null==f?void 0:f.validateUser)||void 0===c?void 0:c.isValidToken)&&!y?p?(x.push(p),document.cookie="registerRedirect=; path=/;",e(Vt,{})):("undefined"!=typeof window&&(window.location.href=i),e(Vt,{})):n:void 0},Uv=h.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 5px;
  flex: 1;
  cursor: pointer;

  background: #fff;
  box-shadow:
    0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);

  transition: transform 0.4s;

  .row-button-title {
    margin-right: 10px;
  }

  svg {
    transform: scale(0.8);
  }

  & + div {
    margin-top: 10px;
  }

  &:hover {
    transform: translateX(5px);
  }
`,qv=({title:o})=>t(Uv,{children:[e("p",{className:"row-button-title",children:o}),e(er,{})]}),Wv=h.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`,Gv=h("button")`
  ${({variant:e})=>g`
    ${"red"===e&&`\n        background-color: ${f.colorAlertLight};\n        color: ${f.colorError};\n      `};
    ${"yellow"===e&&`\n        background-color: ${f.colorWarningLight};\n        color: ${f.colorEagroYellow};\n      `};
    ${"green"===e&&`\n        background-color: ${f.colorSuccessLight};\n        color: ${f.color01};\n      `};

    border: 0.25px solid ${f.color07};
    cursor: pointer;
    width: 100%;
    height: 40px;
    padding: 0;
    font-size: ${f.fontSize01};
    font-weight: ${f.fontWeight02};
    transition: 50ms all;

    &:first-child {
      border-radius: 8px 0 0 8px;
    }

    &:last-child {
      border-radius: 0 8px 8px 0;
    }

    &[data-selected='true'] {
      border: 2px solid ${f.color02};
      position: relative;
    }

    :hover,
    :active,
    :focus-within {
      filter: brightness(0.95);
    }
  `}
`,Hv=({className:t,value:o,onChange:i})=>{const n=[1,2,3,4,5,6,7,8,9,10],r=e=>{const t=n.filter((e=>e>=1&&e<=6)),o=n.filter((e=>e>=7&&e<=8)),i=n.filter((e=>e>=9&&e<=10));return t.includes(e)?"red":o.includes(e)?"yellow":i.includes(e)?"green":void 0};return e(Wv,{className:t,children:n.map(((t,n)=>e(Gv,{className:`button ${r(t)}`,onClick:()=>i(t),variant:r(t),"data-selected":t===o,children:t},n)))})},Fv=h.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: 1056px) {
    width: 500px;
  }
  input {
    width: 100%;
    padding: 10px;
    border: 1px solid #a7a8ac;
    border-radius: 5px;
    text-align: left;
    padding-left: 45px;
    background: url(${Wu}) top left no-repeat;
    margin-bottom: 12px;
  }

  .input-icons i {
    position: absolute;
    margin-top: 20px;
  }
  .label {
    color: #0670bf;
    font-weight: 600;
  }
  .input-icons {
    width: 100%;
  }

  .icon {
    padding: 10px;
    color: green;
    min-width: 50px;
    text-align: center;
  }
`,Vv=()=>e(Fv,{children:t("div",{className:"input-icons",children:[e("i",{className:"icon",children:e(Vu,{})}),e("p",{className:"label",style:{marginBottom:"1rem"}}),e("input",{className:"input",placeholder:"Buscar",defaultValue:""})]})}),Kv=h.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 2rem;

  padding: 1.5rem;

  border-radius: 5px;
  border: 1px solid ${f.color07};
  background: ${f.color03};

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    flex-direction: column;

    padding: 0;
  }

  @media (max-width: 320px) {
  }
`,Jv=h(yo)`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  width: 100%;

  padding: 1rem 0;

  border-bottom: 2px solid ${f.color07};
  color: ${f.color04};

  > p {
    color: ${f.color04};
    font-size: ${f.fontSize02};
    font-weight: ${f.fontWeight03};
  }

  .label-group {
    display: flex;
    align-items: center;
    gap: 1rem;

    width: 100%;

    & + .label-group {
      margin-top: 0.5rem;
    }

    strong {
      word-break: break-all;
    }
  }
`,Yv=h.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;

  width: 100%;

  padding: 1rem 0;

  border: 0;
  border-bottom: 2px solid ${f.color07};
  text-align: start;
  color: ${f.color04};

  cursor: pointer;

  :disabled {
    cursor: not-allowed;
  }

  > p {
    color: ${f.color04};
    font-size: ${f.fontSize02};
    font-weight: ${f.fontWeight03};
  }

  .label-group {
    display: flex;
    align-items: center;
    gap: 1rem;

    width: 100%;

    & + .label-group {
      margin-top: 0.5rem;
    }
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    .label-group {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;

      & + .label-group {
        margin-top: 0;
      }

      &.made-by-label {
        margin-top: 0.5rem;
      }
    }
  }

  @media (max-width: 320px) {
  }
`,Zv=h.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  ${({isVertical:e})=>e&&"\n    flex-direction: column;\n    align-items: flex-start;\n  "}

  color: ${f.color09};
  font-size: ${f.fontSize01};

  span {
    width: fit-content;
  }

  strong {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;

    width: fit-content;

    color: ${f.color04};
    font-weight: ${f.fontWeight01};

    div {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
  }

  svg {
    width: 1rem;
    height: 1rem;
    min-width: 1rem;
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    flex-direction: row;

    strong {
      div {
        flex-wrap: wrap;
      }
    }
  }

  @media (max-width: 320px) {
  }
`,Xv=h.h3`
  color: ${f.bg04};
  font-size: ${f.fontSize03};
  font-weight: ${f.fontWeight03};

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    font-size: ${f.fontSize02};
  }

  @media (max-width: 320px) {
  }
`,_v=h.div`
  display: flex;
  align-items: center;
  justify-content: center;

  min-width: 2.5rem;
  min-height: 2.5rem;
  width: fit-content;
  height: fit-content;

  border-radius: 50%;

  svg {
    height: 1rem;
  }

  ${({mode:e})=>"primary"===e&&`\n      background-color: ${f.colorInfoLight};\n\n      svg {\n        color: ${f.bg02};\n      }\n    `};

  ${({mode:e})=>"secondary"===e&&`\n      background-color: ${f.colorAlertLight};\n\n      svg {\n        color: ${f.colorError};\n      }\n    `};
`,$v=h.form`
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem 2.5rem;

  .form-group {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem 4rem;

    width: 100%;

    .radio-group {
      display: flex;
      align-items: center;
      gap: 1.5rem;

      font-size: ${f.fontSize01};
    }

    .search-input-group {
      flex: 1;

      min-width: 16rem;
    }

    .agency-account-group {
      flex: 1;

      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: 1rem;

      .input-group {
        flex: 1 1 16rem;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 1rem;

        .bx--search-close {
          display: none;
        }

        .bx--form-item {
          flex: 1 1 7rem;
        }

        input {
          height: 2.5rem;

          padding: 0rem 1rem;

          border-radius: 8px;
          border: 1px solid ${f.color08};
          background: ${f.color03};

          &::placeholder {
            color: ${f.color08};
          }
        }
      }

      button {
        flex: 1;

        height: 2.5rem;

        padding: 0 1.3125rem;

        border: 2px solid ${f.color01};
        border-radius: 100px;

        color: ${f.color01};
        font-size: ${f.fontSize01};
        font-weight: ${f.fontWeight03};

        transition:
          0.2s border,
          0.2s color;

        cursor: pointer;

        &:disabled {
          color: ${f.color08};
          border: 2px solid ${f.color08};

          cursor: not-allowed;
        }
      }
    }
  }

  &.small {
    flex-direction: column;
    align-items: flex-start;

    padding-right: 0;

    .form-group {
      flex-direction: column;
      align-items: stretch;

      width: 100%;
      max-width: 27.14375rem;

      .search-input-group {
        flex: 0;
        margin-bottom: auto;
      }
    }
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
    align-items: flex-start;
    flex-direction: column;

    .form-group {
      flex-wrap: wrap;

      .radio-group {
        flex-wrap: wrap;
      }

      .search-input-group {
        width: 100%;
      }
    }

    &.small {
      .form-group {
        max-width: 100%;
      }
    }
  }

  @media (max-width: 720px) {
    gap: 1.5rem 2.5rem;
    padding: 1rem;

    .form-group {
      align-items: flex-start;
      flex-direction: column;

      .search-input-group {
        min-width: 0;
      }
    }

    &.small {
      max-width: 100%;

      padding-right: 1rem;
      padding-bottom: 0;
    }
  }

  @media (max-width: 320px) {
  }
`,ex=h(Yt)`
  .bx--radio-button__label {
    > span {
      min-width: fit-content;
      white-space: nowrap;
    }

    .bx--radio-button__appearance {
      margin: 0;
      margin-right: 0.5rem;
      border-color: ${f.bg01};
    }
  }

  .bx--radio-button:checked + .bx--radio-button__label {
    .bx--radio-button__appearance {
      border-color: ${f.bg01};

      ::before {
        background-color: ${f.bg01};
      }
    }
  }
`,tx=h.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  /* max-width: calc(50% - 1rem); */

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    gap: 0;
    padding: 0rem;
    max-width: 100%;

    h3 {
      padding: 0 1rem;
    }
  }

  @media (max-width: 320px) {
  }
`,ox=h.aside`
  flex: 1;
  display: flex;
  align-items: stretch;
  gap: 1rem 1.5rem;
  flex-wrap: wrap;

  .card {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;

    padding: 1rem;

    box-shadow: 0px 2px 8px ${f.bx01};
    border: 1px solid ${f.color07};
    border-radius: 5px;

    svg {
      min-width: 1.5rem;
    }

    .card-subtitle {
      display: flex;
      flex-direction: column;
      flex-basis: 8.875rem;
      gap: 0.5rem;

      font-size: ${f.fontSize07};
      color: ${f.color10};
      white-space: nowrap;

      .amount {
        font-size: ${f.fontSize01};
        font-weight: ${f.fontWeight02};
      }
    }
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    flex-wrap: nowrap;
    gap: 1rem;

    padding: 1rem;
    padding-top: 1.5rem;

    overflow: auto;

    .card {
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;

      min-width: 10rem;

      .card-subtitle {
        flex-basis: 0;

        .amount {
          font-size: ${f.fontSize03};
        }
      }
    }
  }

  @media (max-width: 320px) {
  }
`;var ix,nx=function(e,t,o){return void 0===t&&(t={}),void 0===o&&(o={}),function(i,n,r){try{return Promise.resolve(function(a,l){try{var d=(t.context&&"development"===process.env.NODE_ENV&&console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead"),Promise.resolve(e["sync"===o.mode?"validateSync":"validate"](i,Object.assign({abortEarly:!1},t,{context:n}))).then((function(e){return r.shouldUseNativeValidation&&zi({},r),{values:o.rawValues?i:e,errors:{}}})))}catch(e){return l(e)}return d&&d.then?d.then(void 0,l):d}(0,(function(e){if(!e.inner)throw e;return{values:{},errors:Mi((t=e,o=!r.shouldUseNativeValidation&&"all"===r.criteriaMode,(t.inner||[]).reduce((function(e,t){if(e[t.path]||(e[t.path]={message:t.message,type:t.type}),o){var i=e[t.path].types,n=i&&i[t.type];e[t.path]=Oi(t.path,o,e,t.type,n?[].concat(n,t.message):t.message)}return e}),{})),r)};var t,o})))}catch(e){return Promise.reject(e)}}};!function(e){e.CLIENT="client",e.CPF="cpf",e.ORDER="order",e.AGENCY_ACCOUNT="agency_account"}(ix||(ix={}));const rx=(e="")=>{var t;const o=new RegExp(/^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/g);return 1===(null===(t=null==e?void 0:e.trim().match(o))||void 0===t?void 0:t.length)},ax=Di.object().shape({search_type:Di.string().oneOf(Object.values(ix)).required(),search:Di.string().notRequired().when("search_type",{is:e=>e===ix.CLIENT||e===ix.ORDER,then:Di.string().required().min(3),otherwise:Di.string().notRequired().when("search_type",{is:ix.CPF,then:Di.string().test("test-invalid-cpf","CPF inválido",(e=>rx(e)))})}),agency:Di.string().notRequired().when("search_type",{is:ix.AGENCY_ACCOUNT,then:Di.string().required().min(4).max(4)}),account:Di.string().notRequired().when("search_type",{is:ix.AGENCY_ACCOUNT,then:Di.string().required().min(6).max(12)})}),lx=({client:o})=>{const i=wo();return t(Jv,{to:{pathname:"/clients/view",state:{cpf:null==o?void 0:o.cpf,inviteCode:null==o?void 0:o.inviteCode,isTrusted:!0,psidOrigin:i.location}},children:[e("p",{children:null==o?void 0:o.fullName}),t(Zv,{children:[e("span",{children:"CPF"}),e("strong",{children:$e(null==o?void 0:o.cpf,{allowCNPJ:!0,allowMask:!0})})]}),t(Zv,{children:[e("span",{children:"E-mail"}),e("strong",{children:null==o?void 0:o.email})]})]})},dx=({order:o,onClick:i,isDisabled:n})=>{const{getStatusComponent:r}=ti();return t(Yv,{onClick:e=>null==i?void 0:i(e,o),type:"button",disabled:n,children:[t("p",{children:[null==o?void 0:o.modalidadeCredito," ",(null==o?void 0:o.produto)?" - "+(null==o?void 0:o.produto):""]}),t("div",{className:"label-group",children:[t(Zv,{isVertical:!0,children:[e("span",{children:"Número"}),e("strong",{children:null==o?void 0:o.numeroPedido})]}),t(Zv,{isVertical:!0,children:[e("span",{children:"Valor"}),e("strong",{children:Ze(null==o?void 0:o.valorTotalFormalizacao)})]})]}),t("div",{className:"label-group",children:[t(Zv,{isVertical:!0,children:[e("span",{children:"Cliente"}),e("strong",{children:null==o?void 0:o.nomeCliente})]}),t(Zv,{isVertical:!0,children:[e("span",{children:"Status"}),e("strong",{children:e("div",{children:r((null==o?void 0:o.situacaoFormalizacao)||"")})})]})]}),e("div",{className:"label-group made-by-label",children:e(fm,{orderUserId:null==o?void 0:o.idUsuarioSolicitacaoPedido,orderUserProfile:null==o?void 0:o.perfilUsuarioSolicitacaoPedido})})]})},sx=({className:i,useAutoCloseSearchWrapper:n,hasQuickSearch:l,pathToRedirectOnSearch:d,isDisabled:c,onSearchSubmit:p,handleOrderNavigate:m})=>{var u,h,g,A,f;const v=s(null),x=(null===(u=qt().profile)||void 0===u?void 0:u.profileAccess)===Wt.ASSESSOR,[b,w]=Dt(),[y,C]=r({search:"",type:(null===(h=b.search_type)||void 0===h?void 0:h.trim())||ix.CLIENT}),{control:E,handleSubmit:B,watch:k,formState:I,getValues:N,setValue:S}=Ii({resolver:nx(ax),defaultValues:{search_type:(null===(g=b.search_type)||void 0===g?void 0:g.trim())||ix.CLIENT,search:(null===(A=b.search)||void 0===A?void 0:A.trim())||"",agency:(null===(f=b.agency)||void 0===f?void 0:f.replace(/\D+/g,"").trim())||"",account:nt(b.account).trim()},mode:"onChange"}),{getPossibleClients:O,possibleClientsResponse:P}=jt().getPossibleClientsLazy(),{getClientProfile:Q,clientProfileResponse:z}=ft().getClientProfileLazy(),{getOrderByNumber:M,orderByNumberResponse:D}=Tt().getOrderByNumberLazy(),j=e=>{var t;const o=new RegExp(/^\d+/g);return 1===(null===(t=e.trim().match(o))||void 0===t?void 0:t.length)};return a((()=>{var e;const{search:t,type:o}=y;if(t.trim().length>=3&&l){const i={[ix.CLIENT]:()=>O({filter:{search:t}}),[ix.CPF]:()=>{rx(t)&&Q(t)},[ix.ORDER]:()=>M(t)};null===(e=i[o])||void 0===e||e.call(i)}}),[y,l]),a((()=>{const e=N("search");N("search_type")===ix.ORDER&&S("search",e.replace(/\D+/g,""))}),[k("search_type")]),a((()=>{const e=N("search"),t=N("search_type");if(t===ix.CLIENT||t===ix.CPF){const o=j(e),i=o?ix.CPF:ix.CLIENT;t!==i&&(S("search_type",i),o&&S("search",$e(e)))}const o=setTimeout((()=>{C({search:e,type:t})}),500);return()=>{clearTimeout(o)}}),[k("search"),k("search_type")]),a((()=>{var e;N("agency").length>=4&&(null===(e=v.current)||void 0===e||e.focus())}),[k("agency"),v.current]),t($v,{className:i,onSubmit:B((e=>{null==p||p(e),d&&(e.search_type===ix.AGENCY_ACCOUNT?delete e.search:(delete e.agency,delete e.account),w(e,{path:d}))})),children:[e(Xv,{children:"Busque por:"}),t("div",{className:"form-group",children:[e(Si,{control:E,name:"search_type",render:({field:o})=>t("div",{className:"radio-group",children:[e(ex,{id:"radio-client",name:"search_type",labelText:"Cliente",value:ix.CLIENT,onChange:o.onChange,checked:o.value===ix.CLIENT||o.value===ix.CPF,disabled:c,alt:"Botão para selecionar a opção de cliente",title:"Botão para selecionar a opção de cliente"}),e(ex,{id:"radio-order",name:"search_type",labelText:"Número do pedido",value:ix.ORDER,onChange:o.onChange,checked:o.value===ix.ORDER,disabled:c,alt:"Botão para selecionar a opção de pedido",title:"Botão para selecionar a opção de pedido"}),!x&&e(ex,{id:"radio-agency-account",name:"search_type",labelText:"Agência e conta",value:ix.AGENCY_ACCOUNT,onChange:o.onChange,checked:o.value===ix.AGENCY_ACCOUNT,disabled:c,alt:"Botão para selecionar a opção de conta",title:"Botão para selecionar a opção de conta"})]})}),k("search_type")===ix.AGENCY_ACCOUNT?t("div",{className:"agency-account-group",children:[t("div",{className:"input-group",children:[e(Si,{control:E,name:"agency",render:({field:t})=>e(mo,{id:"agency-input",name:t.name,className:"input-field",type:"text",labelText:"Agência",placeholder:"Agência",alt:"Input para selecionar a agência",title:"Input para selecionar a agência",maxLength:4,hideLabel:!0,value:t.value,onChange:e=>t.onChange(e.target.value.replace(/\D+/g,"")),disabled:c})}),e(Si,{control:E,name:"account",render:({field:t})=>e(mo,{ref:v,id:"account-input",name:t.name,className:"input-field",type:"text",labelText:"Conta",placeholder:"Conta",alt:"Input para selecionar a conta",title:"Input para selecionar a conta",maxLength:12,hideLabel:!0,value:t.value,onChange:e=>t.onChange(nt(e.target.value)),disabled:c})})]}),e("button",{className:"search",type:"submit",disabled:!I.isValid||c,children:"Buscar"})]}):e(Si,{control:E,name:"search",render:({field:t})=>{var i,r,a,l,d,s,p,u,h;return N("search_type")===ix.CLIENT?e(Ns,{autoCloseWrapper:n,searchProps:{name:t.name,labelText:""},placeholder:"Busque por nome ou CPF",value:null!==(i=t.value)&&void 0!==i?i:"",onChange:e=>t.onChange(j(e)?$e(e):e),isLoading:P.loading,hasError:!!P.error,disabled:c,items:null===(a=null===(r=null==P?void 0:P.data)||void 0===r?void 0:r.getPossibleClientsByName)||void 0===a?void 0:a.data,itemKey:"cpf",inputGroupProps:{className:"search-input-group"},renderItem:t=>e(lx,{client:t},null==t?void 0:t.cpf)}):N("search_type")===ix.CPF?e(Ns,{autoCloseWrapper:n,searchProps:{name:t.name,labelText:""},placeholder:"Busque por nome ou CPF",value:null!==(l=t.value)&&void 0!==l?l:"",onChange:e=>t.onChange(j(e)?$e(e):e),isLoading:z.loading,hasError:!!z.error,disabled:c,items:(null===(d=z.data)||void 0===d?void 0:d.getClientProfile)?[null===(s=z.data)||void 0===s?void 0:s.getClientProfile]:rx(t.value)?[]:void 0,itemKey:"cpf",inputGroupProps:{className:"search-input-group"},renderItem:t=>e(lx,{client:t},null==t?void 0:t.cpf)}):N("search_type")===ix.ORDER?e(Ns,{autoCloseWrapper:n,searchProps:{name:t.name,labelText:""},placeholder:"Digite o número do pedido",value:null!==(p=t.value)&&void 0!==p?p:"",onChange:e=>t.onChange(e.replace(/\D+/g,"")),isLoading:D.loading,hasError:!!D.error,disabled:c,items:(null===(u=D.data)||void 0===u?void 0:u.getOrderByOrderNumber)?[null===(h=D.data)||void 0===h?void 0:h.getOrderByOrderNumber]:[],itemKey:"numeroPedido",inputGroupProps:{className:"search-input-group"},renderItem:t=>e(dx,{order:t,onClick:e=>null==m?void 0:m(e,t),isDisabled:c},null==t?void 0:t.numeroPedido)}):e(o,{})}})]})]})},cx=({className:o,onSearchSubmit:i,pathToRedirectOnSearch:n,hasQuickSearch:l=!0,hasCardsAmount:d=!1,clientsNumber:s=0,ordersNumber:c=0})=>{const p=wo(),m=ti(),{createPrivilegedUserSession:u}=ht(),{updatePrivilegedSessionId:h}=gt(),{updateOrderViewed:g}=At(),{clientProfileResponse:A,getClientProfile:f}=ft().getClientProfileLazy(),[v,x]=r(!1),[b,w]=r({pathname:"#"}),[y,C]=r({isOpen:!1,title:"Acesso não permitido",message:""}),E=()=>{C((e=>Object.assign(Object.assign({},e),{isOpen:!1})))};return a((()=>{var e;b.order&&(b.order.numeroCPFCNPJ?f(null===(e=b.order)||void 0===e?void 0:e.numeroCPFCNPJ):p.push("/partner/error"))}),[b.order]),a((()=>{A.error&&p.push("/partner/error")}),[A.error]),a((()=>{var e,t,o,i;if((null===(e=A.data)||void 0===e?void 0:e.getClientProfile)&&(null===(t=b.order)||void 0===t?void 0:t.numeroCPFCNPJ)===(null===(o=A.data)||void 0===o?void 0:o.getClientProfile.cpf)){const{cpf:e="",email:t="",fullName:o="",phoneNumber:n=""}=(null===(i=A.data)||void 0===i?void 0:i.getClientProfile)||{};x(!0),u({clientCPFCNPJ:e,clientEmail:t,clientName:o,clientPhone:n}).then((e=>{var t,o,i;const n=String(null!==(o=null===(t=b.order)||void 0===t?void 0:t.numeroPedido)&&void 0!==o?o:""),{privilegedSessionId:r=""}=(null===(i=e.data)||void 0===i?void 0:i.createPrivilegedUserSession)||{};r&&(h(r),g(n),p.push(b.pathname,{selectedOrder:b.order,isTrusted:!0}))})).catch((()=>{p.push("/partner/error")})).finally((()=>{x(!1)}))}}),[b,A]),t(Kv,{className:o,children:[e(Us,Object.assign({},y,{icon:e(ce,{}),onConfirm:E,onCancel:E})),e(sx,{className:d?"small":"",onSearchSubmit:i,pathToRedirectOnSearch:n,hasQuickSearch:l,handleOrderNavigate:(e,t)=>{const{message:o,canAccess:i,pathname:n}=m.canAccessOrderVerify(t);i?w({order:t,pathname:n}):C((e=>Object.assign(Object.assign({},e),{isOpen:!0,message:o})))},useAutoCloseSearchWrapper:!y.isOpen,isDisabled:v||A.loading}),d&&t(tx,{children:[e(Xv,{children:"Acompanhe pedidos e clientes"}),t(ox,{children:[t("div",{className:"card",children:[e(_v,{mode:"primary",children:e(Ue,{title:"Ícone representando pedidos de crédito"})}),t("div",{className:"card-subtitle",children:["Pedidos de crédito",e("p",{className:"amount",children:c})]})]}),t("div",{className:"card",children:[e(_v,{mode:"secondary",children:e(qe,{title:"Ícone representando a quantidade de clientes"})}),t("div",{className:"card-subtitle",children:["Meus clientes",e("p",{className:"amount",children:s})]})]})]})]})]})};h.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;

  width: 100%;

  padding: 1rem 0;

  border: 0;
  border-bottom: 2px solid ${f.color07};
  text-align: start;
  color: ${f.color04};

  cursor: pointer;

  :disabled {
    cursor: not-allowed;
  }

  > p {
    color: ${f.color04};
    font-size: ${f.fontSize02};
    font-weight: ${f.fontWeight03};
  }

  .label-group {
    display: flex;
    align-items: center;
    gap: 1rem;

    width: 100%;

    & + .label-group {
      margin-top: 0.5rem;
    }
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    .label-group {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;

      & + .label-group {
        margin-top: 0;
      }

      &.made-by-label {
        margin-top: 0.5rem;
      }
    }
  }

  @media (max-width: 320px) {
  }
`,h.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  ${({isVertical:e})=>e&&"\n    flex-direction: column;\n    align-items: flex-start;\n  "}

  color: ${f.color09};
  font-size: ${f.fontSize01};

  span {
    width: fit-content;
  }

  strong {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;

    width: fit-content;

    color: ${f.color04};
    font-weight: ${f.fontWeight01};

    div {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
  }

  svg {
    width: 1rem;
    height: 1rem;
    min-width: 1rem;
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    flex-direction: row;

    strong {
      div {
        flex-wrap: wrap;
      }
    }
  }

  @media (max-width: 320px) {
  }
`;const px=h.h3`
  color: ${f.bg04};
  font-size: ${f.fontSize03};
  font-weight: ${f.fontWeight03};

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    font-size: ${f.fontSize02};
  }

  @media (max-width: 320px) {
  }
`;h.div`
  display: flex;
  align-items: center;
  justify-content: center;

  min-width: 2.5rem;
  min-height: 2.5rem;
  width: fit-content;
  height: fit-content;

  border-radius: 50%;

  svg {
    height: 1rem;
  }

  ${({mode:e})=>"primary"===e&&`\n      background-color: ${f.colorInfoLight};\n\n      svg {\n        color: ${f.bg02};\n      }\n    `};

  ${({mode:e})=>"secondary"===e&&`\n      background-color: ${f.colorAlertLight};\n\n      svg {\n        color: ${f.colorError};\n      }\n    `};
`;const mx=h.div`
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  font-size: ${f.fontSize01};
  flex-wrap: wrap;
`,ux=h.form`
  gap: 1rem;
  display: grid;

  .search-input-group {
    flex: 1;

    min-width: 16rem;
  }

  &.small {
    flex-direction: column;
    align-items: flex-start;

    padding-right: 0;

    .form-group {
      flex-direction: column;
      align-items: stretch;

      width: fit-content;
      max-width: min-content;

      .search-input-group {
        flex: 0;
        margin-bottom: auto;
      }
    }
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
    align-items: flex-start;
    flex-direction: column;

    .form-group {
      flex-wrap: wrap;

      .radio-group {
        flex-wrap: wrap;
      }

      .search-input-group {
        width: 100%;
      }
    }

    &.small {
      .form-group {
        max-width: 100%;
      }
    }
  }

  @media (max-width: 720px) {
    gap: 1.5rem 2.5rem;
    padding: 1rem;

    .form-group {
      align-items: flex-start;
      flex-direction: column;

      .search-input-group {
        min-width: 0;
      }
    }

    &.small {
      max-width: 100%;

      padding-right: 1rem;
      padding-bottom: 0;
    }
  }

  @media (max-width: 320px) {
  }
`,hx=h(Yt)`
  .bx--radio-button__label {
    > span {
      min-width: fit-content;
      white-space: nowrap;
    }

    .bx--radio-button__appearance {
      margin: 0;
      margin-right: 0.5rem;
      border-color: ${f.bg01};
    }
  }

  .bx--radio-button:checked + .bx--radio-button__label {
    .bx--radio-button__appearance {
      border-color: ${f.bg01};

      ::before {
        background-color: ${f.bg01};
      }
    }
  }
`;h.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  /* max-width: calc(50% - 1rem); */

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    gap: 0;
    padding: 0rem;
    max-width: 100%;

    h3 {
      padding: 0 1rem;
    }
  }

  @media (max-width: 320px) {
  }
`,h.aside`
  flex: 1;
  display: flex;
  align-items: stretch;
  gap: 1rem 1.5rem;
  flex-wrap: wrap;

  .card {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;

    padding: 1rem;

    box-shadow: 0px 2px 8px ${f.bx01};
    border: 1px solid ${f.color07};
    border-radius: 5px;

    svg {
      min-width: 1.5rem;
    }

    .card-subtitle {
      display: flex;
      flex-direction: column;
      flex-basis: 8.875rem;
      gap: 0.5rem;

      font-size: ${f.fontSize07};
      color: ${f.color10};
      white-space: nowrap;

      .amount {
        font-size: ${f.fontSize01};
        font-weight: ${f.fontWeight02};
      }
    }
  }

  @media (max-width: 1312px) {
  }

  @media (max-width: 1056px) {
  }

  @media (max-width: 720px) {
    flex-wrap: nowrap;
    gap: 1rem;

    padding: 1rem;
    padding-top: 1.5rem;

    overflow: auto;

    .card {
      flex-direction: column;
      align-items: flex-start;
      gap: 1rem;

      min-width: 10rem;

      .card-subtitle {
        flex-basis: 0;

        .amount {
          font-size: ${f.fontSize03};
        }
      }
    }
  }
`;const gx=({className:i,useAutoCloseSearchWrapper:n,hasQuickSearch:l,pathToRedirectOnSearch:d,isDisabled:s,onSearchSubmit:c,handleOrderNavigate:p})=>{var m,u,h,g;const[A,f]=Dt(),[v,x]=r({search:"",type:(null===(m=A.search_type)||void 0===m?void 0:m.trim())||ix.CLIENT}),{control:b,handleSubmit:w,watch:y,getValues:C,setValue:E}=Ii({resolver:nx(ax),defaultValues:{search_type:(null===(u=A.search_type)||void 0===u?void 0:u.trim())||ix.CLIENT,search:(null===(h=A.search)||void 0===h?void 0:h.trim())||"",agency:(null===(g=A.agency)||void 0===g?void 0:g.replace(/\D+/g,"").trim())||"",account:nt(A.account).trim()},mode:"onChange"}),{getPossibleClients:B,possibleClientsResponse:k}=jt().getPossibleClientsLazy(),{getClientProfile:I,clientProfileResponse:N}=ft().getClientProfileLazy(),{getOrderByNumber:S,orderByNumberResponse:O}=Tt().getOrderByNumberLazy(),P=e=>{var t;const o=new RegExp(/^\d+/g);return 1===(null===(t=e.trim().match(o))||void 0===t?void 0:t.length)};return a((()=>{var e;const{search:t,type:o}=v;if(t.trim().length>=3&&l){const i={[ix.CLIENT]:()=>B({filter:{search:t}}),[ix.CPF]:()=>{rx(t)&&I(t)},[ix.ORDER]:()=>S(t)};null===(e=i[o])||void 0===e||e.call(i)}}),[v,l]),a((()=>{const e=C("search");C("search_type")===ix.ORDER&&E("search",e.replace(/\D+/g,""))}),[y("search_type")]),a((()=>{const e=C("search"),t=C("search_type");if(t===ix.CLIENT||t===ix.CPF){const o=P(e),i=o?ix.CPF:ix.CLIENT;t!==i&&(E("search_type",i),o&&E("search",$e(e)))}const o=setTimeout((()=>{x({search:e,type:t})}),500);return()=>{clearTimeout(o)}}),[y("search"),y("search_type")]),t(ux,{className:i,onSubmit:w((e=>{null==c||c(e),d&&(e.search_type===ix.AGENCY_ACCOUNT?delete e.search:(delete e.agency,delete e.account),f(e,{path:d}))})),children:[e(px,{children:"Busque por:"}),e(mx,{children:e(Si,{control:b,name:"search_type",render:({field:i})=>t(o,{children:[e(hx,{id:"radio-client",name:"search_type",labelText:"Cliente",value:ix.CLIENT,onChange:i.onChange,checked:i.value===ix.CLIENT||i.value===ix.CPF,disabled:s,alt:"Botão para selecionar a opção de cliente",title:"Botão para selecionar a opção de cliente"}),e(hx,{id:"radio-order",name:"search_type",labelText:"Número do pedido",value:ix.ORDER,onChange:i.onChange,checked:i.value===ix.ORDER,disabled:s,alt:"Botão para selecionar a opção de pedido",title:"Botão para selecionar a opção de pedido"})]})})}),e(Si,{control:b,name:"search",render:({field:t})=>{var i,r,a,l,d,c,m,u,h;return C("search_type")===ix.CLIENT?e(Ns,{autoCloseWrapper:n,searchProps:{name:t.name,labelText:""},placeholder:"Busque por nome ou CPF",value:null!==(i=t.value)&&void 0!==i?i:"",onChange:e=>t.onChange(P(e)?$e(e):rt(e)),isLoading:k.loading,hasError:!!k.error,disabled:s,items:null===(a=null===(r=null==k?void 0:k.data)||void 0===r?void 0:r.getPossibleClientsByName)||void 0===a?void 0:a.data,itemKey:"cpf",inputGroupProps:{className:"search-input-group"},renderItem:t=>e(lx,{client:t},null==t?void 0:t.cpf)}):C("search_type")===ix.CPF?e(Ns,{autoCloseWrapper:n,searchProps:{name:t.name,labelText:""},placeholder:"Busque por nome ou CPF",value:null!==(l=t.value)&&void 0!==l?l:"",onChange:e=>t.onChange(P(e)?$e(e):rt(e)),isLoading:N.loading,hasError:!!N.error,disabled:s,items:(null===(d=N.data)||void 0===d?void 0:d.getClientProfile)?[null===(c=N.data)||void 0===c?void 0:c.getClientProfile]:rx(t.value)?[]:void 0,itemKey:"cpf",inputGroupProps:{className:"search-input-group"},renderItem:t=>e(lx,{client:t},null==t?void 0:t.cpf)}):C("search_type")===ix.ORDER?e(Ns,{autoCloseWrapper:n,searchProps:{name:t.name,labelText:""},placeholder:"Digite o número do pedido",value:null!==(m=t.value)&&void 0!==m?m:"",onChange:e=>t.onChange(e.replace(/\D+/g,"")),isLoading:O.loading,hasError:!!O.error,disabled:s,items:(null===(u=O.data)||void 0===u?void 0:u.getOrderByOrderNumber)?[null===(h=O.data)||void 0===h?void 0:h.getOrderByOrderNumber]:[],itemKey:"numeroPedido",inputGroupProps:{className:"search-input-group"},renderItem:t=>e(dx,{order:t,onClick:e=>null==p?void 0:p(e,t),isDisabled:s},null==t?void 0:t.numeroPedido)}):e(o,{})}})]})},Ax=h.form`
  .searchInputs {
    display: flex;
    border-style: solid;
    border-width: 1px;
    border-radius: 10px;
    border-color: #a7a8ac;
    background-color: #ffffff;
  }

  .search input {
    border-width: 0px;
    font-size: 18px;
    padding: 15px;
    margin-right: 5px;
    height: 40px;
    width: 100%;
  }

  .searchIcon {
    width: 50px;
    display: grid;
    place-items: center;
  }
  svg.search-icon {
    fill: #a7a8ac;
    width: 16px;
    height: 16px;
  }
  input:focus {
    outline: none;
  }
  .searchIcon svg {
    font-size: 35px;
  }
  .searchIcon svg:hover {
    cursor: pointer;
  }
`,fx=({onChange:o,defaultValue:i})=>{const n=s(null),r=()=>{var e;o(null===(e=n.current)||void 0===e?void 0:e.value)};return e(Ax,{onSubmit:r,children:e("div",{className:"search",children:t("div",{className:"searchInputs",children:[e("div",{onClick:r,className:"searchIcon",children:e(V,{"aria-label":"Search",className:"search-icon"})}),e("input",{id:"searchField",ref:n,placeholder:"Buscar",defaultValue:'""'===i?i="":i})]})})},i)},vx=h("div")`
  display: flex;
  flex-direction: column;
  color: ${v.color01};
  ${e=>So(e.theme.typography.display.body1,{weight:"600"})};
  font-size: 2rem;

  .slider {
    margin-top: 20px;
    width: 100%;
    height: 8px;
    color: ${v.color01};
    background-color: #fff;
    border: none;
    border-radius: 2.5px;
    outline: none;
  }

}

  input.slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 55px;
    height: 55px;
    border-radius: 50%;

    background: #2796ee;
    cursor: pointer;
  }
  input.slider::-moz-range-thumb {
    width: 55px;
    height: 55px;
    border-radius: 50%;

    background: #2796ee;
    cursor: pointer;
  }


  @media (max-width: 440px) {
    font-size: ${v.fontSize08};

    & .slider {
      margin-top: 10px;
      height: 6px;
    }
  }
`,xx=({creditsValue:o})=>t(vx,{children:[e("label",{htmlFor:"resend-after",children:o}),e("input",{className:"slider",name:"resend-after",type:"range",min:"0",max:"60"})]});var bx;function wx(){return wx=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},wx.apply(null,arguments)}const yx=e=>i.createElement("svg",wx({xmlns:"http://www.w3.org/2000/svg",width:42,height:42,fill:"currentColor","aria-hidden":"true",viewBox:"0 0 32 32"},e),bx||(bx=i.createElement("path",{d:"m16 2-4.55 9.22-10.17 1.47 7.36 7.18L6.9 30l9.1-4.78L25.1 30l-1.74-10.13 7.36-7.17-10.17-1.48Z"}))),Cx=h("div")`
  button {
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    width: 42px;
  }

  .on {
    color: ${f.colorWarning};
  }

  .off {
    color: ${f.color06};
  }
`,Ex=({className:t,rating:o,onRating:i,totalStars:n})=>{const[a,l]=r(0);return e(Cx,{className:`star-rating ${t}`,children:[...Array(n)].map(((t,n)=>{var r;return e("button",{type:"button",className:(n+=1)<=(null!==(r=a||o)&&void 0!==r?r:0)?"on":"off",onClick:()=>i(n),onMouseEnter:()=>l(n),onMouseLeave:()=>l(null!=o?o:0),children:e(yx,{})},n)}))})},Bx=h.div`
  border: 0.1rem solid #000;
  border: none;
  padding: 0.5rem;

  .tableBox > thead > tr {
    background-color: #ffffff;
  }

  .headerTitle {
    background-color: transparent;
  }

  .bx--data-table--zebra tbody tr:hover td {
    background-color: transparent;
  }

  .tbody {
    background-color: transparent;
  }
`,kx=({headers:o,rows:i})=>e(Bx,{children:t(uo,{useZebraStyles:!0,className:"tableBox",children:[e(ho,{children:e(go,{children:o.map((t=>e(Ao,{id:t,className:"headerTitle",children:t},t)))})}),e(fo,{children:i.map((t=>e(go,{className:"trow",children:Object.keys(t).filter((e=>"id"!==e)).map((o=>e(vo,{className:"tcell",children:t[o]},o)))},t.id)))})]})}),Ix=h.div`
  width: 100%;

  .tabContainer {
    width: 100%;
  }

  .bx--tab-content {
    padding: 0;
    outline: none;
  }

  .bx--tabs--scrollable
    .bx--tabs--scrollable__nav-item--selected
    .bx--tabs--scrollable__nav-link {
    border-bottom: 2px solid ${f.color01};
  }

  .bx--tabs--scrollable .bx--tabs--scrollable__nav,
  .tab,
  .bx--tabs--scrollable
    .bx--tabs--scrollable__nav-item--selected
    .bx--tabs--scrollable__nav-link,
  .bx--tabs--scrollable
    .bx--tabs--scrollable__nav-item
    .bx--tabs--scrollable__nav-link {
    width: 100%;
    text-align: center;
    outline: none;
  }
`,Nx=({className:t,page:o,selected:i})=>e(Ix,{children:e(xo,{selected:i,className:`tabsContainer ${t}`,children:o.map((o=>e(bo,{label:o.title,className:`tab ${t}`,onClick:o.onClick,disabled:o.disabled,children:o.page},o.title)))})}),Sx=h.div`
  a {
    color: ${v.link01};
    text-decoration: underline;
  }

  .bx--modal-close {
    display: none;
  }

  .bx--modal-content p,
  .bx--modal-content__regular-content {
    padding-right: 0;
  }

  .bx--modal-header__heading {
    display: flex;
    justify-content: center;
  }

  .bx--modal-container {
    background-color: #fff;
    border-radius: 8px;
    padding: 22px 47px 38px 47px;

    @media only screen and (max-width: 671px) {
      padding: 16px;
    }
  }

  .button-modal .bx--btn--primary {
    background-color: ${v.bg05};
    border: 1px solid ${v.border01};
    color: ${v.button01};
  }

  .button-modal .bx--btn--secondary {
    background-image: ${v.bg06};
  }

  .bx--btn--primary:focus,
  .bx--btn--secondary:focus {
    box-shadow: 0 0 0 0;
    text-align: center;
  }

  .bx--btn--primary,
  .bx--btn--secondary {
    border: none;
    justify-content: center;
    padding: 0px;
    width: 100%;
    border-radius: 30px;
    font-weight: bold;
    border: none;
    height: 48px;

    @media only screen and (max-width: 671px) {
      margin-bottom: 20px;
    }
  }

  .bx--btn--primary:hover,
  .bx--btn--secondary:hover {
    opacity: 0.8;
  }

  .bx--modal-close:focus {
    border: none;
  }

  .bx--modal-footer {
    gap: 40px;

    @media only screen and (max-width: 671px) {
      flex-direction: column;
      align-items: center;
      gap: 5px;
    }
  }

  .checkboxTerms {
    margin-bottom: 18px;
    margin-top: 32px;

    .bx--checkbox-label {
      align-items: center;
    }

    .bx--checkbox-label::before {
      border-width: 1px;
      border-color: ${v.border02};
      transform: scale(2);
      margin-right: 1rem;
      border-radius: 1px;
      //top: inherit;

      @media only screen and (max-width: 671px) {
        transform: scale(1.5);
      }
    }

    .bx--checkbox:checked + .bx--checkbox-label::before {
      border-color: ${v.border01};
      background-color: ${v.bg02};
    }

    .bx--checkbox-label-text {
      padding-left: 1.375rem;
    }
  }
`,Ox=({className:i,termsOfUse:n,check:a,setCheck:l})=>{const[d,s]=r(!1);return t(Sx,{children:[e(fl,{classWrapper:"checkboxTerms",onChange:()=>s(!0),labelText:t(o,{children:["Li e concordo com os ",e("a",{children:"termos de uso"})," e políticas de privacidade."]}),id:"checkbox",checked:a,className:"checkbox",required:!0}),e(ao,{modalHeading:"Termos de uso",primaryButtonText:"Concordo",secondaryButtonText:"Não concordo",preventCloseOnClickOutside:!0,onRequestSubmit:()=>(l(!0),void s(!1)),open:d,onSecondarySubmit:()=>(l(!1),void s(!1)),onRequestClose:()=>s(!1),className:`button-modal ${i}`,"data-testid":"modal-id",children:e("p",{children:n})})]})},Px=h.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  .bx--tooltip__trigger {
    svg {
      width: 1.25rem;
      height: 1.25rem;
      fill: ${f.color03};
    }
  }
  .icon-logout {
    color: ${f.color01};
    width: 24px;
    margin-right: 8px;
  }
  .usersplited {
    color: ${f.color03};
    align-items: center;
  }
  @media (max-width: 1106px) {
    .usersplited {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 75px;
      color: ${f.color03};
      align-items: center;
    }
  }

  .normaluser {
    color: ${f.color03};
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
  }
`,Qx=h(Xo)`
  .bx--tooltip__content {
    gap: 1rem;
    display: flex;
    flex-direction: column;
  }

  .buttonLink {
    text-decoration: none;
    color: ${f.color03};
    text-align: left;
    font-size: ${f.fontSize01};
    font-weight: ${f.fontWeight01};
  }

  .buttonLink--logout {
    margin-left: -1rem;
    font-size: ${f.fontSize01};
    font-weight: ${f.fontWeight01};
    color: ${f.color03} !important;
    margin-top: -0.8rem;
    button {
      color: ${f.color03} !important;
    }
    svg {
      color: ${f.color03} !important;
      margin-right: 1rem !important;
    }
  }
  .icon-tooltip {
    color: ${f.color03};
  }
`,zx=h(ne)`
  color: ${f.color03};
  margin-right: 8px;
`,Mx=h.div`
  display: flex;
  gap: 1rem;

  align-items: center;
`;var Dx;function jx(){return jx=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},jx.apply(null,arguments)}const Tx=e=>i.createElement("svg",jx({xmlns:"http://www.w3.org/2000/svg",xmlSpace:"preserve",viewBox:"0 0 32 32"},e),Dx||(Dx=i.createElement("path",{d:"M16 22 6 12l1.4-1.4 8.6 8.6 8.6-8.6L26 12z"})),i.createElement("path",{d:"M0 0h32v32H0z",style:{fill:"none"}}));var Rx;function Lx(){return Lx=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},Lx.apply(null,arguments)}const Ux=e=>i.createElement("svg",Lx({xmlns:"http://www.w3.org/2000/svg",xmlSpace:"preserve",viewBox:"0 0 32 32"},e),Rx||(Rx=i.createElement("path",{d:"m16 10 10 10-1.4 1.4-8.6-8.6-8.6 8.6L6 20z"})),i.createElement("path",{d:"M0 0h32v32H0z",style:{fill:"none"}})),qx=({className:o})=>{const[i,n]=r(!1),a=wo(),l=Of().split(" ")[0].length;return t(Px,{className:o,children:[e(zx,{}),t("div",{className:l>=6?"usersplited":"normaluser",children:["Olá, ",Of().split(" ")[0]]}),t(Qx,{align:"end",renderIcon:i?Ux:Tx,onChange:(e,{open:t})=>{n(t)},children:[t(Mx,{children:[e(We,{className:"icon-tooltip"}),e(il,{href:"/myProfile/myProfilePage",label:"Ver minha conta",className:"buttonLink",alt:"Ver minha conta",title:"Ver minha conta",onClick:e=>{e.preventDefault(),a.push("/myProfile/myProfilePage")}})]}),e(Hp,{className:"buttonLink--logout",alt:"Sair",title:"Sair"})]})]})},Wx=h("span")`
  visibility: hidden;
  line-height: 1.5;
  width: 170px;
  background-color: ${f.color10};
  color: ${f.bg03};
  text-align: center;
  border-radius: 6px;
  padding: 5px 5px;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  margin-left: -38px;
  :after {
    content: '';
    position: absolute;
    top: 100%;
    left: 20%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }
  @media (max-width: 672px) {
    visibility: hidden;
    line-height: 1.5;
    width: 150px;
    background-color: ${f.color10};
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 5px;
    position: absolute;
    z-index: 1;
    bottom: 150%;
    margin-left: -125px;
    :after {
      content: '';
      position: absolute;
      top: 100%;
      left: 20%;
      margin-left: 90px;
      border-width: 5px;
      border-style: solid;
      border-color: black transparent transparent transparent;
    }
  }
`,Gx=h.div({position:"relative",display:"inline-block",verticalAlign:"sub",":hover span":{visibility:"visible"}}),Hx=({children:o,toolTipText:i})=>t(Gx,{children:[o,e(Wx,{children:i})]});var Fx;function Vx(){return Vx=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},Vx.apply(null,arguments)}const Kx=e=>i.createElement("svg",Vx({xmlns:"http://www.w3.org/2000/svg",width:17.098,height:17.1},e),Fx||(Fx=i.createElement("g",{"data-name":"Grupo 85776"},i.createElement("path",{d:"M.548 8.46c0 .03 0-.03 0 0a8.076 8.076 0 0 0 8 8.091v-.091a8 8 0 0 0-8-8","data-name":"Caminho 39016"}),i.createElement("path",{d:"M16.548 8.551V8.46a8 8 0 0 0-8 8v.091a8 8 0 0 0 8-8","data-name":"Caminho 39017"}),i.createElement("path",{d:"M8.548 3.737a4.82 4.82 0 0 0-4.389 2.836l1.449.655a3.222 3.222 0 0 1 5.875 0l1.452-.654a4.82 4.82 0 0 0-4.389-2.836","data-name":"Caminho 39018"}),i.createElement("path",{d:"M8.548 6.922a1.63 1.63 0 0 0-1.485.96l1.485.669 1.485-.669a1.63 1.63 0 0 0-1.485-.96","data-name":"Caminho 39019"}),i.createElement("path",{d:"M8.548.551a8 8 0 0 0-7.293 4.713l1.452.654a6.407 6.407 0 0 1 11.683 0l1.452-.654A8 8 0 0 0 8.548.551","data-name":"Caminho 39020"})))),Jx=h.div`
  width: 100%;
  padding: 1rem;
  background-color: ${f.bg03};
  border: 1px solid ${f.color06};
  opacity: 1;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`,Yx=h.div`
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
`,Zx=h.div`
  text-align: left;
  .hello-text {
    margin-bottom: 0.5rem;
  }
`,Xx=h.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 1.5rem 1rem;
  background-color: ${f.color06};
  .banner {
    padding: 0 1rem;
    width: 100%;
  }
`;h.p`
  color: ${f.color03};
  font-size: ${f.fontSize01};
  font-weight: ${f.fontWeight01};
`;const _x=h.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 1.5rem;
  margin-bottom: 2rem;
`,$x=h(Kx)``,eb=h.footer`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.5rem;

  .button-login {
    max-width: 124px;
  }

  .button-register {
    max-width: 140px;
  }
  @media (min-width: 672px) {
    margin-left: 3rem;
    margin-bottom: 0px;

    .button-login {
      width: 108px;
    }
  }
`,tb=h.div`
  color: ${f.color07};
`,ob=()=>{var o;const{redirect:i}=Rt(),n=qt(),r=Lt(),a=wo(),l=null===(o=null===window||void 0===window?void 0:window.location)||void 0===o?void 0:o.pathname.includes("loja");function d(e,t){Je.interact(Ye.Click,"botao",t?"cadastrar-se":"entrar",e?"marketplace":"home",Je.getUserStatus(n),e?`e-agro${null===location||void 0===location?void 0:location.pathname}`:"e-agro/home",null,{userId:Je.getUserId(n)})}const s=[{icon:e(le,{}),label:"Início",url:"/",flow:"Início"},{icon:e($x,{}),label:"Quem Somos",url:"/sobre",flow:"Quem Somos"},{icon:e(Ge,{}),label:"Linhas de crédito",url:"/simulacao-de-credito",flow:"Linhas de crédito"},{icon:e(He,{}),label:"Loja",url:"/loja",flow:"marketplace"}];return t(Xx,{children:[t(Jx,{children:[t(Yx,{children:[e(tb,{children:e(ae,{})}),t(Zx,{children:[e(ba,{text:"Olá!",color:"color04",size:"fontSize03",weight:"fontWeight02",className:"hello-text"}),e(ba,{text:"Faça seu cadastro ou acesse sua conta.",color:"color09",size:"fontSize01",weight:"normal"})]})]}),t(eb,{children:[e(qr,{alt:"Cadastre-se",title:"Cadastre-se",size:"medium",label:"Cadastre-se",variant:"primary",className:"button-register",onClick:()=>(()=>{var e;if(d(l,!0),window.isWebView){const t={event:"createAccount"};null===(e=null===window||void 0===window?void 0:window.ReactNativeWebView)||void 0===e||e.postMessage(JSON.stringify(t))}else r.requestAuthorizationUrl(`${process.env.OIDC_PUBLIC_URL}/auth/callback/code`,process.env.OIDC_FLOW||"").then((e=>{i(`${e.data.authRequestAuthorizationUrl}&cadastrar=true`)}))})()}),e(qr,{alt:"Entrar",title:"Entrar",size:"medium",label:"Entrar",variant:"secondary",className:"button-login",onClick:()=>(()=>{var e;if(d(l),null===window||void 0===window?void 0:window.isWebView){const t={event:"login"};null===(e=null===window||void 0===window?void 0:window.ReactNativeWebView)||void 0===e||e.postMessage(JSON.stringify(t))}else window.location.href="/authenticator/login"})()})]})]}),e(_x,{children:s.map((t=>{const o=(null===window||void 0===window?void 0:window.location.pathname.toLowerCase())===t.url.toLowerCase();return e(al,{icon:t.icon,label:t.label,isActive:o&&"#"!==t.url,onClick:()=>{return e=t,Je.interact(Ye.Click,"botao",`${e.label}`,`${e.flow}`,Je.getUserStatus(n),`e-agro${null===location||void 0===location?void 0:location.pathname}`,null,{userId:Je.getUserId(n)}),void a.push(e.url);var e}},t.label)}))})]})},ib=h.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  width: 100%;
  height: 4rem;

  padding-left: 1rem;
  margin-bottom: 2rem;

  border-radius: 0.25rem;
  background-color: ${f.color03};

  text-align: left;

  img,
  #profilePhoto {
    width: 2rem;
    height: 2rem;
    margin: 0;
    align-self: self-start;
  }
  p {
    font-size: ${f.fontSize03};
    span {
      font-weight: ${f.fontWeight03};
    }
  }
`,nb=h.div``,rb=()=>{const[o,i]=r(""),[n,l]=r(""),d=st();return a((()=>{var e,t;const{data:o,loading:n}=d;n||(i((null===(e=null==o?void 0:o.getProfile)||void 0===e?void 0:e.fullName)||""),l((null===(t=null==o?void 0:o.getProfile)||void 0===t?void 0:t.picture)||""))}),[d]),t(ib,{children:[e(nb,{children:e(Lu,{isEditableAvatar:!1,imageSrc:n})}),t("p",{children:["Olá, ",e("span",{children:o}),"!"]})]})},ab=h.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;

  padding: 1.5rem 1rem;
  background-color: ${f.color06};

  .banner {
    margin-top: 15px;
    padding: 0 1rem;
    width: 100%;
  }

  .btn-logout {
    display: flex;
    justify-content: flex-start;
    font-size: 14px;
    margin-top: 0.5rem;

    .icon-logout {
      color: ${f.color04};
      width: 18px;
      margin-right: 13px;
    }

    .bx--btn {
      padding: 0;
    }
  }
`;h.p`
  color: ${f.color03};
  font-size: ${f.fontSize01};
  font-weight: ${f.fontWeight01};
`;const lb=h.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`,db=h(Kx)``;h.img`
  height: 12rem;
`;const sb=()=>{const o=qt(),i=[{icon:e(le,{}),label:"Início",url:"/",flow:"Início"},{icon:e(ne,{}),label:"Meu perfil",url:"/myProfile/MyProfilePage",flow:"Meu perfil"},{icon:e(db,{}),label:"Quem Somos",url:"/sobre",flow:"Quem Somos"},{icon:e(Ge,{}),label:"Linhas de crédito",url:"/simulationLogged/AvailableProducts"},{icon:e(Fe,{}),label:"Contratações e simulações",url:"/simulationlogged/creditcontractpage",flow:"Contratações e simulações"},{icon:e(He,{}),label:"Loja",url:"/Loja",flow:"marketplace"}],n=e=>{const t=window.location.href.toLowerCase();let o=!1;return"/simulationLogged/BoostProduction"===e?(["/simulationLogged/BoostProduction","/simulationLogged/AuthBradescoPage","simulationLogged/SimulationCPRFPage","/simulationLogged/SimulationResultCPRFPage"].map((e=>{t.includes(e.toLowerCase())&&(o=!0)})),o):t.includes(e.toLowerCase())};return t(ab,{children:[e(rb,{}),e(lb,{children:i.map((t=>e(al,{icon:t.icon,label:t.label,isActive:n(t.url)&&"#"!==t.url,onClick:()=>{return e=t,Je.interact(Ye.Click,"botao",`${e.label}`,`${e.flow}`,Je.getUserStatus(o),`e-agro${null===location||void 0===location?void 0:location.pathname}`,null,{userId:Je.getUserId(o)}),void(window.location.href=e.url);var e}},t.label)))}),e(Hp,{className:"btn-logout"})]})},cb=h.div`
  .image {
    width: 11rem;
  }
  .content {
    flex-direction: column;
    text-align: left;
    @media (max-width: 671px) {
      margin-left: -1.75rem;
    }

    @media (max-width: 1055px) {
      max-width: 60vw;
    }

    @media (min-width: 1056px) {
      width: 70%;
    }
  }
  .row-banner {
    border-radius: 4px;
    background-image: ${f.colorGrad04};
  }

  .col-banner {
    display: flex;
    align-items: center;
    min-height: 12rem;
    overflow: hidden;
    position: relative;
    justify-content: space-around;

    @media (min-width: 1312px) {
      justify-content: flex-start;
      gap: 2rem;
      padding: 0 5rem;
    }
  }

  .btn-transparent {
    margin-top: 1rem;
    border-width: 2px;
    width: 8rem !important;

    @media (min-width: 672px) {
      width: 16rem !important;
    }

    @media (min-width: 1056px) {
      margin-left: 10px;
    }
  }

  .download-banner-text {
    padding-right: 10px;
    @media (min-width: 672px) {
      display: none;
    }
  }

  .content-title {
    margin-bottom: 0.5rem;
    font-size: 13px;
    @media (min-width: 672px) {
      display: none;
    }
  }

  .download-banner-text-responsive {
    margin-bottom: 0.5rem;
    line-height: 22px;
    @media (max-width: 671px) {
      display: none;
    }
  }

  @media (max-width: 1055px) {
    .btn-transparent {
      width: 120px;
    }
  }
`,pb=h.img`
  height: 12rem;
  @media (min-width: 672px) {
    position: absolute;
    height: 15.5rem;
    top: 0;
  }
`,mb=({className:i})=>{const{data:n}=Ut(),r=qt();return n?e(cb,{className:i,children:e(co,{className:"row-banner",children:t(po,{sm:{span:10,offset:0},md:{span:8,offset:0},className:"col-banner",children:[e(co,{className:"image",children:e(pb,{src:null==n?void 0:n.image_url})}),t(co,{className:"content",children:[e(ba,{text:null==n?void 0:n.title.substring(0,22),color:"color03",size:"fontSize01",weight:"fontWeight03",className:"content-title"}),e(ba,{text:null==n?void 0:n.title.substring(23,null==n?void 0:n.title.length),color:"color03",size:"fontSize01",weight:"fontWeight01",className:"download-banner-text"}),e(ba,{text:null==n?void 0:n.title,color:"color03",size:"fontSize03",weight:"fontWeight03",className:"download-banner-text-responsive"}),e(gl,{className:"btn-transparent",label:null==n?void 0:n.label_button,href:"#",alt:null==n?void 0:n.label_button,title:null==n?void 0:n.label_button,onClick:()=>{Je.interact(Ye.Click,"botao","botao-baixar-agora","marketplace",Je.getUserStatus(r),`e-agro${null===location||void 0===location?void 0:location.pathname}`,null,{userId:Je.getUserId(r)})}})]})]})})}):e(o,{children:"Loading"})},ub=h.div`
  margin-top: 1rem;
`,hb=h.footer`
  background-color: ${f.color02Dark};

  @media (min-width: 672px) {
    margin-top: ${e=>e.MyProfileMarginMin672screen};
  }

  @media (max-width: 672px) {
    margin-top: ${e=>e.MyProfileMarginMax672screen};
  }

  @media (min-width: 1056px) {
    margin-top: ${e=>e.MyProfileMarginMin1056screen} !important;
  }

  @media (min-width: 1440px) {
    margin-top: ${e=>e.MyProfileMarginMin1440screen} !important;
  }

  .bx--grid {
    padding: 0;
    max-width: 100%;
  }
`,gb=h(ba)`
  margin: 0.5rem 0;

  @media (max-width: 671px) {
    margin-top: 2rem;
  }
`,Ab=h.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0 2rem;

  @media (max-width: 671px) {
    flex-direction: column;
  }
  @media (min-width: 1056px) {
    gap: 0 5rem;
  }

  @media (min-width: 672px) and (max-width: 750px) {
    gap: 0 6rem;

    .app-download {
      margin-top: 2rem;

      .container-stores {
        display: flex;
        gap: 1rem;
      }
    }
  }
`,fb=h(il)`
  text-decoration: none;
  color: ${f.color03};
  display: flex;
  padding-top: 1.25rem;
  font-size: ${f.fontSize01};
  font-weight: normal;
  :hover {
    color: ${f.color03};
  }
`,vb=h.div`
  justify-content: center;
  background-color: ${f.bg03};
  height: 1px;
  margin: 0 auto;
  margin-top: 2rem;
  border-bottom: 1px solid ${f.bg03};
`,xb=h.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 15px;
  margin-top: 2rem;
  padding-bottom: 2rem !important;
  div {
    @media (min-width: 672px) {
      font-size: 0.75rem;
    }
    line-height: 1rem;
  }
`,bb=h.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 10px;
`,wb=h.img`
  width: 148px;
  height: 32px;
  margin-top: 32px;
  margin-bottom: 8px;

  @media (min-width: 672px) {
    margin-bottom: 32px;
  }
`;var yb,Cb;function Eb(){return Eb=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},Eb.apply(null,arguments)}const Bb=e=>i.createElement("svg",Eb({xmlns:"http://www.w3.org/2000/svg",width:13.028,height:16,"data-name":"Grupo 81400"},e),yb||(yb=i.createElement("defs",null,i.createElement("clipPath",{id:"apple_store_svg__a"},i.createElement("path",{fill:"#fff",d:"M0 0h13.028v16H0z","data-name":"Ret\\xE2ngulo 14898"})))),Cb||(Cb=i.createElement("g",{clipPath:"url(#apple_store_svg__a)","data-name":"Grupo 81399"},i.createElement("path",{fill:"#fff",d:"M10.88 8.5a3.54 3.54 0 0 0 2.147 3.237 8.8 8.8 0 0 1-1.107 2.276c-.667.975-1.359 1.946-2.449 1.966-1.071.02-1.416-.635-2.641-.635s-1.607.615-2.621.655c-1.052.04-1.854-1.054-2.526-2.025C.309 11.987-.741 8.361.669 5.912a3.92 3.92 0 0 1 3.31-2.005c1.033-.02 2.009.7 2.641.7s1.817-.86 3.063-.734a3.74 3.74 0 0 1 2.926 1.587A3.62 3.62 0 0 0 10.88 8.5M8.867 2.555A3.52 3.52 0 0 0 9.7 0a3.59 3.59 0 0 0-2.358 1.213 3.35 3.35 0 0 0-.849 2.475 2.97 2.97 0 0 0 2.374-1.133","data-name":"Caminho 39135"}))));var kb,Ib;function Nb(){return Nb=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},Nb.apply(null,arguments)}const Sb=e=>i.createElement("svg",Nb({xmlns:"http://www.w3.org/2000/svg",width:15.407,height:16},e),kb||(kb=i.createElement("defs",null,i.createElement("clipPath",{id:"googleplay_logo_svg__a"},i.createElement("path",{fill:"#fff",d:"M0 0h15.407v16H0z","data-name":"Ret\\xE2ngulo 14897"})))),Ib||(Ib=i.createElement("g",{"data-name":"Grupo 81397"},i.createElement("g",{fill:"#fff",clipPath:"url(#googleplay_logo_svg__a)","data-name":"Grupo 81396"},i.createElement("path",{d:"M0 1.162v14.1a.155.155 0 0 0 .264.11L7.6 8.211.264 1.052a.155.155 0 0 0-.264.11","data-name":"Caminho 39131"}),i.createElement("path",{d:"M10.682 5.269 1.478.198h-.006a.157.157 0 0 0-.179.253l7.215 6.9Z","data-name":"Caminho 39132"}),i.createElement("path",{d:"M1.294 15.972a.157.157 0 0 0 .179.253h.006l9.2-5.071-2.174-2.079Z","data-name":"Caminho 39133"}),i.createElement("path",{d:"m14.398 7.313-2.57-1.415L9.411 8.21l2.417 2.311 2.57-1.414a1.029 1.029 0 0 0 0-1.794","data-name":"Caminho 39134"}))))),Ob=`${process.env.MIRAKL_PUBLIC_URL}/login`||"",Pb=()=>{var o,i,n,l;const[d,s]=r(!1),[c,p]=r(""),[m,u]=r(""),h=qt(),g=xt(),A=Co(),f=Boolean((null==h?void 0:h.token)&&"GUEST"!==(null==h?void 0:h.type)),{data:v,loading:x}=g.getFooter();a((()=>{var e,t,o;if(!x&&v){const i=(null===(e=null==v?void 0:v.footer)||void 0===e?void 0:e.link_loja_apple)||"",n=(null===(t=null==v?void 0:v.footer)||void 0===t?void 0:t.link_loja_google)||"";(null===(o=null==v?void 0:v.footer)||void 0===o?void 0:o.shouldShow)&&(s(!0),p(i),u(n))}}),[x,v]);const b={company:"© 2022 e-agro - Soluções em Comércio Eletrônico S.A.",cnpj:"CNPJ: 15.010.931/0001-48",address:"Cidade de Deus, s/nº Vila Yara Osasco | SP | CEP: 06029-900",rights:"© Todos direitos reservados",contents:[{label:"Produtos",values:[{label:"Início",path:""+(f?"/dashboard/DashboardPage":"/"),alt:"Início",title:"Início"},{label:"Quem somos",path:"/sobre",alt:"Quem somos",title:"Quem somos"},{label:"Linhas de crédito",path:""+(f?"/simulationLogged/AvailableProducts":"/simulacao-de-credito"),alt:"Linhas de crédito",title:"Linhas de crédito"}]},{label:"Precisa de ajuda?",values:[{label:"Privacidade",path:"/aviso-de-privacidade",alt:"Privacidade",title:"Privacidade"}]},{label:"Loja",values:[{label:"Acesse a loja",path:"/loja",alt:"Loja",title:"Loja"},{label:"Minha loja",path:`${Ob}`,alt:"Minha loja",title:"Minha loja",target:"_blank"}]}]};return e(hb,{id:"footer",MyProfileMarginMin672screen:(null===(o=null==A?void 0:A.pathname)||void 0===o?void 0:o.includes("/myProfile/myProfilePage"))?"-2rem":"2.5rem",MyProfileMarginMax672screen:(null===(i=null==A?void 0:A.pathname)||void 0===i?void 0:i.includes("/myProfile/myProfilePage"))?"-2.5rem":"2.5rem",MyProfileMarginMin1056screen:(null===(n=null==A?void 0:A.pathname)||void 0===n?void 0:n.includes("/myProfile/myProfilePage"))?"-1.3rem":"2.5rem",MyProfileMarginMin1440screen:(null===(l=null==A?void 0:A.pathname)||void 0===l?void 0:l.includes("/myProfile/myProfilePage"))?"-1.2rem":"2.5rem",children:e(so,{children:t(po,{sm:4,md:8,lg:{span:10,offset:1},xlg:{span:10,offset:1},max:{span:8,offset:2},children:[e(ub,{children:e(wb,{src:"data:image/png;base64,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"})}),t(Ab,{children:[b.contents.map(((o,i)=>t("div",{children:[e(gb,{text:o.label,color:"color03",size:"fontSize02",weight:"fontWeight02"}),o.values.map((t=>e(fb,{alt:t.alt,title:t.title,label:t.label,target:null==t?void 0:t.target,href:null==t?void 0:t.path,onClick:e=>{e.preventDefault(),Je.interact(Ye.Click,"botao-rodape",`${t.label}`,"marketplace",Je.getUserStatus(h),`e-agro${null==A?void 0:A.pathname}`,null,{userId:Je.getUserId(h)}),window.location.href=null==t?void 0:t.path}},t.title)))]},i))),d&&t("div",{className:"app-download",children:[e(gb,{text:"Baixe o app e-agro",color:"color03",size:"fontSize02",weight:"fontWeight02"}),t("div",{className:"container-stores",children:[t(bb,{children:[e(Sb,{}),e(fb,{alt:"Disponível na Google Play",title:"Disponível na Google Play",label:"Disponível na Google Play",onClick:()=>window.open(m)})]}),t(bb,{children:[e(Bb,{color:"#FFFFFF"}),e(fb,{alt:"Disponível na App Store",title:"Disponível na App Store",label:"Disponível na App Store",onClick:()=>window.open(c)})]})]})]})]}),e(vb,{}),t(xb,{children:[e(ba,{text:b.company,color:"color03",size:"fontSize01",weight:"fontWeight01"}),e(ba,{text:b.cnpj,color:"color03",size:"fontSize01",weight:"fontWeight01"}),e(ba,{text:b.address,color:"color03",size:"fontSize01",weight:"fontWeight01"}),e(ba,{text:b.rights,color:"color03",size:"fontSize01",weight:"fontWeight01"})]})]})})})},Qb=h(Kx)`
  height: 1.5rem;
  width: 110px;
  margin: 1rem;
  cursor: pointer;
`,zb=h.div`
  background-color: ${f.bg01};

  &.menu-fixed {
    position: fixed;
    top: 0;
    z-index: 1;
    height: 100%;
    overflow-y: auto;
  }

  .menu {
    margin-left: 17px;
    padding-top: 17px;
    padding-bottom: 17px;
    font-weight: 400;
  }
  .bx--grid {
    padding: 0;
    margin: 0;
    max-width: 100%;
  }

  .row {
    display: flex;
    text-align: center;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 3.5rem;
    margin: 0;
  }

  & .icon {
    color: ${f.color03};
  }

  .link-container {
    display: flex;

    .header-name {
      gap: 1rem;
      margin-left: 3rem;

      > a {
        color: ${f.color03};
        font-size: ${f.fontSize01};
      }

      @media (max-width: 1055px) {
        display: none;
        visibility: hidden;
      }
    }

    @media (max-width: 1055px) {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
  }

  & .btn-link {
    color: #fff;
    text-decoration: none;

    :hover {
      color: #fff;
    }
  }

  @media (min-width: 1056px) {
    & .header-name {
      display: flex;
      align-items: center;
    }

    & .btn-agro {
      display: flex;
      justify-content: center;
    }

    & .btn-logout {
      display: flex;
      justify-content: center;
    }
  }
`,Mb=h(il)`
  color: ${f.color03};
  text-decoration: none;
  font-weight: ${f.fontWeight01};

  :hover {
    color: ${f.color03};
  }

  ${({isActive:e})=>e&&`\n      border-bottom: 1px solid ${f.color03};\n      margin-top: 2px;\n      padding-bottom: 2px;\n      font-weight: ${f.fontWeight02};\n   `};
`,Db=h.div`
  display: flex;
  gap: 1rem;

  a {
    width: 8.125rem;
    height: 33px;
    font-size: ${f.fontSize01};
  }

  .enter-button {
    border: 2px solid ${f.color03};
  }

  .register-button {
    border: 2px solid ${f.color03};
  }

  @media (max-width: 1055px) {
    display: none;
  }
`,jb=[{name:"Início",path:"/",alt:"Onboarding",title:"Onboarding",flow:"Onboarding"},{name:"Quem somos",path:"/sobre",alt:"Quem somos",title:"Quem somos",flow:"Quem somos"},{name:"Linhas de crédito",path:"/simulacao-de-credito",alt:"Linhas de crédito",title:"Linhas de crédito",flow:"Linhas de crédito"},{name:"Loja",path:"/loja",alt:"Loja",title:"Loja",flow:"marketplace"}],Tb=({isMkt:o=!1})=>{const i=wo(),n=qt(),[a,l]=r(!1),d=kt();function s(e,t){Je.interact(Ye.Click,"botao",t?"cadastrar-se":"entrar",e?"marketplace":"home",Je.getUserStatus(n),e?`e-agro${null===location||void 0===location?void 0:location.pathname}`:"e-agro/home",null,{userId:Je.getUserId(n)})}const c=()=>{var e;if(Je.interact(Ye.Click,"botao","entrar","home",Je.getUserStatus(n),`e-agro${null===location||void 0===location?void 0:location.pathname}`,null,{userId:Je.getUserId(n)}),window.isWebView){const t={event:"login"};null===(e=null===window||void 0===window?void 0:window.ReactNativeWebView)||void 0===e||e.postMessage(JSON.stringify(t))}else s(o),o?d.redirectLogin("/loja"):i.push("/authenticator/login")},p=()=>{var e;if(Je.interact(Ye.Click,"botao","cadastrar","home",Je.getUserStatus(n),`e-agro${null===location||void 0===location?void 0:location.pathname}`,null,{userId:Je.getUserId(n)}),window.isWebView){const t={event:"createAccount"};null===(e=null===window||void 0===window?void 0:window.ReactNativeWebView)||void 0===e||e.postMessage(JSON.stringify(t))}else s(o,!0),o?d.redirectRegister(window.location.href):d.redirectRegister("/authentication/valid-user")};return e(zb,{className:a?"menu-fixed":"menu-header",children:e(so,{narrow:!0,children:e(po,{sm:4,md:8,lg:{span:10,offset:1},xlg:{span:10,offset:1},max:{span:8,offset:2},children:t(co,{className:"row",children:[t("div",{className:"link-container",children:[e(Qb,{onClick:()=>{i.push("/")}}),e(pv,{Content:ob,output:()=>{l(!a)}}),e("div",{className:"header-name",children:jb.map((t=>e(Mb,{isActive:(null===window||void 0===window?void 0:window.location.pathname.toLowerCase())===t.path.toLowerCase()&&"#"!==t.path,alt:t.alt,title:t.title,label:t.name,className:"btn-link",onClick:()=>{(e=>{Je.interact(Ye.Click,"botao",`${e.name}`,`${e.flow}`,Je.getUserStatus(n),`e-agro${null===location||void 0===location?void 0:location.pathname}`,null,{userId:Je.getUserId(n)}),i.push(`${e.path}`)})(t)}},t.path)))})]}),t(Db,{children:[e(qr,{label:"Entrar",size:"medium",variant:"secondary",alt:"Entrar",title:"Entrar",onClick:()=>c(),className:"enter-button"}),e(qr,{label:"Cadastrar-se",size:"medium",variant:"primary",alt:"Cadastrar-se",title:"Cadastrar-se",onClick:()=>p(),className:"register-button"})]})]})})})})},Rb=h(Kx)`
  height: 1.5rem;
  width: 110px;
  margin: 1rem;
  cursor: pointer;
`,Lb=h.div`
  background-color: ${f.bg01};

  .menu-title {
    padding: 1rem;
    font-weight: 400;
  }

  .bx--grid {
    padding: 0;
    margin: 0;
    max-width: 100%;
  }

  .row {
    display: flex;
    text-align: center;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    &.menu-header {
      height: 3.5rem;
    }
    margin: 0;
  }

  .menu-and-notify {
    display: flex;
    align-items: flex-end;
    gap: 1rem;
  }

  .menu-open .notify {
    display: none;
  }

  .link-container {
    display: flex;

    .header-name {
      gap: 1rem;
      margin-left: 3rem;

      > a {
        color: ${f.color03};
        font-size: ${f.fontSize01};
      }

      @media (max-width: 1055px) {
        display: none;
        visibility: hidden;
      }
    }
  }

  @media (max-width: 1055px) {
    .menu-fixed {
      background-color: ${f.bg01};
      position: fixed;
      z-index: 9999;
      overflow-y: auto;
      overflow-x: hidden;
      height: 100%;

      .link-container {
        .header-name {
          gap: 0;
          margin-left: 0;
        }
      }

      .dashbaord-content {
        padding-left: 0 !important;
      }
    }
    .toogleTip {
      display: none;
    }

    .menu-and-notify {
      display: flex;
      align-items: center;
      margin-left: 10px;
    }

    .notify {
      svg {
        width: 24px;
        height: 24px;
      }
    }
  }

  .btn-link {
    color: ${f.color03};
    text-decoration: none;

    :hover {
      color: ${f.color03};
    }
  }

  @media (min-width: 1056px) {
    .header-name,
    .btn-agro {
      display: flex;
      align-items: center;
    }
  }
`,Ub=h(il)`
  color: ${f.color03};
  text-decoration: none;
  font-weight: ${f.fontWeight01};

  :hover {
    color: ${f.color03};
  }

  ${({isActive:e})=>e&&`\n      border-bottom: 1px solid ${f.color03};\n      margin-top: 2px;\n      padding-bottom: 2px;\n      font-weight: ${f.fontWeight02};\n   `};
`,qb=()=>{var o,i;const[n,l]=r(!1),[d,s]=r(!1),c=qt(),p=wo(),m=Pt(),u=null===(i=null===(o=null==m?void 0:m.data)||void 0===o?void 0:o.getNotificationBell)||void 0===i?void 0:i.message;a((()=>{u&&l("Todas as notificações já foram lidas."!==u)}),[u]);const h=e=>{const t=window.location.href.toLowerCase();let o=!1;return"/simulationLogged/BoostProduction"===e?(["/simulationLogged/BoostProduction","/simulationLogged/AuthBradescoPage","simulationLogged/SimulationCPRFPage","/simulationLogged/SimulationResultCPRFPage"].map((e=>{t.includes(e.toLowerCase())&&(o=!0)})),o):t.includes(e.toLowerCase())};return e(Lb,{children:e(so,{narrow:!0,children:e(po,{sm:4,md:8,lg:{span:10,offset:1},xlg:{span:10,offset:1},max:{span:8,offset:2},children:t(co,{className:d?"menu-fixed row":"menu-header row",children:[t("div",{className:"link-container",children:[e(Rb,{onClick:()=>{p.push("/dashboard")}}),e("div",{className:"header-name",children:[{name:"Início",path:"/",alt:"Início",title:"Início",flow:"Início"},{name:"Quem somos",path:"/sobre",alt:"Quem somos",title:"Quem somos",flow:"Quem somos"},{name:"Linhas de crédito",path:"/simulationLogged/AvailableProducts",alt:"Linhas de crédito",title:"Linhas de crédito",flow:"Quem somos"},{name:"Contratações e simulações",path:"/simulationlogged/creditcontractpage",alt:"Contratações e simulações",title:"Contratações e simulações",flow:"Contratações e simulações"},{name:"Loja",path:"/loja",alt:"Loja",title:"Loja",flow:"marketplace"}].map((t=>e(Ub,{isActive:h(t.path)&&"#"!==t.path,alt:t.alt,title:t.title,label:t.name,className:"btn-link",onClick:e=>{(e=>{Je.interact(Ye.Click,"botao",`${e.name}`,`${e.flow}`,Je.getUserStatus(c),`e-agro${null===location||void 0===location?void 0:location.pathname}`,null,{userId:Je.getUserId(c)})})(t),e.preventDefault(),p.push(t.path)}},t.path)))})]}),t("div",{className:d?"menu-open":"menu-and-notify",children:[e(Bv,{hasNotification:n,href:"/notification",className:"notify"}),e(qx,{className:"toogleTip"}),e(pv,{Content:sb,output:()=>{s(!d)}})]})]})})})})},Wb=h.div`
  top: 0;

  .row-haderMKT {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    padding: 0 10%;
    height: 56px;
    box-shadow: 0px 2px 8px #22222229;
    svg.arrow {
      fill: #000000;
      width: 19px;
      height: 19px;
    }
    .arrow {
      @media (min-width: 1056px) {
        display: none;
      }
    }
    .categorias {
      @media (max-width: 1056px) {
        display: none;
      }
    }
    .favorite {
      @media (max-width: 1056px) {
        display: none;
      }
    }
    .shopping {
      @media (max-width: 1056px) {
        display: none;
      }
    }
  }
  @media (max-width: 1056px) {
    .searchContainer {
      display: none;
    }
  }
  .headerMKT-options {
    display: flex;
    flex-direction: row;
    gap: 8px;

    svg {
      color: ${f.color01};
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
`,Gb=({defaultValue:o,onChange:i})=>e(Wb,{children:t(co,{className:"row-haderMKT",children:[e("div",{className:"headerMKT-options",children:e(k,{className:"arrow"})}),t("div",{className:"headerMKT-options",children:[e(Ie,{}),e(ba,{text:"Santa Catarina",color:"color01",size:"fontSize01",weight:"fontWeight01"})]}),t("div",{className:"headerMKT-options",children:[e(ge,{className:"categorias"}),e(ba,{className:"categorias",text:"Categorias",color:"color01",size:"fontSize01",weight:"fontWeight01"})]}),e("div",{className:"searchContainer",children:e(fx,{defaultValue:o,onChange:i})}),t("div",{className:"headerMKT-options",children:[e(Ee,{}),e(ba,{className:"shopping",text:"Carrinho",color:"color01",size:"fontSize01",weight:"fontWeight01"})]})]})}),Hb=h.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`,Fb=h.div`
  flex-direction: row;
  position: relative;
  display: block;
  -webkit-tap-highlight-color: transparent;
  width: 100%;

  .arrow-button {
    display: none;
    position: absolute;
    top: 46%;
    transform: translate(0, -50%);
    cursor: pointer;
    background-color: rgba(248, 255, 251, 0.5);
    width: 81px;
    border-radius: 50%;
    height: 81px;
    z-index: 2;
    color: #0c881e;

    @media (min-width: 1056px) {
      display: flex;
    }
  }

  .arrow-button-left {
    margin-left: -2rem;
  }

  .arrow-button-right {
    right: -25px;
  }
`,Vb=h.div`
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
  padding: 10px;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`,Kb=h.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 6px;

  .dot {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    margin: 5px;
    background-color: #cccccc;
    cursor: pointer;
  }

  .dot-active {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    margin: 5px;
    background-color: #0c881e;
    cursor: pointer;
  }
`,Jb=h.div`
  padding-right: 1rem;
`,Yb=h.div`
  padding-right: 16px;
`,Zb=h.div`
  padding-bottom: 0;
`,Xb=h.div`
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.2);
  outline: 1px solid transparent;
  border-radius: 8px;
  transition: all 0.3s;
  min-height: 395px;
`,_b=h.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.3s;
  position: relative;
  border-radius: 5px;
  width: 220px;
  min-height: 395px;

  .title-product,
  .title-disabled {
    text-align: left;
    font: normal normal normal 16px/20px Bradesco Sans;
    letter-spacing: 0;
    opacity: 1;
    color: ${f.bg04};
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    text-transform: uppercase;
  }

  .title-disabled {
    color: ${f.color09};
  }
`;h.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;

  position: absolute;
  top: 0;
  width: 100%;
  height: 2rem;
  background-color: ${f.bg02};
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;

  .discount-offer-title {
    color: ${f.color03};
  }
`;const $b=h("div")`
  position: absolute;
  top: -9.5px;
  left: 8px;
  padding: 2px 6px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 19px;
  text-align: center;
  font: normal normal 600 12px/16px Bradesco Sans;
  letter-spacing: 0;
  color: ${f.color03};
  opacity: 1;
  z-index: 9;

  background: ${f.color20} 0% 0% no-repeat padding-box;
  border-radius: 4px;
`,ew=h.div`
  position: relative;
  width: stretch;
  height: 226px;

  .link {
    height: 100%;
  }

  @media (min-width: 200px) {
    align-items: center;
    display: flex;
    flex-direction: column-reverse;
    align-content: center;
    justify-content: end;
  }

  .image-product,
  .image-disabled {
    object-fit: cover;
    object-position: center center;
    block-size: auto;
    width: 100%;
    height: 100%;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .image-disabled {
    filter: saturate(0);
    -webkit-filter: saturate(0);
  }

  .favorite {
    background: none;
    border: none;
    cursor: pointer;
    width: 38px;
    height: 35px;
    right: 0;
    bottom: 0;
    margin: 0 0.3rem 0.1rem 0 !important;
    outline: none;
    position: absolute;
    color: #0c881e;
    z-index: 9;
  }
`,tw=h("div")`
  position: absolute;
  left: 0;
  bottom: 0;
`,ow=h.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 12px;
`;h.div`
  position: relative;
  border-top: solid 0.0625rem #dcdcdc;
  padding: 12px;
`;const iw=h("div")`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 12px;
  filter: saturate(0);

  .indisponivel {
    position: absolute;
    bottom: 0;
    left: 0;
    text-align: left;
    font: normal normal 600 22px/28px Bradesco Sans;
    letter-spacing: 0;
    color: ${f.color09};
    opacity: 1;

    @media (max-width: 671px) {
      font-size: 18px;
      line-height: 24px;
    }

    @media (min-width: 1056px) {
      font: normal normal 600 20px/28px Bradesco Sans;
    }
  }
`,nw=h("div")`
  position: relative;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  ${e=>So(e.theme.typography.body.short.M)};
`;h.div`
  position: relative;

  p {
    font-size: 18px;
    color: ${f.color09};
  }

  .label-price-from {
    font-weight: normal;
    font-size: 14px;
    color: ${f.color09};
  }

  .label-price-discount {
    font-size: 14px;
    text-decoration: line-through;
  }

  .price-in-cash {
    font-size: 14px;
    font-weight: 400;
    color: ${f.color04};
  }
`,h.div`
  position: absolute;
  bottom: 0;
  right: 0;
  margin-bottom: 6px;
  margin-right: 6px;
  min-height: 20px;
`,h.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #a4c8fd;
  margin: auto auto 6px 10px;
  border-radius: 10px;
  padding: 5px 0;

  .minimumQuantityText {
    font-size: 12px;
    margin-left: 10px;
    margin-right: 10px;
    color: #295281;
  }
`;const rw=h.p`
  text-align: left;
  margin-top: -4px;
  font: normal normal normal 12px/20px Bradesco Sans;
  letter-spacing: 0;
  opacity: 1;
  color: ${f.color09};
`;function aw(o){var i,n,l,d,s,c,p,m,u,h,g,A,f,v,x,b,w,y,C,E,B,k,I,N,S,O,P,Q,z,M,D,j,T,R;const[L,U]=r(),q=wo(),W=qt(),{context:G}=di(),{itemCreditUser:H}=si(),F=o.product.mp_info.offers,V=at(F,null==G?void 0:G.regionList),K=o.product.mp_info.offers.length>0&&(null===(i=o.product.mp_info.offers.filter((e=>(null==e?void 0:e.offer_id)===(null==V?void 0:V.offer_id)))[0])||void 0===i?void 0:i.min_order_quantity)||0,J=null===(n=null==o?void 0:o.product)||void 0===n?void 0:n.precisa_de_cotacao,Y=null===(l=null==o?void 0:o.product)||void 0===l?void 0:l.show_price;let Z=[],X=!1,_=!1;const $=null==F?void 0:F.find((e=>(null==e?void 0:e.offer_id)===(null==V?void 0:V.offer_id)));(null===(d=null==$?void 0:$.additional_info)||void 0===d?void 0:d.json_string)&&(Z=null===(p=null===(c=JSON.parse(null===(s=null==$?void 0:$.additional_info)||void 0===s?void 0:s.json_string))||void 0===c?void 0:c.region)||void 0===p?void 0:p.split(","),X=Z&&!!(null==Z?void 0:Z.find((e=>-1!==(null==e?void 0:e.indexOf("BR"))))),_=Z&&!!(null===(m=null==G?void 0:G.regionList)||void 0===m?void 0:m.find((e=>-1!==(null==Z?void 0:Z.indexOf(e))))));const ee=(null==F?void 0:F.length)<1||(null==$?void 0:$.quantity)<1||(null==$?void 0:$.quantity)<(null==$?void 0:$.min_order_quantity)||!$||!!(null==W?void 0:W.username)&&!!(null==G?void 0:G.city)&&(null===(u=null==G?void 0:G.regionList)||void 0===u?void 0:u.length)>1&&!_,te=!!(null==G?void 0:G.city)&&(null===(h=null==G?void 0:G.regionList)||void 0===h?void 0:h.length)>1&&!_&&Y,oe=!!(null==W?void 0:W.username)&&!!(null==G?void 0:G.city)&&(null===(g=null==G?void 0:G.miraklRegion)||void 0===g?void 0:g.length)>1&&_||!!(null==W?void 0:W.username)&&!(null==G?void 0:G.city)&&(null===(A=null==G?void 0:G.miraklRegion)||void 0===A?void 0:A.length)<=1&&X||!(null==W?void 0:W.username)&&!!(null==G?void 0:G.city)&&(null===(f=null==G?void 0:G.miraklRegion)||void 0===f?void 0:f.length)>1&&Y&&_||!(null==W?void 0:W.username)&&!(null==G?void 0:G.city)&&(null===(v=null==G?void 0:G.miraklRegion)||void 0===v?void 0:v.length)<=1&&X&&Y,ie=null===(b=null===(x=null==$?void 0:$.shop)||void 0===x?void 0:x.additional_info)||void 0===b?void 0:b.json_string,ne=ie&&(null===(w=JSON.parse(ie))||void 0===w?void 0:w.additional_field_values),re="true"===(null===(C=null===(y=null==ne?void 0:ne.find((e=>{var t;return"cpr-outras-garantias"===(null===(t=null==e?void 0:e.code)||void 0===t?void 0:t.toLocaleLowerCase())})))||void 0===y?void 0:y.value)||void 0===C?void 0:C.toLocaleLowerCase()),ae="true"===(null===(B=null===(E=null==ne?void 0:ne.find((e=>{var t;return"cpr-avalista"===(null===(t=null==e?void 0:e.code)||void 0===t?void 0:t.toLocaleLowerCase())})))||void 0===E?void 0:E.value)||void 0===B?void 0:B.toLocaleLowerCase()),le=(null===(k=null==o?void 0:o.product)||void 0===k?void 0:k.accepts_cpr_payment)&&(re&&null!=(null===(I=null==H?void 0:H.cprData)||void 0===I?void 0:I.creditType)&&"L"!==(null===(N=null==H?void 0:H.cprData)||void 0===N?void 0:N.creditType)||(null==o?void 0:o.sellerId)===(null===(P=null===(O=null===(S=null==o?void 0:o.product)||void 0===S?void 0:S.mp_info.offers[0])||void 0===O?void 0:O.shop_id)||void 0===P?void 0:P.toString())&&ae&&"L"===(null===(Q=null==H?void 0:H.cprData)||void 0===Q?void 0:Q.creditType));void 0!==(null==o?void 0:o.sellerPlan)?(null==o||o.sellerPlan,location.pathname):null===location||void 0===location||location.pathname;const de=(e=!1)=>{var t,i,n;return`${e&&null!==(t=process.env.OIDC_PUBLIC_URL)&&void 0!==t?t:""}/loja/${null===(i=null==o?void 0:o.product)||void 0===i?void 0:i.url_key}/p?oferta=${null!==(n=null==$?void 0:$.offer_id)&&void 0!==n?n:"indisponivel"}`},se=()=>{let e="";return ee||te?e="":le?e="Pague com CPR":o.product.grande_desconto?e="Grande desconto":o.product.entrega_expressa&&(e="Entrega rápida"),e};return a((()=>{var e;const t=null===(e=null==o?void 0:o.dataProducts)||void 0===e?void 0:e.find((e=>{var t;return(null==e?void 0:e.item_id)===(null===(t=null==o?void 0:o.product)||void 0===t?void 0:t.partnumber)}));t&&U(t)}),[null==o?void 0:o.dataProducts]),t(Xb,{className:"background-card",style:o.style,onClick:e=>{(e=>{var t,i,n;e.preventDefault(),Je.tagecommerce({event:tt.SelectItem,items:(()=>{if(o.dataProducts)return[L]})()});const r=(null===(i=null===(t=null===window||void 0===window?void 0:window.location)||void 0===t?void 0:t.href)||void 0===i?void 0:i.indexOf("loja"))>=0?"loja":"home";"home"===r&&Je.overrideFirebaseScreenClass("home"),Je.interact(Ye.Click,Je.getActionLocation(),et(null===(n=null==o?void 0:o.product)||void 0===n?void 0:n.name),"produtos",Je.getUserStatus(W),`e-agro/${r}`,null,{userId:Je.getUserId(W)}),q.push(de())})(e)},children:[""!==se()&&e($b,{children:se()}),t(_b,{children:[e(ew,{children:e(Xl,{href:de(!0),title:o.product.name,onClick:e=>{e.preventDefault()},className:"link",children:e("img",{src:o.product.fullImage,className:ee||te?"image-disabled":"image-product",title:o.product.name,alt:o.product.name,loading:"lazy"})})}),ee||te?e(iw,{children:t(nw,{children:[(null===(T=null==o?void 0:o.product)||void 0===T?void 0:T.marca)&&e(rw,{children:null===(R=null==o?void 0:o.product)||void 0===R?void 0:R.marca}),e("h2",{className:"title-disabled",children:o.product.name}),e("h3",{className:"indisponivel",children:"Indisponível"})]})}):e(ow,{children:t(nw,{children:[(null===(z=null==o?void 0:o.product)||void 0===z?void 0:z.marca)&&e(rw,{children:null===(M=null==o?void 0:o.product)||void 0===M?void 0:M.marca}),e("h3",{className:"title-product",children:o.product.name}),(null===(D=null==o?void 0:o.product)||void 0===D?void 0:D.mp_info)&&e(tw,{children:e(Ei,{mp_info:null===(j=null==o?void 0:o.product)||void 0===j?void 0:j.mp_info,cotation:J,hidePrice:!oe,minimumQuantity:K})})]})})]})]},o.key)}const lw=h.div`
  display: flex;
  flex-direction: row;
  -webkit-tap-highlight-color: transparent;
  width: 96vw;

  @media (min-width: 672px) {
    width: 98vw;
  }

  @media (min-width: 1056px) {
    box-shadow:
      0.0625rem 0.0625rem 10px #dcdcdc,
      -0.0625rem -0.0625rem 5px #dcdcdc;
    border-radius: 6px;
    min-width: 405px;
    width: 405px;
  }

  .link {
    outline: 1px solid transparent;
    border-radius: 6px;
    width: stretch;
  }

  .link:hover {
    outline: 1px solid #0062ff;
  }
`,dw=h.div`
  display: flex;
  flex-direction: row;
  overflow: hidden;

  position: relative;
  border-radius: 5px;
  width: stretch;

  @media (min-width: 1052px) {
    width: 405px;
  }
`;h.div`
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;

  position: absolute;
  top: 0;
  width: 100%;
  height: 2rem;
  background-color: ${f.bg02};
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;

  .discount-offer-title {
    color: ${f.color03};
  }
`;const sw=h.div`
  position: relative;
  min-width: 136px;
  min-height: 136px;
  width: 136px;
  height: 136px;
  align-items: center;
  display: flex;
  flex-direction: column-reverse;
  align-content: center;
  justify-content: end;
  border-radius: 0.3rem;
  overflow: hidden;
  margin: 10px;

  @media (min-width: 672px) {
    min-width: 227px;
    min-height: 179px;
    width: 227px;
    height: 179px;
  }

  @media (min-width: 1056px) {
    min-width: 193px;
    min-height: 166px;
    width: 193px;
    height: 166px;
  }

  .image-product {
    object-fit: cover;
    object-position: center center;
    block-size: auto;
    width: 100%;
    height: 100%;
  }

  .favorite {
    background: none;
    border: none;
    cursor: pointer;
    width: 38px;
    height: 35px;
    right: 0;
    bottom: 0;
    margin: 0 0.3rem 0.1rem 0 !important;
    outline: none;
    position: absolute;
    color: #0c881e;
    z-index: 9;
  }
`,cw=h.div`
  padding: 5px 10px 16px 0;

  @media (min-width: 672px) {
    padding-left: 10px;
  }

  .title-product {
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 8px;
    font-size: 14px;

    @media (min-width: 672px) {
      font-size: 16px;
    }
  }
`,pw=h.div`
  position: relative;

  p {
    font-size: 18px;
    color: ${f.color09};
  }

  .label-price-from {
    font-weight: normal;
    font-size: 14px;
    color: ${f.color09};
  }

  .label-price-discount {
    font-size: 14px;
    text-decoration: line-through;
    line-height: inherit;
  }

  .price-in-cash {
    font-size: 14px;
    font-weight: 400;
    color: ${f.color04};
  }
`,mw=h.div`
  position: absolute;
  bottom: 0;
  right: 0;
  margin-bottom: 6px;
  margin-right: 6px;
  min-height: 20px;
`;var uw;function hw(){return hw=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},hw.apply(null,arguments)}const gw=e=>i.createElement("svg",hw({xmlns:"http://www.w3.org/2000/svg",width:24,height:24},e),uw||(uw=i.createElement("g",{"data-name":"shopping--cart--arrow-down (1)",transform:"translate(.203 .204)"},i.createElement("circle",{cx:1.5,cy:1.5,r:1.5,fill:"currentColor","data-name":"Elipse 2019",transform:"translate(6.797 19.796)"}),i.createElement("circle",{cx:1.5,cy:1.5,r:1.5,fill:"currentColor","data-name":"Elipse 2020",transform:"translate(16.797 19.796)"}),i.createElement("path",{fill:"currentColor",d:"M3.792 2.185a.74.74 0 0 0-.726-.6H.105v1.481h2.354l2.846 14.212a.74.74 0 0 0 .726.6h13.324v-1.486H6.635l-.592-2.961h13.312a.74.74 0 0 0 .723-.58l1.679-7.566h-1.516l-1.48 6.663H5.747Z","data-name":"Caminho 39489"}),i.createElement("path",{fill:"currentColor",d:"m16.087 4.985-2.655 2.65v-6.05h-1.483v6.05l-2.653-2.65-1.047 1.042 4.442 4.442 4.442-4.442Z","data-name":"Caminho 39490"}),i.createElement("path",{fill:"none",d:"M-.203-.204h24v24h-24z","data-name":"<Transparent Rectangle>"}))));function Aw(i){const[n,l]=r(),[d,s]=r(),[c,p]=r(!1),{setProduct:m,setChangedProducts:u,getShoppingCart:h,addToCart:g}=pi(),{pageInfo:A,setPagination:f}=Ai(),v=fi(),{setCartSideMenu:x}=ci(),{createNotification:b}=ni(),{context:w}=di(),y=wo(),C=qt(),{setHasNewItemAddedToCartState:E,setCartItens:B}=ui();let k=!1;a((()=>{i.product.mp_info.offers.length>0&&(l(Number(i.product.mp_info.offers[0].formatted_price.price.regular_price.value).toLocaleString("pt-br",{style:"currency",currency:"BRL"})),i.product.mp_info.offers[0].formatted_price.price.discount.amount_off>0&&s(Number(i.product.mp_info.offers[0].formatted_price.price.final_price.value).toLocaleString("pt-br",{style:"currency",currency:"BRL"})))}),[i.product]);const I=()=>{f(Object.assign(Object.assign({},A),{currentPage:1,resetCurrentPage:!0})),k||y.push((()=>{const e=location.search,t=void 0!==e&&""!==e;return`/loja/${i.product.url_key}/p${t?`?oferta=${void 0===i.product.partnumber?"indisponivel":i.product.partnumber}`:""}`})())},N=()=>{if(!((null==w?void 0:w.miraklRegion)&&(null==w?void 0:w.miraklRegion.length)>0))return;E(!0);void 0!==i.dataProducts&&Je.tagecommerce({event:tt.AddToCard,items:(()=>{var e;if(!i.dataProducts)return;return null===(e=i.dataProducts)||void 0===e?void 0:e.find((e=>(null==e?void 0:e.item_id)===i.product.partnumber))})()}),"sku"===i.product.type?(p(!0),v.add({quantity:1,partnumber:i.product.partnumber,offer_id:i.product.mp_info.offers[0].offer_id}).then((e=>Yl(this,void 0,void 0,(function*(){var t,o,n,r,a,l,d,s,c,A,f,v;const b={productId:1,name:null===(t=null==i?void 0:i.product)||void 0===t?void 0:t.name,sku:null===(o=null==i?void 0:i.product)||void 0===o?void 0:o.partnumber,pricing:{regularPrice:Number(null===(s=null===(d=null===(l=null===(a=null===(r=null===(n=null==i?void 0:i.product)||void 0===n?void 0:n.mp_info)||void 0===r?void 0:r.offers[0])||void 0===a?void 0:a.formatted_price)||void 0===l?void 0:l.price)||void 0===d?void 0:d.regular_price)||void 0===s?void 0:s.value),currencyCode:"BRL"}};m(b);const w=yield h(),y=!(null===(c=null==w?void 0:w.items)||void 0===c?void 0:c.find((e=>{var t;return(null===(t=null==e?void 0:e.product)||void 0===t?void 0:t.sku)===(null==b?void 0:b.sku)})));if(y){const e={canApplyMsrp:!1,formattedPrice:null===(f=Number(null===(A=null==b?void 0:b.pricing)||void 0===A?void 0:A.regularPrice))||void 0===f?void 0:f.toLocaleString("pt-br",{style:"currency",currency:"BRL"}),id:null==b?void 0:b.sku,prices:{price:{value:Number(null===(v=null==b?void 0:b.pricing)||void 0===v?void 0:v.regularPrice)}},product:b,quantity:1};yield u({items:[e]}),yield g()}x({openSideMenu:!0}),p(!1),B(e)})))).catch((e=>{p(!1),b({kind:"error",title:null===JSON||void 0===JSON?void 0:JSON.stringify(null==e?void 0:e.message)})}))):I()};return e(lw,{style:i.style,children:e(Xl,{className:"link",title:i.product.name,alt:i.product.name,onClick:e=>{if(!k){e.preventDefault(),y.push(`/loja/${i.product.url_key}/p`);const t=()=>{var e;if(!i.dataProducts)return;const t=null===(e=i.dataProducts)||void 0===e?void 0:e.find((e=>(null==e?void 0:e.item_id)===i.product.partnumber));return Object.assign(Object.assign({},t),{quantity:1})};Je.tagecommerce({event:tt.SelectItem,items:t()}),Je.interact(Ye.Click,"clique",i.offerName.toLowerCase().replace(" ","-"),"produtos",it.LoggedIn,"e-agro/loja",null,{userId:Je.getUserId(C)})}},style:{marginRight:i.isLast?0:void 0},children:t(dw,{children:[e(sw,{children:e("img",{src:i.product.fullImage,className:"image-product"})}),t(cw,{children:[i.product.precisa_de_cotacao,e(ba,{color:"color13",size:"fontSize02",weight:"fontWeight03",text:i.product.name,className:"title-product"}),i.product.precisa_de_cotacao?e(ba,{color:"color13",size:"fontSize03",weight:"fontWeight02",text:"Consulte aqui"}):i.product.mp_info.offers.length>0&&t(pw,{children:[i.product.mp_info.offers.length>1&&e("p",{className:"label-price-from",children:"A partir de"}),i.product.mp_info.offers[0].formatted_price.price.discount.amount_off>0?t(o,{children:[e("p",{className:"label-price-discount",children:n}),e(ba,{color:"color13",size:"fontSize03",weight:"fontWeight02",text:d})]}):e(o,{children:e(ba,{color:"color13",size:"fontSize03",weight:"fontWeight02",text:n})}),e("p",{className:"price-in-cash",children:"à vista"})]})]}),!i.product.precisa_de_cotacao&&e(mw,{id:"CartIcon",onClick:e=>{e.preventDefault(),k=!0},children:c?e(Vt,{small:!0,withOverlay:!1}):e($a,{Icon:e(gw,{}),onEventClick:()=>{N()},isIconAddToCartAvailable:!0})})]})})},i.key)}var fw,vw;!function(e){e[e.carousel=0]="carousel",e[e.list=1]="list"}(fw||(fw={})),function(e){e[e.grid=0]="grid",e[e.row=1]="row"}(vw||(vw={}));const xw=({offers:i,displayMode:n,listType:l,dataProducts:d,offerName:c,sellerId:p,sellerPlan:m})=>{var u;const h=s(null),g=s(null),[A,f]=r(0),[v,x]=r(!0),[b,w]=r(0),[y,C]=r(0),[E,B]=r(1),[k,I]=r(0),[N,S]=r(0),[O,z]=r(!0),{width:M}=lt(),D=e=>{if(null!==h.current){const t=e*k;h.current.scrollLeft=t,f(t),Math.floor(h.current.scrollWidth-h.current.scrollLeft)<=h.current.offsetWidth?x(!0):x(!1)}},j=()=>{null!==h.current&&(z(A<h.current.scrollLeft),f(h.current.scrollLeft),Math.floor(h.current.scrollWidth-h.current.scrollLeft)<=h.current.offsetWidth?x(!0):x(!1))};return a((()=>{j()}),[M]),a((()=>{var e;void 0!==g.current&&void 0!==(null===(e=g.current)||void 0===e?void 0:e.clientWidth)&&w(g.current.clientWidth)}),[g,M]),a((()=>{var e;if(b>0&&void 0!==h.current&&void 0!==(null===(e=h.current)||void 0===e?void 0:e.clientWidth)){const e=Math.floor(h.current.clientWidth/b);C(e),I(b*e)}}),[b,M]),a((()=>{y>0&&B(Math.ceil(i.length/y))}),[y,M]),a((()=>{if(v)S(E-1);else{const e=O?Math.ceil(A/k):Math.floor(A/k);S(e)}}),[A,k,v,O,N]),e(Hb,{children:n===fw.carousel?t(Fb,{children:[0!==A&&e(P,{className:"arrow-button arrow-button-left",onClick:()=>{z(!1),D(N-1)}}),e(Vb,{id:"HomeCarouselProductBelowDesc",ref:h,onScroll:()=>j(),onTouchEnd:()=>{setTimeout((()=>{const e=O?Math.ceil(A/k):Math.floor(A/k);D(e)}),100),setTimeout((()=>{const e=O?Math.ceil(A/k):Math.floor(A/k);D(e)}),500)},style:{justifyContent:1===E?"center":"flex-start"},children:null==i?void 0:i.map(((t,n)=>e(o,{children:l===vw.grid?e(Jb,{ref:g,children:e(aw,{sellerId:p,offerName:c,dataProducts:d,product:t,sellerPlan:m,isLast:n===i.length-1},t.url_key)}):e(Yb,{ref:g,children:e(Aw,{offerName:c,dataProducts:d,product:t,isLast:n===i.length-1},t.url_key)})})))}),!v&&e(Q,{className:"arrow-button arrow-button-right",onClick:()=>{z(!0),D(N+1)}}),e(Kb,{className:"grid-page-container",children:null===(u=Array.from({length:E}))||void 0===u?void 0:u.map(((t,o)=>e("div",{className:"dot"+(N===o?"-active":""),onClick:()=>{D(o),S(o)}},o)))})]}):e(o,{children:null==i?void 0:i.map(((t,o)=>e(Zb,{children:e(Aw,{offerName:c,dataProducts:d,product:t,isLast:o===i.length-1},t.url_key)},o)))})})},bw=h.div`
  display: flex;
  flex-direction: column;
  margin: 10px;

  min-width: 220px;
  width: 220px;
  height: 377px;
  border-radius: 6px;
  box-shadow:
    0.0625rem 0.0625rem 10px #dcdcdc,
    -0.0625rem -0.0625rem 5px #dcdcdc;

  .image {
    width: stretch;
    height: 226px;
    border-radius: 6px;
  }

  .title {
    width: stretch;
    height: 40px;
    margin: 10px;
    margin-top: 16px;
  }

  .discount {
    width: 50px;
    height: 25px;
    margin: 10px;
    margin-top: 10px;
  }

  .price {
    width: 90px;
    height: 30px;
    margin: 10px;
    margin-top: 5px;
  }

  .cart {
    width: 24px;
    height: 24px;
    margin: auto 10px 10px auto;
  }
`,ww=()=>t(bw,{className:"skeleton",children:[e(Ci,{className:"image"}),e(Ci,{className:"title"}),e(Ci,{className:"discount"}),e(Ci,{className:"price"}),e(Ci,{className:"cart"})]}),yw=h.div`
  display: flex;
  flex-direction: row;

  width: stretch;
  border-radius: 6px;

  @media (min-width: 1056px) {
    box-shadow:
      0.0625rem 0.0625rem 10px #dcdcdc,
      -0.0625rem -0.0625rem 5px #dcdcdc;
    border-radius: 6px;
    min-width: 405px;
    width: 405px;
    margin: 16px;
    margin-right: 0;
  }

  .image {
    border-radius: 6px;

    min-width: 136px;
    min-height: 136px;
    width: 136px;
    height: 136px;
    margin: 10px;

    @media (min-width: 672px) {
      min-width: 227px;
      min-height: 179px;
      width: 227px;
      height: 179px;
    }

    @media (min-width: 1056px) {
      min-width: 193px;
      min-height: 166px;
      width: 193px;
      height: 166px;
    }
  }
`,Cw=h.div`
  display: flex;
  flex-direction: column;
  width: stretch;

  .title {
    width: stretch;
    height: 35px;
    margin: 10px;
    margin-top: 10px;
  }

  .discount {
    width: 50px;
    height: 20px;
    margin: 10px;
    margin-top: 5px;
  }

  .price {
    width: 90px;
    height: 25px;
    margin: 10px;
    margin-top: 0px;
  }

  .cart {
    width: 24px;
    height: 24px;
    margin: auto 10px 10px auto;
  }
`;function Ew(){return t(yw,{children:[e(Ci,{className:"image"}),t(Cw,{children:[e(Ci,{className:"title"}),e(Ci,{className:"discount"}),e(Ci,{className:"price"}),e(Ci,{className:"cart"})]})]})}const Bw={s:"20rem",m:"28rem",l:"60vw",xl:"75vw",c:"23.75rem"},kw=h("div")``,Iw=h("div")`
  background-color: white;
  bottom: 0;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 9999;
  top: 0;
  transition: transform 0.25s ease-out;
  width: 100vw;
  overflow-y: auto;
  /* Position outside of screen */
  ${e=>"left"===e.position&&"left: calc(-100vw - 1rem);"}
  ${e=>"right"===e.position&&"right: calc(-100vw - 1rem);"}

  /* Move into screen when open */
  ${e=>"left"===e.position&&e.isOpen&&"transform: translateX(calc(100vw + 1rem));"}
  ${e=>"right"===e.position&&e.isOpen&&"transform: translateX(calc(-100vw - 1rem));"}

  /* Shift the main panel as needed */
  ${e=>"push"===e.mode&&g`
      & ~ ${kw} {
        ${"left"===e.position&&e.isOpen&&"transform: translateX(100vw);"}
        ${"right"===e.position&&e.isOpen&&"transform: translateX(-100vw);"}
      }
    `}

  ${e=>Bo.greaterThan(e,"medium").then(g`
      width: ${Bw[e.size]};
      overflow-y: auto;
      overflow-x: hidden;
      /* Position outside of screen */
      ${"left"===e.position&&`left: calc(-${Bw[e.size]} - 1rem);`}
      ${"right"===e.position&&`right: calc(-${Bw[e.size]} - 1rem);`}

    /* Move into screen when open */
    ${"left"===e.position&&e.isOpen&&`transform: translateX(calc(${Bw[e.size]} + 1rem));`}
    ${"right"===e.position&&e.isOpen&&`transform: translateX(calc(-${Bw[e.size]} - 1rem));`}

    /* Shift the main panel as needed */
    ${Eo(e,"mode").switch([ko.eq("compress").then(g`
          & ~ ${kw} {
            position: relative;
            ${"left"===e.position&&e.isOpen&&`margin-left: ${Bw[e.size]};`};
            ${"right"===e.position&&e.isOpen&&`margin-right: ${Bw[e.size]};`};
          }
        `),ko.eq("push").then(g`
          & ~ ${kw} {
            position: relative;
            ${"left"===e.position&&e.isOpen&&`transform: translateX(${Bw[e.size]});`}
            ${"right"===e.position&&e.isOpen&&`transform: translateX(-${Bw[e.size]});`}
          }
        `)])};
    `)}

  & ~ ${kw} {
    transition:
      transform 0.25s ease-out,
      margin 0.25s ease-out;
  }
`,Nw=h("div")`
  align-items: center;
  display: flex;
  margin-top: 24px;
  padding: 0 16px 16px 16px;
`;h("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fd;
`,h("div")`
  font-weight: bold;
  font-size: 20px;
  padding: 1rem;
`,h("div")`
  font-size: 20px;
  padding: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
`,h("div")`
  font-weight: bold;
  font-size: 20px;
  padding: 0.4rem;
  margin-left: 1.8rem;
  margin-bottom: 1rem;
`,h("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -40%;
  left: 47%;
  transform: translate(-50%, -50%);
`,h("div")`
  font-weight: bold;
  font-size: 20px;
  padding: 0.4rem;
  margin-left: 1.8rem;
  margin-bottom: 2rem;
`,h(wi)`
  width: 100%;
  padding: ${e=>e.theme.spacing.inset.L};
  background-color: ${f.color01};
  color: ${f.color03};
  border: none;
  border-radius: 30px;
  font-weight: ${f.fontWeight02};
  justify-content: center;
  align-items: center;
  :hover {
    cursor: pointer;
    background-color: ${f.color01Dark};
    color: ${f.color03};
    border: none;
  }
  ${e=>Bo.lessThan(e,"medium").then(g`
      flex-direction: column;
    `)}
`,h("div")`
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
`;const Sw=h("button")`
  ${e=>!e.show&&"visibility: hidden;"}
  margin-left: auto;
  border: none;
  cursor: pointer;
  color: ${f.color04};

  /* stylelint-disable-next-line selector-max-universal */
  & > *:hover {
    color: ${e=>e.theme.colors.interactive.primary.hover.bg};
  }
`,Ow=h("div")`
  height: 100%;
  margin-bottom: ${e=>Io(No("2rem",{}))};
  ${e=>e.isScrolling&&"overflow-y: auto;"};
  ${e=>!e.isScrolling&&"overflow: hidden;"};
  padding: ${e=>No("2rem",{vertical:"0"})};

  &::-webkit-scrollbar {
    width: 0;
  }
`,Pw=h("div")`
  padding: ${e=>No("2rem",{vertical:"0"})};
`,Qw=h("div")`
  margin-bottom: ${e=>Io(No("2rem",{}))};
  margin-top: calc(-1 * ${e=>Io(No("2rem",{}))});
  padding: ${e=>No("2rem",{vertical:"0"})};
`,zw=h(Yo)`
  height: 4rem;
  margin-top: auto;
  width: 100%;

  /* stylelint-disable-next-line selector-max-universal */
  & > * {
    height: 4rem;
    width: 50%;
  }
`,Mw=h("div")`
  ${e=>e.isVisible&&`background: ${e.theme.colors.backgrounds.overlay};`}
  ${e=>!e.isVisible&&"background: transparent;"}

  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9998;
  overscroll-behavior: none;
  transition: background 0.25s ease-out;
`,Dw=h("div")`
  position: relative;
`,jw=h("button")`
  ${e=>!e.show&&"visibility: hidden;"};
  margin-left: auto;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 1.5rem;
  right: 1rem;
  z-index: 9999;

  /* stylelint-disable-next-line selector-max-universal */
  & > *:hover {
    color: ${e=>e.theme.colors.interactive.primary.hover.bg};
  }
`,Tw=h.p`
  font-size: ${f.fontSize04};
  font-weight: ${f.fontWeight03};
  color: ${f.color04};
`,Rw=({children:i,isOpen:n=!1,size:r="m",position:l="left",mode:d="onTop",isClosable:s=!0,onClose:c=()=>{},title:p,hasOverlay:m=!0,isCloseOnOverlayClick:u=!0,isDanger:h=!1,elevation:g,buttons:A=[],className:f,isCategoriesMenu:v,overlayClassName:x,ref:b,isPanelCpr:w=!1})=>{a((()=>{const e=document.body.style.overflow;return document.body.style.overflow=n&&m?"hidden":"auto",()=>{document.body.style.overflow=e}}),[m,n]);const y=h?"danger":"primary",C=qt();return a((()=>{var e;!n||(null===(e=null===location||void 0===location?void 0:location.pathname)||void 0===e?void 0:e.includes("checkout"))||w||Je.pageview(Ye.PageView,"marketplace",Je.getUserStatus(C),`e-agro${null===location||void 0===location?void 0:location.pathname}/orcamento`,Je.getActionLocation(),null)}),[n]),t(o,{children:[t(Iw,{className:f,size:r,position:l,mode:d,isOpen:n,elevation:g,id:"FilterSidePanel",ref:b,children:[(p||s&&!v)&&(w?t(Dw,{children:[p&&e(Tw,{children:p}),e(jw,{show:s,onClick:()=>c(),children:e(ur,{})})]}):t(Nw,{children:[p&&e(Tw,{children:p}),e(Sw,{show:s,onClick:()=>c(),children:e(ur,{})})]})),i,A.length>0&&e(zw,{isCompact:!0,children:A.map((t=>e(Zo,{disabled:t.disabled,variant:t.isPrimary?y:"secondary",label:t.label},t.label)))})]}),m&&n&&e(Mw,{isVisible:m&&n,onClick:()=>u&&c(),className:x})]})};Rw.Body=({children:t,isScrolling:o=!0})=>e(Ow,{isScrolling:o,children:t}),Rw.Section=({children:t})=>e(Pw,{children:t}),Rw.Footer=({children:t})=>e(Qw,{children:t}),Rw.Main=({children:t})=>e(kw,{children:t});const Lw=n.memo(Rw),Uw=h.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  width: 98.5%;

  .categs-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .separator {
      border-top: 1px solid ${f.color16};
      width: 90%;
      height: 2px;
    }
  }

  .title-grid {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    img {
      width: 12px;
      height: 9px;
      margin-right: 17px;
    }

    li {
      font: normal normal normal 14px/17px Bradesco Sans;
      letter-spacing: 0.16px;
      color: ${f.color04};
      margin-left: 16px;
      margin-bottom: 16px;
      margin-top: 16px;
      width: 100%;
      display: inline-flex;
      align-items: center;
      justify-content: space-between;

      a {
        color: ${f.color04};
        width: 100%;
      }
    }
  }
`,qw=h.div`
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    background-color: transparent;
    max-width: 100%;
    max-height: 100%;
  }

  width: 95%;
  height: 376px;
  margin-top: 16px;

  img {
    min-width: 95%;
    max-width: 232px;
    min-height: 376px;
    max-height: 95%;
    /* aspect-ratio: 1; */
    object-fit: contain;
    margin-bottom: 70px;

    @media (min-height: 1000px) {
      margin-bottom: 0 !important;
    }

    @media (min-height: 900px) and (max-height: 1000px) {
      margin-bottom: 60px !important;
    }
  }
`,Ww=h.div`
  width: 100%;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;

  .voltar-container {
    width: 100%;
    display: flex;
    margin-left: 13px;
    align-items: center;

    h3 {
      margin-left: 0 !important;
    }
  }

  .close {
    max-width: 12px;
    max-height: 12px;
    margin-right: 18px;
  }

  h3 {
    margin-left: 13px;
  }

  @media (min-width: 400px) {
    right: 10px;
  }

  .voltar-arrow {
    width: 12px;
    height: 9px;

    transform: rotate(-0.5turn);
    position: relative;
    top: 1px;
    margin-right: 8px;
  }

  .voltar {
    font: normal normal normal 14px/17px Bradesco Sans;
    letter-spacing: 0.16px;
    color: ${f.color09};
    margin-left: 15px;
  }

  .header-title {
    font: normal normal 600 16px/20px Bradesco Sans;
    letter-spacing: 0px;
    color: ${f.color04};
  }
`,Gw=h.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-left: 16px;
  margin-top: 16px;
  h1 {
    font: normal normal 600 16px/24px Bradesco Sans;
    letter-spacing: 0px;
    color: ${f.color04};
  }
`,Hw=h.div`
  cursor: default;
  width: 100%;
  height: 100%;

  .content-container {
    margin-top: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: transparent;

    .categs-and-banner {
      display: flex;
      flex-direction: column;
      width: 100%;
      justify-content: space-between;

      @media (min-height: 1000px) {
        height: 77vh !important;
      }

      @media (min-height: 1050px) {
        height: 83vh !important;
      }

      @media (min-height: 1050px) and (max-height: 1180px) {
        height: 81vh !important;
      }

      @media (max-height: 1000px) {
        height: 0vh !important;
      }
    }

    .sub-categs-title {
      width: 100%;
      display: flex;
      align-items: flex-start;
      margin-left: 16px;
      margin-top: 16px;
      h1 {
        font: normal normal 600 16px/24px Bradesco Sans;
        letter-spacing: 0px;
        color: ${f.color04};
      }
    }
  }
`,Fw=h.div`
  z-index: 9000;
  color: ${f.color04};

  .sidebar {
    width: 264px !important;
    height: 95% !important;
    top: 110px !important;
    background: ${f.bg14} 0% 0% no-repeat padding-box !important;
    box-shadow: none !important;
  }

  .overlay {
    position: fixed;
    left: 0;
    top: 110px !important;
    width: 100%;
    height: 100vh;
    z-index: 9998;
    overscroll-behavior: none;
    transition: background 0.25s ease-out;
    overflow-x: hidden;
  }
`;var Vw="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAATCAYAAABlcqYFAAAABHNCSVQICAgIfAhkiAAAANFJREFUOE+t1MENgjAUBuD/JXCvB52DERhFR/CgQ8DBEWQTu4IbcC4HvWuEvhgTTEhbXl8vJLT0a9L/hyAdreswwuK862JbUGzB4nw71B64fefGQwySIbx34/YAXVMgObICykMSoXwkAdJBIpAeEoAIzWA5h6IoL39U+ddmnjpGNIF/lnDHaVsRuFha40MGNHJ3/NMDRVHjuHnq3cnlYfB681+gmgN8fh0kAOggESAfSQDykERAjqwA5EjjfOHI+tj0v5iGWiBPF0Nl2XMPYjWbAAQDbRTuhppfAAAAAElFTkSuQmCC";const Kw=({options:i,isCategoriesSideBarOpen:n,setIsCategoriesSideBarOpen:l})=>{var d,s,c,p,m,u,h,g;const A=wo(),f=qt(),{data:v}=wt(),x=Lw,[b,w]=r("Categorias"),[y,C]=r({categoryName:"",SubCategs:[]}),{width:E}=lt();return a((()=>(n&&(document.body.style.overflow="hidden"),()=>{document.body.style.overflow="auto"})),[n]),e(o,{children:E<=1055&&e(Fw,{children:e("div",{className:"dropdown",children:e(x,{isOpen:n,position:"left",isCloseOnOverlayClick:!0,onClose:()=>l(!1),elevation:9999,className:"sidebar",isCategoriesMenu:!0,overlayClassName:"overlay",children:e(Hw,{children:t("div",{className:"content-container",children:[t(Ww,{children:[t("div",{className:"Voltar"===b?"voltar-container":"",children:["Voltar"===b&&e("img",{src:Vw,alt:"voltar",title:"voltar",className:"voltar-arrow",onClick:()=>{w("Categorias"),C({categoryName:"",SubCategs:[]})}}),e("h3",{className:"Voltar"===b?"voltar":"header-title",onClick:()=>{w("Categorias"),C({categoryName:"",SubCategs:[]})},children:b})]}),e("img",{src:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAOJJREFUSEullYsNwyAMBZvJ2k2aTFaySUarX2tLCPwLRrJQAN3FYMH2+Led4klx8He1awS4KNrG8A8TMVGVgPFm3gFBP4DximRknRAIVKyrkgmO3RFBVaLCAe0FqxITrgnuSly4JchKQrgniCQpeCSwJDi3vuJOVAtX49SNh6ytG/+2X+PCMxkITJOE8KoA0vBaqW5RKIkEWrUg8/S14gm8UhznzEwsQabOUxJNkIFb1TVlEl12mVJ0M/Gu6ww8zMR6cO7AXYn2ZK7ATcn46FfgmuT36KPtFC/uZWGlx8FfFO0LepFSGDfPmVkAAAAASUVORK5CYII=",alt:"fechar",title:"fechar",className:"close",onClick:()=>{l(!1),w("Categorias"),C({categoryName:"",SubCategs:[]})}})]}),t("div",{className:"categs-and-banner",children:[e(Uw,{children:0===(null===(d=null==y?void 0:y.SubCategs)||void 0===d?void 0:d.length)?e(o,{children:i.map((i=>{var n;const r=null===(n=null==i?void 0:i.children.slice())||void 0===n?void 0:n.sort(((e,t)=>{var o;return null===(o=null==e?void 0:e.name)||void 0===o?void 0:o.localeCompare(null==t?void 0:t.name)}));return e(o,{children:t("div",{className:"categs-container",onClick:e=>{e.preventDefault(),C({categoryName:null==i?void 0:i.name,SubCategs:r}),w("Voltar")},children:[e("ul",{className:"title-grid",children:t("li",{className:"link-title",children:[null==i?void 0:i.name,e("img",{src:Vw,alt:null==i?void 0:i.name,title:null==i?void 0:i.name})]})}),e("div",{className:"separator"})]})})}))}):t(o,{children:[e(Gw,{className:"sub-categs-title",children:e("h1",{children:y.categoryName})}),null===(s=null==y?void 0:y.SubCategs)||void 0===s?void 0:s.map((i=>e(o,{children:t("div",{className:"categs-container",onClick:e=>{var t;e.preventDefault(),l(!1),Je.interact(Ye.Click,Je.getActionLocation(),`${null===(t=null==i?void 0:i.name)||void 0===t?void 0:t.toLowerCase()}`,"header",Je.getUserStatus(f),"e-agro/header",null,{userId:Je.getUserId(f)}),(e=>{A.push(`/loja/${null==e?void 0:e.url_path}`)})(i)},children:[e("ul",{className:"title-grid",children:t("li",{className:"link-title",onClick:e=>{e.preventDefault()},children:[e(Xl,{title:null==i?void 0:i.name,href:`/loja/${null==i?void 0:i.url_path}`,className:"link",onClick:e=>{e.preventDefault()},children:null==i?void 0:i.name}),e("img",{src:Vw,alt:null==i?void 0:i.name,title:null==i?void 0:i.name})]})}),e("div",{className:"separator"})]})})))]})}),0===(null===(c=null==y?void 0:y.SubCategs)||void 0===c?void 0:c.length)&&e(qw,{children:e(Xl,{title:null===(p=null==v?void 0:v.getMenuMarketplace)||void 0===p?void 0:p.title,href:null===(m=null==v?void 0:v.getMenuMarketplace)||void 0===m?void 0:m.link,onClick:e=>{var t;e.preventDefault(),A.push(null===(t=null==v?void 0:v.getMenuMarketplace)||void 0===t?void 0:t.link)},children:e("img",{className:"banner",src:null===(u=null==v?void 0:v.getMenuMarketplace)||void 0===u?void 0:u.image_url_mobile,alt:null===(h=null==v?void 0:v.getMenuMarketplace)||void 0===h?void 0:h.alt,title:null===(g=null==v?void 0:v.getMenuMarketplace)||void 0===g?void 0:g.title,onClick:()=>{l(!1)}})})})]})]})})})})})})},Jw=h.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem 2.625rem 1.5rem 1.5rem;
  position: relative;
`,Yw=h.p`
  text-align: left;
  font: normal normal 600 22px/28px Bradesco Sans;
  letter-spacing: 0;
  opacity: 1;
  color: ${f.color04};
  margin-bottom: 1rem;
  max-width: 90%;
`,Zw=h.p`
  text-align: left;
  font: normal normal normal 14px/20px Bradesco Sans;
  letter-spacing: 0;
  color: ${f.color10};
  opacity: 1;
  margin-bottom: 1.5rem;
`,Xw=h.hr`
  margin: 1.5rem 0;
  border: 1px solid ${f.color07};
`,_w=h.p`
  margin-bottom: 1.5rem;
  color: ${f.color04};
  text-align: left;
  font: normal normal 600 16px/24px Bradesco Sans;
  letter-spacing: 0;
  opacity: 1;
`,$w=h.div`
  display: flex;
  flex-direction: row;
`,ey=h.div`
  min-width: 2rem;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: center;

  svg {
    z-index: 999;
  }
`,ty=h.div`
  position: absolute;
  max-width: 1.5px;
  min-width: 1.5px;
  left: 17px;
  top: 1rem;
  height: 100%;
  border: 1px dashed ${f.color20};
  z-index: 0;
  opacity: 0.4;
`,oy=h.div`
  display: flex;
  flex-direction: column;
  margin-left: 0.625rem;
  text-align: left;
  justify-content: center;
  align-items: flex-start;
`,iy=h.div`
  min-height: 36px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`,ny=h.p`
  text-align: left;
  font: normal normal normal 12px/16px Bradesco Sans;
  letter-spacing: 0;
  color: ${f.color09};
  opacity: 1;
`,ry=h.p`
  text-align: left;
  font: normal normal 600 14px/20px Bradesco Sans;
  letter-spacing: 0;
  color: ${f.color04};
  opacity: 1;
`,ay=h.p`
  margin: 0.5rem 0 2rem 0;
  color: ${f.color09};
  text-align: left;
  font: normal normal normal 12px/16px Bradesco Sans;
  letter-spacing: 0;
  opacity: 1;

  .bold-text {
    font: normal normal bold 12px/16px Bradesco Sans;
  }

  @media (max-width: 671px) {
    margin-top: 0.5rem;
  }
`,ly=h.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${f.colorAlertLight};
  border-radius: 4px;
  opacity: 1;
  width: 100%;
  height: 2rem;

  svg {
    margin: 0 0.5rem;
  }

  .tag-text {
    text-align: left;
    font: normal normal normal 12px/16px Bradesco Sans;
    letter-spacing: 0;
    color: ${f.bg04};
  }

  .red-text {
    color: ${f.colorError};
    font-weight: bold;
  }
`;var dy;function sy(){return sy=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},sy.apply(null,arguments)}const cy=e=>i.createElement("svg",sy({xmlns:"http://www.w3.org/2000/svg",width:36,height:36},e),dy||(dy=i.createElement("g",{"data-name":"Grupo 147077",transform:"translate(9338 20088)"},i.createElement("circle",{cx:18,cy:18,r:18,fill:"#f5f7fd","data-name":"Elipse 2216",transform:"translate(-9338 -20088)"}),i.createElement("path",{fill:"none",d:"M-9328-20078h16v16h-16z"}),i.createElement("g",{"data-name":"Enterprise / Commerce / shopping--cart / 16"},i.createElement("path",{fill:"#008aeb",d:"M-9322.292-20064.784a1.017 1.017 0 1 1-1.017 1.017 1.02 1.02 0 0 1 1.017-1.017m7.116 0a1.017 1.017 0 1 1-1.017 1.017 1.02 1.02 0 0 1 1.018-1.017Zm2.033-9.658h-11.284l-.406-2.135a.5.5 0 0 0-.509-.407h-2.033v1.017h1.627l1.932 9.759a.5.5 0 0 0 .508.407h9.149v-1.017h-8.743l-.407-2.033h9.149a.5.5 0 0 0 .508-.407l1.017-4.575a.515.515 0 0 0-.407-.61Zm-1.423 4.574h-8.946l-.712-3.558h10.42Z","data-name":"Caminho 34"}),i.createElement("path",{fill:"none",d:"M-9328-20078h16v16h-16z"})))));var py;function my(){return my=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},my.apply(null,arguments)}const uy=e=>i.createElement("svg",my({xmlns:"http://www.w3.org/2000/svg",width:36,height:36},e),py||(py=i.createElement("g",{"data-name":"Grupo 147080",transform:"translate(9338 19949)"},i.createElement("circle",{cx:18,cy:18,r:18,fill:"#f5f7fd","data-name":"Elipse 2217",transform:"translate(-9338 -19949)"}),i.createElement("path",{fill:"#008aeb",d:"M-9315.39-19923h-9.22a1.087 1.087 0 0 1-1.152-1.144v-13.713a1.086 1.086 0 0 1 1.152-1.143h5.763a.9.9 0 0 1 .461.228l4.034 4a1.1 1.1 0 0 1 .115.343v10.285a1.087 1.087 0 0 1-1.153 1.144m-9.22-14.857v13.713h9.219v-9.141h-3.456a1.087 1.087 0 0 1-1.153-1.144v-3.428Zm5.762.228v3.2h3.227Zm2.306 11.2h-6.914v-1.143h6.914v1.142Zm0-3.428h-6.914v-1.143h6.914v1.142Z","data-name":"Organization / File / document / 16"}))));var hy,gy;function Ay(){return Ay=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},Ay.apply(null,arguments)}const fy=e=>i.createElement("svg",Ay({xmlns:"http://www.w3.org/2000/svg",width:36,height:36},e),hy||(hy=i.createElement("defs",null,i.createElement("clipPath",{id:"cpr-passo-3_svg__a"},i.createElement("path",{fill:"#008aeb",d:"M16 6a2.67 2.67 0 0 0 2.667-2.667v-2h-2a2.65 2.65 0 0 0-1.831.738A4 4 0 0 0 11.333 0h-2v2a4 4 0 0 0 4 4H14v8.667H6v-3.334h.667a2.67 2.67 0 0 0 2.667-2.667v-2h-2A2.65 2.65 0 0 0 5.5 7.4 4 4 0 0 0 2 5.329H0v2a4 4 0 0 0 4 4h.667v3.333H0V16h18.667v-1.333h-3.334V6Zm-.667-2a1.335 1.335 0 0 1 1.333-1.333h.667v.667A1.335 1.335 0 0 1 16 4.667h-.667ZM6 9.333A1.335 1.335 0 0 1 7.333 8H8v.667A1.335 1.335 0 0 1 6.667 10H6ZM4.667 10H4a2.67 2.67 0 0 1-2.667-2.667v-.667H2a2.67 2.67 0 0 1 2.667 2.667ZM14 4.667h-.667A2.67 2.67 0 0 1 10.667 2v-.667h.667A2.67 2.67 0 0 1 14 4Z",clipRule:"evenodd","data-name":"Caminho 714367"})))),gy||(gy=i.createElement("g",{"data-name":"Grupo 147083",transform:"translate(9338 19826)"},i.createElement("circle",{cx:18,cy:18,r:18,fill:"#f5f7fd","data-name":"Elipse 2217",transform:"translate(-9338 -19826)"}),i.createElement("g",{"data-name":"Grupo 147082"},i.createElement("g",{clipPath:"url(#cpr-passo-3_svg__a)","data-name":"Grupo 147062",transform:"translate(-9329.334 -19816)"},i.createElement("path",{fill:"#008aeb",d:"M-.889-.889h20.444v17.778H-.889Z","data-name":"Caminho 714366"}))))));var vy;function xy(){return xy=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},xy.apply(null,arguments)}const by=e=>i.createElement("svg",xy({xmlns:"http://www.w3.org/2000/svg",width:36,height:36},e),vy||(vy=i.createElement("g",{"data-name":"Grupo 147085",transform:"translate(9338 19719)"},i.createElement("circle",{cx:18,cy:18,r:18,fill:"#f5f7fd","data-name":"Elipse 2217",transform:"translate(-9338 -19719)"}),i.createElement("path",{fill:"#008aeb",d:"m-9320-19693-8-10.331 3.8-5.669h8.4l3.8 5.669zm3.191-9.732-2.1 6.412 4.966-6.412Zm-9.246 0 4.967 6.412-2.1-6.412Zm4.055 0 2 6.092 2-6.092Zm3.011-5.015 2.1 3.76h3.051l-2.52-3.76Zm-1.011.557-1.789 3.2h3.579Zm-3.641-.557-2.52 3.76h3.05l2.1-3.76Z","data-name":"Organization / File / model / 16"}))));var wy,yy;function Cy(){return Cy=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},Cy.apply(null,arguments)}const Ey=e=>i.createElement("svg",Cy({xmlns:"http://www.w3.org/2000/svg",width:36,height:36},e),wy||(wy=i.createElement("defs",null,i.createElement("clipPath",{id:"cpr-passo-5_svg__a"},i.createElement("path",{fill:"#008aeb",d:"M2.286 2.286h6.857v1.143H2.286Zm0 2.286h6.857v1.143H2.286Zm0 2.286h3.428V8H2.286Zm0 5.714h2.285v1.143H2.286Zm12.4-2.69-1.714-1.714a.57.57 0 0 0-.4-.167.57.57 0 0 0-.4.167l-5.31 5.31V16h2.517l5.31-5.31a.57.57 0 0 0 .167-.4.57.57 0 0 0-.166-.408Zm-5.78 4.975H8v-.906l2.857-2.857.906.906Zm3.665-3.665-.906-.906.906-.906.906.906Zm-8 4.808H1.143A1.144 1.144 0 0 1 0 14.857V1.143A1.144 1.144 0 0 1 1.143 0h9.143a1.144 1.144 0 0 1 1.143 1.143v5.714h-1.143V1.143H1.143v13.714h3.428Z",clipRule:"evenodd","data-name":"Caminho 714438"})))),yy||(yy=i.createElement("g",{"data-name":"Grupo 147079",transform:"translate(-16 -429)"},i.createElement("circle",{cx:18,cy:18,r:18,fill:"#f5f7fd","data-name":"Elipse 2217",transform:"translate(16 429)"}),i.createElement("g",{"data-name":"Grupo 114020"},i.createElement("g",{clipPath:"url(#cpr-passo-5_svg__a)","data-name":"Grupo 114019",transform:"translate(26.57 439)"},i.createElement("path",{fill:"#008aeb",d:"M-.762-.762h16.381v17.524H-.762Z","data-name":"Caminho 714437"}))))));var By,ky;function Iy(){return Iy=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},Iy.apply(null,arguments)}const Ny=e=>i.createElement("svg",Iy({xmlns:"http://www.w3.org/2000/svg",width:36,height:36},e),By||(By=i.createElement("defs",null,i.createElement("clipPath",{id:"cpr-passo-6_svg__a"},i.createElement("path",{fill:"#008aeb",d:"M10.857 5.714V4.571H8.571V2.857H7.429v1.714H6.286a1.144 1.144 0 0 0-1.143 1.143v1.714a1.144 1.144 0 0 0 1.143 1.143h3.428v1.714H5.143v1.143h2.286v1.714h1.142v-1.713h1.143a1.144 1.144 0 0 0 1.143-1.143V8.572a1.144 1.144 0 0 0-1.143-1.143H6.286V5.715ZM8 1.143A6.857 6.857 0 0 1 14.857 8 6.857 6.857 0 0 1 8 14.857 6.857 6.857 0 0 1 1.143 8 6.877 6.877 0 0 1 8 1.143M8 0a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8.024 8.024 0 0 0-8-8",clipRule:"evenodd","data-name":"Caminho 714440"})))),ky||(ky=i.createElement("g",{"data-name":"Grupo 147076",transform:"translate(-16 -535)"},i.createElement("circle",{cx:18,cy:18,r:18,fill:"#f5f7fd","data-name":"Elipse 2218",transform:"translate(16 535)"}),i.createElement("g",{"data-name":"Grupo 114022"},i.createElement("g",{clipPath:"url(#cpr-passo-6_svg__a)","data-name":"Grupo 114021",transform:"translate(26 545)"},i.createElement("path",{fill:"#008aeb",d:"M-.762-.762h17.524v17.524H-.762Z","data-name":"Caminho 714439"}))))));var Sy,Oy;function Py(){return Py=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var i in o)({}).hasOwnProperty.call(o,i)&&(e[i]=o[i])}return e},Py.apply(null,arguments)}const Qy=e=>i.createElement("svg",Py({xmlns:"http://www.w3.org/2000/svg",width:16,height:15.273},e),Sy||(Sy=i.createElement("defs",null,i.createElement("clipPath",{id:"logo-bradesco-16_svg__a"},i.createElement("path",{fill:"#cc092f",d:"M0 0h16v15.273H0z","data-name":"Ret\\xE2ngulo 16055"})))),Oy||(Oy=i.createElement("g",{clipPath:"url(#logo-bradesco-16_svg__a)","data-name":"Grupo 85687"},i.createElement("g",{"data-name":"Grupo 94735"},i.createElement("path",{fill:"#cc092f",d:"M6.54 11.637v3.418a.143.143 0 0 0 .147.149h.94v-4.379l-.94.549a.29.29 0 0 0-.147.263m.952-8.39a17.6 17.6 0 0 0-2.923.263 5.557 5.557 0 0 1 7.9-.9c.159.137.283.149.408.023s.113-.24-.023-.4a6.169 6.169 0 0 0-10.54 1.803A11 11 0 0 0 .2 4.927c-.17.1-.238.217-.17.366a.263.263 0 0 0 .351.137c.544-.16 1.1-.286 1.677-.423a5 5 0 0 0-.1.949 6.18 6.18 0 0 0 2.821 5.269c.17.114.317.114.419-.023a.253.253 0 0 0-.057-.389 5.44 5.44 0 0 1-1.728-3.965 5.3 5.3 0 0 1 .43-2.115c.578-.046 1.2-.091 1.892-.091 4.475 0 8.247 1.486 8.247 3.441 0 .983-1.246 1.977-2.719 2.64-.351.16-.4.274-.34.423s.215.194.4.137c2.583-.857 4.531-2.263 4.531-3.955 0-2.309-3.693-4.081-8.36-4.081M9.3 9.854l-1.246.72v4.618h1.341a.233.233 0 0 0 .238-.24v-4.927a.208.208 0 0 0-.333-.171","data-name":"Caminho 39877"}))))),zy=({isAvalista:i,shopName:n})=>t(Jw,{children:[t(o,i&&n?{children:[t(Yw,{children:[n," parceira do seu negócio"]}),t(Zw,{children:["Clientes selecionados ",n," podem financiar suas compras no E-agro com um pré-aprovado disponibilizado pelo vendedor."]})]}:{children:[e(Yw,{children:"Pagamento via CPR Digital"}),e(Zw,{children:"A Cédula de Produto Rural é um título de crédito em que é possível receber recursos de maneira antecipada\n              às vendas da produção rural. É utilizado para compra de rações, remédios, sementes, fertilizantes,\n              equipamentos, máquinas e outros produtos para viabilizar o plantio e o cultivo agrícola e pecuário."})]}),t(ly,{children:[e(Qy,{}),t("p",{className:"tag-text",children:["Exclusivo para clientes",e("span",{className:"red-text",children:" Bradesco"})]})]}),e(Xw,{}),e(_w,{children:"Como funciona?"}),t($w,{children:[t(ey,{children:[e(cy,{}),e(ty,{})]}),t(oy,{children:[t(iy,{children:[e(ny,{children:"Passo 1"}),e(ry,{children:"Adicione itens ao carrinho"})]}),t(ay,i&&n?{children:["Você deve colocar itens ",t("strong",{children:["apenas da ",n]})," ao carrinho de compras com o",e("strong",{children:" valor mínimo de R$ 20.000,00"}),"."]}:{children:["Você deve colocar itens"," ",e("strong",{children:"apenas de um mesmo vendedor"})," ao carrinho de compras com o",e("strong",{children:" valor mínimo de R$ 20.000,00"}),"."]})]})]}),t($w,{children:[t(ey,{children:[e(uy,{}),e(ty,{})]}),t(oy,{children:[e(ny,{children:"Passo 2"}),e(ry,{children:"Simulação"}),e(ay,{children:"Simule o valor do seu carrinho de compras, escolha em quanto tempo vai pagar e saiba o custo das suas parcelas."})]})]}),t($w,{children:[t(ey,{children:[e(fy,{}),e(ty,{})]}),t(oy,{children:[e(ny,{children:"Passo 3"}),e(ry,{children:"Dados da atividade rural"}),e(ay,{children:"Informe a sua fazenda, o seu produto e confirme os dados da safra."})]})]}),t($w,{children:[t(ey,{children:[e(by,{}),e(ty,{})]}),t(oy,{children:[e(ny,{children:"Passo 4"}),e(ry,{children:"Garantia"}),e(ay,{children:i&&n?"O vendedor será seu avalista nesta operação.":"Escolha a garantia que mais fizer sentido com as suas necessidades."})]})]}),t($w,{children:[t(ey,{children:[e(Ey,{}),e(ty,{})]}),t(oy,{children:[e(ny,{children:"Passo 5"}),e(ry,{children:"Assinar o contrato"}),e(ay,{children:"Assine o contrato do seu crédito 100% online, sem necessidade de ir a uma agência."})]})]}),t($w,{children:[e(ey,{children:e(Ny,{})}),t(oy,{children:[e(ny,{children:"Passo 6"}),e(ry,{children:"Crédito direto na conta do lojista"}),e(ay,{children:"O recurso vai para a conta do lojista e a sua compra é processada na hora!"})]})]})]}),My=h("div")`
  background: white;
  border: 1px solid #dde0e0;
  padding: 1rem 0.8rem;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
  -webkit-box-shadow: 1px 2px 20px -13px #9c9c9c;
  box-shadow: 1px 2px 20px -13px #9c9c9c;
  justify-content: space-between;
`,Dy=h.div`
  padding: 0 0 0.3rem 0.3rem;
  color: ${f.color04};
  font-weight: bold;
  font-size: 14px;
  margin-top: -1.5rem;
  margin-left: 0.5rem;
`,jy=h.div`
  padding: 0.3rem;
  font-size: 11px;
  letter-spacing: 0px;
  color: ${f.color09};
  margin-left: 0.5rem;
`,Ty=h.div`
  padding: 0.3rem;
  color: ${f.color04};
  font-weight: bold;
  font-size: 14px;
`,Ry=h.svg`
  opacity: 1;
  z-index: 1;
  cursor: pointer;
  width: 25px;
  height: 25px;
  color: ${f.color01};
`;h("div")`
  display: flex;
  margin-top: 0.5rem;
`,h("div")``;const Ly=({title:o,description:i,valor:n,selected:r})=>t(My,{style:{backgroundColor:r?"#F8FFFB":"white"},children:[t("div",{children:[e(Ry,{children:e(r?Ve:Ke,{})}),t("div",{style:{marginLeft:"1.5rem"},children:[e(Dy,{children:o}),e(jy,{children:i})]})]}),e("div",{children:e(Ty,{children:Number(n).toLocaleString("pt-br",{style:"currency",currency:"BRL"})})})]}),Uy=h("button")`
  border: none;
`,qy=({previousLabel:o="Prev",nextLabel:i="Next",pageCount:n,onPageChange:a,pageRangeDisplayed:d=2,breakLabel:s="...",pageLinkClassName:p,previousClassName:m,nextClassName:u,disabledClassName:h,breakClassName:g,containerClassName:A,activeClassName:f,gap:v={marginRight:"4px"},forcePage:x})=>{const[b,w]=r(x||0),y=c((e=>{a({selected:e}),w(e)}),[a]),C=l((()=>{const t=[],o=d/2,i=d-o;for(let r=0;r<n;r++){const a=r+1;let l=p;r===b&&(l+=` ${f}`),0===r||r===n-1||r>=b-o&&r<=b+i?t.push(e(Uy,{onClick:()=>y(r),className:l,style:v,children:a},r)):(r<b-o&&1===r||r>b+i&&r===n-2)&&t.push(e("span",{className:g,style:v,children:s},r))}return t}),[b,n,d,p,f,g,s]);return t("div",{className:A,children:[e(Uy,{onClick:()=>y(b-1),className:0===b?`${m} ${h}`:m,disabled:0===b,style:v,children:o}),C,e(Uy,{onClick:()=>y(b+1),className:b===n-1?`${u} ${h}`:u,disabled:b===n-1,children:i})]})},Wy=h(Yt)`
  margin: 0 !important;

  .bx--radio-button__label {
    display: flex;
    align-items: center;
    justify-content: center;

    height: 2rem;

    padding: 0 0.5rem;

    background: transparent;
    border: 1px solid ${f.color01};
    border-radius: 16px;

    font-size: ${f.fontSize01};
    font-weight: ${f.fontWeight04};
    line-height: ${f.lineHeight01};

    color: ${f.color01};

    transition: all 0.2s;

    .bx--radio-button__appearance {
      display: none;
    }
  }

  .bx--radio-button:checked + .bx--radio-button__label {
    background: ${f.bg01};

    color: ${f.color03};

    .bx--radio-button__appearance {
      display: none;
    }
  }
`;function Gy(t){var{label:o,value:i}=t,n=Jl(t,["label","value"]);return e(Wy,Object.assign({labelText:o},n))}export{ja as AccessibilityBar,Mr as Accordion,Lr as AccordionText,_r as AccordionWithButton,Cl as AccountCardItem,El as AccountCardList,Qm as AlertCard,Lu as Avatar,Ua as BackArrow,Wa as BackButton,vd as BalloonText,yd as BaloonOptions,Pa as Button,Ha as ButtonBack,Xa as ButtonClick,Vg as ButtonDefinirRegiao,Va as ButtonEnter,dp as ButtonFilled,Ya as ButtonGoToTop,qr as ButtonGtm,_a as ButtonIcon,$a as ButtonIconClick,tl as ButtonLink,il as ButtonLinkGtm,al as ButtonMenu,sp as ButtonOutline,dl as ButtonQA,sl as ButtonRadio,pl as ButtonSecondary,ul as ButtonSelect,cp as ButtonText,gl as ButtonTransparent,ip as CalendarInput,zr as Card,Nl as CardContent,Ml as CardExpander,Ll as CardOnboading,hd as CardOrder,ql as CardRadio,Fl as CardSlider,Hl as CardSliderSlideDirection,$l as CardStatus,lf as CartCounter,of as CartItem,bf as CartItemList,Ku as CategoriesSearchBar,Hd as Chatbot,Xd as ChatbotBanner,Jd as ChatbotBox,fl as Checkbox,Cc as CheckboxForElement,kc as CheckboxNewForm,Zu as Chip,Wf as ChromeWrapper,Ip as ClientsList,mc as ComboBox,ob as ContentMenu,sb as ContentMenuLogged,Tu as ContentType,$f as CookiesModal,tv as CountdownTimer,qy as CustomPagination,ls as DatePicker,nv as DebitQuestioner,Mc as DoubleInput,mb as DownloadBanner,eg as DropDownCategories,Kw as DropDownCategoriesSidebar,wd as Dropdown,ss as DropdownSelect,Lf as ErrorFormalizationHTML,Rf as ErrorHTML,qf as ErrorHTMLCPF,gm as EspecialistaChromeWrapper,mm as EspecialistaHeader,rm as EspecialistaMenuHamburger,ym as EspecialistaOrderCard,yp as EspecialistaPagination,Fp as EspecialistaToggletipProfile,Sp as EspecialistaWrapperContainer,wa as FaqAccordion,Na as FaqAccordionAboutUs,Rw as FilterSidePanel,Lw as FilterSidePanelMemo,Pb as Footer,Ly as FreteCard,Tb as Header,Nd as HeaderChat,qb as HeaderLogged,av as HeaderMKT,Gb as HeaderMKTPortal,rb as HelloMenu,xw as HomeCarouselProductBelowDesc,aw as HomeProductCarouselGrid,ww as HomeProductCarouselGridSkeleton,Aw as HomeProductCarouselRow,Ew as HomeProductCarouselRowSkeleton,zy as HowCprWorks,od as InfoCard,rd as InfoText,dd as InfoWarning,ps as Input,hs as InputAuthentication,ms as InputCurrency,Td as InputMessage,Ys as InputNewForm,ef as InputNumber,qg as InputRegiao,As as InputRegister,vs as InputSearch,bs as InputWithIcon,fg as LateralMenu,Xl as Link,hp as LinkFilled,gp as LinkOutline,Ap as LinkText,Ra as Logo,Hp as LogoutButton,Uf as MarketplaceErrorHTML,Xs as MaskedInput,tc as Masks,pv as MenuHamburger,mv as MetaTagsWapper,Ms as Modal,Us as ModalAlert,Ws as ModalMyProfile,ys as MultiSelect,bc as MultiSelectForElement,Ac as MultiSelectNewForm,os as NewChatbotBanner,Cv as NewFileUploader,Bh as NewFooter,Sf as NewHeader,Pf as NewHeaderLogged,Bv as NotificationAlert,fm as OrderLabel,Nm as OrdersList,tf as OrganizeUtmCampaign,Pv as PageNotFound,Tv as PageWrapper,Ls as PrivilegedClientInfo,Rv as PrivilegedUserValidation,fw as ProcuctDisplayMode,vw as ProductListType,Lv as Protected,Rc as QuarterInput,iv as QuestionGenerator,Sc as Radio,xl as RadioButton,Gy as RadioButtonTag,Qc as RadioForElement,Jg as RegionPopover,Kg as RegionPopoverContentWrapped,Gg as RegionsOption,qv as RowButton,Hv as Score,Vv as SearchBar,Cf as SearchBarPortal,cx as SearchCard,lx as SearchClientItem,Ns as SearchDropdown,Os as SearchForm,gx as SearchFormAdvisor,sx as SearchFormCard,fx as SearchFormPortal,jc as SearchInput,dx as SearchOrderItem,Qs as Select,dc as SelectNewForm,wf as SidePanel,yf as SidePanelMemo,xx as Slider,Ex as Stars,_l as StatusIcon,kx as Table,Nx as Tabs,Ox as TermsOfUseModal,ba as Text,Fs as TextArea,wl as Toggle,xp as ToggleNewForm,qx as ToggletipProfile,as as ToolTip,Hx as ToolTipRura,Of as Username,Mf as WarningMessage,Tf as useFullScreenLoader};
//# sourceMappingURL=bundle.esm.js.map
